!(function (t) {
    t({ theme: { landing: { loadDefaultTemplates: !0, loadDefaultStyles: !0, templateContainer: window.document.body } } }),
        t.interactive(function () {
            var e = t.getSetting(t.settings, "settings.theme.landing");
            !0 === e.loadDefaultStyles &&
                t.dom.helpers.addElementToHead({
                    name: "klevu-landing-search-theme-styles",
                    content:
                        '[ku-container] a,[ku-container] p,[ku-container] div,[ku-container] ul li{font-family:inherit;font-size:13px;line-height:130%;text-decoration:none;font-weight:normal}[ku-container] *{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;outline:0;-webkit-font-smoothing:antialiased;vertical-align:top}.kuBase{margin:0;padding:0;border:0;box-sizing:border-box;box-shadow:none;position:relative;max-width:100%}[ku-container],[ku-block]{margin:0;padding:0;border:0;box-sizing:border-box;box-shadow:none;position:relative;max-width:100%}[ku-container][data-container-role="main"]{margin:0;padding:0;border:0;box-sizing:border-box;box-shadow:none;position:relative;max-width:100%;width:1200px;margin:0 auto}[ku-container][data-container-role="header"]{margin:0;padding:0;border:0;box-sizing:border-box;box-shadow:none;position:relative;max-width:100%}[ku-container][data-container-role="header"] [ku-block][data-container-role="subPanel"]{margin:0;padding:0;border:0;box-sizing:border-box;box-shadow:none;position:relative;max-width:100%}[ku-container][data-container-role="header"] [ku-block][data-container-role="banner"]{margin:0;padding:0;border:0;box-sizing:border-box;box-shadow:none;position:relative;max-width:100%}[ku-container][data-container-role="header"] [ku-block][data-container-role="navigation"]{margin:0;padding:0;border:0;box-sizing:border-box;box-shadow:none;position:relative;max-width:100%}.kuResultContent{margin:0;padding:0;border:0;box-sizing:border-box;box-shadow:none;position:relative;max-width:100%}.kuResultContent [ku-container]:empty{display:none!important;width:0!important;padding:0;margin:0;overflow:hidden}[ku-container][data-container-role="content"]{margin:0;padding:0;border:0;box-sizing:border-box;box-shadow:none;position:relative;max-width:100%;display:table;width:100%}[ku-container][data-container-role="content"] [ku-block]:empty{display:none!important;width:0!important;padding:0;margin:0;overflow:hidden}[ku-block][ku-empty],[ku-container][ku-empty]{display:none!important;width:0!important;padding:0!important;height:0!important;margin:0!important;overflow:hidden!important}[ku-container][data-container-role="left"]{display:table-cell;width:22%;height:auto;max-width:275px}[ku-container][data-container-role="right"]{display:table-cell;width:22%;height:auto;max-width:275px}[ku-container][data-container-role="content"] [ku-container][data-container-role="results"]{display:table-cell;width:auto;height:auto}[ku-container][data-container-role="content"]:after{content:\'\';display:block;clear:both}[ku-block]:empty{display:none!important;width:0!important;height:0!important;min-height:0!important;padding:0;margin:0;overflow:hidden}@media only screen and (max-width:1100px){.kuResults ul li{width:33%;padding:5px}.kuFilterBox .kuFilterNames ul li a span.kufacet-text{max-width:60%;width:60%}}@media only screen and (max-width:991px){[ku-container][data-container-role="left"],[ku-container][data-container-role="right"]{width:32%}}@media only screen and (max-width:767px){[ku-container][data-container-role="content"],[ku-container][data-container-role="content"] [ku-container][data-container-role="results"],[ku-container][data-container-role="left"],[ku-container][data-container-role="right"]{display:block;width:100%;height:auto}.kuContainer .kuTabs a{display:inline-block}.kuContainer .kuTabs a:hover{border-bottom:0 solid #ddd;text-decoration:none;background:#f5f5f5}.kuContainer a.kuTabSelected{border-bottom:0 solid #ddd;background:#f5f5f5}.kuLandingNoResultsMessage{font-size:15px;line-height:1.2em;padding:10px 5%;text-align:center}.kuFilterBox{margin-bottom:5px;padding-bottom:10px;width:100%}}.klevu-stars-small-l2{height:13px;display:inline-block;vertical-align:bottom;background:transparent url(https://js.klevu.com/klevu-js-v1/img-1-1/star-gray.png) top left repeat-x;width:65px;margin-top:5px}.klevu-stars-small-l2 .klevu-rating-l2{background:transparent url(https://js.klevu.com/klevu-js-v1/img-1-1/star-yellow.png) top left repeat-x;height:13px}.kuQuickSearchFacetedLayout>div,.kuEmptySearchBox.klevuTarget.kuQuickSearchResultsContainer.kuPersonalizedSearchRecsEnabled>div{width:100%!important;max-width:550px!important}.kuQuickSearchFacetedLayout [ku-container][data-container-role="left"],.kuEmptySearchBox.klevuTarget.kuQuickSearchResultsContainer.kuPersonalizedSearchRecsEnabled [ku-container][data-container-role="left"]{width:33%;padding-right:2%}.kuQuickSearchFacetedLayout [ku-container][data-container-role="right"],.kuEmptySearchBox.klevuTarget.kuQuickSearchResultsContainer.kuPersonalizedSearchRecsEnabled [ku-container][data-container-role="right"]{width:Calc(65%)}.kuQuickSearchFacetedLayout [ku-container][data-container-role="left"]{width:33%;padding-right:0}.kuQuickSearchFacetedLayout [ku-container][data-container-role="right"]{width:33%}.kuQuickSearchFacetedLayout .kuQuickResultsListContainer{position:relative;height:360px;overflow:auto}.kuQuickSearchFacetedLayout .kuPagination{padding:10px 20px;text-align:right}.kuQuickSearchFacetedLayout .kuPagination a{margin:0;position:relative;display:inline-block;padding-left:0;padding-right:10px;color:#333;cursor:pointer;text-decoration:none;border-right:1px solid #ddd;font-size:14px}.kuQuickSearchFacetedLayout .kuPagination a:hover{color:#333}.kuQuickSearchFacetedLayout .kuPagination a:last-child{border-right:0}.kuQuickSearchFacetedLayout .kuPagination a.kuCurrent{background:#fff;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;font-weight:bold}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct{width:32%!important;border-right:1px solid #e2e2e2;border-top:1px solid #e2e2e2;display:inline-block;float:left;min-height:200px}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct .klevu-desc-l2{display:none}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct:hover{background-color:#f8f8f8}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct:hover .klevuQuickAddtoCart{opacity:1;visibility:visible}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct:nth-child(1){border-top:0;border-top:0}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct:nth-child(2){border-top:0;border-top:0}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct:nth-child(3){border-top:0;border-top:0}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct:nth-last-child(1){border-bottom:1px solid #e2e2e2}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct:nth-last-child(2){border-bottom:1px solid #e2e2e2}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct:nth-last-child(3){border-bottom:1px solid #e2e2e2}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct:nth-child(3n+3){border-right:0}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuResultsBlock .klevuQuickSearchResults .klevuProductItemTop{width:100%;float:none}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuResultsBlock .klevuQuickSearchResults .klevuProductItemBottom{width:100%;float:none}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'].klevuQuickSearchResults .klevuQuickAddtoCart{margin:0 auto;position:absolute;display:inline-block;bottom:auto;width:auto;top:25%;left:0;width:100%;text-align:center;opacity:0;visibility:hidden}.kuQuickSearchFacetedLayout .klevuResultsBlock [data-result-view=\'grid\'].klevuQuickSearchResults .klevuProductItemBottom{width:100%;float:none}.kuQuickSearchFacetedLayout .klevuResultsBlock [data-result-view=\'grid\'].klevuQuickSearchResults .klevuProductItemTop{width:100%;float:none}.kuQuickSearchFacetedLayoutRightSideFilters .kuPagination{text-align:left}.klevuTarget.klevu-fluid.kuQuickSearchFacetedLayout>div{min-width:54%}@media only screen and (min-width:768px) and (max-width:991px){.klevuTarget.klevu-fluid.kuQuickSearchFacetedLayout>div{min-width:66%;max-width:100%}.kuQuickSearchFacetedLayout [ku-container][data-container-role="left"]{width:38%}.kuQuickSearchFacetedLayout [ku-container][data-container-role="right"]{width:38%}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct{width:49%!important;border-top:0;min-height:230px}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct:nth-child(3){border-top:1px solid #e2e2e2}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct:nth-last-child(1){border-top:0}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct:nth-child(2n+2){border-right:0}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct:nth-child(odd){border-right:1px solid #e2e2e2;border-top:0}.kuEmptySearchBox.klevuTarget.kuQuickSearchResultsContainer.kuPersonalizedSearchRecsEnabled [ku-container][data-container-role="left"]{width:38%;padding-right:2%}}@media only screen and (max-width:767px){.kuQuickSearchFacetedLayout [ku-container][data-container-role="left"]{width:100%;padding-right:0;max-width:100%}.kuQuickSearchFacetedLayout [ku-container][data-container-role="right"]{width:100%;padding-right:0;max-width:100%}.kuQuickSearchFacetedLayout .kuFilterBox .kuFilterHead{font-weight:bold}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct{width:49%!important;border-top:0;min-height:230px}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct:nth-child(3){border-top:1px solid #e2e2e2}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct:nth-last-child(1){border-top:0}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct:nth-child(2n+2){border-right:0}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct:nth-child(odd){border-right:1px solid #e2e2e2;border-top:0}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'] .klevuProduct:hover .klevuQuickAddtoCart{opacity:1;visibility:visible}.kuQuickSearchFacetedLayout [data-result-view=\'grid\'].klevuQuickSearchResults .klevuQuickAddtoCart{position:relative;display:inline-block;bottom:15px;width:auto;top:auto;left:0;width:100%;text-align:center;opacity:1;visibility:visible;margin-top:10px}.kuEmptySearchBox.klevuTarget.kuQuickSearchResultsContainer.kuPersonalizedSearchRecsEnabled [ku-container][data-container-role="left"]{width:100%;padding-right:0;max-width:100%}.kuEmptySearchBox.klevuTarget.kuQuickSearchResultsContainer.kuPersonalizedSearchRecsEnabled [ku-container][data-container-role="right"]{width:100%;padding-right:0;max-width:100%}}.kuFilterNames{height:118px;overflow:hidden}.kuFilterNames ul{margin:0;padding:0}.kuFilterNames ul li{list-style:none;text-align:left;width:100%;display:inline-block;margin:0;padding:0}.kuFilterNames ul li a{display:block;position:relative;overflow:hidden;padding:0;text-decoration:none;cursor:pointer;font-style:normal;color:#333;background:0;margin:2px;margin-left:5px}.kuFilterNames ul li a span{display:inline-block;vertical-align:middle}.kuFilterNames ul li a span.kufacet-text{max-width:74%;width:74%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;float:left}.kuFilterNames ul li a span.kuFilterIcon{float:left;margin:0;padding:0;font-weight:normal}.kuFilterNames ul li a:hover{cursor:pointer}.kuFilterNames ul li a:hover span.kuFilterIcon:before{background:#fff}.kuFilterNames ul li a:hover span.kuFilterIcon:after{content:\'\';position:absolute;width:8px;height:8px;background:#333;top:5px;left:5px;border:0;margin-top:0;margin-left:0;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transform:rotate(-45deg);-moz-transform:rotate(-45deg);-o-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg);border-radius:50%}.kuFilterNames ul li a span.kuFilterTotal{float:right;text-align:right;margin:0;padding:0}.kuFilterNames ul li a span.kuFilterCancel{float:right;text-align:right;margin:0;padding:0}.kuFilterNames ul li.kuSelected a{color:#333}.kuFilterNames ul li.kuSelected span.kuFilterIcon:before{background:#fff}.kuFilterNames ul li.kuSelected span.kuFilterIcon:after{content:\'\';position:absolute;width:8px;height:8px;background:#333;top:5px;left:5px;border:0;margin-top:0;margin-left:0;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transform:rotate(-45deg);-moz-transform:rotate(-45deg);-o-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg);border-radius:50%;border-color:#333}.kuFilterNames ul li.kuSelected:hover span.kuFilterIcon:after{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;border-color:#333}.kuFilterNames.kuFilterShowAll{height:auto;overflow:unset}.kuFilterHead{font-family:inherit;font-size:13px;font-weight:bold;padding:5px;color:#333;display:block;line-height:1.8;text-transform:uppercase;border-bottom:1px solid #eee;background:0;margin-bottom:15px;margin-top:0;position:relative;cursor:pointer;transition:all .3s ease}.kuShowOpt{padding:0 5px;cursor:pointer;position:absolute;bottom:-5px}.kuShowOpt a{color:#333;text-decoration:none}.kuHideOpt a{color:#333;text-decoration:none}.kuFilterDot{height:5px;width:5px;background-color:#333;border-radius:50%;display:inline-block;margin:2px}.kuFilterIcon:before{content:\'\';border:2px solid #ddd;border-radius:50%;margin:0;margin-right:6px;height:18px;width:18px;display:inline-block;color:#ddd;position:relative;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;transition:background 200ms;-webkit-transition:background 200ms;-moz-transition:background 200ms;-webkit-transition:border-color 200ms;-moz-transition:border-color 200ms;transition:border-color 200ms}.kuMulticheck .kuFilterIcon:before{content:\'\';border:1px solid #ddd;border-radius:0;margin:0;margin-right:8px;height:18px;width:18px;display:inline-block;color:#ddd;position:relative}.kuMulticheck .kuFilterNames ul li a:hover span.kuFilterIcon:before{background:#fff;border:1px solid #333}.kuMulticheck .kuFilterNames ul li a:hover span.kuFilterIcon:after{content:\'\';position:absolute;width:10px;height:5px;background:transparent;top:5px;left:4px;border:2px solid #333;border-top:0;border-right:0;border-radius:0;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transform:rotate(-45deg);-moz-transform:rotate(-45deg);-o-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg)}.kuMulticheck .kuFilterNames ul li.kuSelected span.kuFilterIcon:before{background:#fff;border:1px solid #333}.kuMulticheck .kuFilterNames ul li.kuSelected span.kuFilterIcon:after{content:\'\';position:absolute;width:10px;height:5px;background:transparent;top:4px;left:4px;border:2px solid #ddd;border-top:0;border-right:0;border-radius:0;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transform:rotate(-45deg);-moz-transform:rotate(-45deg);-o-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg)}.kuMulticheck .kuFilterNames ul li.kuSelected:hover span.kuFilterIcon:after{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;border-color:#333}.kuQuickSearchFacetedLayout .kuFilters,.kuSearchResultsPageContainer .kuFilters{padding:10px}.kuQuickSearchFacetedLayout .kuFilterBox .kuFilterNames ul li a span.kufacet-text,.kuSearchResultsPageContainer .kuFilterBox .kuFilterNames ul li a span.kufacet-text{max-width:70%;width:70%}.kuQuickSearchFacetedLayout [data-block-id="ku_quick_left_facets"]{background-color:#fff;overflow:auto;max-height:400px;text-align:left}.kuQuickSearchFacetedLayout [data-block-id="ku_quick_right_facets"]{background-color:#fff;overflow:auto;max-height:400px;text-align:left}.kuFilterBox{margin-bottom:12px;background:0;padding-bottom:12px;position:relative}.kuFilterBox .kuFilterHead{padding:5px 0;color:#333;display:block;text-transform:uppercase;border-bottom:1px solid #ddd;background:0;margin-bottom:0}.kuFilterBox .kuFilterNames{height:125px;overflow:hidden}.kuFilterBox .kuFilterNames ul{margin:0;padding:0}.kuFilterBox .kuFilterNames ul li{list-style:none;text-align:left;width:100%;display:inline-block;margin:0;padding:0}.kuFilterBox .kuFilterNames ul li a{display:block;position:relative;overflow:hidden;padding:0;text-decoration:none;cursor:pointer;color:#333;background:0;margin:2px 5px 2px 0}.kuFilterBox .kuFilterNames ul li a span{display:inline-block;vertical-align:middle}.kuFilterBox .kuFilterNames ul li a span.kufacet-text{max-width:75%;width:75%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;float:left}.kuFilterBox .kuFilterNames ul li a span.kuFilterIcon{float:left;margin:0;padding:0;font-weight:normal}.kuFilterBox .kuFilterNames ul li a:hover span.kuFilterIcon:before{background:#fff}.kuFilterBox .kuFilterNames ul li a:hover span.kuFilterIcon:after{content:"";position:absolute;width:8px;height:8px;top:5px;left:5px;border:0;margin-top:0;margin-left:0;-webkit-transform:rotate(-45deg);-moz-transform:rotate(-45deg);-o-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg);border-radius:50%;background:#ddd}.kuFilterBox .kuFilterNames ul li.kuSelected a{color:#333}.kuFilterBox .kuFilterNames ul li.kuSelected span.kuFilterIcon:before{background:#fff}.kuFilterBox .kuFilterNames ul li.kuSelected span.kuFilterIcon:after{content:"";position:absolute;width:8px;height:8px;top:5px;left:5px;border:0;margin-top:0;margin-left:0;-webkit-transform:rotate(-45deg);-moz-transform:rotate(-45deg);-o-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg);border-radius:50%;background:#ddd;border-color:#333!important}.kuFilterBox .kuFilterNames ul li.kuSelected:hover span.kuFilterIcon:after{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;border-color:#333}.kuFilterBox .kuFilterIcon:before{content:"";border:2px solid #ccc;border-radius:50%;margin:0;margin-right:8px;height:18px;width:18px;display:inline-block;color:#ccc;position:relative;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;transition:background 200ms;-webkit-transition:background 200ms;-moz-transition:background 200ms;-webkit-transition:border-color 200ms;-moz-transition:border-color 200ms;transition:border-color 200ms}.kuFilterBox .kuFilterNames.kuFilterCollapse{height:0;overflow:hidden}.kuFilterBox .kuFilterNames.kuFilterCollapse .kuShowOpt{display:none}.kuFilterBox .kuFilterNames.kuFilterShowAll{height:auto;overflow:unset}.kuFilterBox .kuShowOpt{padding:0;cursor:pointer;position:absolute;bottom:-12px}.kuFilterBox .kuShowOpt a{color:#4d7abf;text-decoration:none}.kuFilterBox .kuShowOpt .kuFilterDot{height:5px;width:5px;background-color:#888;border-radius:50%;display:inline-block;margin:2px}.kuFilterBox .kuExpand{position:relative!important;transition:all .3s ease}.kuFilterBox .kuCollapse{position:relative!important;transition:all .3s ease}.kuFilterBox .kuFilterHead.kuCollapse{margin-bottom:10px}.kuFilterBox .kuFilterHead.kuCollapse::after{border-color:#333;border-image:none;border-style:solid;border-width:0 1px 1px 0;content:"";display:inline-block;padding:4px;position:absolute;right:12px;top:14px;-webkit-transform:rotate(-135deg);-moz-transform:rotate(-135deg);-o-transform:rotate(-135deg);-ms-transform:rotate(-135deg);transform:rotate(-135deg);transition:all .3s ease}.kuFilterBox .kuFilterHead.kuExpand::after{-moz-border-bottom-colors:none;-moz-border-left-colors:none;-moz-border-right-colors:none;-moz-border-top-colors:none;border-color:#333;border-image:none;border-style:solid;border-width:0 1px 1px 0;content:"";display:inline-block;padding:4px;position:absolute;right:12px;top:10px;-webkit-transform:rotate(45deg);-moz-transform:rotate(45deg);-o-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);transition:all .3s ease 0s}.kuFilterBox.kuMulticheck .kuFilterIcon:before{content:"";border:1px solid #ccc;border-radius:0}.kuFilterBox.kuMulticheck .kuFilterNames ul li a:hover span.kuFilterIcon:after{width:10px;height:5px;background:transparent;top:4px;left:4px;border:2px solid #ddd;border-top:0;border-right:0;border-radius:0}.kuFilterBox.kuMulticheck .kuFilterNames ul li a:hover span.kuFilterIcon:before{background:#fff;border:1px solid #333}.kuFilterBox.kuMulticheck .kuFilterNames ul li.kuSelected span.kuFilterIcon:after{width:10px;height:5px;background:transparent;top:4px;left:4px;border:2px solid #ddd;border-top:0;border-right:0;border-radius:0}.kuFilterBox.kuMulticheck .kuFilterNames ul li.kuSelected span.kuFilterIcon:before{background:#fff;border:1px solid #333}.kuFilterBox.kuMulticheck .kuFilterNames ul li.kuSelected:hover span.kuFilterIcon:after{border-color:#333}.kuCarousel{box-sizing:border-box;position:relative;width:100%;height:210px}.kuCarousel *:before{box-sizing:border-box}.kuCarousel *:after{box-sizing:border-box}.kuCarousel .kuCarousel-content{position:relative;overflow:hidden;transition:width .4s;height:100%}.kuCarousel .kuSlide{height:100%;position:absolute;z-index:1;transition:left .4s cubic-bezier(0.47,0.13,0.15,0.89)}.kuCarousel .nav{position:absolute;top:50%;margin-top:-8%;background-color:#FFF;width:24px;height:24px;z-index:2;cursor:pointer;border-radius:50%;border:0;outline:0;color:white;-webkit-user-select:none;background-position:center;background-repeat:no-repeat;background-size:100%;display:block}.kuCarousel .nav-left{left:-5px;background-image:url(https://js.klevu.com/klevu-js-v1/img-1-1/icon-prev.png)}.kuCarousel .nav-right{right:-5px;background-image:url(https://js.klevu.com/klevu-js-v1/img-1-1/icon-next.png)}.kuCarousel .kuCarousel-arrow-icon-left{margin-left:5px;margin-top:2px}.kuCarousel .kuCarousel-arrow-icon-right{margin-left:7px;margin-top:2px}/*! nouislider - 8.2.1 - 2015-12-02 21:43:15 */.noUi-target,.noUi-target *{-webkit-touch-callout:none;-webkit-user-select:none;-ms-touch-action:none;touch-action:none;-ms-user-select:none;-moz-user-select:none;-moz-box-sizing:border-box;box-sizing:border-box}.noUi-target{position:relative;direction:ltr}.noUi-base{width:100%;height:100%;position:relative;z-index:1}.noUi-origin{position:absolute;right:0;top:0;left:0;bottom:0}.noUi-handle{position:relative;z-index:1}.noUi-stacking .noUi-handle{z-index:10}.noUi-state-tap .noUi-origin{-webkit-transition:left .3s,top .3s;transition:left .3s,top .3s}.noUi-state-drag *{cursor:inherit!important}.noUi-base{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}.noUi-horizontal{height:12px}.noUi-horizontal .noUi-handle{width:24px;height:24px;left:-17px;top:-7px;border-radius:100%}.noUi-vertical{width:18px}.noUi-vertical .noUi-handle{width:28px;height:34px;left:-6px;top:-17px}.noUi-background{background:#fafafa;box-shadow:inset 0 1px 1px #f0f0f0}.noUi-connect{background:#333;box-shadow:inset 0 0 3px rgba(51,51,51,0.45);-webkit-transition:background 450ms;transition:background 450ms}.noUi-origin{border-radius:2px}.noUi-target{border-radius:4px;border:1px solid #d3d3d3;box-shadow:inset 0 1px 1px #f0f0f0,0 3px 6px -5px #bbb}.noUi-target.noUi-connect{box-shadow:inset 0 0 3px rgba(51,51,51,0.45),0 3px 6px -5px #bbb}.noUi-draggable{cursor:w-resize}.noUi-vertical .noUi-draggable{cursor:n-resize}.noUi-handle{border:1px solid #d9d9d9;background:#fff;cursor:default;box-shadow:inset 0 0 1px #fff,inset 0 1px 7px #ebebeb,0 3px 6px -3px #bbb;cursor:pointer}.noUi-active{box-shadow:inset 0 0 1px #fff,inset 0 1px 7px #ddd,0 3px 6px -3px #bbb}.noUi-handle:after,.noUi-handle:before{content:"";display:block;position:absolute;height:14px;width:1px;background:#e4e1e1;left:8px;top:4px}.noUi-handle:after{left:12px}.noUi-vertical .noUi-handle:after,.noUi-vertical .noUi-handle:before{width:14px;height:1px;left:6px;top:14px}.noUi-vertical .noUi-handle:after{top:17px}[disabled] .noUi-connect,[disabled].noUi-connect{background:#b8b8b8}[disabled] .noUi-handle,[disabled].noUi-origin{cursor:not-allowed}.noUi-pips,.noUi-pips *{-moz-box-sizing:border-box;box-sizing:border-box}.noUi-pips{position:absolute;color:#999}.noUi-value{width:40px;position:absolute;text-align:center}.noUi-value-sub{color:#ccc;font-size:10px}.noUi-marker{position:absolute;background:#ccc}.noUi-marker-large,.noUi-marker-sub{background:#aaa}.noUi-pips-horizontal{padding:10px 0;height:50px;top:100%;left:0;width:100%}.noUi-value-horizontal{margin-left:-20px;padding-top:20px}.noUi-value-horizontal.noUi-value-sub{padding-top:15px}.noUi-marker-horizontal.noUi-marker{margin-left:-1px;width:2px;height:5px}.noUi-marker-horizontal.noUi-marker-sub{height:10px}.noUi-marker-horizontal.noUi-marker-large{height:15px}.noUi-pips-vertical{padding:0 10px;height:100%;top:0;left:100%}.noUi-value-vertical{width:15px;margin-left:20px;margin-top:-5px}.noUi-marker-vertical.noUi-marker{width:5px;height:2px;margin-top:-1px}.noUi-marker-vertical.noUi-marker-sub{width:10px}.noUi-marker-vertical.noUi-marker-large{width:15px}.noUi-tooltip{display:block;position:absolute;border:1px solid #d9d9d9;border-radius:3px;background:#fff;padding:5px;text-align:center;width:max-content}.noUi-horizontal .noUi-handle-lower .noUi-tooltip{bottom:-32px}.noUi-horizontal .noUi-handle-upper .noUi-tooltip{bottom:-32px;right:0}.noUi-vertical .noUi-handle-lower .noUi-tooltip{left:120%}.noUi-vertical .noUi-handle-upper .noUi-tooltip{right:120%}.klevu-fluid,.klevu-fluid *,.klevuTarget,.klevuTarget *,.kuContainer *{font-family:inherit}[ku-container] a,[ku-container] p,[ku-container] div,[ku-container] ul li{font-family:inherit;font-size:13px;line-height:130%;text-decoration:none;font-weight:normal}[ku-container] *{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;outline:0;-webkit-font-smoothing:antialiased;vertical-align:top}.kuClearLeft{clear:left}.kuClearRight{clear:right}.kuClearBoth,.kuClearBoth:after{clear:both}.kuGreen{color:#009b46!important}.kuBlack{color:#333!important}.kuClipped{overflow:hidden;display:-webkit-box!important;-webkit-box-orient:vertical}.kuClippedOne{overflow:hidden;display:-webkit-box!important;-webkit-box-orient:vertical;-webkit-line-clamp:1}.kuClippedTwo{overflow:hidden;display:-webkit-box!important;-webkit-box-orient:vertical;-webkit-line-clamp:2}#loader{height:400px}#loader img{margin-top:10%;display:inline-block;width:auto!important}.kuBtn{display:inline-block;padding:5px 10px;cursor:pointer;font-size:11px!important;text-transform:uppercase;text-decoration:none;margin:5px 5px 5px 0;border-radius:3px;border:2px solid transparent;text-align:center}.kuBtnDark{background:#333;color:#fff;border-color:#333}.kuBtnLight{background:#ddd;color:#333;border-color:#dedede}.kuBtnDarkOutline{background:transparent;color:#333;border:2px solid #333}.kuBtnLightOutline{background:transparent;color:#ddd;border:2px solid #ddd}.kuBtnDark:hover,.kuBtnLight:hover,.kuBtnDarkOutline:hover,.kuBtnLightOutline:hover{background:#757575;color:#fff;border-color:#757575}.kuBase{margin:0;padding:0;border:0;box-sizing:border-box;box-shadow:none;position:relative;max-width:100%}[ku-container],[ku-block]{margin:0;padding:0;border:0;box-sizing:border-box;box-shadow:none;position:relative;max-width:100%}[ku-container][data-container-role="main"]{margin:0;padding:0;border:0;box-sizing:border-box;box-shadow:none;position:relative;max-width:100%;width:1200px;margin:0 auto}[ku-container][data-container-role="header"]{margin:0;padding:0;border:0;box-sizing:border-box;box-shadow:none;position:relative;max-width:100%}[ku-container][data-container-role="header"] [ku-block][data-container-role="subPanel"]{margin:0;padding:0;border:0;box-sizing:border-box;box-shadow:none;position:relative;max-width:100%}[ku-container][data-container-role="header"] [ku-block][data-container-role="banner"]{margin:0;padding:0;border:0;box-sizing:border-box;box-shadow:none;position:relative;max-width:100%}[ku-container][data-container-role="header"] [ku-block][data-container-role="navigation"]{margin:0;padding:0;border:0;box-sizing:border-box;box-shadow:none;position:relative;max-width:100%}.kuResultContent{margin:0;padding:0;border:0;box-sizing:border-box;box-shadow:none;position:relative;max-width:100%}.kuResultContent [ku-container]:empty{display:none!important;width:0!important;padding:0;margin:0;overflow:hidden}[ku-block][ku-empty],[ku-container][ku-empty]{display:none!important;width:0!important;padding:0!important;height:0!important;margin:0!important;overflow:hidden!important}[ku-container][data-container-role="left"]{display:table-cell;width:22%;height:auto;max-width:275px}[ku-container][data-container-role="right"]{display:table-cell;width:22%;height:auto;max-width:275px}[ku-block]:empty{display:none!important;width:0!important;height:0!important;min-height:0!important;padding:0;margin:0;overflow:hidden}.kuContainer{width:100%;margin:0 auto;font-family:inherit;font-size:12px;background-color:#fff;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;padding:10px;max-width:1280px;width:100%!important}.kuContainer .kuTabs{text-align:center;margin-bottom:15px;margin-top:15px;border-bottom:1px solid #eee}.kuContainer .kuTabs a{padding:8px;cursor:pointer;margin-right:5px;color:#333;display:inline-block;position:relative}.kuContainer .kuTabs a:hover{border-bottom:3px solid #ddd;text-decoration:none}.kuContainer .kuTabs a.kuTabSelected{border-bottom:3px solid #ddd}.kuContainer .kuTabs a.kuTabSelected:hover{background:0}.kuBlockFullwidth{width:100%!important;box-sizing:border-box}.kuProListing{margin-top:20px;margin-bottom:20px}.kuSearchResultsPageContainer .kuPagination{width:auto;float:right;text-align:right;box-sizing:border-box;padding:12px 5px}.kuSearchResultsPageContainer .kuPagination a{margin:0;position:relative;display:inline-block;padding-left:0;padding-right:10px;color:#333;cursor:pointer;text-decoration:none;border-right:1px solid #ddd;font-size:14px}.kuSearchResultsPageContainer .kuPagination a:hover{color:#333}.kuSearchResultsPageContainer .kuPagination a:last-child{border-right:0}.kuSearchResultsPageContainer .kuPagination a.kuCurrent{background:#fff;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;font-weight:bold}.kuSearchResultsPageContainer .kuOtherContent{display:none}.kuSearchResultsPageContainer .kuResults .kuNoRecordsFoundLabelTextContainer{padding:30px 20px;font-size:14px;color:gray;text-align:center}.kuSearchResultsPageContainer .kuResults ul{margin:0!important;padding:0!important;width:100%}.kuSearchResultsPageContainer .kuResults ul li{display:inline-block;width:25%;font-style:normal;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;margin:0;padding:10px;border-radius:0;position:relative;float:left}.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap{display:block;height:auto;width:100%;margin:0;padding:0;border:1px solid #ececec;position:relative}.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdTop{margin:0;padding:10px;position:relative}.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdTop .klevuImgWrap{overflow:hidden;width:100%!important;height:130px!important;text-align:center;margin:0 auto;position:relative;margin-bottom:10px}.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdTop .klevuImgWrap a{display:block;max-width:100%!important;max-height:100%!important;height:auto;width:auto}.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdTop .klevuImgWrap a img{max-width:100%!important;max-height:100%!important;left:0;right:0;margin:auto;display:inline-block;position:absolute}.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdBottom{margin:0;box-sizing:border-box;float:none;padding:10px;position:relative;height:82px}.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdAdditional{position:absolute;background:#fff;padding:0;margin:0;z-index:99;visibility:hidden;opacity:1;width:101%;left:-1px;right:0;top:98%;border:1px solid #ececec;border-top:0}.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdAdditional .kuProdAdditionalData{position:relative;padding:10px 12px}@media(max-width:767px){.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdAdditional{position:relative;visibility:visible;opacity:1;left:0;width:100%}}.kuSearchResultsPageContainer .kuResults ul li:hover .kuProdAdditional{visibility:visible;opacity:1;box-shadow:0 10px 10px 0 rgba(17,17,17,0.1)}.kuSearchResultsPageContainer .kuResults ul li .kuDesc{font-size:12px;line-height:18px;color:#757575}.kuSearchResultsPageContainer .kuResults ul li .kuName{margin-bottom:5px}.kuSearchResultsPageContainer .kuResults ul li .kuName a{font-size:115%;text-decoration:none;color:#333;font-weight:normal}.kuSearchResultsPageContainer .kuResults ul li .kuName a:hover{text-decoration:underline}.kuSearchResultsPageContainer .kuResults .kuStarsSmall{height:13px;display:inline-block;vertical-align:bottom;background:transparent url(https://js.klevu.com/klevu-js-v1/img-1-1/star-gray.png) top left repeat-x;width:66px}.kuSearchResultsPageContainer .kuResults .kuStarsSmall .kuRating{background:transparent url(https://js.klevu.com/klevu-js-v1/img-1-1/star-yellow.png) top left repeat-x;height:13px}.klevuNoResultsRecs-itemPrice,.productQuick-Price,.kuPrice{margin-top:5px;text-align:left;color:#333;width:100%;box-sizing:border-box;font-size:115%}.klevuNoResultsRecs-itemPrice .klevuQuickPriceGreyText,.productQuick-Price .klevuQuickPriceGreyText,.kuPrice .klevuQuickPriceGreyText{font-weight:normal!important;color:#393939!important;font-size:11px!important}.klevuNoResultsRecs-itemPrice .kuSalePrice,.productQuick-Price .kuSalePrice,.kuPrice .kuSalePrice{font-weight:bold;font-family:inherit;text-align:left;display:inline;margin-right:5px;color:#333;float:left}.klevuNoResultsRecs-itemPrice .kuSalePrice.kuSpecialPrice,.productQuick-Price .kuSalePrice.kuSpecialPrice,.kuPrice .kuSalePrice.kuSpecialPrice{float:none;display:inline-block}.klevuNoResultsRecs-itemPrice .kuSalePrice .kuStartPrice,.productQuick-Price .kuSalePrice .kuStartPrice,.kuPrice .kuSalePrice .kuStartPrice{float:none;display:inline-block}.klevuNoResultsRecs-itemPrice .kuOrigPrice,.productQuick-Price .kuOrigPrice,.kuPrice .kuOrigPrice{margin-right:5px;text-decoration:line-through;text-align:left;display:block;float:left;color:#757575;font-weight:400;font-size:11px}.kuProdBottom .kuPrice{overflow:hidden}@media only screen and (max-width:900px){.kuProdBottom .kuPrice{font-size:11px}}.kuLandingNoResults{background:#fff;width:100%;margin:30px auto;max-width:850px}.kuLandingNoResultsMessage{font-size:18px;padding:10px 5%;text-align:center}.kuLandingNoResultsMessage span{font-weight:bold;font-style:italic}.kuSearchResultsPageContainer .productList{display:block}.kuSearchResultsPageContainer .kuDropdown{margin:5px;position:relative;display:inline-block;width:auto;max-width:100%;z-index:11}.kuSearchResultsPageContainer .kuDropdown:first-child{margin-left:10px}.kuSearchResultsPageContainer .kuDropdown:hover .kuDropdownOptions{display:block}.kuSearchResultsPageContainer .kuDropdown .kuDropdownLabel{background-color:#fff;color:#333;padding:8px 12px;display:inline-block;text-transform:capitalize;cursor:pointer;border:1px solid #ddd;padding-right:35px;position:relative}.kuSearchResultsPageContainer .kuDropdown .kuDropdownLabel:after{-moz-border-bottom-colors:none;-moz-border-left-colors:none;-moz-border-right-colors:none;-moz-border-top-colors:none;border-color:#333;border-image:none;border-style:solid;border-width:0 1px 1px 0;content:"";display:inline-block;padding:4px;position:absolute;right:12px;top:10px;-webkit-transform:rotate(45deg);-moz-transform:rotate(45deg);-o-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);transition:all .3s ease 0s}.kuSearchResultsPageContainer .kuDropdown .kuDropdownOptions{display:none;position:absolute;background-color:#efefef;min-width:150px;box-shadow:0 4px 8px 0 rgba(0,0,0,0.2);z-index:12}.kuSearchResultsPageContainer .kuDropdown .kuDropdownOptions .kuDropOption{color:#333;padding:8px 12px;text-decoration:none;display:block;cursor:pointer}.kuSearchResultsPageContainer .kuDropdown .kuDropdownOptions .kuDropOption:hover{background-color:#ddd}@media only screen and (max-width:1100px){.kuSearchResultsPageContainer .kuResults ul li{width:33%;padding:5px}.kuSearchResultsPageContainer .kuFilterBox .kuFilterNames ul li a span.kufacet-text{max-width:60%;width:60%}}@media only screen and (max-width:991px){.kuSearchResultsPageContainer [ku-container][data-container-role="left"],.kuSearchResultsPageContainer [ku-container][data-container-role="right"]{width:32%}}@media only screen and (max-width:767px){.kuSearchResultsPageContainer .kuContainer .kuTabs a{display:inline-block}.kuSearchResultsPageContainer .kuContainer .kuTabs a:hover{border-bottom:0 solid #ddd;text-decoration:none;background:#f5f5f5}.kuSearchResultsPageContainer .kuContainer a.kuTabSelected{border-bottom:0 solid #ddd;background:#f5f5f5}.kuSearchResultsPageContainer .kuLandingNoResultsMessage{font-size:15px;line-height:1.2em;padding:10px 5%;text-align:center}.kuSearchResultsPageContainer .kuFilterBox{margin-bottom:5px;padding-bottom:10px;width:100%}.kuSearchResultsPageContainer .kuResults ul li{width:50%}}@media only screen and (max-width:576px){.kuSearchResultsPageContainer .kuResults ul li{width:100%}.kuSearchResultsPageContainer .kuDropdown .kuDropdownLabel{display:inline-block;padding:5px 5px;padding-right:20px;font-size:11px}.kuSearchResultsPageContainer .kuDropdown .kuDropdownLabel:after{right:5px;padding:3px;top:7px}}@media only screen and (min-width:481px) and (max-width:900px){.kuSearchResultsPageContainer.kuLEFTFilters .kuResults ul li,.kuSearchResultsPageContainer.kuRIGHTFilters .kuResults ul li{width:50%}}.searchRequestLoading .kuResultsListing .kuResults{opacity:.6;pointer-events:none}@-webkit-keyframes load7{0%,80%,100%{box-shadow:0 2.5em 0 -1.3em}40%{box-shadow:0 2.5em 0 0}}@keyframes load7{0%,80%,100%{box-shadow:0 2.5em 0 -1.3em}40%{box-shadow:0 2.5em 0 0}}.kuResourceLoader{border-radius:50%;width:2.5em;height:2.5em;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:load7 1.8s infinite ease-in-out;animation:load7 1.8s infinite ease-in-out;color:#dcdcdc;font-size:10px;margin:80px auto;position:relative;text-indent:-9999em;-webkit-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-0.16s;animation-delay:-0.16s}.kuResourceLoader:before{border-radius:50%;width:2.5em;height:2.5em;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:load7 1.8s infinite ease-in-out;animation:load7 1.8s infinite ease-in-out;content:"";position:absolute;top:0;left:-3.5em;-webkit-animation-delay:-0.32s;animation-delay:-0.32s}.kuResourceLoader:after{border-radius:50%;width:2.5em;height:2.5em;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:load7 1.8s infinite ease-in-out;animation:load7 1.8s infinite ease-in-out;content:"";position:absolute;top:0;left:3.5em}.kuSearchResultsPageContainer .kuResultsHeadingTitleContainer{margin:6px;padding-bottom:11px;border-bottom:1px solid #eee;margin-bottom:15px;margin-top:20px}.kuFilters[data-position="top"]{float:left;margin-bottom:15px;width:100%;padding:5px}.kuFilters[data-position="top"] .kuFilterBox{display:inline-block;float:left;position:relative;margin-bottom:0;padding-bottom:0;width:auto;height:auto}.kuFilters[data-position="top"] .kuFilterBox .kuFilterHead{padding:6px 15px 6px 0;text-align:left;text-transform:uppercase;position:relative;color:#333;border:0;font-weight:bold;margin:5px;transition:all .3s ease;margin-right:15px;pointer-events:initial}.kuFilters[data-position="top"] .kuFilterBox .kuFilterHead:hover{transition:all .5s ease;cursor:pointer}.kuFilters[data-position="top"] .kuFilterBox .kuFilterHead:hover+.kuFilterNames{display:block!important}.kuFilters[data-position="top"] .kuFilterBox .kuFilterHead::after{-moz-border-bottom-colors:none;-moz-border-left-colors:none;-moz-border-right-colors:none;-moz-border-top-colors:none;border-color:#333;border-image:none;border-style:solid;border-width:0 1px 1px 0;content:"";display:inline-block;padding:3px;position:absolute;right:3px;top:10px;-webkit-transform:rotate(45deg);-moz-transform:rotate(45deg);-o-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);transition:all .3s ease}.kuFilters[data-position="top"] .kuFilterBox .kuFilterNames{display:none;left:0;position:absolute;top:30px;min-width:280px;width:100%;min-height:80px;max-height:180px;overflow:hidden;background:#fff;border:1px solid #eee;z-index:100000000;padding:12px 10px;height:auto;margin-top:-1px}.kuFilters[data-position="top"] .kuFilterBox .kuFilterNames:hover{overflow-y:auto;display:block!important}.kuFilters[data-position="top"] .kuFilterBox .kuFilterHead.kuCollapse::after{-moz-border-bottom-colors:none;-moz-border-left-colors:none;-moz-border-right-colors:none;-moz-border-top-colors:none;border-color:#333;border-image:none;border-style:solid;border-width:0 1px 1px 0;content:"";display:inline-block;padding:3px;position:absolute;right:3px;top:8px;-webkit-transform:rotate(45deg);-moz-transform:rotate(45deg);-o-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);transition:all .3s ease}.kuFilters[data-position="top"] .kuFilterBox .kuFilterHead.kuExpand::after{-moz-border-bottom-colors:none;-moz-border-left-colors:none;-moz-border-right-colors:none;-moz-border-top-colors:none;border-color:#333;border-image:none;border-style:solid;border-width:0 1px 1px 0;content:"";display:inline-block;padding:3px;position:absolute;right:3px;top:10px;-webkit-transform:rotate(45deg);-moz-transform:rotate(45deg);-o-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);transition:all .3s ease}.kuFilters[data-position="top"] .kuShowOpt{display:none}@media only screen and (max-width:767px){.kuFilters[data-position="top"]{width:100%}.kuFilters[data-position="top"] .kuFilterHead{border-bottom:1px solid #eee;margin:0 auto}.kuFilters[data-position="top"] .kuFilterHead:hover+.kuFilterNames{pointer-events:none}.kuFilters[data-position="top"] .kuFilterNames:hover{pointer-events:none}.kuFilters[data-position="top"] .kuFilterNames.kuFilterCollapse{height:0;overflow:hidden;min-height:unset;padding:0;border:0;transition:none}}.kuSearchResultsPageContainer .kuAddtocart{margin:10px auto;width:100%}.kuSearchResultsPageContainer .kuAddtocart .kuBtn{display:block}.kuSearchResultsPageContainer .kuAddtocart img{width:auto;height:auto;max-height:35px;max-width:100%}.kuSwatches{width:100%;padding:5px 2px;border:0;min-height:30px;max-width:300px;float:none;box-sizing:border-box;position:relative;margin:10px 0;text-align:left}.kuSwatches .kuSwatchItem{display:inline-block;height:28px;width:28px;max-height:28px;max-width:28px;line-height:28px;border:0;padding:0;box-sizing:border-box;vertical-align:top;text-align:center;margin:2px}.kuSwatches .kuSwatchItem .kuSwatchLink{display:block;width:100%;height:100%;border:0;margin:0;padding:0;background-size:100% 100%!important;background-repeat:no-repeat!important;background-position:center;border-radius:0;background-color:transparent;text-decoration:none;color:#333;box-sizing:border-box;outline:1px solid #dedede;font-size:12px}.kuSwatches .kuSwatchItem .kuSwatchLink:hover,.kuSwatches .kuSwatchItem .kuSwatchLink:focus{text-decoration:none;box-shadow:none;outline-width:2px}.kuSwatches .kuSwatchItem .kuSwatchLink.active{text-decoration:none;box-shadow:none;outline-width:2px}.kuSwatchItem.kuSwatchMore{font-size:11px;font-weight:bold;color:#333;background-color:transparent}.kuSwatchItem.kuSwatchMore .kuSwatchMoreText{display:block;height:100%;width:100%;text-align:center;padding-top:5px}.kuSwatchItem.kuDefaultSwatch a.kuSwatchLink{background-color:#eee!important}.kuSwatches{width:100%;padding:5px 2px;border:0;min-height:30px;max-width:300px;float:none;box-sizing:border-box;position:relative;text-align:center;margin-top:10px;margin-bottom:10px;text-align:left}.kuSwatchItem{display:inline-block;height:32px;width:32px;max-height:32px;max-width:32px;border:0;padding:0;box-sizing:border-box;line-height:32px;vertical-align:top;text-align:center;margin:2px}.kuSwatchItem a.kuSwatchLink{display:block;width:100%;height:100%;border:0;margin:0;padding:2px;background-size:100% 100%!important;background-repeat:no-repeat!important;background-position:center;border-radius:0;background-color:transparent;text-decoration:none;color:#000;box-sizing:border-box;outline:1px solid #dedede;font-size:12px}.kuSwatchItem a.kuSwatchLink:hover{text-decoration:none;box-shadow:none;outline-width:2px}.kuSwatchItem a.kuSwatchLink:focus{text-decoration:none;box-shadow:none;outline-width:2px}.kuSwatchItem a.kuSwatchLink.active{text-decoration:none;box-shadow:none;outline-width:2px}.kuSwatchItem.kuSwatchMore{font-size:12px;font-weight:bold;color:#000;background-color:transparent}.kuSwatchItem.kuDefaultSwatch a.kuSwatchLink{background-color:#eee!important}.productQuick-colorInStock .kuSwatchMoreText{display:block;height:100%;width:100%;text-align:center;padding-top:0!important}.kuCaptionStockIn{margin-top:12px;text-align:left;color:green;width:100%;box-sizing:border-box;font-size:115%}.kuCaptionStockOut{margin-top:5px;text-align:left;color:#F00;width:100%;box-sizing:border-box;font-size:115%}.kuSearchResultsPageContainer .kuCaptionVat{display:block;font-size:10px;color:#767676;width:100%;float:left;padding:0;box-sizing:border-box;margin:2px 0}.kuSearchResultsPageContainer .kuCaptionVat::before{content:\'\';clear:both;display:block}.kuSearchResultsPageContainer .productList,.kuSearchResultsPageContainer .contentList{display:none}.kuSearchResultsPageContainer .productListActive .productList{display:block}.kuSearchResultsPageContainer .contentListActive .contentList{display:block}.kuSearchResultsPageContainer [data-result-view=\'list\'] footer.kuCMSProductNoImageFound{width:100%!important}.kuSearchResultsPageContainer [data-result-view=\'list\'] .kuProdBottom{height:auto!important}.kuDiscountBadge{top:6px;right:6px;position:absolute;background:#333;padding:0;color:#fff;width:55px;height:55px;border-radius:50%;font-weight:normal;text-align:center;box-sizing:border-box;z-index:1;font-style:italic;display:flex;align-items:center;line-height:100%}.kuDiscountBadge span{width:100%;align-items:center;text-align:center;font-size:11px}.kuBannerAd{text-align:center;width:100%;padding:10px;padding-left:0;padding-right:0;margin-bottom:20px;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.kuBannerAd img{display:inline-block;width:auto;max-width:100%;max-height:100%}.kuLandingNoRecordFound{text-align:center;margin-top:5%;margin-bottom:5%;color:#333;font-size:13px;background:#fff;display:block}.kuLandingNoRecordFound .kuLandingNoResultsMessage{font-size:22px!important;margin-bottom:20px}.kuLandingNoRecordFound .klevu-no-results-banner-ad{clear:both;text-align:center;width:100%;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.kuLandingNoRecordFound .klevu-no-results-banner-ad img{display:inline-block;width:auto;max-width:100%;max-height:185px;margin-bottom:20px}.kuLandingNoRecordFound .kuNoResultsProductRecommendationSlider{font-family:sans-serif}.kuLandingNoRecordFound .klevuNoResultsRecsWrap{max-width:100%;position:relative;padding:0;box-sizing:border-box;font-family:inherit;overflow:hidden}.kuLandingNoRecordFound .klevuNoResultsRecsWrap *{outline:0}.kuLandingNoRecordFound .klevuNoResultsRecs{position:relative;margin:0 auto;overflow:hidden;word-wrap:wrap;text-overflow:ellipsis}.kuLandingNoRecordFound .klevuNoResultsRecs h3{text-transform:uppercase;font-weight:bold;font-size:16px;cursor:pointer;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.kuLandingNoRecordFound .klevuNoResultsRecsResults{margin:0 auto;max-width:100%;overflow:hidden;margin-bottom:20px}.kuLandingNoRecordFound .klevuNoResultsRecsResultsInner{transition:-ms-transform .5s ease 0s,-webkit-transform .5s ease 0s,transform .5s ease 0s;position:relative;display:flex;flex-wrap:wrap;transition:all .5s ease}.kuLandingNoRecordFound .klevuNoResultsRecsResultsInner .klevuNoResultsRecs-item{margin:0 auto;border:1px solid #eee;background:#fff;transition:all .5s ease;transform:scale(1);min-height:240px}.kuLandingNoRecordFound .klevuNoResultsRecsResultsInner .klevuNoResultsRecs-itemImg{display:flex;justify-content:center;align-items:center;flex-direction:column;width:100%}.kuLandingNoRecordFound .klevuNoResultsRecsResultsInner a.klevuNoResultsRecsImg img{max-width:100%;max-height:100%;height:auto;width:auto;display:inline-block;margin:0}.kuLandingNoRecordFound .klevuNoResultsRecsResultsInner a.klevuNoResultsRecsTitle{font-size:12px;text-decoration:none;display:block;text-align:left;color:#000;overflow:hidden;line-height:180%;text-overflow:ellipsis}.kuLandingNoRecordFound .klevuNoResultsRecsResultsInner .klevuNoResultsRecs-itemDesc{box-sizing:border-box}.kuLandingNoRecordFound .klevuNoResultsRecsResultsInner .klevuNoResultsRecs-itemSku{color:rgba(0,0,0,0.5);font-size:80%;line-height:110%;margin-bottom:5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.kuLandingNoRecordFound .klevuNoResultsRecsResultsInner .klevuNoResultsRecs-itemPrice{margin-top:0;font-size:14px;color:#000;text-align:left}.kuLandingNoRecordFound .klevuNoResultsRecsResultsInner .klevuNoResultsRecs-itemPrice .kuSalePrice{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.kuLandingNoRecordFound .klevuNoResultsRecs-itemWrap{margin:8px}.kuLandingNoRecordFound .klevuNoResultsRecsControl-left{left:-24px}.kuLandingNoRecordFound .klevuNoResultsRecsControl-right{right:-18px}.kuLandingNoRecordFound .klevuNoResultsRecsControl{bottom:0;display:block;padding:0;width:24px;position:absolute;top:40%;z-index:1;height:28px}.kuLandingNoRecordFound .klevuNoResultsRecsControl-btn{background-color:transparent;border:0 none;cursor:pointer;display:block}.kuLandingNoRecordFound .klevuNoResultsRecsControl-btn svg{width:24px;height:24px;outline:0}.kuLandingNoRecordFound #klevuNoResultsRecsControl-left{display:none}.kuLandingNoRecordFound .kuNoResultsContainer{max-width:100%}.kuLandingNoRecordFound .klevuHeadingText{font-weight:bold;display:inline-block}.kuLandingNoRecordFound .kuNoResultsLandingPopularSearchesBlock{text-align:center}.kuLandingNoRecordFound .kuNoResultsLandingPopularSearchTerms ul{margin:0;padding:0;display:inline-block}.kuLandingNoRecordFound .kuNoResultsLandingPopularSearchTerms li{display:inline-block;cursor:pointer;text-transform:capitalize}.kuLandingNoRecordFound .kuNoResultsLandingPopularSearchTerms li a{color:#333}@media(min-width:768px){.kuLandingNoRecordFound .klevuNoResultsRecs-itemImg{min-height:170px}.kuLandingNoRecordFound .klevuNoResultsRecs-itemWrap{flex:22%}}@media(min-width:480px) and (max-width:768px){.kuLandingNoRecordFound .klevuNoResultsRecsResultsInner{max-width:60%;margin:0 auto}.kuLandingNoRecordFound .klevuNoResultsRecsResultsInner .klevuNoResultsRecs-item{min-height:200px}.kuLandingNoRecordFound .klevuNoResultsRecs-itemWrap{flex:44%}}@media(max-width:480px){.kuLandingNoRecordFound .klevuNoResultsRecsResultsInner{flex-direction:column;max-width:80%;margin:0 auto}.kuLandingNoRecordFound .klevuNoResultsRecsResultsInner a.klevuNoResultsRecsImg img{min-height:160px}.kuLandingNoRecordFound .kuLandingNoResultsMessage{font-size:16px!important}.kuLandingNoRecordFound .klevuNoResultsRecs-itemWrap{flex:50%}}@media only screen and (max-width:640px){.kuLandingNoRecordFound .klevuNoResultsRecs{max-width:80%}}.kuFilterTagsContainer{margin-bottom:3px;padding:3px}.kuFilterTagsContainer .kuFilterTagKey{color:gray;display:inline-block;padding:2px;margin:2px}.kuFilterTagsContainer .kuFilterTagValue{padding:2px 7px;border-radius:2px;background-color:#f3f2f2;margin:2px;display:inline-block;cursor:pointer}.kuFilterTagsContainer .kuFilterTagValue:hover{background-color:#ece9e9}.kuFilterTagsContainer .kuFilterTagClearAll{cursor:pointer;display:inline-block;padding:1px 7px;margin:2px;margin-left:8px;border:1px solid #ddd;border-radius:2px}.kuLandingResultsViewSwitchContainer{position:relative;display:inline-block;z-index:11;width:auto;padding:10px 5px}.kuLandingResultsViewSwitchContainer a{display:inline-block;width:22px;height:22px;margin-left:4px;text-align:center;vertical-align:middle;overflow:hidden}.kuLandingResultsViewSwitchContainer a.kuCurrent{background-position:0 -25px;text-decoration:none}.kuLandingResultsViewSwitchContainer .kuGridViewBtn{background:url(https://js.klevu.com/klevu-js-v1/img-1-1/ku-gridview.png) no-repeat 0 0;cursor:pointer}.kuLandingResultsViewSwitchContainer .kuListViewBtn{background:url(https://js.klevu.com/klevu-js-v1/img-1-1/ku-listview.png) no-repeat 0 0;cursor:pointer}[data-result-view=\'list\'] .klevuProduct{width:100%!important}[data-result-view=\'list\'] .klevuProduct:hover .kuProdAdditional{box-shadow:none!important}[data-result-view=\'list\'] .klevuProduct main{display:inline-block;width:30%}[data-result-view=\'list\'] .klevuProduct footer{display:inline-block;width:69%}[data-result-view=\'list\'] .klevuProduct .kuProdAdditional{position:relative!important;visibility:unset!important;border:0!important}[data-result-view=\'list\'] .klevuProduct .kuAddtocart .kuBtn{display:inline-block}@media only screen and (max-width:576px){[data-result-view=\'list\'] .klevuProduct main{width:100%}[data-result-view=\'list\'] .klevuProduct footer{width:100%}[data-result-view=\'list\'] .klevuProduct .kuAddtocart .kuBtn{display:block}}.kuSearchResultsSearchBarContainer input{width:100%}.kuSearchResultsSearchBarContainer.kuHideExtraSearch{display:none}.kuPriceSlider{width:auto;min-width:190px;max-width:98%;padding:20px;margin:auto;position:relative;box-sizing:border-box}.kuPriceSlider .noUi-tooltip{font-size:90%}.sliderFilterNames{height:90px}.kuSearchResultsPageContainer .kuInfiniteScrollContainer{text-align:center}.kuSearchResultsPageContainer .kuInfiniteScrollContainer .kuLoadMoreBtn{width:100%;margin:12px 0;height:34px;border:0;border-radius:2px;cursor:pointer}.kuSearchResultsPageContainer .kuInfiniteScrollContainer .kuLoadMoreBtn.hide{display:none!important}.klevuLandingImageSearchUploadBannerContainer{width:100%;margin-top:10px;margin-bottom:30px;position:relative;display:table}.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageLeft{display:table-cell;vertical-align:middle;padding:5px;width:70%;position:relative}.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageLeft .kuSearchedImageLeftContent{display:table;background-color:#f5f6f4;position:relative}.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageLeft .kuSearchedImageLeftContent .kuImgBannerTotalResultLabelContainer,.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageLeft .kuSearchedImageLeftContent .kuImgBannerTotalResultUploadImgContainer{display:table-cell;vertical-align:middle;padding:20px}.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageLeft .kuSearchedImageLeftContent img.kuImgBannerTotalResultUploadImg{height:100%;width:auto;max-height:120px}.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageLeft .kuSearchedImageLeftContent p{margin:0}.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageLeft .kuSearchedImageLeftContent .kuImgBannerTotalResultLabel{font-size:2.8em}.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageRight{display:table-cell;vertical-align:middle;padding:5px 20px;width:29.5%}.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageRight .kuSearchedImageRightContent{text-align:center}.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageRight .kuSearchedImageRightContent .kuTryAnotherPhotoBtn{width:100%;max-width:220px;text-align:center;padding:10px;border-width:0;background-color:#343420;color:#fff;cursor:pointer}.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageRight .kuSearchedImageRightContent .kuTryAnotherPhotoBtn img,.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageRight .kuSearchedImageRightContent .kuTryAnotherPhotoBtn svg{margin-right:5px}.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageRight .kuSearchedImageRightContent .kuTryAnotherPhotoBtn:disabled{cursor:default;opacity:.95}.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageRight .kuSearchedImageRightContent .kuTryAnotherPhotoBtn .kuUploadText::before{display:inline-block;width:16px;margin-right:5px;cursor:pointer}.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageRight .kuSearchedImageRightContent .kuTryAnotherPhotoBtn .kuUploadText.upload::before{content:url(data:image/svg+xml,%3Csvg%20width%3D%2210%22%20height%3D%2211%22%20viewBox%3D%220%200%2010%2011%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M0.333333%207.95508C0.149%207.95508%200%208.10441%200%208.28841V10.3327C0%2010.5167%200.149%2010.6661%200.333333%2010.6661H9.66667C9.851%2010.6661%2010%2010.5167%2010%2010.3327V8.28841C10%208.10441%209.851%207.95508%209.66667%207.95508C9.48233%207.95508%209.33333%208.10441%209.33333%208.28841V9.99941H0.666667V8.28841C0.666667%208.10441%200.517667%207.95508%200.333333%207.95508Z%22%20fill%3D%22white%22%2F%3E%0A%3Cpath%20d%3D%22M5.01445%208.62233C5.19878%208.62233%205.34778%208.473%205.34778%208.289V1.119L7.46211%203.16133C7.52645%203.224%207.61011%203.255%207.69345%203.255C7.78078%203.255%207.86778%203.221%207.93311%203.15333C8.06111%203.021%208.05745%202.81%207.92511%202.682L5.25078%200.0983334C5.25045%200.098%205.25045%200.0980001%205.25011%200.0976667L5.24578%200.0936667C5.23378%200.082%205.21878%200.077%205.20578%200.0676667C5.18445%200.0523334%205.16478%200.0353334%205.14045%200.0253334C5.10245%200.00966674%205.06211%200.00233355%205.02145%200.00133355C5.01911%200.00133355%205.01678%200%205.01445%200C5.01211%200%205.00978%200.00133355%205.00745%200.00133355C4.96678%200.00233355%204.92678%200.00966674%204.88845%200.0253334C4.86411%200.0353334%204.84445%200.0523335%204.82312%200.0673335C4.81012%200.0770002%204.79511%200.082%204.78311%200.0936667L4.77911%200.0973333C4.77878%200.0976666%204.77878%200.0976669%204.77845%200.0980002L2.10412%202.68167C1.97178%202.80967%201.96812%203.02067%202.09612%203.153C2.22345%203.28533%202.43545%203.28933%202.56711%203.161L4.68145%201.11867V8.28867C4.68111%208.473%204.83011%208.62233%205.01445%208.62233Z%22%20fill%3D%22white%22%2F%3E%0A%3C%2Fsvg%3E)}@media screen and (max-width:900px){.klevuLandingImageSearchUploadBannerContainer{border:1px solid silver}.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageLeft{display:block;width:100%}.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageLeft .kuSearchedImageLeftContent{background-color:#fff;padding-bottom:0}.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageLeft .kuSearchedImageLeftContent .kuImgBannerTotalResultLabel{font-size:2em}.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageLeft img.kuImgBannerTotalResultUploadImg{max-height:110px}.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageRight{display:block;width:100%}.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageRight .kuSearchedImageRightContent{text-align:left;padding:2%;padding-top:0;padding-left:138px;padding-bottom:20px}.klevuLandingImageSearchUploadBannerContainer .kuSearchedImageRight .kuSearchedImageRightContent .kuTryAnotherPhotoBtn{max-width:250px;margin:0;width:auto}}',
                    type: "css",
                }),
                !0 === e.loadDefaultTemplates &&
                ((e.templateContainer = e.templateContainer && "" !== e.templateContainer ? e.templateContainer : window.document.body),
                    (t.dom.helpers.addElementToParent(e.templateContainer, "div", { id: "klevu-landing-search-theme-templates" }).innerHTML =
                        '<script type="template/klevu" id="klevuLandingTemplateBase"> <div ku-container data-container-id="ku_landing_main_container" data-container-role="main"> <header ku-container data-container-id="ku_landing_main_header_container" data-container-role="header"> <section ku-block data-block-id="ku_landing_main_header_sub_panel"></section> <section ku-block data-block-id="ku_landing_main_header_banner"> <%=helper.render(\'klevuLandingPromotionBanner\',scope,data,"top") %> <%=helper.render(\'klevuLandingPromotionBanner\',scope,data,"bottom") %> </section> <section ku-block data-block-id="ku_landing_main_header_site_navigation"></section> </header> <div class="kuContainer"> <% if(!helper.hasResults(data,"productList") && !helper.hasFilters(data,"productList")) { %> <%=helper.render(\'noResultsFoundLanding\',scope) %> <% } else { %> <%= helper.render(\'klevuLandingTemplateSearchBar\', scope) %> <%=helper.render(\'klevuLandingImageSearchUploadBanner\',scope,data) %> <%= helper.render(\'tab-results\', scope) %> <%= helper.render(\'results\',scope) %> <% } %> <div class="kuClearBoth"></div> </div> <footer ku-container data-container-id="ku_landing_main_footer_container" data-container-role="footer"> <section ku-block data-block-id="ku_landing_main_footer_sub_panel"></section> <section ku-block data-block-id="ku_landing_main_footer_banner"> </section> </footer> </div></script><script type="template/klevu" id="klevuLandingTemplatePagination"> <% if(data.query[dataLocal].result.length > 0 ) { %> <% var productListLimit = data.query[dataLocal].meta.noOfResults; %> <% var productListTotal = data.query[dataLocal].meta.totalResultsFound - 1; %> <div class="kuPagination"> <% if(data.query[dataLocal].meta.offset > 0) { %> <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="0">&lt;&lt;</a>&nbsp; <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(data.query[dataLocal].meta.offset-productListLimit)%>">&lt;</a>&nbsp; <% } %> <% if(data.query[dataLocal].meta.offset > 0) { %> <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(data.query[dataLocal].meta.offset-productListLimit)%>"><%=(Math.ceil(data.query[dataLocal].meta.offset/productListLimit))%></a>&nbsp; <% } %> <a href="javascript:void(0);" class="kuCurrent"><%=(Math.ceil(data.query[dataLocal].meta.offset/productListLimit)+1)%></a>&nbsp; <% if(productListTotal >= data.query[dataLocal].meta.offset+productListLimit) { %> <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(data.query[dataLocal].meta.offset+productListLimit)%>"><%=(Math.ceil(data.query[dataLocal].meta.offset/productListLimit)+2)%></a>&nbsp; <% } %> <% if(productListTotal >= data.query[dataLocal].meta.offset+productListLimit) { %> <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(data.query[dataLocal].meta.offset+productListLimit)%>">&gt;</a>&nbsp; <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(Math.floor(productListTotal/productListLimit)*productListLimit)%>">&gt;&gt;</a> <% } %> </div> <% } %></script><script type="template/klevu" id="klevuLandingTemplateProductBlock"> <% var updatedProductName = dataLocal.name; if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) { if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) { updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku); } } %> <li ku-product-block class="klevuProduct" data-id="<%=dataLocal.id%>"> <div class="kuProdWrap"> <header ku-block data-block-id="ku_landing_result_item_header"> <%=helper.render(\'landingProductBadge\', scope, data, dataLocal) %> </header> <% var desc = [dataLocal.summaryAttribute,dataLocal.packageText,dataLocal.summaryDescription].filter(function(el) { return el; }); desc = desc.join(" "); %> <main ku-block data-block-id="ku_landing_result_item_info"> <div class="kuProdTop"> <div class="klevuImgWrap"> <a data-id="<%=dataLocal.id%>" href="<%=dataLocal.url%>" class="klevuProductClick kuTrackRecentView"> <img src="<%=dataLocal.image%>" origin="<%=dataLocal.image%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" class="kuProdImg"> <%=helper.render(\'landingImageRollover\', scope, data, dataLocal) %> </a> </div> <!-- <div class="kuQuickView"> <button data-id="<%=dataLocal.id%>" class="kuBtn kuBtnLight kuQuickViewBtn" role="button" tabindex="0" area-label="">Quick view</button> </div> --> </div> </main> <footer ku-block="" data-block-id="ku_landing_result_item_footer"> <div class="kuProdBottom"> <div class="kuName kuClippedOne"><a data-id="<%=dataLocal.id%>" href="<%=dataLocal.url%>" class="klevuProductClick kuTrackRecentView" title="<%= updatedProductName %>"><%= updatedProductName %></a></div> <% if(dataLocal.inStock && dataLocal.inStock != "yes") { %> <%=helper.render(\'landingProductStock\', scope, data, dataLocal) %> <% } else { %> <% if(klevu.search.modules.kmcInputs.base.getShowPrices()) { %> <div class="kuPrice"> <% var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants); var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency); var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency); var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency); %> <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %> <div class="kuSalePrice kuStartPrice kuClippedOne"> <span class="klevuQuickPriceGreyText"><%=helper.translate("Starting at")%></span> <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span> </div> <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %> <span class="kuOrigPrice kuClippedOne"> <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %> </span> <span class="kuSalePrice kuSpecialPrice kuClippedOne"> <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%> </span> <% } else if(!Number.isNaN(kuSalePrice)) { %> <span class="kuSalePrice kuSpecialPrice"> <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %> </span> <% } else if(!Number.isNaN(kuPrice)) { %> <span class="kuSalePrice"> <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %> </span> <% } %> <%=helper.render(\'searchResultProductVATLabel\', scope, data, dataLocal) %> </div> <% } %> <% } %> </div> <div class="kuProdAdditional"> <div class="kuProdAdditionalData"> <% if(desc && desc.length) { %> <div class="kuDesc kuClippedTwo"> <%=desc%> </div> <% } %> <%=helper.render(\'landingProductSwatch\',scope,data,dataLocal) %> <%=helper.render(\'klevuLandingProductRating\',scope,data,dataLocal) %> <% var isAddToCartEnabled = klevu.search.modules.kmcInputs.base.getAddToCartEnableValue(); %> <% if(isAddToCartEnabled) { %> <%=helper.render(\'landingPageProductAddToCart\',scope,data,dataLocal) %> <% } %> <div> </div> </footer> </div> </li></script><script type="template/klevu" id="klevuLandingTemplateResultsHeadingTitle"> <% var totalNumberOfResults = klevu.getObjectPath(data,"query."+dataLocal+".meta.totalResultsFound"); var searchedTerm = helper.escapeHTML(data.settings.term); var isCATNAV = data.settings.isCATNAV; if(isCATNAV){ searchedTerm = helper.escapeHTML(data.settings.categoryPath); } %> <div class="kuResultsHeadingTitleContainer"> <strong class="kuResultsNumber"> <%= (totalNumberOfResults) ? totalNumberOfResults : 0 %> </strong> <%= helper.translate((parseInt(totalNumberOfResults) > 1) ? " Results" : " Result") %> <%=helper.translate("found")%> <%= (searchedTerm && searchedTerm.length && searchedTerm != "*") ? helper.translate("for") + " \'<span>"+ klevu.dom.helpers.cleanCatogeryPath(searchedTerm) +"</span>\'" : "" %> </div></script><script type="template/klevu" id="klevuLandingTemplateResults"> <div class="kuResultsListing"> <div class="productList klevuMeta" data-section="productList"> <div class="kuResultContent"> <div class="kuResultWrap <%=(data.query.productList.filters.length == 0 )?\'kuBlockFullwidth\':\'\'%>"> <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content"> <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left"> <div ku-block data-block-id="ku_landing_left_facets"> <%=helper.render(\'filters\',scope,data,"productList") %> </div> <div ku-block data-block-id="ku_landing_left_call_outs"></div> <div ku-block data-block-id="ku_landing_left_banner"></div> </section> <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center"> <header ku-block data-block-id="ku_landing_result_header"> <%=helper.render(\'klevuLandingTemplateResultsHeadingTitle\',scope,data,"productList") %> <%=helper.render(\'filtersTop\',scope,data,"productList") %> <%= helper.render(\'kuFilterTagsTemplate\',scope,data,"productList") %> <% if(helper.hasResults(data,"productList")) { %> <%=helper.render(\'sortBy\',scope,data,"productList") %> <%=helper.render(\'limit\',scope,data,"productList") %> <%=helper.render(\'kuTemplateLandingResultsViewSwitch\',scope,data,"productList") %> <%=helper.render(\'pagination\',scope,data,"productList") %> <% } %> <div class="kuClearBoth"></div> </header> <div ku-block data-block-id="ku_landing_result_items"> <div class="kuResults"> <% if(helper.hasResults(data,"productList")) { %> <ul> <% helper.each(data.query.productList.result,function(key,item){ %> <% if(item.typeOfRecord == "KLEVU_PRODUCT") { %> <%=helper.render(\'productBlock\',scope,data,item) %> <% } %> <% }); %> </ul> <% } else { %> <div class="kuNoRecordsFoundLabelTextContainer"> <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span> </div> <% } %> <div class="kuClearBoth"></div> </div> </div> <div ku-block data-block-id="ku_landing_other_items"> <%=helper.render(\'klevuLandingTemplateInfiniteScrollDown\',scope,data) %> </div> <footer ku-block data-block-id="ku_landing_result_footer"></footer> </section> <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right"> <div ku-block data-block-id="ku_landing_right_facets"></div> <div ku-block data-block-id="ku_landing_right_call_outs"></div> <div ku-block data-block-id="ku_landing_right_banner"></div> </section> </div> </div> </div> </div> <% if(data.query.contentList) { %> <div class="contentList klevuMeta" data-section="contentList" data-result-view="list"> <div class="kuResultContent"> <div class="kuResultWrap <%=(data.query.contentList.filters.length == 0 )?\'kuBlockFullwidth\':\'\'%>"> <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content"> <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left"> <div ku-block data-block-id="ku_landing_left_facets"> <%=helper.render(\'filters\',scope,data,"contentList") %> </div> <div ku-block data-block-id="ku_landing_left_call_outs"></div> <div ku-block data-block-id="ku_landing_left_banner"></div> </section> <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center"> <header ku-block data-block-id="ku_landing_result_header"> <%=helper.render(\'filtersTop\',scope,data,"contentList") %> <%= helper.render(\'kuFilterTagsTemplate\',scope,data,"contentList") %> <% if(helper.hasResults(data,"contentList")) { %> <%=helper.render(\'limit\',scope,data,"contentList") %> <%=helper.render(\'pagination\',scope,data,"contentList") %> <% } %> <div class="kuClearBoth"></div> </header> <div ku-block data-block-id="ku_landing_result_items"> <div class="kuClearBoth"></div> <div class="kuResults"> <% if(helper.hasResults(data,"contentList")) { %> <ul> <% helper.each(data.query.contentList.result,function(key,item){ %> <% if(item.typeOfRecord == "KLEVU_CMS") { %> <%=helper.render(\'contentBlock\',scope,data,item) %> <% }%> <% }); %> </ul> <% } else { %> <div class="kuNoRecordsFoundLabelTextContainer"> <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span> </div> <% } %> <div class="kuClearBoth"></div> </div> </div> <div ku-block data-block-id="ku_landing_other_items"> <%=helper.render(\'klevuLandingTemplateInfiniteScrollDown\',scope,data) %> </div> <footer ku-block data-block-id="ku_landing_result_footer"></footer> </section> <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right"> <div ku-block data-block-id="ku_landing_right_facets"></div> <div ku-block data-block-id="ku_landing_right_call_outs"></div> <div ku-block data-block-id="ku_landing_right_banner"></div> </section> </div> </div> </div> </div> <% } %> </div></script><script type="template/klevu" id="klevuLandingTemplateFilters"> <% if(data.query[dataLocal].filters.length > 0 ) { %> <div class="kuFilters" role="navigation" data-position="left" aria-label="Product Filters" tabindex="0"> <h3 class="kuFiltersTitleHeading"><%=helper.translate("Narrow by")%></h3> <% helper.each(data.query[dataLocal].filters,function(key,filter){ %> <% if(filter.type == "OPTIONS"){ %> <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?\'kuMulticheck\':\'\'%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>> <div class="kuFilterHead <%=(filter.isCollapsed) ? \'kuExpand\' : \'kuCollapse\'%>"> <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %> <%=helper.translate(filter_label)%> </div> <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? \'kuFilterShowAll\': \'\' %> <%=(filter.isCollapsed) ? \'kuFilterCollapse\' : \'\'%>"> <ul> <% helper.each(filter.options,function(key,filterOption){ %> <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>> <a target="_self" href="#" title="<%=helper.escapeHTML(filterOption.name)%>" class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" data-value="<%=helper.escapeHTML(filterOption.value)%>" > <span class="kuFilterIcon"></span> <span class="kufacet-text"><%=filterOption.name%></span> <% if(filterOption.selected ==true) { %> <span class="kuFilterCancel">X</span> <% } else { %> <span class="kuFilterTotal"><%=filterOption.count%></span> <% } %> </a> </li> <% }); %> </ul> <% if(filter.options.length > 5 ) { %> <div class="kuShowOpt" tabindex="-1"> <span class="kuFilterDot"></span><span class="kuFilterDot"></span><span class="kuFilterDot"></span> </div> <% } %> </div> </div> <% } else if(filter.type == "SLIDER") { %> <div class="kuFilterBox klevuFilter" data-filter="<%=filter.key%>"> <div class="kuFilterHead <%=(filter.isCollapsed) ? \'kuExpand\' : \'kuCollapse\'%>"> <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %> <%=helper.translate(filter_label)%> </div> <div class="kuFilterNames sliderFilterNames <%=(filter.isCollapsed) ? \'kuFilterCollapse\' : \'\'%>"> <div class="kuPriceSlider klevuSliderFilter" data-query = "<%=dataLocal%>"> <div data-querykey = "<%=dataLocal%>" class="noUi-target noUi-ltr noUi-horizontal noUi-background kuSliderFilter kuPriceRangeSliderFilter<%=dataLocal%>"></div> </div> </div> </div> <% } else { %> <!-- Other Facets --> <% } %> <% }); %> <!-- <div class="kuFiltersFooter"> <a target="_self" href="javascript:void(0)" class="kuBtn kuFacetsSlideOut kuMobileFilterCloseBtn" role="button" tabindex="0" area-label=""><%=helper.translate("Close")%></a> </div> --> </div> <% } %></script><script type="template/klevu" id="klevuLandingTemplateTopFilters"> <% if(data.query[dataLocal].filters.length > 0 ) { %> <div class="kuFilters kuFiltersTop" role="navigation" data-position="top" aria-label="Product Filters" tabindex="0"> <h3 class="kuFiltersTitleHeading"><%=helper.translate("Narrow by")%></h3> <% helper.each(data.query[dataLocal].filters,function(key,filter){ %> <% if(filter.type == "OPTIONS"){ %> <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?\'kuMulticheck\':\'\'%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>> <div class="kuFilterHead <%=(filter.isCollapsed) ? \'kuExpand\' : \'kuCollapse\'%>"> <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %> <%=helper.translate(filter_label)%> </div> <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length < 5 ) ? \'kuFilterShowAll\': \'\' %> <%=(filter.isCollapsed) ? \'kuFilterCollapse\' : \'\'%>"> <ul> <% helper.each(filter.options,function(key,filterOption){ %> <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>> <a target="_self" href="#" title="<%=helper.escapeHTML(filterOption.name)%>" class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" data-value="<%=helper.escapeHTML(filterOption.value)%>" > <span class="kuFilterIcon"></span> <span class="kufacet-text"><%=filterOption.name%></span> <% if(filterOption.selected ==true) { %> <span class="kuFilterCancel">X</span> <% } else { %> <span class="kuFilterTotal"><%=filterOption.count%></span> <% } %> </a> </li> <% }); %> </ul> <% if(filter.options.length > 5 ) { %> <div class="kuShowOpt" tabindex="-1"> <span class="kuFilterDot"></span><span class="kuFilterDot"></span><span class="kuFilterDot"></span> </div> <% } %> </div> </div> <% } else if(filter.type == "SLIDER") { %> <div class="kuFilterBox klevuFilter" data-filter="<%=filter.key%>"> <div class="kuFilterHead <%=(filter.isCollapsed) ? \'kuExpand\' : \'kuCollapse\'%>"> <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %> <%=helper.translate(filter_label)%> </div> <div class="kuFilterNames sliderFilterNames <%=(filter.isCollapsed) ? \'kuFilterCollapse\' : \'\'%>"> <div class="kuPriceSlider klevuSliderFilter" data-query = "<%=dataLocal%>"> <div data-querykey = "<%=dataLocal%>" class="noUi-target noUi-ltr noUi-horizontal noUi-background kuSliderFilter kuPriceRangeSliderFilter<%=dataLocal%>"></div> </div> </div> </div> <% } else { %> <!-- Other Facets --> <% } %> <% }); %> <!-- <div class="kuFiltersFooter"> <a target="_self" href="javascript:void(0)" class="kuBtn kuFacetsSlideOut kuMobileFilterCloseBtn" role="button" tabindex="0" area-label=""><%=helper.translate("Close")%></a> </div> --> </div> <% } %></script><!-- Landing page add to cart button template--><script type="template/klevu" id="landingPageProductAddToCart"> <% if(dataLocal.inStock != "no") { %> <% var addToCartCaption = klevu.search.modules.kmcInputs.base.getAddToCartButtonCaption(); %> <% if(addToCartCaption && addToCartCaption.indexOf("<img") !== -1) { %> <div class="kuAddtocart" data-id="<%=dataLocal.id%>"> <a target="_self" href="javascript:void(0)" class="kuBtn kuLandingAddToCartBtn" role="button" tabindex="0" area-label="Add to cart"><%= addToCartCaption %></a> </div> <% } else { %> <div class="kuAddtocart" data-id="<%=dataLocal.id%>"> <a target="_self" href="javascript:void(0)" class="kuBtn kuBtnDark kuLandingAddToCartBtn" role="button" tabindex="0" area-label="<%= addToCartCaption %>"><%=helper.translate(addToCartCaption) %></a> </div> <% } %> <% } %></script><!-- Color swatch template for landing page products--><script type="template/klevu" id="landingPageProductColorSwatches"> <% var hasAnyVariantImageAdded = false; if(dataLocal.swatchesInfo && dataLocal.swatchesInfo.length) { helper.each(dataLocal.swatchesInfo,function(key,item) { if(item.variantImage && item.variantImage.length) { hasAnyVariantImageAdded = true; } }); } %> <% if(((!dataLocal.swatchesInfo || !dataLocal.swatchesInfo.length) || !hasAnyVariantImageAdded) && dataLocal.totalVariants) { %> <div class="kuSwatches"> <span class="kuSwatchesVariantCountText">+<%= dataLocal.totalVariants %> <%= helper.translate("variant(s)") %></span> </div> <% } %> <% if(dataLocal.swatchesInfo && dataLocal.swatchesInfo.length && hasAnyVariantImageAdded) { %> <div class="kuSwatches"> <% var totalVariantIndex = dataLocal.swatchesInfo.length; var swatchIndex = 0; helper.each(dataLocal.swatchesInfo,function(key,item) { var isSwatchInfoAdded = false; if(swatchIndex > 2){ return true; } if(item.variantImage && item.variantImage.length) { %> <div class="kuSwatchItem"> <a target="_self" href="javascript:void(0)" data-variant="<%= item.variantId %>" class="kuSwatchLink klevuLandingSwatchColorGrid" <% if(item.variantColor && item.variantColor.length) { %> title="<%= item.variantColor %>" <% } %> style="<% if(item.variantColor && item.variantColor.length) { isSwatchInfoAdded = true; %> background-color:<%= item.variantColor %>; <% } %> <% if(item.variantSwatchImage && item.variantSwatchImage.length) { isSwatchInfoAdded = true; %> background-image: url(\'<%= item.variantSwatchImage %>\'); <% } %> <% if(!isSwatchInfoAdded) { %> background-image: url(\'https://js.klevu.com/klevu-js-v1/img-1-1/default-swatch.jpg\'); <% } %>" > </a> </div> <% swatchIndex++; } }); %> <% if(totalVariantIndex > swatchIndex) { %> <div class="kuSwatchItem kuSwatchMore"> <a target="_self" href="<%=dataLocal.url%>" class="kuSwatchLink"> <span class="kuSwatchMoreText"> +<%= (totalVariantIndex - swatchIndex) %> </span> </a> </div> <% } %> </div> <% } %></script><!-- Color swatch for Product Quick view. --><script type="template/klevu" id="quickViewProductColorSwatches"> <% var hasAnyVariantImageAdded = false; if(dataLocal.swatchesInfo && dataLocal.swatchesInfo.length) { helper.each(dataLocal.swatchesInfo,function(key,item) { if(item.variantImage && item.variantImage.length) { hasAnyVariantImageAdded = true; } }); } %> <% if(((!dataLocal.swatchesInfo || !dataLocal.swatchesInfo.length) || !hasAnyVariantImageAdded) && dataLocal.totalVariants) { %> <span class="productQuick-label"><%=helper.translate("Color Variants:") %></span> <div class="kuSwatches"> <span class="kuSwatchesVariantCountText">+<%= dataLocal.totalVariants %> <%= helper.translate("variant(s)") %></span> </div> <% } %> <% if(dataLocal.swatchesInfo && dataLocal.swatchesInfo.length && hasAnyVariantImageAdded) { %> <div class="productQuick-colorInStock"> <span class="productQuick-label"><%=helper.translate("Color Variants:") %></span> <div class="kuSwatches"> <% var totalVariantIndex = dataLocal.swatchesInfo.length; var swatchIndex = 0; helper.each(dataLocal.swatchesInfo,function(key,item) { var isSwatchInfoAdded = false; if(swatchIndex > 2){ return true; } if(item.variantImage && item.variantImage.length) { %> <div class="kuSwatchItem"> <a target="_self" href="javascript:void(0)" data-variant="<%= item.variantId %>" class="kuSwatchLink klevuLandingSwatchColorGrid" <% if(item.variantColor && item.variantColor.length) { %> title="<%= item.variantColor %>" <% } %> style="<% if(item.variantColor && item.variantColor.length) { isSwatchInfoAdded = true; %> background-color:<%= item.variantColor %>; <% } %> <% if(item.variantSwatchImage && item.variantSwatchImage.length) { isSwatchInfoAdded = true; %> background-image: url(\'<%= item.variantSwatchImage %>\'); <% } %> <% if(!isSwatchInfoAdded) { %> background-image: url(\'https://js.klevu.com/klevu-js-v1/img-1-1/default-swatch.jpg\'); <% } %>" > </a> </div> <% swatchIndex++; } }); %> <% if(totalVariantIndex > swatchIndex) { %> <div class="kuSwatchItem kuSwatchMore"> <a target="_self" href="<%=dataLocal.url%>" class="kuSwatchLink"> <span class="kuSwatchMoreText"> +<%= (totalVariantIndex - swatchIndex) %> </span> </a> </div> <% } %> </div> </div> <% } %></script><!-- Search result Product stock availability label template file--><script type="template/klevu" id="landingSearchResultProductStock"> <% var outOfStockCaption = klevu.search.modules.kmcInputs.base.getOutOfStockCaptionValue(); var productStockStatus = helper.translate(outOfStockCaption); %> <div class="kuClippedOne kuCaptionStockOut"> <%= productStockStatus %> </div></script><!-- Search result Product VAT label template file--><script type="template/klevu" id="searchResultProductVATLabel"> <% var caption = klevu.search.modules.kmcInputs.base.getVatCaption(); var vatCaption = helper.translate("(" + caption + ")"); %> <div class="kuCaptionVat kuClippedOne"><%= vatCaption %></div></script><script type="template/klevu" id="klevuLandingTemplateSortBy"> <div class="kuDropdown kuDropSortBy" role="listbox"> <div class="kuDropdownLabel"><%=helper.translate("Sort by : ")%> <%=helper.translate(helper.getSortBy(dataLocal))%></div> <div class="kuDropdownOptions"> <div class="kuDropOption kuSort" data-value="RELEVANCE" role="option"><%=helper.translate("Relevance")%></div> <div class="kuDropOption kuSort" data-value="PRICE_ASC" role="option"><%=helper.translate("Price: Low to high")%></div> <div class="kuDropOption kuSort" data-value="PRICE_DESC" role="option"><%=helper.translate("Price: High to low")%></div> </div> </div></script> <script type="template/klevu" id="klevuLandingTemplateLimit"> <div class="kuDropdown kuDropItemsPerpage"> <div class="kuDropdownLabel"><%=helper.translate("Items per page : %s",helper.getLimit(dataLocal))%></div> <div class="kuDropdownOptions"> <div class="kuDropOption kuLimit" data-value="12">12</div> <div class="kuDropOption kuLimit" data-value="24">24</div> <div class="kuDropOption kuLimit" data-value="36">36</div> </div> </div></script><script type="template/klevu" id="klevuLandingTemplateContentBlock"> <% var updatedProductName = dataLocal.name; if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) { if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) { updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku); } } var hasImageFound = (dataLocal.image && dataLocal.image != "") ? true : false; if(!hasImageFound){ hasImageFound = (dataLocal.imageUrl && dataLocal.imageUrl != "") ? true : false; } %> <li class="klevuProduct klevuCMSProduct" data-id="<%=dataLocal.id%>"> <div class="kuProdWrap"> <main ku-block data-block-id="ku_landing_result_item_info"> <% if(hasImageFound) { %> <div class="kuProdTop"> <div class="klevuImgWrap"> <a target="_self" href="<%=dataLocal.url%>" class="klevuProductClick"><img origin="<%=dataLocal.image%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" src="<%=dataLocal.image%>" alt="<%=updatedProductName%>" class="kuProdImg"></a> </div> </div> <% } %> </main> <footer class="<%= (hasImageFound) ? \'\' : \'kuCMSProductNoImageFound\' %>" ku-block="" data-block-id="ku_landing_result_item_footer"> <div class="kuProdBottom"> <div class="kuNameDesc"> <div class="kuName"><a title="<%= updatedProductName %>" target="_self" href="<%=dataLocal.url%>" class="klevuProductClick"><%= updatedProductName %></a></div> <div class="kuDesc kuClippedTwo"> <%=dataLocal.shortDesc%> </div> <%=helper.render(\'klevuLandingProductRating\',scope,data,dataLocal) %> </div> </div> </footer> </div> </li></script><script type="template/klevu" id="klevuLandingTemplateTabResults"> <% var isCmsEnabled = klevu.search.modules.kmcInputs.base.getCmsEnabledValue(); %> <div class="kuTabs" role="tablist" style="display:<%= isCmsEnabled ? \'block\' : \'none\' %>"> <% var selectedTab = false; %> <% helper.each(data.query,function(key,query){ %> <% if(query.tab == true) { %> <% if(helper.hasResults(data,query.id) || helper.hasFilters(data,query.id)) { %> <a target="_self" class="kuTab<% if(!selectedTab){ selectedTab = true; %> kuTabSelected<% } %>" data-section="<%=query.id%>" role="tab" tabindex="0" aria-selected="" area-label="Products tab"> <%=helper.translate(query.tabText,data.query[query.id].meta.totalResultsFound)%> </a> <% } else { %> <a target="_self" class="kuTabDeactive" data-section="<%=query.id%>" role="tab" tabindex="0" aria-selected="" area-label="Products tab"> <%=helper.translate(query.tabText,0)%> </a> <% } %> <% } %> <% }); %> </div></script><!-- Search result Product badge template file--><script type="template/klevu" id="searchResultProductBadge"> <%if(dataLocal.stickyLabelHead && dataLocal.stickyLabelHead != "") { %> <div class="kuDiscountBadge"><span class="kuDiscountTxt"><%= dataLocal.stickyLabelHead %></span></div> <% } %></script><!--Landing page banner template--><script type="template/klevu" id="klevuLandingPromotionBanner"> <% var hasNoResultFound = klevu.getObjectPath(data,"modules.promotionalBanner.hasNoResultFound"); %> <% if(data.banners && data.banners[dataLocal] && data.banners[dataLocal].length && !hasNoResultFound) { klevu.each(data.banners[dataLocal], function(index, banner){ %> <div class="kuBannerAd kuBannerContainer"> <a role="banner" area-label="Promotion Banner label" class="kuTrackBannerClick" target="_self" data-id="<%= banner.bannerRef %>" data-name="<%= banner.bannerName %>" data-image="<%= banner.bannerImg %>" data-redirect="<%= banner.redirectUrl %>" href="<%= banner.redirectUrl %>" alt="<%= klevu.dom.helpers.getBannerAltTagText(banner) %>" title="<%= klevu.dom.helpers.getBannerAltTagText(banner) %>" > <img src="<%= banner.bannerImg %>" alt="<%= klevu.dom.helpers.getBannerAltTagText(banner) %>" /> </a> </div> <% }); } %></script><!-- No Results Found template for Landing Search Results --><script type="template/klevu" id="klevuLandingTemplateNoResultFound"> <div class="kuContainer"> <div class="kuLandingNoRecordFound"> <div class="kuLandingNoResults"> <div class="kuLandingNoResultsInner"> <div class="kuLandingNoResultsMessage"> <%= helper.translate(data.noResultsFoundMsg) %> </div> <%=helper.render(\'noResultsLandingPopularProductsTemplate\', scope, data) %> <%=helper.render(\'landingNoResultsFoundBanners\', scope, data) %> <%=helper.render(\'noResultsLandingPopularSearches\', scope, data) %> </div> </div> </div> </div></script><script type="template/klevu" id="klevuNoResultsPopularProductsLanding"> <div class="kuNoResultsProductRecommendationSlider kuNoResultsPopularProducts" data-section="noResultsFoundPopularProductList"> <% var popularProductList = klevu.getObjectPath(data,"query.noResultsFoundPopularProductList.result");%> <% if(popularProductList && popularProductList.length) { %> <div class="klevuNoResultsRecs" title="<%= helper.translate(data.landingNoResultsPopularHeading) %>"> <h3><%= helper.translate(data.landingNoResultsPopularHeading) %> </h3> </div> <div class="klevuNoResultsRecsWrap"> <div class="klevuNoResultsRecsResults"> <div class="klevuNoResultsRecsResultsInner"> <% helper.each(popularProductList, function(key, product){ %> <% var updatedProductName = product.name; if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) { if(klevu.dom.helpers.cleanUpSku(product.sku)) { updatedProductName += klevu.dom.helpers.cleanUpSku(product.sku); } } %> <div class="klevuNoResultsRecs-itemWrap klevuRecommendedProduct klevuProduct" data-id="<%= product.id %>"> <div class="klevuNoResultsRecs-item"> <div class="klevuNoResultsRecs-itemImg"> <a href="<%= product.url %>" class="klevuProductClick kuTrackRecentView klevuNoResultsRecsImg" data-id="<%= product.id %>"> <img src="<%= product.image %>" origin="<%= product.image %>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%= updatedProductName %>" class="prodImg" width="100%" /> </a> </div> </div> <div class="klevuNoResultsRecs-itemDesc"> <a href="<%= product.url %>" title="<%= updatedProductName %>" data-id="<%= product.id %>" class="klevuProductClick kuTrackRecentView klevuNoResultsRecsTitle"><%= updatedProductName %></a> <% if(klevu.search.modules.kmcInputs.base.getShowPrices()) { %> <div class="klevuNoResultsRecs-itemPrice"> <% var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(product.totalVariants); var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(product.startPrice,product.currency); var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(product.salePrice,product.currency); var kuPrice = klevu.dom.helpers.cleanUpPriceValue(product.price,product.currency); %> <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %> <div class="kuSalePrice kuStartPrice"> <span class="klevuQuickPriceGreyText"><%=helper.translate("Starting at")%></span> <span><%=helper.processCurrency(product.currency,parseFloat(product.startPrice))%></span> </div> <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %> <span class="kuOrigPrice kuClippedOne"> <%= helper.processCurrency(product.currency,parseFloat(product.price)) %> </span> <span class="kuSalePrice kuSpecialPrice kuClippedOne"> <%=helper.processCurrency(product.currency,parseFloat(product.salePrice))%> </span> <% } else if(!Number.isNaN(kuSalePrice)) { %> <span class="kuSalePrice kuSpecialPrice"> <%= helper.processCurrency(product.currency,parseFloat(product.salePrice)) %> </span> <% } else if(!Number.isNaN(kuPrice)) { %> <span class="kuSalePrice"> <%= helper.processCurrency(product.currency,parseFloat(product.price)) %> </span> <% } %> <%=helper.render(\'searchResultProductVATLabel\', scope, data, product) %> </div> <% } %> </div> </div> <% }) %> </div> </div> </div> </div> <% } %> </div></script><!-- Popular searches template for Landing Search Results --><script type="template/klevu" id="kuNoResultsPopularSearchesLanding"> <% if(data.noResultsFoundPopularSearches && data.noResultsFoundPopularSearches.length) { %> <div class="kuNoResultsLandingPopularSearchesBlock"> <div class="kuNoResultsLandingPopularSearchTerms"> <span class="klevuHeadingText"><%=helper.translate("Popular Searches")%>:</span> <ul> <% helper.each(data.noResultsFoundPopularSearches, function(key,term){ %> <% if(term && term.length) { %> <% var landingURLPrefix = klevu.getObjectPath(klevu.settings,"url.landing"); if(typeof landingURLPrefix === "undefined" || landingURLPrefix === ""){ landingURLPrefix = "/"; } %> <li class="kuNoResultsLandingPopularSearchTerm" data-value="<%= term %>"> <a href="<%= landingURLPrefix %>?q=<%= term %>" title="<%= term %>"> <%= (data.noResultsFoundPopularSearches.length -1 != key) ? term + ", " : term %> </a> </li> <% } %> <% }); %> </ul> </div> </div> <% } %></script><script type="template/klevu" id="klevuLandingNoResultsFoundBanners"> <% if(data.landingNoResultsFoundBanners && data.landingNoResultsFoundBanners.length) { klevu.each(data.landingNoResultsFoundBanners, function(index, banner){ %> <div class="klevu-no-results-banner-ad"> <a role="banner" class="kuTrackBannerClick" target="_self" data-id="<%= banner.bannerRef %>" data-image="<%= banner.bannerImageUrl %>" data-redirect="<%= banner.redirectUrl %>" href="<%= banner.redirectUrl %>" alt="<%= klevu.dom.helpers.getBannerAltTagText(banner) %>" title="<%= klevu.dom.helpers.getBannerAltTagText(banner) %>" > <img src="<%= banner.bannerImageUrl %>" alt="<%= klevu.dom.helpers.getBannerAltTagText(banner) %>" /> </a> </div> <% }); } %></script><script type="template/klevu" id="kuFilterTagsTemplate"> <% var filterTagsModule = data.filterTags; var filterTagsData = []; if(dataLocal && dataLocal.length){ filterTagsData = filterTagsModule.query[dataLocal].tags; } %> <% if(filterTagsData.length) { %> <div class="kuFilterTagsContainer"> <% helper.each(filterTagsData, function(key,item){ var filterTagItemKey = helper.escapeHTML(helper.translate(item.key)); var filterTagItemLabel = helper.escapeHTML(helper.translate(item.label)); %> <span class="kuFilterTag" data-key="<%= filterTagItemKey %>" > <span title="<%= filterTagItemLabel %>" data-value="<%= filterTagItemLabel %>" class="kuFilterTagKey" > <%= helper.translate(item.label) %> </span> <% helper.each(item.values, function(key,option){ %> <span title="<%= helper.escapeHTML(helper.translate(option)) %>" data-value="<%= helper.escapeHTML(helper.translate(option)) %>" class="kuFilterTagValue"> <%= helper.translate(option) %> <span>&times;</span> </span> <% }); %> </span> <% }); %> <span title="<%= helper.translate("Clear all") %>" class="kuFilterTagClearAll"><%= helper.translate("Clear all") %></span> </div> <% } %></script><script type="template/klevu" id="kuTemplateLandingResultsViewSwitch"> <div class="kuLandingResultsViewSwitchContainer"> <a title="<%= helper.translate("Grid View") %>" class="kuViewSwitch kuGridViewBtn" data-value="grid"> <span class="icon-gridview"></span> </a> <a title="<%= helper.translate("List View") %>" class="kuViewSwitch kuListViewBtn" data-value="list"> <span class="icon-listview"></span> </a> </div></script><script type="template/klevu" id="klevuLandingTemplateSearchBar"> <% var queryParam = klevu.getSetting(klevu, "settings.url.queryParam"); %> <div class="kuSearchResultsSearchBarContainer kuHideExtraSearch"> <form action="/" method="get"> <input type="text" name="<%= queryParam %>" id="search" class="kuSearchInput header-bar__search-input" placeholder="<%=helper.translate("Search text")%>" /> </form> </div></script><script type="template/klevu" id="landingImageRollover"> <% if(dataLocal.imageHover) { %> <img style="display:none;" class="kuProdImgHover" src="<%=dataLocal.imageHover%>" origin="<%=dataLocal.imageHover%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=dataLocal.name%>"> <% } %></script><script type="template/klevu" id="landingQuickViewImageRollover"> <% if(data.selected_product.imageHover) { %> <img style="display:none;" class="kuProdQuickviewImgHover" src="<%=data.selected_product.imageHover%>" origin="<%=data.selected_product.imageHover%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=data.selected_product.name%>"> <% } %></script><script type="template/klevu" id="klevuLandingTemplateInfiniteScrollDown"> <div class="kuInfiniteScrollContainer"> <button class="kuLoadMoreBtn">Load More</button> </div></script><script type="template/klevu" id="klevuLandingImageSearchUploadBanner"> <% if(data.kuResultsPageImageUploadEnabled == true) { %> <div class="klevuLandingImageSearchUploadBannerContainer"> <div class="kuSearchedImageLeft"> <div class="kuSearchedImageLeftContent"> <div class="kuImgBannerTotalResultUploadImgContainer"> <img class="kuImgBannerTotalResultUploadImg" src="<%= data.kuResultsPageImageUploadPath %>" /> </div> <div class="kuImgBannerTotalResultLabelContainer"> <% var totalImageUploadResultFound = klevu.getObjectPath(data,"query."+data.productQueryId+".meta.totalResultsFound"); %> <p class="kuImgBannerTotalResultLabel"> <%= helper.translate("We found %s matches to your uploaded photo.", totalImageUploadResultFound) %> </p> </div> </div> </div> <div class="kuSearchedImageRight"> <div class="kuSearchedImageRightContent"> <button class="kuTryAnotherPhotoBtn"> <span class="kuUploadText upload"><%= helper.translate("Try another photo")%></span> </button> </div> </div> </div> <% } %></script><script type="klevu/template" id="klevuLandingProductRating"> <% if(typeof dataLocal.rating != "undefined" && dataLocal.rating !== "") { %> <div class="klevu-stars-small-l2"> <div class="klevu-rating-l2" style="width:<%=(20*Number(dataLocal.rating))%>%;"></div> </div> <% } %></script>'));
        });
})(klevu),
    !(function () {
        if (document.documentElement.dataset) {
            var e = document.createElement("div");
            return e.setAttribute("data-a-b", "c"), e.dataset && "c" == e.dataset.aB;
        }
    })() &&
    Object.defineProperty(Element.prototype, "dataset", {
        get: function () {
            for (var e = this.attributes, t = {}, a = 0; a < e.length; a++) {
                var r,
                    n,
                    s = e[a];
                s &&
                    s.name &&
                    /^data-\w[\w-]*$/.test(s.name) &&
                    ((r = s.name),
                        (n = s.value),
                        (s = r.substr(5).replace(/-./g, function (e) {
                            return e.charAt(1).toUpperCase();
                        })),
                        Object.defineProperty(t, s, {
                            enumerable: !0,
                            get: function () {
                                return this.value;
                            }.bind({ value: n || "" }),
                            set: function (e, t) {
                                void 0 !== t ? this.setAttribute(e, t) : this.removeAttribute(e);
                            }.bind(this, r),
                        }));
            }
            return t;
        },
    }),
    "function" != typeof NodeList.prototype.forEach && (NodeList.prototype.forEach = Array.prototype.forEach),
    "function" != typeof window.isNaN &&
    (window.isNaN = function (e) {
        e = Number(e);
        return e != e;
    }),
    "function" != typeof Number.isNaN &&
    (Number.isNaN =
        Number.isNaN ||
        function (e) {
            return "number" == typeof e && e != e;
        }),
    (function (o) {
        o.extend({
            baseStructure: {
                base: {
                    initialize: function (e) {
                        (e = o.getSetting(e.kScope.settings, "settings.search.searchBoxTarget")), (e = o.dom.find("[ku-container]", e));
                        o.each(e, function (e, t) {
                            var r = 0,
                                a = t.children;
                            a &&
                                a.length &&
                                o.each(a, function (e, t) {
                                    var a = t.getAttribute("ku-block");
                                    ("" != a && !a) || t.children.length || (t.setAttribute("ku-empty", ""), r++);
                                }),
                                t.children.length === r && t.setAttribute("ku-empty", "");
                        });
                    },
                },
                build: !0,
            },
        }),
            (o.dom.helpers.cleanUpProductImage = function (e) {
                var t = e.getAttribute("src");
                if (t && t.length) {
                    var a,
                        r,
                        n = "";
                    if (
                        ((n = "function" == typeof o.search.modules.kmcInputs.base.getKMCUserOptionsNoImageUrl ? o.search.modules.kmcInputs.base.getKMCUserOptionsNoImageUrl() : "https://js.klevu.com/klevu-js-v1/img-1-1/place-holder.jpg"),
                            -1 < e.src.indexOf(n))
                    )
                        return (e.src = ""), void (e.onerror = "");
                    -1 < e.src.indexOf("/pub")
                        ? ((e.src = e.src.replace("/pub", "")),
                            (e.onerror = function () {
                                (e.src = n), (e.onerror = "");
                            }))
                        : ((a = -1 < e.src.indexOf("/media")),
                            (r = -1 < e.src.indexOf("needtochange/")),
                            (t = e.getAttribute("origin")),
                            r
                                ? (e.src = e.src.replace("needtochange/", ""))
                                : a
                                    ? (e.src = e.src.replace("/media", "/pub/media"))
                                    : t &&
                                    ((e.src = t.replace("needtochange/", "pub/")),
                                        (e.onerror = function () {
                                            (e.src = n), (e.onerror = "");
                                        })));
                } else {
                    n = "";
                    (n = "function" == typeof o.search.modules.kmcInputs.base.getKMCUserOptionsNoImageUrl ? o.search.modules.kmcInputs.base.getKMCUserOptionsNoImageUrl() : "https://js.klevu.com/klevu-js-v1/img-1-1/place-holder.jpg"),
                        (e.src = n),
                        (e.onerror = "");
                }
            }),
            (o.dom.helpers.escapeHTML = function (e) {
                if (e && e.length) {
                    var t = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "/": "&#x2F;", "`": "&#x60;", "=": "&#x3D;" };
                    return String(e).replace(/[&<>"'`=\/]/g, function (e) {
                        return t[e];
                    });
                }
                return e;
            }),
            (o.dom.helpers.cleanCatogeryPath = function (e) {
                if (void 0 === e || "" == e) return e;
                var t = document.createElement("textarea");
                return (t.innerHTML = e), (e = t.value).replace(/;/g, " &gt; ");
            }),
            (o.dom.helpers.readCookie = function (e) {
                var t = " " + document.cookie,
                    a = t.indexOf(" " + e + "="),
                    r = t.indexOf(";", a + 1);
                return -1 === a && (a = t.indexOf(";" + e + "=")), -1 === a || "" === e ? "" : (-1 === (r = t.indexOf(";", a + 1)) && (r = t.length), decodeURIComponent(t.substring(a + e.length + 2, r)));
            }),
            (o.dom.helpers.addClickedProductToCookie = function (e) {
                var t = window.btoa(e),
                    a = o.dom.helpers.readCookie(o.settings.constants.COOKIE_KLEVU_RCP),
                    r = t,
                    n = new Date(),
                    e = "undefined" != typeof klevu_setHttpOnlyToCookies && klevu_setHttpOnlyToCookies ? "; HttpOnly" : "";
                a && "" !== a.trim() && (-1 !== (a = a.split("#-#")).indexOf(t) ? a.splice(a.indexOf(t), 1) : 20 <= a.length && a.splice(-1, 1), a.splice(0, 0, t), (r = a.join("#-#"))),
                    n.setTime(n.getTime() + 31536e6),
                    (document.cookie = o.settings.constants.COOKIE_KLEVU_RCP + "=" + r + ";expires=" + n.toUTCString() + ";path=/;SameSite=None; Secure" + e);
            }),
            (o.dom.helpers.cleanUpSku = function (e) {
                if (void 0 === e || "" == e) return !1;
                e = e.toUpperCase();
                return -1 !== e.indexOf(";;;;") && (e = e.split(";;;;")[0]), "(" === e.slice(0, 1) && ")" === e.slice(-1) ? " " + e : " (" + e + ")";
            }),
            (o.dom.helpers.cleanUpPriceValue = function (e, t) {
                if (void 0 === e || "" == e || !e) return Number("N/A");
                var a = String(e),
                    e = !1;
                return (
                    !t ||
                    "function" != typeof o.search.modules.kmcInputs.base.getPriceFormatterObject ||
                    ((t = o.search.modules.kmcInputs.base.getPriceFormatterObject(t)) && t.decimal && "" != t.decimal && ((a = a.replace(t.decimal, ".")), (e = !0))),
                    e || (a = a.replace(",", ".")),
                    Number(a)
                );
            }),
            (o.dom.helpers.getBannerAltTagText = function (e) {
                var t = "";
                return (
                    e &&
                    (e.bannerAltTag && "" != e.bannerAltTag
                        ? (t = e.bannerAltTag)
                        : e.bannerName && "" != e.bannerName
                            ? (t = e.bannerName)
                            : e.bannerImg && "" != e.bannerImg
                                ? (t = (t = e.bannerImg.match(/.*\/(.*)$/)[1]).replace(/\.[^/.]+$/, ""))
                                : e.bannerImageUrl && "" != e.bannerImageUrl && (t = (t = e.bannerImageUrl.match(/.*\/(.*)$/)[1]).replace(/\.[^/.]+$/, ""))),
                    t
                );
            }),
            (o.dom.helpers.moveObjectElement = function (a, r, n) {
                var s = {},
                    o = n[a];
                delete n[a];
                var i = -1,
                    l = 0;
                return (
                    null == r && (r = ""),
                    Object.keys(n).forEach(function (e) {
                        var t = e,
                            e = n[e];
                        (("" === r && 0 === l) || 1 === i) && ((s[a] = o), (i = 0)), t === r && (i = 1), (s[t] = e), ++l;
                    }),
                    1 === i && (s[a] = o),
                    -1 !== i ? s : n
                );
            }),
            (o.dom.helpers.initializeTabSelection = function (r, e, t, n) {
                var s;
                o.each(o.dom.find(".kuTab", t), function (e, t) {
                    var a = n.getElement("active");
                    t.classList.remove("kuTabSelected"),
                        a &&
                        t.dataset &&
                        t.dataset.section &&
                        a == t.dataset.section &&
                        (t.classList.add("kuTabSelected"),
                            null !== (a = o.dom.helpers.getClosest(t, ".klevuWrap")) && ((r.context.activeQueryId = t.dataset.section), (r.context.section = t.dataset.section), a.classList.add(t.dataset.section + "Active"), (s = !0)));
                }),
                    s ||
                    o.each(o.dom.find(".kuTab", t), function (e, t) {
                        t.classList.remove("kuTabSelected"),
                            0 === e && (t.classList.add("kuTabSelected"), null !== (e = o.dom.helpers.getClosest(t, ".klevuWrap")) && ((r.context.activeQueryId = t.dataset.section), e.classList.add(t.dataset.section + "Active")));
                    });
            }),
            (o.dom.helpers.getQueryStringValue = function (e) {
                return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(e).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
            }),
            (o.dom.helpers.updateQueryStringParameter = function (e, t, a) {
                var r = new RegExp("([?&])" + t + "=.*?(&|$)", "i"),
                    n = -1 !== e.indexOf("?") ? "&" : "?";
                return e.match(r) ? e.replace(r, "$1" + t + "=" + a + "$2") : e + n + t + "=" + a;
            }),
            (o.dom.helpers.isMobileDevice = function () {
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|BB10/i.test(navigator.userAgent)) return !0;
            }),
            o.interactive(function () {
                var e = o.getSetting(o, "settings.url.landing");
                (e && "" != e) || o.setSetting(o, "settings.url.landing", "#");
            });
    })(klevu);
var klevu_currencySymbols = {
    IRR: "Ø±ÛŒØ§Ù„",
    PLN: "z&#322;&nbsp;",
    AUD: "AU$",
    HRK: "kn",
    BRL: "R$",
    NGN: "â‚¦",
    HUF: "FT",
    NOK: "kr",
    CAD: "$",
    NZD: "NZ$",
    ZAR: "R",
    VND: "&#8363;",
    SEK: "kr",
    COP: "$",
    RUB: "Ñ€ÑƒÐ±.",
    MXN: "$",
    SGD: "S$",
    EGP: "LE",
    USD: "$",
    HKD: "HK$",
    IDR: "RP ",
    KRW: "ì›",
    BDT: "&#2547;",
    EUR: "&euro;",
    GBP: "&pound;",
    INR: "&#8377;",
    JPY: "&#165;",
    CNY: "&#165;",
    CRC: "&#8353;",
    ILS: "&#8362;",
},
    klevu_priceFormatters = {
        USD: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "$", appendCurrencyAtLast: !1 },
        EUR: { decimalPlaces: 2, thousandSeparator: ".", decimalSeparator: ",", currencySymbol: "&euro;", appendCurrencyAtLast: !0 },
        GBP: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "&pound;", appendCurrencyAtLast: !1 },
        IRR: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "Ø±ÛŒØ§Ù„", appendCurrencyAtLast: !1 },
        PLN: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "z&#322;&nbsp;", appendCurrencyAtLast: !1 },
        AUD: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "AU$", appendCurrencyAtLast: !1 },
        HRK: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "kn", appendCurrencyAtLast: !0 },
        BRL: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "R$", appendCurrencyAtLast: !1 },
        NGN: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "â‚¦", appendCurrencyAtLast: !1 },
        HUF: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "FT", appendCurrencyAtLast: !0 },
        NOK: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ",", currencySymbol: "kr", appendCurrencyAtLast: !0 },
        CAD: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "$", appendCurrencyAtLast: !1 },
        NZD: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "NZ$", appendCurrencyAtLast: !1 },
        ZAR: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "R", appendCurrencyAtLast: !1 },
        VND: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "&#8363;", appendCurrencyAtLast: !0 },
        SEK: { decimalPlaces: 2, thousandSeparator: ".", decimalSeparator: ",", currencySymbol: "kr", appendCurrencyAtLast: !0 },
        COP: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "$", appendCurrencyAtLast: !1 },
        RUB: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "Ñ€ÑƒÐ±.", appendCurrencyAtLast: !0 },
        MXN: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "$", appendCurrencyAtLast: !1 },
        SGD: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "S$", appendCurrencyAtLast: !1 },
        EGP: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "LE", appendCurrencyAtLast: !1 },
        HKD: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "HK$", appendCurrencyAtLast: !1 },
        IDR: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "RP ", appendCurrencyAtLast: !1 },
        KRW: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "ì›", appendCurrencyAtLast: !0 },
        BDT: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "&#2547;", appendCurrencyAtLast: !1 },
        INR: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "&#8377;", appendCurrencyAtLast: !1 },
        JPY: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "&#165;", appendCurrencyAtLast: !1 },
        CNY: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "&#165;", appendCurrencyAtLast: !1 },
        CRC: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "&#8353;", appendCurrencyAtLast: !1 },
        ILS: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "&#8362;", appendCurrencyAtLast: !1 },
        BGN: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "Ð»Ð²", appendCurrencyAtLast: !1 },
        CZK: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "KÄ", appendCurrencyAtLast: !1 },
        DKK: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "kr.", appendCurrencyAtLast: !1 },
        ISK: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "kr.", appendCurrencyAtLast: !1 },
        RON: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "Lei", appendCurrencyAtLast: !1 },
        CHF: { decimalPlaces: 2, thousandSeparator: ",", decimalSeparator: ".", currencySymbol: "CHF", appendCurrencyAtLast: !1 },
    },
    klevu_urlProtocol = "",
    klevu_javascriptDomain = "";
!(function (s) {
    var e;
    s.isUndefined(s.support.kmc) &&
        !0 !== s.support.kmc &&
        ((e = {
            appendScriptsToHeader: function (e) {
                var t, a, r, n;
                !0 !== s.search.modules.kmcInputs.resourceLoadInitiated &&
                    ((s.search.modules.kmcInputs.resourceLoadInitiated = !0),
                        ((t = s.getSetting(s.settings, "settings.url.kmcData")) && t.length) || (t = "https://js.klevu.com/klevu-js-v1/klevu-js-api/"),
                        (a = 0),
                        (n = function () {
                            a == r.length && ((s.search.modules.kmcInputs.hasAllResourcesLoaded = !0), "function" == typeof klevu_processKMCInputData && klevu_processKMCInputData());
                        }),
                        (r = [
                            { id: e, src: t + e + ".js" },
                            { id: e + "-banner", src: t + e + "-banner.js" },
                            { id: e + "-maps", src: t + e + "-maps.js" },
                        ]).forEach(function (e) {
                            var t = document.createElement("script");
                            (t.type = "text/javascript"),
                                (t.async = !1),
                                (t.src = e.src),
                                (t.id = e.id),
                                (t.onload = function () {
                                    a++, n();
                                }),
                                (t.onerror = function () {
                                    a++, n();
                                }),
                                document.head.appendChild(t);
                        }));
            },
            getBannerList: function () {
                return "undefined" == typeof klevu_banner || s.isEmptyObject(klevu_banner) ? [] : klevu_banner;
            },
            getKeywordUrlMap: function () {
                return "undefined" == typeof klevu_keywordUrlMap || s.isEmptyObject(klevu_keywordUrlMap) ? {} : klevu_keywordUrlMap;
            },
            getMaxNumberOfAutoSuggestions: function () {
                return "undefined" != typeof klevu_maxSuggestionsToShow && klevu_maxSuggestionsToShow ? klevu_maxSuggestionsToShow : 5;
            },
            getMaxNumberOfQuickSearchCategories: function () {
                return "undefined" != typeof klevu_maxCategoriesToShow && klevu_maxCategoriesToShow ? klevu_maxCategoriesToShow : 3;
            },
            getMaxNumberOfProductSuggestions: function () {
                return "undefined" != typeof klevu_productsToShowInSlimLayout ? klevu_productsToShowInSlimLayout : 3;
            },
            getColorSwatchesEnableValue: function () {
                return "undefined" != typeof klevu_uc_userOptions && void 0 !== klevu_uc_userOptions.showProductSwatches && klevu_uc_userOptions.showProductSwatches;
            },
            getFiltersEnableValue: function () {
                return "undefined" == typeof klevu_filtersEnabled || klevu_filtersEnabled;
            },
            getLandingFilterPosition: function () {
                return "undefined" != typeof klevu_uc_userOptions && void 0 !== klevu_uc_userOptions.landingFilterPosition ? klevu_uc_userOptions.landingFilterPosition : "left";
            },
            getFilterMultiSelectValue: function () {
                return "undefined" != typeof klevu_multiSelectFilters && klevu_multiSelectFilters;
            },
            getShowOutOfStockValue: function () {
                return "undefined" != typeof klevu_showOutOfStock && klevu_showOutOfStock;
            },
            getOutOfStockCaptionValue: function () {
                return "undefined" != typeof klevu_uc_userOptions && void 0 !== klevu_uc_userOptions.outOfStockCaption && klevu_uc_userOptions.outOfStockCaption.length ? klevu_uc_userOptions.outOfStockCaption : "";
            },
            getShowPopularSearchesValue: function () {
                return "undefined" != typeof klevu_showPopularSearches && klevu_showPopularSearches;
            },
            getShowRecentSearchesValue: function () {
                return "undefined" != typeof klevu_showRecentSerches && klevu_showRecentSerches;
            },
            getWebstorePopularTermsValue: function () {
                return "undefined" != typeof klevu_webstorePopularTerms && klevu_webstorePopularTerms.length ? klevu_webstorePopularTerms : [];
            },
            getCmsEnabledValue: function () {
                return "undefined" != typeof klevu_cmsEnabled && klevu_cmsEnabled;
            },
            getAddToCartEnableValue: function () {
                return "undefined" != typeof klevu_addToCartEnabled && klevu_addToCartEnabled;
            },
            getAddToCartButtonCaption: function () {
                return "undefined" != typeof klevu_uc_userOptions && void 0 !== klevu_uc_userOptions.addToCartButton ? klevu_uc_userOptions.addToCartButton : "Add to cart";
            },
            getNoResultsFoundObject: function () {
                return "undefined" != typeof klevu_uc_userOptions && void 0 !== klevu_uc_userOptions.noResultsOptions ? klevu_uc_userOptions.noResultsOptions : {};
            },
            getShowSearchOnLandingPageEnableValue: function () {
                return "undefined" != typeof klevu_uc_userOptions && void 0 !== klevu_uc_userOptions.showSearchBoxOnLandingPage && klevu_uc_userOptions.showSearchBoxOnLandingPage;
            },
            getSkuOnPageEnableValue: function () {
                return "undefined" != typeof klevu_showProductCode && "boolean" == typeof klevu_showProductCode && klevu_showProductCode;
            },
            getKMCUserOptionsNoImageUrl: function () {
                return "undefined" != typeof klevu_uc_userOptions && void 0 !== klevu_uc_userOptions.noImageUrl ? klevu_uc_userOptions.noImageUrl : "https://js.klevu.com/klevu-js-v1/img-1-1/place-holder.jpg";
            },
            getShowRolloverImageValue: function () {
                return "undefined" != typeof klevu_uc_userOptions && void 0 !== klevu_uc_userOptions.showRolloverImage && klevu_uc_userOptions.showRolloverImage;
            },
            getVatCaption: function () {
                return "undefined" != typeof klevu_uc_userOptions && void 0 !== klevu_uc_userOptions.vatCaption && klevu_uc_userOptions.vatCaption;
            },
            getShowPrices: function () {
                return "undefined" != typeof klevu_showPrices && "boolean" == typeof klevu_showPrices && klevu_showPrices;
            },
            getShowPriceSlider: function () {
                return "undefined" != typeof klevu_showPriceSlider && "boolean" == typeof klevu_showPriceSlider && klevu_showPriceSlider;
            },
            getPriceIntervalValue: function () {
                return "undefined" != typeof klevu_uc_userOptions && void 0 !== klevu_uc_userOptions.priceInterval ? klevu_uc_userOptions.priceInterval : 500;
            },
            getFacetRangeFilterSettings: function () {
                var e = !1,
                    t = s.search.modules.kmcInputs.base.getShowPrices(),
                    a = s.search.modules.kmcInputs.base.getShowPriceSlider(),
                    r = s.search.modules.kmcInputs.base.getPriceIntervalValue();
                return t && ((e = { key: "klevu_price" }), a ? (e.minMax = "true") : (e.rangeInterval = r)), e;
            },
            getPriceFormatterObject: function (e) {
                var t = {},
                    a = "undefined" != typeof klevu_uc_userOptions && klevu_uc_userOptions.priceFormatter ? klevu_uc_userOptions.priceFormatter : void 0;
                if (void 0 === a || "object" != typeof a) {
                    if (void 0 === klevu_priceFormatters || !klevu_priceFormatters[e]) return (t = { string: e, format: "%s %s" });
                    a = klevu_priceFormatters[e];
                } else void 0 !== klevu_priceFormatters && klevu_priceFormatters[e] && ((e = klevu_priceFormatters[e]), (a = s.extend(!0, e, a)));
                return (
                    void 0 !== a.decimalPlaces && "" !== a.decimalPlaces && (t.precision = a.decimalPlaces),
                    void 0 !== a.thousandSeparator && (t.thousand = a.thousandSeparator),
                    void 0 !== a.decimalSeparator && "" !== a.decimalSeparator && (t.decimal = a.decimalSeparator),
                    void 0 !== a.currencySymbol && "" !== a.currencySymbol && (t.string = a.currencySymbol),
                    void 0 !== a.appendCurrencyAtLast && "" !== a.appendCurrencyAtLast && (t.atEnd = a.appendCurrencyAtLast),
                    void 0 !== a.format && "" !== a.format ? (t.format = a.format) : (t.format = "%s %s"),
                    t
                );
            },
            getEnablePersonalisationInSearch: function () {
                return "undefined" != typeof klevu_uc_userOptions && void 0 !== klevu_uc_userOptions.enablePersonalisationInSearch && klevu_uc_userOptions.enablePersonalisationInSearch;
            },
            getEnablePersonalisationInCatNav: function () {
                return "undefined" != typeof klevu_uc_userOptions && void 0 !== klevu_uc_userOptions.enablePersonalisationInCatNav && klevu_uc_userOptions.enablePersonalisationInCatNav;
            },
            getShowRecentlyViewedItemsValue: function () {
                var e = { showRecentlyViewedItems: !1, showRecentlyViewedItemsLimit: 10, showRecentlyViewedItemsCaption: "" };
                return (
                    "undefined" != typeof klevu_uc_userOptions &&
                    (void 0 !== klevu_uc_userOptions.showRecentlyViewedItems && (e.showRecentlyViewedItems = klevu_uc_userOptions.showRecentlyViewedItems),
                        void 0 !== klevu_uc_userOptions.showRecentlyViewedItemsCaption && (e.showRecentlyViewedItemsCaption = klevu_uc_userOptions.showRecentlyViewedItemsCaption),
                        void 0 !== klevu_uc_userOptions.showRecentlyViewedItemsLimit && (e.showRecentlyViewedItemsLimit = klevu_uc_userOptions.showRecentlyViewedItemsLimit)),
                    e
                );
            },
            getShowTrendingProductsValue: function () {
                var e = { showTrendingProducts: !1, showTrendingProductsLimit: 10, showTrendingProductsCaption: "" };
                return (
                    "undefined" != typeof klevu_uc_userOptions &&
                    (void 0 !== klevu_uc_userOptions.showTrendingProducts && (e.showTrendingProducts = klevu_uc_userOptions.showTrendingProducts),
                        void 0 !== klevu_uc_userOptions.showTrendingProductsCaption && (e.showTrendingProductsCaption = klevu_uc_userOptions.showTrendingProductsCaption),
                        void 0 !== klevu_uc_userOptions.showTrendingProductsLimit && (e.showTrendingProductsLimit = klevu_uc_userOptions.showTrendingProductsLimit)),
                    e
                );
            },
            getQuickSearchLayoutType: function () {
                return "undefined" != typeof klevu_layoutType && "" !== klevu_layoutType ? klevu_layoutType : "slim";
            },
            getQuickSearchLayoutView: function () {
                return "undefined" != typeof klevu_layoutView && "" !== klevu_layoutView ? klevu_layoutView : "grid";
            },
            isQuickFacetedLayoutFilterOnLeft: function () {
                return "undefined" == typeof klevu_filtersOnLeft || klevu_filtersOnLeft;
            },
            showProductRatingQuick: function () {
                return void 0 === klevu_uc_userOptions.showRatingsOnQuickSearches || klevu_uc_userOptions.showRatingsOnQuickSearches;
            },
            showProductRatingLanding: function () {
                return void 0 === klevu_uc_userOptions.showRatingsOnSearchResultsLandingPage || klevu_uc_userOptions.showRatingsOnQuickSearches;
            },
            showProductRatingCatnav: function () {
                return void 0 === klevu_uc_userOptions.showRatingsOnCategoryPage || klevu_uc_userOptions.showRatingsOnQuickSearches;
            },
        }),
            s.extend(!0, s.search.modules, { kmcInputs: { base: e, build: !0, hasAllResourcesLoaded: !1, resourceLoadInitiated: !1 } }));
})(klevu),
    klevu.isUndefined(klevu.support.kmc) &&
    !0 !== klevu.support.kmc &&
    (klevu.coreEvent.build({
        name: "setRemoteKMCInputs",
        fire: function () {
            return !!klevu.getGlobalSetting("search.apiKey", klevu.getGlobalSetting("global.apiKey", !1));
        },
        maxCount: 1e3,
        delay: 30,
    }),
        klevu.coreEvent.attach("setRemoteKMCInputs", {
            name: "assignAPIKeyForCookie",
            fire: function () {
                var e = klevu.getGlobalSetting("search.apiKey", klevu.getGlobalSetting("global.apiKey")).replace(/-/g, "_");
                klevu.setObjectPath(klevu.settings, "constants.COOKIE_KLEVU_RCP", "klevu_rcp_" + e);
            },
        }),
        klevu.coreEvent.attach("setRemoteKMCInputs", {
            name: "initKMCInputs",
            fire: function () {
                (klevu_urlProtocol = klevu.settings.url.protocol), klevu.search.modules.kmcInputs.base.appendScriptsToHeader(klevu.getGlobalSetting("search.apiKey", klevu.getGlobalSetting("global.apiKey")));
            },
        })),
    klevu.coreEvent.build({
        name: "encodeAnalyticsRequestAttributeValue",
        fire: function () {
            return !klevu.isUndefined(klevu.analytics) && !klevu.isUndefined(klevu.analytics.build);
        },
    }),
    klevu.coreEvent.attach("encodeAnalyticsRequestAttributeValue", function () {
        (klevu.analytics.base.getScope().encodeExcludeAttrList = ["klevu_term", "klevu_keywords", "klevu_totalResults", "klevu_limit", "klevu_pageNumber", "klevu_apiKey"]),
            (klevu.analytics.base.getScope().encodeListAttrs = function (a) {
                var e = klevu.getObjectPath(a, "request.analytics");
                e &&
                    klevu.each(e, function (e, t) {
                        -1 < klevu.analytics.base.getScope().encodeExcludeAttrList.indexOf(e) || (a.request.analytics[e] = encodeURIComponent(t));
                    });
            }),
            klevu.analytics.base.getScope().chains.events.term.addAfter("termRequestCheck", {
                name: "encodeAttributes",
                fire: function (e, t) {
                    klevu.analytics.base.getScope().encodeListAttrs(e);
                },
            }),
            klevu.analytics.base.getScope().chains.events.click.addAfter("clickRequestCheck", {
                name: "encodeAttributes",
                fire: function (e, t) {
                    klevu.analytics.base.getScope().encodeListAttrs(e);
                },
            }),
            klevu.analytics.base.getScope().chains.events.catview.addAfter("viewRequestCheck", {
                name: "encodeAttributes",
                fire: function (e, t) {
                    klevu.analytics.base.getScope().encodeListAttrs(e);
                },
            }),
            klevu.analytics.base.getScope().chains.events.catclick.addAfter("clickRequestCheck", {
                name: "encodeAttributes",
                fire: function (e, t) {
                    klevu.analytics.base.getScope().encodeListAttrs(e);
                },
            }),
            klevu.analytics.base.getScope().chains.events.buy.addAfter("buyRequestCheck", {
                name: "encodeAttributes",
                fire: function (e, t) {
                    klevu.analytics.base.getScope().encodeListAttrs(e);
                },
            });
    }),
    (function (u) {
        var e = {
            storage: { dictionary: "analytics-util", term: "termList", click: "clickList", categoryClick: "categoryClickList", buy: "buyList" },
            getTermOptions: function (e, t) {
                var a = { klevu_term: e.data.context.termOriginal || "*", klevu_pageNumber: "", klevu_src: "", klevu_limit: "", klevu_sort: "", klevu_totalResults: "0", klevu_typeOfQuery: "WILDCARD_AND", filters: !1 },
                    r = e.data.context.section;
                if (!r) return a;
                var n = u.getObjectPath(e.data, "request.current.recordQueries");
                !(n = n || u.getObjectPath(e.data, "request.original.recordQueries")) ||
                    ((i = n.filter(function (e) {
                        return e.id == r;
                    })[0]) &&
                        ((a.klevu_limit = i.settings.limit), (a.klevu_sort = i.settings.sort), (a.klevu_src = "[[typeOfRecord:" + i.settings.typeOfRecords[0] + "]]")));
                var s,
                    o,
                    i = e.data.response.current.queryResults;
                return (
                    !i ||
                    ((e = i.filter(function (e) {
                        return e.id == r;
                    })[0]) &&
                        ((a.klevu_totalResults = e.meta.totalResultsFound),
                            (a.klevu_typeOfQuery = e.meta.typeOfSearch),
                            (i = e.meta.noOfResults),
                            (a.klevu_pageNumber = Math.ceil(e.meta.offset / i) + 1),
                            t &&
                            ((o = !(s = " [[")),
                                u.each(e.filters, function (e, a) {
                                    "SLIDER" == a.type
                                        ? null !== a.start && void 0 !== a.start && null !== a.end && void 0 !== a.end && ((a.start == a.min && a.end == a.max) || (o && (s += ";;"), (o = !0), (s += a.key + ":" + a.start + " - " + a.end)))
                                        : u.each(a.options, function (e, t) {
                                            t.selected && (o && (s += ";;"), (o = !0), (s += a.key + ":" + t.name));
                                        });
                                }),
                                (s += "]]"),
                                o && ((a.filters = !0), (a.klevu_term += s))))),
                    a
                );
            },
            getProductDetailsFromId: function (t, e) {
                var a,
                    r = e.data.context.section;
                return (
                    (e = e.data.response.current.queryResults) &&
                    (!(e = e.filter(function (e) {
                        return e.id == r;
                    })[0]) ||
                        ((e = e.records.filter(function (e) {
                            return e.id == t;
                        })[0]) &&
                            (a = e))),
                    a
                );
            },
            getDetailsFromURLAndName: function (t, a, e, r) {
                var n = {};
                return (
                    (e = e.data.response.current.queryResults) &&
                    (!(e = e.filter(function (e) {
                        return e.id == r;
                    })[0]) ||
                        ((e = e.records.filter(function (e) {
                            return e.name == a && e.url == t;
                        })[0]) &&
                            (n = e))),
                    n
                );
            },
            getCategoryViewOptions: function (e) {
                var a = { klevu_categoryName: "", klevu_src: "", klevu_categoryPath: "", klevu_productIds: "", klevu_pageStartsFrom: "", filters: !1 },
                    t = e.data.context.section;
                if (!t) return a;
                var r = u.getObjectPath(e.data, "request.current.recordQueries");
                !(r = r || u.getObjectPath(e.data, "request.original.recordQueries")) ||
                    ((n = r.filter(function (e) {
                        return e.id == t;
                    })[0]) &&
                        (n.settings.query && n.settings.query.categoryPath && (a.klevu_categoryName = n.settings.query.categoryPath),
                            (a.klevu_limit = n.settings.limit),
                            (a.klevu_sort = n.settings.sort),
                            (a.klevu_src = "[[typeOfRecord:" + n.settings.typeOfRecords[0] + "]]")));
                var n = u.getObjectPath(u.extensions, "abTest.catnav." + a.klevu_categoryName.toLowerCase(), !1);
                return (
                    n && ((a.klevu_abTestId = n.abTestId), (a.klevu_abTestVariantId = n.abTestVariantId), (a.klevu_abTestSource = n.sourceId.toLowerCase())),
                    (a.klevu_categoryPath = a.klevu_categoryName),
                    (a.klevu_categoryName = a.klevu_categoryName ? a.klevu_categoryName.split(";").pop() : ""),
                    !(e = e.data.response.current.queryResults) ||
                    ((e = e.filter(function (e) {
                        return e.id == t;
                    })[0]) &&
                        ((a.klevu_pageStartsFrom = e.meta.offset),
                            e.records &&
                            e.records.length &&
                            ((a.klevu_productIds = ""),
                                u.each(e.records, function (e, t) {
                                    a.klevu_productIds && "" !== a.klevu_productIds && t.id && (a.klevu_productIds += ","), t.id && (a.klevu_productIds += t.id);
                                })))),
                    a
                );
            },
            registerAutoSuggestProductClickEvent: function (s, o, i, l) {
                var c = u.getSetting(s.settings, "settings.search.searchBoxTarget");
                u.each(u.dom.find(".trackProductClick", c), function (e, n) {
                    u.event.attach(
                        n,
                        "click",
                        function (e) {
                            var t,
                                a = n.dataset.id,
                                r = u.dom.find(o, c)[0];
                            r && (t = r.dataset.section),
                                t &&
                                ((s.data.context.section = t),
                                    a &&
                                    (!(t = u.analyticsUtil.base.getProductDetailsFromId(a, s)) ||
                                        ((a = u.analyticsUtil.base.getTermOptions(s)) &&
                                            ((a.klevu_keywords = a.klevu_term),
                                                (a.klevu_productId = t.id),
                                                void 0 !== t.itemGroupId && (a.klevu_productGroupId = t.itemGroupId),
                                                (a.klevu_productVariantId = t.id),
                                                (a.klevu_productName = t.name),
                                                (a.klevu_productUrl = t.url),
                                                (a.klevu_src = "[[typeOfRecord:" + t.typeOfRecord + ";;template:quick-search]]"),
                                                delete a.klevu_term,
                                                u.analyticsUtil.base.storeAnalyticsEvent(i, l, a)))));
                        },
                        !0
                    );
                });
            },
            registerAutoSuggestTermEvent: function (n, e, s, o) {
                var i = u.getSetting(n.settings, "settings.search.searchBoxTarget");
                u.each(u.dom.find(e, i), function (e, t) {
                    u.each(u.dom.find(".klevu-track-click", t), function (e, r) {
                        u.event.attach(r, "click", function (e) {
                            var t,
                                a = u.dom.find(".klevuQuickSearchResults", i)[0];
                            a && (t = a.dataset.section),
                                t &&
                                ((n.data.context.section = t),
                                    (a = r.dataset.content),
                                    (t = u.analyticsUtil.base.getTermOptions(n, !0)) &&
                                    ((t.klevu_originalTerm = t.klevu_term), (t.klevu_term = a), (t.klevu_src = "[[template:ac-suggestions]]"), u.analyticsUtil.base.storeAnalyticsEvent(s, o, t)));
                        });
                    });
                });
            },
            registerAutoSuggestPageClickEvent: function (n, e, s, o, i) {
                var t = u.getSetting(n.settings, "settings.search.searchBoxTarget");
                u.each(u.dom.find(e, t), function (e, t) {
                    u.each(u.dom.find(".klevu-track-click", t), function (e, r) {
                        u.event.attach(r, "click", function (e) {
                            var t = r.dataset.url,
                                a = r.dataset.name,
                                t = u.analyticsUtil.base.getDetailsFromURLAndName(t, a, n, s),
                                a = u.analyticsUtil.base.getTermOptions(n);
                            a &&
                                ((a.klevu_keywords = a.klevu_term),
                                    (a.klevu_productId = t.id),
                                    void 0 !== t.itemGroupId && (a.klevu_productGroupId = t.itemGroupId),
                                    (a.klevu_productVariantId = t.id),
                                    (a.klevu_productName = t.name),
                                    (a.klevu_productUrl = t.url),
                                    (a.klevu_src = "[[typeOfRecord:" + t.typeOfRecord + ";;template:quick-search]]"),
                                    delete a.klevu_term,
                                    u.analyticsUtil.base.storeAnalyticsEvent(o, i, a));
                        });
                    });
                });
            },
            registerLandingProductClickEvent: function (n, s, o) {
                var e = u.getSetting(n.settings, "settings.search.searchBoxTarget");
                u.each(u.dom.find(".klevuProductClick", e), function (e, r) {
                    u.event.attach(r, "click", function (e) {
                        var t,
                            a = u.dom.helpers.getClosest(r, ".klevuProduct");
                        !a ||
                            null === a ||
                            ((t = a.dataset.id) &&
                                (!(a = u.analyticsUtil.base.getProductDetailsFromId(t, n)) ||
                                    ((t = u.analyticsUtil.base.getTermOptions(n)) &&
                                        ((t.klevu_keywords = t.klevu_term),
                                            (t.klevu_productId = a.id),
                                            void 0 !== a.itemGroupId && (t.klevu_productGroupId = a.itemGroupId),
                                            (t.klevu_productVariantId = a.id),
                                            (t.klevu_productName = a.name),
                                            (t.klevu_productUrl = a.url),
                                            (t.klevu_src = "[[typeOfRecord:" + a.typeOfRecord + ";;template:landing]]"),
                                            delete t.klevu_term,
                                            u.analyticsUtil.base.storeAnalyticsEvent(s, o, t)))));
                    });
                });
            },
            registerCategoryProductClickEvent: function (n, s, o) {
                var e = u.getSetting(n.settings, "settings.search.searchBoxTarget");
                u.each(u.dom.find(".klevuProductClick", e), function (e, r) {
                    u.event.attach(r, "click", function (e) {
                        var t,
                            a = u.dom.helpers.getClosest(r, ".klevuProduct");
                        a &&
                            null !== a &&
                            (!(t = a.dataset.id) ||
                                ((a = u.analyticsUtil.base.getProductDetailsFromId(t, n)) &&
                                    (((t = u.analyticsUtil.base.getCategoryViewOptions(n)).klevu_productId = a.id),
                                        void 0 !== a.itemGroupId && (t.klevu_productGroupId = a.itemGroupId),
                                        (t.klevu_productVariantId = a.id),
                                        (t.klevu_productName = a.name),
                                        (t.klevu_productUrl = a.url),
                                        (t.klevu_src = "[[typeOfRecord:" + a.typeOfRecord + ";;template:category]]"),
                                        (t.klevu_productSku = a.sku),
                                        (t.klevu_salePrice = a.salePrice),
                                        (t.klevu_productRatings = a.rating),
                                        (t.klevu_productPosition = t.klevu_pageStartsFrom),
                                        delete t.klevu_term,
                                        delete t.klevu_pageStartsFrom,
                                        u.analyticsUtil.base.storeAnalyticsEvent(s, o, t))));
                    });
                });
            },
            registerAnalyticsClickEvent: function (n, s, o, e, i, l, c) {
                (e = (e = u.dom.find(e)) && e.length ? e[0] : void 0) &&
                    u.each(u.dom.find(".klevuProductClick", e), function (e, r) {
                        u.event.attach(r, "click", function (e) {
                            var t,
                                a = u.dom.helpers.getClosest(r, i);
                            !a ||
                                null === a ||
                                ((t = a.dataset.id) &&
                                    (!(a = u.analyticsUtil.base.getProductDetailsFromId(t, n)) ||
                                        ((t = u.analyticsUtil.base.getTermOptions(n)) &&
                                            ((t.klevu_keywords = l),
                                                (t.klevu_productId = a.id),
                                                void 0 !== a.itemGroupId && (t.klevu_productGroupId = a.itemGroupId),
                                                (t.klevu_productVariantId = a.id),
                                                (t.klevu_productName = a.name),
                                                (t.klevu_productUrl = a.url),
                                                (t.klevu_src = "[[typeOfRecord:" + a.typeOfRecord + ";;template:" + c + "]]"),
                                                delete t.klevu_term,
                                                u.analyticsUtil.base.storeAnalyticsEvent(s, o, t)))));
                        });
                    });
            },
            sendAnalyticsEventsFromStorage: function (e, a) {
                var t = u.dictionary(e);
                t.setStorage("local"),
                    t.mergeFromGlobal(),
                    (e = t.getElement(a)) &&
                    e != a &&
                    ((e = JSON.parse(e)),
                        u.each(e, function (e, t) {
                            delete t.filters,
                                a == u.analyticsUtil.base.storage.click
                                    ? u.analyticsEvents.click && u.analyticsEvents.click(t)
                                    : a == u.analyticsUtil.base.storage.buy
                                        ? u.analyticsEvents.buy && u.analyticsEvents.buy(t)
                                        : a == u.analyticsUtil.base.storage.categoryClick
                                            ? u.analyticsEvents.catclick && u.analyticsEvents.catclick(t)
                                            : a == u.analyticsUtil.base.storage.bannerClick
                                                ? u.analyticsEvents.bannerClick && u.analyticsEvents.bannerClick(t)
                                                : a == u.analyticsUtil.base.storage.personalizedSearchTracking
                                                    ? u.analyticsEvents.personalizedSearchTracking && u.analyticsEvents.personalizedSearchTracking(t)
                                                    : u.analyticsEvents.term(t);
                        }),
                        t.addElement(a, ""),
                        t.mergeToGlobal());
            },
            storeAnalyticsEvent: function (e, t, a) {
                var r,
                    n = u.dictionary(e);
                n &&
                    a &&
                    (n.setStorage("local"), n.mergeFromGlobal(), (r = []), (e = n.getElement(t)) && e.length && e != t ? (e = JSON.parse(e)).length && (e.push(a), (r = e)) : r.push(a), n.addElement(t, JSON.stringify(r)), n.mergeToGlobal());
            },
            getDataTrackingOptions: function (e) {
                return { klevu_term: e.data.context.termOriginal || "*", klevu_bannerId: "", klevu_bannerName: "", klevu_image: "", klevu_target: "", klevu_userID: "", klevu_loginCustomerEmail: "", klevu_request: "click", type: "banner" };
            },
        };
        u.analyticsUtil && u.analyticsUtil.base ? u.extend(!0, u.analyticsUtil.base, e) : u.extend({ analyticsUtil: { base: e } }), (u.analyticsUtil.build = !0);
    })(klevu),
    klevu.coreEvent.build({
        name: "analyticsPowerUp",
        fire: function () {
            return !!(klevu.getSetting(klevu.settings, "settings.powerUp.analyticsUtil", !1) && klevu.analytics.build && klevu.analyticsUtil.build);
        },
        maxCount: 500,
        delay: 30,
    }),
    klevu.interactive(function () {
        void 0 === klevu.getSetting(klevu, "settings.powerUp.analyticsUtil") && klevu.setSetting(klevu, "settings.powerUp.analyticsUtil", !0);
    }),
    klevu.coreEvent.build({
        name: "analyticsSendStoredData",
        fire: function () {
            return !!(klevu.getSetting(klevu.settings, "settings.powerUp.analyticsUtil", !1) && klevu.analytics.build && klevu.analyticsUtil.build && klevu.analyticsUtil.base.sendAnalyticsEventsFromStorage);
        },
        maxCount: 50,
        delay: 300,
    }),
    klevu.coreEvent.attach("analyticsSendStoredData", {
        name: "attachSendRequestEvent",
        fire: function () {
            klevu.analyticsUtil.base.sendAnalyticsEventsFromStorage(klevu.analyticsUtil.base.storage.dictionary, klevu.analyticsUtil.base.storage.term),
                klevu.analyticsUtil.base.sendAnalyticsEventsFromStorage(klevu.analyticsUtil.base.storage.dictionary, klevu.analyticsUtil.base.storage.click),
                klevu.analyticsUtil.base.sendAnalyticsEventsFromStorage(klevu.analyticsUtil.base.storage.dictionary, klevu.analyticsUtil.base.storage.categoryClick),
                klevu.analyticsUtil.base.sendAnalyticsEventsFromStorage(klevu.analyticsUtil.base.storage.dictionary, klevu.analyticsUtil.base.storage.buy);
        },
    }),
    (function (a) {
        var e = {
            updateImagePath: function (e) {
                (e = e.data),
                    (e = a.getObjectPath(e, "response.current.queryResults")) &&
                    a.each(e, function (e, t) {
                        t &&
                            t.records &&
                            a.each(t.records, function (e, t) {
                                "undefined" == typeof klevu_pubIsInUse || klevu_pubIsInUse ? (t.image = t.image ? t.image.replace("needtochange/", "") : "") : (t.image = t.image ? t.image.replace("needtochange/", "pub/") : "");
                            });
                    });
            },
        };
        a.extend(!0, a.search.modules, { productDataModification: { base: e, build: !0 } });
    })(klevu),
    klevu.coreEvent.build({
        name: "productDataModificationModuleBuild",
        fire: function () {
            return !!(klevu.search.modules && klevu.search.modules.productDataModification && klevu.search.modules.productDataModification.build);
        },
        maxCount: 500,
        delay: 30,
    }),
    (function (a) {
        function r(e, t) {
            e = a.getSetting(e.kScope.settings, "settings.search.searchBoxTarget");
            "start" == t ? e.classList.add("searchRequestLoading") : e.classList.remove("searchRequestLoading");
        }
        a.extend(!0, a.search.modules, {
            requestLoader: {
                base: {
                    initSearchRequestLoader: function (e) {
                        e.chains.request.send.add({
                            name: "startLoader",
                            fire: function (e, t) {
                                r(t, "start");
                            },
                        }),
                            e.chains.response.success.add({
                                name: "stopLoader",
                                fire: function (e, t) {
                                    r(t, "stop");
                                },
                            }),
                            e.chains.response.fail.add({
                                name: "stopLoader",
                                fire: function (e, t) {
                                    r(t, "stop");
                                },
                            }),
                            e.chains.response.done.add({
                                name: "stopLoader",
                                fire: function (e, t) {
                                    r(t, "stop");
                                },
                            }),
                            e.chains.response.ajax.success.add({
                                name: "stopLoader",
                                fire: function (e, t) {
                                    r(t, "stop");
                                },
                            }),
                            e.chains.response.ajax.fail.add({
                                name: "stopLoader",
                                fire: function (e, t) {
                                    r(t, "stop");
                                },
                            }),
                            e.chains.response.ajax.done.add({
                                name: "stopLoader",
                                fire: function (e, t) {
                                    r(t, "stop");
                                },
                            });
                    },
                },
                build: !0,
            },
        });
    })(klevu),
    (function (o) {
        var e = {
            attachFacetItemsClickEvent: function (e) {
                (e = o.getSetting(e.settings, "settings.search.searchBoxTarget")),
                    o.each(o.dom.find(".klevuFilterOption", e), function (e, t) {
                        o.event.attach(
                            t,
                            "click",
                            function (e) {
                                (e = e || window.event).preventDefault();
                                var t = o.dom.helpers.getClosest(this, ".klevuFilter");
                                null === t ||
                                    "true" !== t.dataset.singleselect ||
                                    this.classList.contains("klevuFilterOptionActive") ||
                                    ((a = o.dom.find(".klevuFilterOptionActive", t)),
                                        o.each(a, function (e, t) {
                                            t.classList.remove("klevuFilterOptionActive");
                                        })),
                                    this.classList.toggle("klevuFilterOptionActive");
                                var a,
                                    n,
                                    r,
                                    s = o.dom.helpers.getClosest(this, ".klevuTarget");
                                null !== s &&
                                    (((t = s.kElem).kScope.data = t.kObject.resetData(t.kElem)),
                                        (t.kScope.data.context.keyCode = 0),
                                        (t.kScope.data.context.eventObject = e),
                                        (t.kScope.data.context.event = "keyUp"),
                                        (t.kScope.data.context.preventDefault = !1),
                                        null !== (a = o.dom.helpers.getClosest(this, ".klevuMeta")) &&
                                        ((n = []),
                                            0 < (s = o.dom.find(".klevuFilterOptionActive", a)).length &&
                                            o.each(s, function (e, t) {
                                                var a,
                                                    r = o.dom.helpers.getClosest(t, ".klevuFilter");
                                                null !== r &&
                                                    (0 ===
                                                        (a = n.filter(function (e) {
                                                            return e.key == r.dataset.filter;
                                                        })).length
                                                        ? n.push({
                                                            key: r.dataset.filter,
                                                            settings: { singleSelect: !o.isUndefined(r.dataset.singleselect) && r.dataset.singleselect },
                                                            values: [!o.isUndefined(t.dataset.value) && t.dataset.value],
                                                        })
                                                        : a[0].values.push(!o.isUndefined(t.dataset.value) && t.dataset.value));
                                            }),
                                            (r = o.search.modules.kmcInputs.base.getFacetRangeFilterSettings()),
                                            (s = o.getObjectPath(t.kScope.data, "localOverrides.query." + a.dataset.section + ".filters.applyFilters.filters")),
                                            r &&
                                            "true" == r.minMax &&
                                            s &&
                                            o.each(s, function (e, t) {
                                                t.key == r.key && n.push(t);
                                            }),
                                            n.length
                                                ? o.setObjectPath(t.kScope.data, "localOverrides.query." + a.dataset.section + ".filters.applyFilters.filters", n)
                                                : o.setObjectPath(t.kScope.data, "localOverrides.query." + a.dataset.section + ".filters.applyFilters", {}),
                                            o.setObjectPath(t.kScope.data, "localOverrides.query." + a.dataset.section + ".settings.offset", 0),
                                            o.event.fireChain(t.kScope, "chains.events.keyUp", t, t.kScope.data, e)));
                            },
                            !0
                        );
                    });
            },
        };
        o.extend(!0, o.search.modules, { facets: { base: e, build: !0 } });
    })(klevu),
    klevu.coreEvent.build({
        name: "facetsModuleBuild",
        fire: function () {
            return !!(klevu.search.modules && klevu.search.modules.facets && klevu.search.modules.facets.build);
        },
        maxCount: 500,
        delay: 30,
    }),
    klevu.extend(!0, klevu.search.modules, {
        locale: {
            globalTranslations: {
                en: { "Narrow by": "Narrow by", price: "price", "No records found for your selection": "No records found for your selection" },
                ar: { "Narrow by": "Ø¶ÙŠÙ‚ Ù…Ù† Ù‚Ø¨Ù„", price: "Ø³Ø¹Ø±", "No records found for your selection": "Ù„Ù… ÙŠØªÙ… Ø§Ù„Ø¹Ø«ÙˆØ± Ø¹Ù„Ù‰ Ø³Ø¬Ù„Ø§Øª Ù„Ø§Ø®ØªÙŠØ§Ø±Ùƒ" },
                bg: { "Narrow by": "Ð¢ÐµÑÐ½Ð¾ Ð´Ð¾", price: "Ñ†ÐµÐ½Ð°", "No records found for your selection": "ÐÐµ ÑÐ° Ð½Ð°Ð¼ÐµÑ€ÐµÐ½Ð¸ Ð·Ð°Ð¿Ð¸ÑÐ¸ Ð·Ð° Ð’Ð°ÑˆÐ¸Ñ Ð¸Ð·Ð±Ð¾Ñ€" },
                da: { "Narrow by": "Smalle by", price: "pris", "No records found for your selection": "Ingen poster fundet for dit valg" },
                de: { "Narrow by": "Einschlafen", price: "Preis", "No records found for your selection": "Keine DatensÃ¤tze fÃ¼r Ihre Auswahl gefunden" },
                el: { "Narrow by": "Î£Ï„ÎµÎ½Î¿Î¯", price: "Ï„Î¹Î¼Î®", "No records found for your selection": "Î”ÎµÎ½ Î²ÏÎ­Î¸Î·ÎºÎ±Î½ Î±ÏÏ‡ÎµÎ¯Î± Î³Î¹Î± Ï„Î·Î½ ÎµÏ€Î¹Î»Î¿Î³Î® ÏƒÎ±Ï‚" },
                es: { "Narrow by": "Estrecho por", price: "precio", "No records found for your selection": "No se encontraron registros para su selecciÃ³n." },
                et: { "Narrow by": "Kitsendama", price: "hind", "No records found for your selection": "Teie valiku jaoks ei leitud Ã¼htegi kirjet" },
                fa: { "Narrow by": "Ø¨Ø§Ø±ÛŒÚ©", price: "Ù‚ÛŒÙ…Øª", "No records found for your selection": "Ù‡ÛŒÚ† Ù¾Ø±ÙˆÙ†Ø¯Ù‡ Ø§ÛŒ Ø¨Ø±Ø§ÛŒ Ø§Ù†ØªØ®Ø§Ø¨ Ø´Ù…Ø§ ÛŒØ§ÙØª Ù†Ø´Ø¯" },
                fi: { "Narrow by": "Kapea", price: "hinta", "No records found for your selection": "Valikoimusta ei lÃ¶ytynyt" },
                fr: { "Narrow by": "Ã‰troit par", price: "le prix", "No records found for your selection": "Aucun enregistrement trouvÃ© pour votre sÃ©lection" },
                he: { "Narrow by": "×¦×ž×¦× ×¢×œ ×™×“×™", price: "×ž×—×™×¨", "No records found for your selection": "×œ× × ×ž×¦××• ×¨×©×•×ž×•×ª ×œ×‘×—×™×¨×” ×©×œ×š" },
                hr: { "Narrow by": "Usko", price: "cijena", "No records found for your selection": "Nema pronaÄ‘enih zapisa za vaÅ¡ odabir" },
                hu: { "Narrow by": "Keskeny", price: "Ã¡r", "No records found for your selection": "Nincsenek nyilvÃ¡ntartÃ¡sok a kivÃ¡lasztÃ¡shoz" },
                is: { "Narrow by": "ÃžrÃ¶ngt af", price: "verÃ°", "No records found for your selection": "Engar fÃ¦rslur fundust fyrir val Ã¾itt" },
                it: { "Narrow by": "Ristretto", price: "prezzo", "No records found for your selection": "Nessun record trovato per la tua selezione" },
                ja: { "Narrow by": "ç‹­ã", price: "ä¾¡æ ¼", "No records found for your selection": "ã‚ãªãŸã®é¸æŠžã®ãŸã‚ã«ãƒ¬ã‚³ãƒ¼ãƒ‰ãŒè¦‹ã¤ã‹ã‚Šã¾ã›ã‚“ã§ã—ãŸ" },
                ko: { "Narrow by": "ì¢ì€ë§Œí¼", price: "ê°€ê²©", "No records found for your selection": "ê·€í•˜ì˜ ì„ íƒì— ëŒ€í•œ ê¸°ë¡ì´ ì—†ìŠµë‹ˆë‹¤" },
                lv: { "Narrow by": "Å aurs ar", price: "cena", "No records found for your selection": "JÅ«su izvÄ“lei nav atrasti ieraksti" },
                nb: { "Narrow by": "Smal av.", price: "pris", "No records found for your selection": "Ingen poster funnet for ditt valg" },
                nl: { "Narrow by": "Smal bij", price: "prijs", "No records found for your selection": "Geen records gevonden voor uw selectie" },
                no: { "Narrow by": "Smal av.", price: "pris", "No records found for your selection": "Ingen poster funnet for ditt valg" },
                pl: { "Narrow by": "WÄ…ski", price: "Cena Â£", "No records found for your selection": "Nie znaleziono rekordÃ³w do wyboru" },
                pt: { "Narrow by": "Estreito por", price: "preÃ§o", "No records found for your selection": "Nenhum registro encontrado para sua seleÃ§Ã£o" },
                ro: { "Narrow by": "ÃŽngust cu", price: "PreÈ›", "No records found for your selection": "Nu au fost gÄƒsite Ã®nregistrÄƒri pentru selecÈ›ia dvs." },
                ru: { "Narrow by": "Ð£Ð·ÐºÐ¸Ð¹", price: "Ñ†ÐµÐ½Ð°", "No records found for your selection": "Ð—Ð°Ð¿Ð¸ÑÐ¸ Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ñ‹ Ð´Ð»Ñ Ð²Ð°ÑˆÐµÐ³Ð¾ Ð²Ñ‹Ð±Ð¾Ñ€Ð°" },
                sk: { "Narrow by": "Ãšzky", price: "cena", "No records found for your selection": "Pre vÃ¡Å¡ vÃ½ber neboli nÃ¡jdenÃ© Å¾iadne zÃ¡znamy" },
                sl: { "Narrow by": "Ozek by.", price: "Cena", "No records found for your selection": "Za izbiro ni najdenih zapisov" },
                sr: { "Narrow by": "Ð£ÑÐºÐ¸", price: "Ð¦ÐµÐ½Ð°", "No records found for your selection": "ÐÐ¸Ñ˜Ðµ Ð¿Ñ€Ð¾Ð½Ð°Ñ’ÐµÐ½ Ð½Ð¸Ñ˜ÐµÐ´Ð°Ð½ Ð·Ð°Ð¿Ð¸ÑÐ¸ Ð·Ð° Ð²Ð°Ñˆ Ð¸Ð·Ð±Ð¾Ñ€" },
                sv: { "Narrow by": "Smal av", price: "pris", "No records found for your selection": "Inga poster hittades fÃ¶r ditt val" },
                tr: { "Narrow by": "Daraltmak", price: "fiyat", "No records found for your selection": "SeÃ§iminiz iÃ§in kayÄ±t bulunamadÄ±" },
                vi: { "Narrow by": "Thu háº¹p bá»Ÿi", price: "giÃ¡ bÃ¡n", "No records found for your selection": "KhÃ´ng tÃ¬m tháº¥y há»“ sÆ¡ nÃ o cho lá»±a chá»n cá»§a báº¡n" },
                zh: { "Narrow by": "ç‹­çª„", price: "ä»·é’±", "No records found for your selection": "æ²¡æœ‰æ‰¾åˆ°æ‚¨çš„é€‰æ‹©çš„è®°å½•" },
            },
        },
    }),
    (function (e) {
        var t = {
            sendAddToCartRequest: function (e, t, a) {
                "function" == typeof klevu_addtocart && klevu_addtocart(e, t, a);
            },
        };
        e.extend(!0, e.search.modules, { addToCart: { base: t, build: !0 } });
    })(klevu),
    klevu.coreEvent.build({
        name: "addToCartModuleBuild",
        fire: function () {
            return !!(klevu.search.modules && klevu.search.modules.addToCart && klevu.search.modules.addToCart.build);
        },
        maxCount: 500,
        delay: 30,
    }),
    (function (r) {
        var e = {
            parseProductColorSwatch: function (e, t) {
                var a = this;
                (t = r.getObjectPath(e.data.template.query, t)) &&
                    t.result &&
                    r.each(t.result, function (e, t) {
                        t.swatchesInfo && t.swatchesInfo.length && (t.swatchesInfo = a.getColorSwatchesInfoFromString(t.swatchesInfo));
                    });
            },
            getColorSwatchesInfoFromString: function (e) {
                if (e && e[0] && e[0].variantId) return e;
                var e = e.split(";;;;"),
                    a = [];
                return (
                    e.forEach(function (e) {
                        var t;
                        e.length && ((t = {}), 2 === (e = e.trim().split(":")).length ? (t = { name: e[0], value: e[1] }) : 2 < e.length && (t = { name: e.shift(), value: e.join(":") }), a.push(t));
                    }),
                    this.parseKeyValuePairs(a)
                );
            },
            parseKeyValuePairs: function (a) {
                var s = [];
                return (
                    a.forEach(function (e, t) {
                        var r = t + 1,
                            n = {};
                        a.forEach(function (e, t) {
                            var a = e.name;
                            -1 < a.indexOf(r) && ((a = a.replace(r, "")), (n[a] = e.value), (n.isMatched = !0));
                        }),
                            n.isMatched && (delete n.isMatched, s.push(n));
                    }),
                    s
                );
            },
        };
        r.extend(!0, r.search.modules, { colorSwatches: { base: e, build: !0 } });
    })(klevu),
    klevu.coreEvent.build({
        name: "colorSwatchesModuleBuild",
        fire: function () {
            return !!(klevu.search.modules && klevu.search.modules.colorSwatches && klevu.search.modules.colorSwatches.build);
        },
        maxCount: 500,
        delay: 30,
    }),
    (function (s) {
        s({ analytics: { url: { bannerClick: "dataTracking" } } }),
            s.coreEvent.build({
                name: "analyticsBannerPowerUp",
                fire: function () {
                    return !(!s.analytics || !s.analytics.build);
                },
                maxCount: 500,
                delay: 30,
            }),
            s.coreEvent.attach("analyticsBannerPowerUp", {
                name: "registerChain",
                fire: function () {
                    s.setObjectPath(s.analytics.base.getScope().element.kScope, "chains.events.bannerClick", s.chain({ stopOnFalse: !0 }));
                },
            }),
            s.coreEvent.attach("analyticsBannerPowerUp", {
                name: "populateChain",
                fire: function () {
                    s.analytics.base.getScope().chains.events.bannerClick.add({
                        name: "bannerClickRequestCheck",
                        fire: function (e, t) {
                            s.clean(e.request.analytics);
                            var a = e.request.analytics;
                            try {
                                var r = !1,
                                    n = "";
                                if ((s.isUndefined(a.klevu_bannerId) ? ((r = !0), (n = "klevu_bannerId")) : s.isUndefined(a.klevu_target) ? ((r = !0), (n = "klevu_target")) : s.isUndefined(a.type) && ((r = !0), (n = "type")), r))
                                    throw new Error(n + " parameter is missing from the banner click analytics request!");
                            } catch (e) {
                                return (
                                    s.settings.console.type.event &&
                                    (s.logError("chains.events.bannerClick - bannerClickRequestCheck - check paramaters."), s.logError("chains.events.bannerClick - bannerClickRequestCheck - error:"), s.logError(e)),
                                    !1
                                );
                            }
                        },
                    }),
                        s.analytics.base.getScope().chains.events.bannerClick.add({
                            name: "encodeAttributes",
                            fire: function (a, e) {
                                var r = ["klevu_term", "klevu_keywords", "klevu_request", "type"],
                                    t = s.getObjectPath(a, "request.analytics");
                                t &&
                                    s.each(t, function (e, t) {
                                        -1 < r.indexOf(e) || (a.request.analytics[e] = encodeURIComponent(t));
                                    });
                            },
                        }),
                        s.analytics.base.getScope().chains.events.bannerClick.add({
                            name: "generateURL",
                            fire: function (e, t) {
                                var a = s.getSetting(t.kScope.settings, "settings.url.analyticsCat", !1);
                                if (!a) return !1;
                                e.context.url = a + s.getSetting(t.kScope.settings, "settings.analytics.url.bannerClick", !1);
                            },
                        }),
                        s.analytics.base.getScope().chains.events.bannerClick.add({
                            name: "addApiKey",
                            fire: function (e, t) {
                                e.request.analytics.klevu_apiKey = s.getSetting(t.kScope.settings, "settings.analytics.apiKey", s.getGlobalSetting("analytics.apiKey", s.getGlobalSetting("global.apiKey")));
                            },
                        }),
                        s.analytics.base.getScope().chains.events.bannerClick.add({
                            name: "doAnalytics",
                            fire: function (e, t) {
                                var a = s.getObjectPath(t.kScope, "chains.actions.doAnalytics");
                                if ((s.isUndefined(a) || 0 === a.list().length || (a.setScope(t.kElem), a.setData(e), a.fire()), !0 === (t.kScope.data = e).context.preventDefault)) return !1;
                            },
                        }),
                        s.analytics.base.getScope().chains.request.send.addBefore("requestTypeAjaxV1", {
                            name: "requestTypeAjaxBanner",
                            fire: function (e, t) {
                                "bannerClick" === e.context.eventAction && (e.context.eventAction = "analyticsAjaxV1");
                            },
                        });
                },
            }),
            s.coreEvent.attach("analyticsBannerPowerUp", {
                name: "buildEvent",
                fire: function () {
                    s.extend(!0, s.analyticsEvents, {
                        bannerClick: function (e, t) {
                            s.isEmptyObject(t) && (t = s.analytics.base);
                            var a = t.getScope();
                            return (
                                (a.data = t.resetData()),
                                (a.data.context.eventAction = "bannerClick"),
                                (a.data.request.analytics = e),
                                (a.data.context.preventDefault = !1),
                                s.event.fireChain(a, "chains.events.bannerClick", a.element, a.data, null),
                                t
                            );
                        },
                    });
                },
            }),
            s.coreEvent.attach("analyticsBannerPowerUp", {
                name: "buildEvent",
                fire: function () {
                    s.extend(!0, s.support, { analytics: { bannerClick: !0 } });
                },
            });
    })(klevu),
    klevu.coreEvent.build({
        name: "promotionBannerModule",
        fire: function () {
            return !!(
                klevu.search.modules &&
                klevu.search.modules.promotionBanner &&
                klevu.search.modules.promotionBanner.build &&
                klevu.support.analytics &&
                klevu.support.analytics.bannerClick &&
                klevu.analyticsUtil &&
                klevu.analyticsUtil.build
            );
        },
        maxCount: 500,
        delay: 30,
    }),
    klevu.coreEvent.attach("promotionBannerModule", {
        name: "attachPromotionalBannerModuleEvents",
        fire: function () {
            klevu.extend(!0, klevu.analyticsUtil.base, {
                storage: { bannerClick: "bannerClickList" },
                registerBannerClickEvent: function (r, n, s) {
                    var e = klevu.getSetting(r.settings, "settings.search.searchBoxTarget");
                    klevu.each(klevu.dom.find(".kuTrackBannerClick", e), function (e, a) {
                        klevu.event.attach(a, "click", function (e) {
                            var t = klevu.analyticsUtil.base.getDataTrackingOptions(r);
                            a.dataset &&
                                (a.dataset.id && (t.klevu_bannerId = a.dataset.id),
                                    a.dataset.name && (t.klevu_bannerName = a.dataset.name),
                                    a.dataset.image && (t.klevu_image = a.dataset.image),
                                    a.dataset.redirect && (t.klevu_target = a.dataset.redirect)),
                                klevu.analyticsUtil.base.storeAnalyticsEvent(n, s, t);
                        });
                    });
                },
            });
        },
    }),
    klevu.coreEvent.attach("analyticsSendStoredData", {
        name: "sendStoredBannerClickEvent",
        fire: function () {
            klevu.analyticsUtil.base.sendAnalyticsEventsFromStorage(klevu.analyticsUtil.base.storage.dictionary, klevu.analyticsUtil.base.storage.bannerClick);
        },
    }),
    (function (n) {
        function e(e, a) {
            var r = [];
            return (
                e.length &&
                n.each(e, function (e, t) {
                    ("all" === a ||
                        (t.hasOwnProperty("showOnLandingPage") && !0 === t.showOnLandingPage && "landing" === a) ||
                        (t.hasOwnProperty("showOnQuickSearch") && !0 === t.showOnQuickSearch && "quick" === a) ||
                        (t.hasOwnProperty("showOnCategoryPage") && !0 === t.showOnCategoryPage && "category" === a)) &&
                        r.push(t);
                }),
                r
            );
        }
        function a(e) {
            for (var t = e.concat(), a = 0; a < t.length; ++a) for (var r = a + 1; r < t.length; ++r) n.isEqualObj(t[a], t[r]) && t.splice(r--, 1);
            return t;
        }
        var t = {
            bannerDataObject: { banners: [] },
            init: function (e) {
                n.isEmptyObject(e) ||
                    ((this.bannerDataObject.banners = a(this.bannerDataObject.banners.concat(e))),
                        (e = (function (e) {
                            var t = [];
                            if (0 < e.length) {
                                var a,
                                    r,
                                    n = new Date();
                                n.setHours(0, 0, 0, 0);
                                for (var s = 0; s < e.length; s++) (a = new Date(e[s].startDate)), (void 0 !== e[s].endDate && e[s].endDate ? ((r = new Date(e[s].endDate)), n < a || r < n) : n < a) && (e.splice(s, 1), s--);
                                t = e;
                            }
                            return t;
                        })(e)),
                        (this.bannerDataObject.banners = a(this.bannerDataObject.banners.concat(e))));
            },
            mergeData: function () {
                var e = n.extend(!0, [], this.bannerDataObject.banners),
                    t = n.search.modules.kmcInputs.base.getBannerList();
                return a(e.concat(t));
            },
            getAllBanners: function () {
                return e(this.mergeData(), "all");
            },
            getQuickSearchBanners: function () {
                return e(this.mergeData(), "quick");
            },
            getLandingPageBanners: function () {
                return e(this.mergeData(), "landing");
            },
            getCategoryPageBanners: function () {
                return e(this.mergeData(), "category");
            },
        };
        n.extend(!0, n.search.modules, { promotionBanner: { base: t, build: !0 } });
    })(klevu),
    (function (i) {
        var e = {
            collapse: function (e, t, a) {
                var r;
                e &&
                    e.template &&
                    e.template.query &&
                    t &&
                    t.length &&
                    (a = i.getObjectPath(e.template.query, a)) &&
                    a.filters &&
                    ((r = a.filters).forEach(function (e) {
                        e.isCollapsed = !1;
                    }),
                        t.forEach(function (t) {
                            r.forEach(function (e) {
                                t.key == e.key && (e.isCollapsed = !0);
                            });
                        }));
            },
            initialize: function (o) {
                var e = i.getSetting(o.settings, "settings.search.searchBoxTarget");
                i.each(i.dom.find(".kuFilterHead", e), function (e, s) {
                    i.event.attach(s, "click", function (e) {
                        var a = s;
                        (e = e || window.event).preventDefault();
                        var r = !1,
                            t = i.getSetting(o.settings, "settings.storage");
                        t.filterCollapse.setStorage("session"), t.filterCollapse.mergeFromGlobal();
                        var n = t.filterCollapse.getElement("keys");
                        this.classList.toggle("kuCollapse"), this.classList.toggle("kuExpand");
                        e = i.dom.helpers.getClosest(this, ".kuFilterBox");
                        i.each(i.dom.find(".kuFilterNames", e), function (e, t) {
                            t.classList.toggle("kuFilterCollapse"),
                                (r = t.classList.contains("kuFilterCollapse")),
                                a.classList.contains("kuCollapse") && t.dataset && parseInt(t.dataset.optioncount) < 5 ? t.classList.add("kuFilterShowAll") : t.classList.remove("kuFilterShowAll");
                        });
                        e = (e = i.dom.helpers.getClosest(this, ".kuFilterBox")) && e.dataset && e.dataset.filter ? e.dataset.filter : "";
                        e && e.length && (r ? (n += e + ",") : (n = n.replace(new RegExp(e + ",", "g"), "")), t.filterCollapse.addElement("keys", n), t.filterCollapse.mergeToGlobal());
                    });
                }),
                    i.each(i.dom.find(".kuFilterBox", e), function (e, t) {
                        var a,
                            r,
                            n = t && t.dataset && t.dataset.filter ? t.dataset.filter : "";
                        n.length &&
                            ((r = function (e, t) {
                                var a = !1;
                                return e.setStorage("session"), e.mergeFromGlobal(), -1 < e.getElement("keys").indexOf(t) && (a = !0), a;
                            })((a = i.getSetting(o.settings, "settings.storage")).filterShowMore, n) &&
                                i.each(i.dom.find(".kuFilterNames", t), function (e, t) {
                                    t.classList.add("kuFilterShowAll");
                                }),
                                r(a.filterCollapse, n) &&
                                (i.each(i.dom.find(".kuFilterHead", t), function (e, t) {
                                    t.classList.remove("kuCollapse"), t.classList.add("kuExpand");
                                }),
                                    i.each(i.dom.find(".kuFilterNames", t), function (e, t) {
                                        t.classList.remove("kuFilterShowAll"), t.classList.add("kuFilterCollapse");
                                    })));
                    }),
                    i.each(i.dom.find(".kuShowOpt", e), function (e, t) {
                        i.event.attach(t, "click", function (e) {
                            (e = e || window.event).preventDefault();
                            var t = i.getSetting(o.settings, "settings.storage");
                            t.filterShowMore.setStorage("session"), t.filterShowMore.mergeFromGlobal();
                            var a = t.filterShowMore.getElement("keys"),
                                r = !1,
                                e = i.dom.helpers.getClosest(this, ".kuFilterBox");
                            i.each(i.dom.find(".kuFilterNames", e), function (e, t) {
                                t.classList.toggle("kuFilterShowAll"), (r = t.classList.contains("kuFilterShowAll"));
                            });
                            e = e && e.dataset && e.dataset.filter ? e.dataset.filter : "";
                            e && e.length && (r ? (a += e + ",") : (a = a.replace(new RegExp(e + ",", "g"), "")), t.filterShowMore.addElement("keys", a), t.filterShowMore.mergeToGlobal());
                        });
                    });
            },
        };
        i.extend(!0, i.search.modules, { collapseFilters: { base: e, build: !0 } });
    })(klevu),
    klevu.coreEvent.build({
        name: "collapseFiltersModuleBuild",
        fire: function () {
            return !!(klevu.search.modules && klevu.search.modules.collapseFilters && klevu.search.modules.collapseFilters.build);
        },
        maxCount: 500,
        delay: 30,
    }),
    (function (s) {
        var e = {
            getMessage: function (t, e) {
                var a = this.kmcInputs.getNoResultsFoundObject();
                if (((t = s.dom.helpers.escapeHTML(t)), (e = e.kScope.template.translate("We're sorry, no results found for") + ' <em>"' + t + '"</em>.'), !a.messages || !a.messages.length)) return e;
                if (a.messages && 1 == a.messages.length) {
                    var r = a.messages[0].message;
                    return ((n = document.createElement("textarea")).innerHTML = r), (r = n.value), (t = '<em>"' + t + '"</em>'), (r = r.replace(/#/g, t));
                }
                if (
                    (r = a.messages.find(function (e) {
                        return (
                            null != e.showForTerms &&
                            e.showForTerms.find(function (e) {
                                return e.toLowerCase() == t.toLowerCase();
                            })
                        );
                    }))
                ) {
                    r = r.message;
                    return ((n = document.createElement("textarea")).innerHTML = r), (r = n.value), (t = '<em>"' + t + '"</em>'), (r = r.replace(/#/g, t));
                }
                var n,
                    a = a.messages.find(function (e) {
                        return null == e.showForTerms;
                    }),
                    a = s.isUndefined(a) ? e : a.message;
                return ((n = document.createElement("textarea")).innerHTML = a), (a = n.value), (t = '<em>"' + t + '"</em>'), (a = a.replace(/#/g, t));
            },
            kmcInputs: s.search.modules.kmcInputs.base,
            getLandingBanners: function (r) {
                var e = this.kmcInputs.getNoResultsFoundObject(),
                    n = [];
                return (
                    e.banners &&
                    s.each(e.banners, function (e, t) {
                        var a = !1;
                        1 == t.showOnLandingPage &&
                            (null == t.showForTerms
                                ? (a = !0)
                                : r &&
                                r.length &&
                                t.showForTerms &&
                                t.showForTerms.length &&
                                s.each(t.showForTerms, function (e, t) {
                                    t && t.toLowerCase() == r.toLowerCase() && (a = !0);
                                })),
                            a && n.push(t);
                    }),
                    n
                );
            },
            getQuickSearchBanners: function (r) {
                var e = this.kmcInputs.getNoResultsFoundObject(),
                    n = [];
                return (
                    e.banners &&
                    s.each(e.banners, function (e, t) {
                        var a = !1;
                        1 == t.showOnQuickSearch &&
                            (null == t.showForTerms
                                ? (a = !0)
                                : r &&
                                r.length &&
                                t.showForTerms &&
                                t.showForTerms.length &&
                                s.each(t.showForTerms, function (e, t) {
                                    t && t.toLowerCase() == r.toLowerCase() && (a = !0);
                                })),
                            a && n.push(t);
                    }),
                    n
                );
            },
            isPopularSearchesKeywordsEnabled: function () {
                var e = this.kmcInputs.getNoResultsFoundObject();
                return e.showPopularKeywords || !1;
            },
            isPopularProductsEnabled: function () {
                var e = this.kmcInputs.getNoResultsFoundObject();
                return e.showPopularProducts || !1;
            },
            setPopularSearchesKeyword: function () {
                var e;
                this.isPopularSearchesEnabled() &&
                    ((e = s.dom.find(".kuPopularSearchTermItem")),
                        s.each(e, function (e, a) {
                            s.event.attach(a, "click", function () {
                                var e = a.dataset.value,
                                    e = encodeURIComponent(e),
                                    t = s.dom.find(s.getSetting(scope.kScope.settings, "settings.search.searchBoxSelector"))[0].name;
                                t && (window.location = "/?" + t + "=" + e);
                            });
                        }));
            },
            buildPopularProductsReq: function (e, t, a) {
                this.isPopularProductsEnabled() &&
                    ((t = s.getSetting(t.kScope.settings, "settings.search.map", !1)),
                        ((t = s.extend(!0, {}, t.recordQuery)).id = "noResultsFoundPopularProductList"),
                        (t.typeOfRequest = "RECS_TRENDING"),
                        (t.settings.typeOfRecords = ["KLEVU_PRODUCT"]),
                        (t.settings.query = { term: "*" }),
                        (t.settings.limit = a),
                        e.request.current.recordQueries.push(t),
                        (e.context.doSearch = !0),
                        (e.context.section = t.id));
            },
            popularProductsHeading: function () {
                return this.kmcInputs.getNoResultsFoundObject().productsHeading;
            },
        };
        s.extend(!0, s.search.modules, { noResultsFound: { base: e } });
    })(klevu),
    klevu.coreEvent.build({
        name: "noResultsFoundModuleBuild",
        fire: function () {
            return !(!klevu.search.modules || klevu.isUndefined(klevu.search.modules.kmcInputs));
        },
        maxCount: 500,
        delay: 30,
    }),
    (function (s) {
        s.extend(!0, s.search.modules, {
            recentViewedProducts: {
                base: {
                    limit: 10,
                    addProductId: function (e, t) {
                        var a, r, n;
                        t &&
                            "" != t &&
                            ((a = this.limit || 10),
                                (r = s.getSetting(e.settings, "settings.storage")).recentViewedProducts.setStorage("local"),
                                r.recentViewedProducts.mergeFromGlobal(),
                                (e = r.recentViewedProducts.getElement("ku_products")) && "ku_products" != e ? (t = t + "," + (e = (e = e.replace(new RegExp(t + ",", "g"), "")).replace(new RegExp(t), "", "g"))) : (t += ","),
                                (n = []),
                                (e = t.split(",")),
                                s.each(e, function (e, t) {
                                    t && n.length < a && n.push(t);
                                }),
                                (t = n.join(",")),
                                r.recentViewedProducts.addElement("ku_products", t),
                                r.recentViewedProducts.mergeToGlobal());
                    },
                    getProductIds: function (e) {
                        var t = [],
                            e = s.getSetting(e.settings, "settings.storage");
                        e.recentViewedProducts.setStorage("local"), e.recentViewedProducts.mergeFromGlobal();
                        e = e.recentViewedProducts.getElement("ku_products");
                        return e && "ku_products" != e && (t = e.split(",")), t;
                    },
                    getRecentViewedProductListPayload: function (e, t) {
                        var a,
                            r,
                            n = this.getProductIds(e);
                        return (
                            n &&
                            n.length &&
                            ((a = []),
                                s.each(n, function (e, t) {
                                    t = { key: "id", value: t };
                                    a.push(t);
                                }),
                                (r = s.getSetting(e.settings, "settings.search.map", !1)),
                                ((r = s.extend(!0, {}, r.recordQuery)).id = "recentViewedProductList"),
                                (r.typeOfRequest = "SEARCH"),
                                (r.settings.query.term = t.context.term),
                                (r.settings.typeOfRecords = ["KLEVU_PRODUCT"]),
                                (r.settings.limit = a.length),
                                (r.settings.typeOfSearch = "WILDCARD_AND"),
                                (r.settings.includeIds = a),
                                (r.settings.topIds = a)),
                            r
                        );
                    },
                },
                build: !0,
            },
        });
    })(klevu),
    klevu.extend({
        productCarousel: {
            base: {
                initProductsSlider: function (r) {
                    var n, e, t, s, o, i, l, c;
                    function u() {
                        var e = n.lastElementChild.cloneNode(!0);
                        (e.style.left = -o + "px"), n.insertBefore(e, n.firstChild);
                    }
                    function d() {
                        var e = n.firstElementChild;
                        e.parentNode.removeChild(e);
                    }
                    function a() {
                        var e = r.querySelectorAll(".kuSlide"),
                            e = Array.prototype.slice.call(e),
                            a = 0;
                        e.forEach(function (e, t) {
                            (e.style.left = a + "px"), (a += o);
                        }),
                            u();
                    }
                    function p() {
                        var e, t;
                        (s = 500 <= r.offsetWidth ? 3 : 300 <= r.offsetWidth ? 2 : 1),
                            (e = r.querySelectorAll(".kuSlide")),
                            (e = Array.prototype.slice.call(e)),
                            (t = -(o = r.offsetWidth / s)),
                            e.forEach(function (e) {
                                (e.style.width = o + "px"), (e.style.left = t + "px"), (t += o);
                            });
                    }
                    function g() {
                        var e, t;
                        i &&
                            ((t = (e = r.querySelectorAll(".kuSlide")).length - 1),
                                parseInt(e[0].id) >= t || ((i = !1), (t = n.lastElementChild).parentNode.removeChild(t), n.insertBefore(t, n.firstChild), d(), n.firstElementChild.addEventListener("transitionend", m), a()));
                    }
                    function m() {
                        var e = n.firstElementChild;
                        (i = !0), e.removeEventListener("transitionend", m);
                    }
                    function h() {
                        var e, t, a;
                        i &&
                            ((t = (e = r.querySelectorAll(".kuSlide")).length - 1),
                                parseInt(e[1].id) + s > t ||
                                ((i = !1),
                                    d(),
                                    n.firstElementChild.addEventListener("transitionend", v),
                                    (t = r.querySelectorAll(".kuSlide")),
                                    (a = ((t = (t = Array.prototype.slice.call(t)).reverse()).length - 1) * o),
                                    t.forEach(function (e, t) {
                                        (a -= o), (e.style.left = a + "px");
                                    })));
                    }
                    function v() {
                        var e = n.firstElementChild;
                        e.parentNode.removeChild(e), n.appendChild(e), (e.style.left = (t.length - 1) * o + "px"), u(), (i = !0), e.removeEventListener("transitionend", v);
                    }
                    function f(e) {
                        var a;
                        i &&
                            ((e = e.clientX),
                                (e = l - e),
                                Math.abs(e) < o / 4 &&
                                ((a = e),
                                    (e = r.querySelectorAll(".kuSlide")),
                                    Array.prototype.slice.call(e).forEach(function (e, t) {
                                        t = c[t];
                                        e.style.left = t + a + "px";
                                    })));
                    }
                    function k(e) {
                        e = e.clientX;
                        0 < l - e ? g() : l - e < 0 && h(), r.removeEventListener("mouseup", k), n.removeEventListener("mousemove", f);
                    }
                    r &&
                        (!(n = r.querySelector(".kuCarousel-content")) ||
                            ((e = r.querySelectorAll(".kuSlide")) &&
                                ((t = Array.prototype.slice.call(e)),
                                    a(),
                                    window.addEventListener("resize", p),
                                    r.querySelector(".nav-right").addEventListener("click", h),
                                    (i = !0),
                                    r.querySelector(".nav-left").addEventListener("click", g),
                                    n.addEventListener("mousedown", function (e) {
                                        (l = e.clientX),
                                            (function () {
                                                var e = r.querySelectorAll(".kuSlide"),
                                                    e = Array.prototype.slice.call(e);
                                                (c = []),
                                                    e.forEach(function (e) {
                                                        e = Math.floor(parseInt(e.style.left.slice(0, -2)));
                                                        c.push(e);
                                                    });
                                            })(),
                                            n.addEventListener("mousemove", f),
                                            r.addEventListener("mouseup", k);
                                    }),
                                    p())));
                },
            },
        },
    }),
    (function (s) {
        s({ analytics: { url: { personalizedSearchTracking: "personalizedSearchTracking" } } }),
            s.coreEvent.build({
                name: "analyticsPersonalizedSearchTrackingPowerUp",
                fire: function () {
                    return !(!s.analytics || !s.analytics.build);
                },
                maxCount: 500,
                delay: 30,
            }),
            s.coreEvent.attach("analyticsPersonalizedSearchTrackingPowerUp", {
                name: "registerChain",
                fire: function () {
                    s.setObjectPath(s.analytics.base.getScope().element.kScope, "chains.events.personalizedSearchTracking", s.chain({ stopOnFalse: !0 }));
                },
            }),
            s.coreEvent.attach("analyticsPersonalizedSearchTrackingPowerUp", {
                name: "populateChain",
                fire: function () {
                    s.analytics.base.getScope().chains.events.personalizedSearchTracking.add({
                        name: "personalizedSearchTrackingRequestCheck",
                        fire: function (e, t) {
                            s.clean(e.request.analytics);
                            var a = e.request.analytics;
                            try {
                                var r = !1,
                                    n = "";
                                if ((s.isUndefined(a.klevu_productId) && ((r = !0), (n = "klevu_productId")), r)) throw new Error(n + " parameter is missing from the banner click analytics request!");
                            } catch (e) {
                                return (
                                    s.settings.console.type.event &&
                                    (s.logError("chains.events.personalizedSearchTracking - personalizedSearchTrackingRequestCheck - check parameters."),
                                        s.logError("chains.events.personalizedSearchTracking - personalizedSearchTrackingRequestCheck - error:"),
                                        s.logError(e)),
                                    !1
                                );
                            }
                        },
                    }),
                        s.analytics.base.getScope().chains.events.personalizedSearchTracking.add({
                            name: "encodeAttributes",
                            fire: function (a, e) {
                                var r = ["klevu_term", "klevu_keywords", "klevu_request", "type"],
                                    t = s.getObjectPath(a, "request.analytics");
                                t &&
                                    s.each(t, function (e, t) {
                                        -1 < r.indexOf(e) || (a.request.analytics[e] = encodeURIComponent(t));
                                    });
                            },
                        }),
                        s.analytics.base.getScope().chains.events.personalizedSearchTracking.add({
                            name: "generateURL",
                            fire: function (e, t) {
                                var a = s.getSetting(t.kScope.settings, "settings.url.analyticsCat", !1);
                                if (!a) return !1;
                                e.context.url = a + s.getSetting(t.kScope.settings, "settings.analytics.url.personalizedSearchTracking", !1);
                            },
                        }),
                        s.analytics.base.getScope().chains.events.personalizedSearchTracking.add({
                            name: "addApiKey",
                            fire: function (e, t) {
                                e.request.analytics.klevu_apiKey = s.getSetting(t.kScope.settings, "settings.analytics.apiKey", s.getGlobalSetting("analytics.apiKey", s.getGlobalSetting("global.apiKey")));
                            },
                        }),
                        s.analytics.base.getScope().chains.events.personalizedSearchTracking.add({
                            name: "doAnalytics",
                            fire: function (e, t) {
                                var a = s.getObjectPath(t.kScope, "chains.actions.doAnalytics");
                                if ((s.isUndefined(a) || 0 === a.list().length || (a.setScope(t.kElem), a.setData(e), a.fire()), !0 === (t.kScope.data = e).context.preventDefault)) return !1;
                            },
                        }),
                        s.analytics.base.getScope().chains.request.send.addBefore("requestTypeAjaxV1", {
                            name: "requestTypeAjaxPersonalizedSearchTracking",
                            fire: function (e, t) {
                                "personalizedSearchTracking" === e.context.eventAction && (e.context.eventAction = "analyticsAjaxV1");
                            },
                        });
                },
            }),
            s.coreEvent.attach("analyticsPersonalizedSearchTrackingPowerUp", {
                name: "buildEvent",
                fire: function () {
                    s.extend(!0, s.analyticsEvents, {
                        personalizedSearchTracking: function (e, t) {
                            s.isEmptyObject(t) && (t = s.analytics.base);
                            var a = t.getScope();
                            return (
                                (a.data = t.resetData()),
                                (a.data.context.eventAction = "personalizedSearchTracking"),
                                (a.data.request.analytics = e),
                                (a.data.context.preventDefault = !1),
                                s.event.fireChain(a, "chains.events.personalizedSearchTracking", a.element, a.data, null),
                                t
                            );
                        },
                    });
                },
            }),
            s.coreEvent.attach("analyticsPersonalizedSearchTrackingPowerUp", {
                name: "buildEvent",
                fire: function () {
                    s.extend(!0, s.support, { analytics: { personalizedSearchTracking: !0 } });
                },
            });
    })(klevu),
    klevu.coreEvent.build({
        name: "personalizedSearchTrackingModule",
        fire: function () {
            return !!(
                klevu.search.modules &&
                klevu.search.modules.trendingProducts &&
                klevu.search.modules.trendingProducts.build &&
                klevu.support.analytics &&
                klevu.support.analytics.personalizedSearchTracking &&
                klevu.analyticsUtil &&
                klevu.analyticsUtil.build
            );
        },
        maxCount: 500,
        delay: 30,
    }),
    klevu.coreEvent.attach("personalizedSearchTrackingModule", {
        name: "attachPersonalizedSearchTrackingModuleEvents",
        fire: function () {
            klevu.extend(!0, klevu.analyticsUtil.base, {
                storage: { personalizedSearchTracking: "personalizedSearchTrackingList" },
                registerPersonalizedSearchTrackingClickEvent: function (i, l, c, u) {
                    var d = klevu.getSetting(i.settings, "settings.search.searchBoxTarget");
                    klevu.each(klevu.dom.find(l + " .kuTrackPersonalizedProductClick", d), function (e, o) {
                        klevu.event.attach(o, "click", function (e) {
                            var t,
                                a,
                                r,
                                n = o.dataset.id,
                                s = klevu.dom.find(l, d)[0];
                            s && ((r = s.dataset.section), (t = s.dataset.source)),
                                r &&
                                ((a = klevu.dom.helpers.getClosest(o, ".klevuProduct")),
                                    (i.data.context.section = r),
                                    (s = ""),
                                    (r = klevu.getObjectPath(i.data, "template.recentSearches")) && r.length && (s = r = r.join("#-#")),
                                    n &&
                                    (!(r = klevu.analyticsUtil.base.getProductDetailsFromId(n, i)) ||
                                        ((n = klevu.analyticsUtil.base.getTermOptions(i)) &&
                                            ((n.klevu_term = ""),
                                                (n.klevu_keywords = ""),
                                                (n.klevu_productId = r.id),
                                                (n.klevu_productName = r.name),
                                                (n.klevu_productUrl = r.url),
                                                (n.klevu_src = "[[typeOfRecord:" + r.typeOfRecord + ";;template:trending]]"),
                                                (n.klevu_source = t),
                                                (n.klevu_recentsearch = s),
                                                (n.klevu_salePrice = r.salePrice),
                                                (n.klevu_rating = void 0 !== r.rating ? r.rating : ""),
                                                (n.klevu_rank = a && a.id ? a.id : ""),
                                                (n.klevu_type = "clicked"),
                                                delete n.filters,
                                                delete n.klevu_limit,
                                                delete n.klevu_pageNumber,
                                                delete n.klevu_totalResults,
                                                delete n.klevu_typeOfQuery,
                                                delete n.klevu_sort,
                                                klevu.analyticsUtil.base.storeAnalyticsEvent(c, u, n)))));
                        });
                    });
                },
            });
        },
    }),
    klevu.coreEvent.attach("analyticsSendStoredData", {
        name: "sendStoredPersonalizedSearchTrackingEvent",
        fire: function () {
            klevu.analyticsUtil.base.sendAnalyticsEventsFromStorage(klevu.analyticsUtil.base.storage.dictionary, klevu.analyticsUtil.base.storage.personalizedSearchTracking);
        },
    }),
    (window.noUiSlider = (function () {
        "use strict";
        function H(e) {
            return e.filter(function (e) {
                return !this[e] ? (this[e] = true) : false;
            }, {});
        }
        function i(e, t) {
            return Math.round(e / t) * t;
        }
        function D(e) {
            var t = e.getBoundingClientRect(),
                a = e.ownerDocument,
                r = a.documentElement,
                n = J();
            if (/webkit.*Chrome.*Mobile/i.test(navigator.userAgent)) n.x = 0;
            return { top: t.top + n.y - r.clientTop, left: t.left + n.x - r.clientLeft };
        }
        function n(e) {
            return typeof e === "number" && !isNaN(e) && isFinite(e);
        }
        function t(e) {
            var t = Math.pow(10, 7);
            return Number((Math.round(e * t) / t).toFixed(7));
        }
        function G(e, t, a) {
            Y(e, t);
            setTimeout(function () {
                $(e, t);
            }, a);
        }
        function K(e) {
            return Math.max(Math.min(e, 100), 0);
        }
        function Q(e) {
            return Array.isArray(e) ? e : [e];
        }
        function W(e) {
            var t = e.split(".");
            return t.length > 1 ? t[1].length : 0;
        }
        function Y(e, t) {
            if (e.classList) e.classList.add(t);
            else e.className += " " + t;
        }
        function $(e, t) {
            if (e.classList) e.classList.remove(t);
            else e.className = e.className.replace(new RegExp("(^|\\b)" + t.split(" ").join("|") + "(\\b|$)", "gi"), " ");
        }
        function Z(e, t) {
            if (e.classList) e.classList.contains(t);
            else new RegExp("(^| )" + t + "( |$)", "gi").test(e.className);
        }
        function J() {
            var e = window.pageXOffset !== undefined,
                t = (document.compatMode || "") === "CSS1Compat",
                a = e ? window.pageXOffset : t ? document.documentElement.scrollLeft : document.body.scrollLeft,
                r = e ? window.pageYOffset : t ? document.documentElement.scrollTop : document.body.scrollTop;
            return { x: a, y: r };
        }
        function X(e) {
            e.stopPropagation();
        }
        function ee(t) {
            return function (e) {
                return t + e;
            };
        }
        var te = window.navigator.pointerEnabled
            ? { start: "pointerdown", move: "pointermove", end: "pointerup" }
            : window.navigator.msPointerEnabled
                ? { start: "MSPointerDown", move: "MSPointerMove", end: "MSPointerUp" }
                : { start: "mousedown touchstart", move: "mousemove touchmove", end: "mouseup touchend" },
            ae = "noUi-";
        function l(e, t) {
            return 100 / (t - e);
        }
        function r(e, t) {
            return (t * 100) / (e[1] - e[0]);
        }
        function c(e, t) {
            return r(e, e[0] < 0 ? t + Math.abs(e[0]) : t - e[0]);
        }
        function u(e, t) {
            return (t * (e[1] - e[0])) / 100 + e[0];
        }
        function d(e, t) {
            var a = 1;
            while (e >= t[a]) a += 1;
            return a;
        }
        function a(e, t, a) {
            if (a >= e.slice(-1)[0]) return 100;
            var r = d(a, e),
                n,
                s,
                o,
                i;
            n = e[r - 1];
            s = e[r];
            o = t[r - 1];
            i = t[r];
            return o + c([n, s], a) / l(o, i);
        }
        function s(e, t, a) {
            if (a >= 100) return e.slice(-1)[0];
            var r = d(a, t),
                n,
                s,
                o,
                i;
            n = e[r - 1];
            s = e[r];
            o = t[r - 1];
            i = t[r];
            return u([n, s], (a - o) * l(o, i));
        }
        function o(e, t, a, r) {
            if (r === 100) return r;
            var n = d(r, e),
                s,
                o;
            if (a) {
                s = e[n - 1];
                o = e[n];
                if (r - s > (o - s) / 2) return o;
                return s;
            }
            if (!t[n - 1]) return r;
            return e[n - 1] + i(r - e[n - 1], t[n - 1]);
        }
        function p(e, t, a) {
            var r;
            if (typeof t === "number") t = [t];
            if (Object.prototype.toString.call(t) !== "[object Array]") throw new Error("noUiSlider: 'range' contains invalid value.");
            if (e === "min") r = 0;
            else if (e === "max") r = 100;
            else r = parseFloat(e);
            if (!n(r) || !n(t[0])) throw new Error("noUiSlider: 'range' value isn't numeric.");
            a.xPct.push(r);
            a.xVal.push(t[0]);
            if (!r) {
                if (!isNaN(t[1])) a.xSteps[0] = t[1];
            } else a.xSteps.push(isNaN(t[1]) ? false : t[1]);
        }
        function g(e, t, a) {
            if (!t) return true;
            a.xSteps[e] = r([a.xVal[e], a.xVal[e + 1]], t) / l(a.xPct[e], a.xPct[e + 1]);
        }
        function m(e, t, a, r) {
            this.xPct = [];
            this.xVal = [];
            this.xSteps = [r || false];
            this.xNumSteps = [false];
            this.snap = t;
            this.direction = a;
            var n,
                s = [];
            for (n in e) if (e.hasOwnProperty(n)) s.push([e[n], n]);
            if (s.length && typeof s[0][0] === "object")
                s.sort(function (e, t) {
                    return e[0][0] - t[0][0];
                });
            else
                s.sort(function (e, t) {
                    return e[0] - t[0];
                });
            for (n = 0; n < s.length; n++) p(s[n][1], s[n][0], this);
            this.xNumSteps = this.xSteps.slice(0);
            for (n = 0; n < this.xNumSteps.length; n++) g(n, this.xNumSteps[n], this);
        }
        (m.prototype.getMargin = function (e) {
            return this.xPct.length === 2 ? r(this.xVal, e) : false;
        }),
            (m.prototype.toStepping = function (e) {
                e = a(this.xVal, this.xPct, e);
                if (this.direction) e = 100 - e;
                return e;
            }),
            (m.prototype.fromStepping = function (e) {
                if (this.direction) e = 100 - e;
                return t(s(this.xVal, this.xPct, e));
            }),
            (m.prototype.getStep = function (e) {
                if (this.direction) e = 100 - e;
                e = o(this.xPct, this.xSteps, this.snap, e);
                if (this.direction) e = 100 - e;
                return e;
            }),
            (m.prototype.getApplicableStep = function (e) {
                var t = d(e, this.xPct),
                    a = e === 100 ? 2 : 1;
                return [this.xNumSteps[t - 2], this.xVal[t - a], this.xNumSteps[t - a]];
            }),
            (m.prototype.convert = function (e) {
                return this.getStep(this.toStepping(e));
            });
        var e = {
            to: function (e) {
                return e !== undefined && e.toFixed(2);
            },
            from: Number,
        };
        function h(e, t) {
            if (!n(t)) throw new Error("noUiSlider: 'step' is not numeric.");
            e.singleStep = t;
        }
        function v(e, t) {
            if (typeof t !== "object" || Array.isArray(t)) throw new Error("noUiSlider: 'range' is not an object.");
            if (t.min === undefined || t.max === undefined) throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
            if (t.min === t.max) throw new Error("noUiSlider: 'range' 'min' and 'max' cannot be equal.");
            e.spectrum = new m(t, e.snap, e.dir, e.singleStep);
        }
        function f(e, t) {
            t = Q(t);
            if (!Array.isArray(t) || !t.length || t.length > 2) throw new Error("noUiSlider: 'start' option is incorrect.");
            e.handles = t.length;
            e.start = t;
        }
        function k(e, t) {
            e.snap = t;
            if (typeof t !== "boolean") throw new Error("noUiSlider: 'snap' option must be a boolean.");
        }
        function b(e, t) {
            e.animate = t;
            if (typeof t !== "boolean") throw new Error("noUiSlider: 'animate' option must be a boolean.");
        }
        function y(e, t) {
            if (t === "lower" && e.handles === 1) e.connect = 1;
            else if (t === "upper" && e.handles === 1) e.connect = 2;
            else if (t === true && e.handles === 2) e.connect = 3;
            else if (t === false) e.connect = 0;
            else throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
        }
        function S(e, t) {
            switch (t) {
                case "horizontal":
                    e.ort = 0;
                    break;
                case "vertical":
                    e.ort = 1;
                    break;
                default:
                    throw new Error("noUiSlider: 'orientation' option is invalid.");
            }
        }
        function w(e, t) {
            if (!n(t)) throw new Error("noUiSlider: 'margin' option must be numeric.");
            e.margin = e.spectrum.getMargin(t);
            if (!e.margin) throw new Error("noUiSlider: 'margin' option is only supported on linear sliders.");
        }
        function P(e, t) {
            if (!n(t)) throw new Error("noUiSlider: 'limit' option must be numeric.");
            e.limit = e.spectrum.getMargin(t);
            if (!e.limit) throw new Error("noUiSlider: 'limit' option is only supported on linear sliders.");
        }
        function C(e, t) {
            switch (t) {
                case "ltr":
                    e.dir = 0;
                    break;
                case "rtl":
                    e.dir = 1;
                    e.connect = [0, 2, 1, 3][e.connect];
                    break;
                default:
                    throw new Error("noUiSlider: 'direction' option was not recognized.");
            }
        }
        function L(e, t) {
            if (typeof t !== "string") throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
            var a = t.indexOf("tap") >= 0,
                r = t.indexOf("drag") >= 0,
                n = t.indexOf("fixed") >= 0,
                s = t.indexOf("snap") >= 0,
                o = t.indexOf("hover") >= 0;
            if (r && !e.connect) throw new Error("noUiSlider: 'drag' behaviour must be used with 'connect': true.");
            e.events = { tap: a || s, drag: r, fixed: n, snap: s, hover: o };
        }
        function T(e, t) {
            var a;
            if (t === false) return;
            else if (t === true) {
                e.tooltips = [];
                for (a = 0; a < e.handles; a++) e.tooltips.push(true);
            } else {
                e.tooltips = Q(t);
                if (e.tooltips.length !== e.handles) throw new Error("noUiSlider: must pass a formatter for all handles.");
                e.tooltips.forEach(function (e) {
                    if (typeof e !== "boolean" && (typeof e !== "object" || typeof e.to !== "function")) throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
                });
            }
        }
        function x(e, t) {
            e.format = t;
            if (typeof t.to === "function" && typeof t.from === "function") return true;
            throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
        }
        function E(e, t) {
            if (t !== undefined && typeof t !== "string") throw new Error("noUiSlider: 'cssPrefix' must be a string.");
            e.cssPrefix = t;
        }
        function re(t) {
            var a = { margin: 0, limit: 0, animate: true, format: e },
                r;
            r = {
                step: { r: false, t: h },
                start: { r: true, t: f },
                connect: { r: true, t: y },
                direction: { r: true, t: C },
                snap: { r: false, t: k },
                animate: { r: false, t: b },
                range: { r: true, t: v },
                orientation: { r: false, t: S },
                margin: { r: false, t: w },
                limit: { r: false, t: P },
                behaviour: { r: true, t: L },
                format: { r: false, t: x },
                tooltips: { r: false, t: T },
                cssPrefix: { r: false, t: E },
            };
            var n = { connect: false, direction: "ltr", behaviour: "tap", orientation: "horizontal" };
            Object.keys(r).forEach(function (e) {
                if (t[e] === undefined && n[e] === undefined) {
                    if (r[e].r) throw new Error("noUiSlider: '" + e + "' is required.");
                    return true;
                }
                r[e].t(a, t[e] === undefined ? n[e] : t[e]);
            });
            a.pips = t.pips;
            a.style = a.ort ? "top" : "left";
            return a;
        }
        function R(e, c) {
            var u = e,
                l = [-1, -1],
                s,
                d,
                w = c.spectrum,
                p = [],
                o = {},
                i;
            var g = [
                "target",
                "base",
                "origin",
                "handle",
                "horizontal",
                "vertical",
                "background",
                "connect",
                "ltr",
                "rtl",
                "draggable",
                "",
                "state-drag",
                "",
                "state-tap",
                "active",
                "",
                "stacking",
                "tooltip",
                "",
                "pips",
                "marker",
                "value",
            ].map(ee(c.cssPrefix || ae));
            function m(e, t, a) {
                var r = e + t[0],
                    n = e + t[1];
                if (a) {
                    if (r < 0) n += Math.abs(r);
                    if (n > 100) r -= n - 100;
                    return [K(r), K(n)];
                }
                return [r, n];
            }
            function h(e, t) {
                e.preventDefault();
                var a = e.type.indexOf("touch") === 0,
                    r = e.type.indexOf("mouse") === 0,
                    n = e.type.indexOf("pointer") === 0,
                    s,
                    o,
                    i = e;
                if (e.type.indexOf("MSPointer") === 0) n = true;
                if (a) {
                    s = e.changedTouches[0].pageX;
                    o = e.changedTouches[0].pageY;
                }
                t = t || J();
                if (r || n) {
                    s = e.clientX + t.x;
                    o = e.clientY + t.y;
                }
                i.pageOffset = t;
                i.points = [s, o];
                i.cursor = r || n;
                return i;
            }
            function v(e, t) {
                var a = document.createElement("div"),
                    r = document.createElement("div"),
                    n = ["-lower", "-upper"];
                if (e) n.reverse();
                Y(r, g[3]);
                Y(r, g[3] + n[t]);
                Y(a, g[2]);
                a.appendChild(r);
                return a;
            }
            function t(e, t, a) {
                switch (e) {
                    case 1:
                        Y(t, g[7]);
                        Y(a[0], g[6]);
                        break;
                    case 3:
                        Y(a[1], g[6]);
                    case 2:
                        Y(a[0], g[7]);
                    case 0:
                        Y(t, g[6]);
                        break;
                }
            }
            function a(e, t, a) {
                var r,
                    n = [];
                for (r = 0; r < e; r += 1) n.push(a.appendChild(v(t, r)));
                return n;
            }
            function r(e, t, a) {
                Y(a, g[0]);
                Y(a, g[8 + e]);
                Y(a, g[4 + t]);
                var r = document.createElement("div");
                Y(r, g[1]);
                a.appendChild(r);
                return r;
            }
            function n(e, t) {
                if (!c.tooltips[t]) return false;
                var a = document.createElement("div");
                a.className = g[18];
                return e.firstChild.appendChild(a);
            }
            function f() {
                if (c.dir) c.tooltips.reverse();
                var r = d.map(n);
                if (c.dir) {
                    r.reverse();
                    c.tooltips.reverse();
                }
                B("update", function (e, t, a) {
                    if (r[t]) r[t].innerHTML = c.tooltips[t] === true ? e[t] : c.tooltips[t].to(a[t]);
                });
            }
            function k(e, t, a) {
                if (e === "range" || e === "steps") return w.xVal;
                if (e === "count") {
                    var r = 100 / (t - 1),
                        n,
                        s = 0;
                    t = [];
                    while ((n = s++ * r) <= 100) t.push(n);
                    e = "positions";
                }
                if (e === "positions")
                    return t.map(function (e) {
                        return w.fromStepping(a ? w.getStep(e) : e);
                    });
                if (e === "values") {
                    if (a)
                        return t.map(function (e) {
                            return w.fromStepping(w.getStep(w.toStepping(e)));
                        });
                    return t;
                }
            }
            function b(m, h, v) {
                function f(e, t) {
                    return (e + t).toFixed(7) / 1;
                }
                var e = w.direction,
                    k = {},
                    t = w.xVal[0],
                    a = w.xVal[w.xVal.length - 1],
                    b = false,
                    y = false,
                    S = 0;
                w.direction = 0;
                v = H(
                    v.slice().sort(function (e, t) {
                        return e - t;
                    })
                );
                if (v[0] !== t) {
                    v.unshift(t);
                    b = true;
                }
                if (v[v.length - 1] !== a) {
                    v.push(a);
                    y = true;
                }
                v.forEach(function (e, t) {
                    var a,
                        r,
                        n,
                        s = e,
                        o = v[t + 1],
                        i,
                        l,
                        c,
                        u,
                        d,
                        p,
                        g;
                    if (h === "steps") a = w.xNumSteps[t];
                    if (!a) a = o - s;
                    if (s === false || o === undefined) return;
                    for (r = s; r <= o; r = f(r, a)) {
                        i = w.toStepping(r);
                        l = i - S;
                        d = l / m;
                        p = Math.round(d);
                        g = l / p;
                        for (n = 1; n <= p; n += 1) {
                            c = S + n * g;
                            k[c.toFixed(5)] = ["x", 0];
                        }
                        u = v.indexOf(r) > -1 ? 1 : h === "steps" ? 2 : 0;
                        if (!t && b) u = 0;
                        if (!(r === o && y)) k[i.toFixed(5)] = [r, u];
                        S = i;
                    }
                });
                w.direction = e;
                return k;
            }
            function y(t, a, r) {
                var n = ["horizontal", "vertical"][c.ort],
                    s = document.createElement("div");
                Y(s, g[20]);
                Y(s, g[20] + "-" + n);
                function o(e) {
                    return ["-normal", "-large", "-sub"][e];
                }
                function i(e, t, a) {
                    return 'class="' + t + " " + t + "-" + n + " " + t + o(a[1]) + '" style="' + c.style + ": " + e + '%"';
                }
                function l(e, t) {
                    if (w.direction) e = 100 - e;
                    t[1] = t[1] && a ? a(t[0], t[1]) : t[1];
                    s.innerHTML += "<div " + i(e, g[21], t) + "></div>";
                    if (t[1]) s.innerHTML += "<div " + i(e, g[22], t) + ">" + r.to(t[0]) + "</div>";
                }
                Object.keys(t).forEach(function (e) {
                    l(e, t[e]);
                });
                return s;
            }
            function S(e) {
                var t = e.mode,
                    a = e.density || 1,
                    r = e.filter || false,
                    n = e.values || false,
                    s = e.stepped || false,
                    o = k(t, n, s),
                    i = b(a, t, o),
                    l = e.format || { to: Math.round };
                return u.appendChild(y(i, r, l));
            }
            function P() {
                return s["offset" + ["Width", "Height"][c.ort]];
            }
            function C(a, r, n) {
                if (r !== undefined && c.handles !== 1) r = Math.abs(r - c.dir);
                Object.keys(o).forEach(function (e) {
                    var t = e.split(".")[0];
                    if (a === t)
                        o[e].forEach(function (e) {
                            e.call(i, Q(j()), r, Q(L(Array.prototype.slice.call(p))), n || false);
                        });
                });
            }
            function L(e) {
                if (e.length === 1) return e[0];
                if (c.dir) return e.reverse();
                return e;
            }
            function T(t, a, r, n) {
                var s = function (e) {
                    if (u.hasAttribute("disabled")) return false;
                    if (Z(u, g[14])) return false;
                    e = h(e, n.pageOffset);
                    if (t === te.start && e.buttons !== undefined && e.buttons > 1) return false;
                    if (n.hover && e.buttons) return false;
                    e.calcPoint = e.points[c.ort];
                    r(e, n);
                },
                    o = [];
                t.split(" ").forEach(function (e) {
                    a.addEventListener(e, s, false);
                    o.push([e, s]);
                });
                return o;
            }
            function x(e, t) {
                if (navigator.appVersion.indexOf("MSIE 9") === -1 && e.buttons === 0 && t.buttonsProperty !== 0) return E(e, t);
                var a = t.handles || d,
                    r,
                    n = false,
                    s = ((e.calcPoint - t.start) * 100) / t.baseSize,
                    o = a[0] === d[0] ? 0 : 1,
                    i;
                r = m(s, t.positions, a.length > 1);
                n = _(a[0], r[o], a.length === 1);
                if (a.length > 1) {
                    n = _(a[1], r[o ? 0 : 1], false) || n;
                    if (n) for (i = 0; i < t.handles.length; i++) C("slide", i);
                } else if (n) C("slide", o);
            }
            function E(e, t) {
                var a = s.querySelector("." + g[15]),
                    r = t.handles[0] === d[0] ? 0 : 1;
                if (a !== null) $(a, g[15]);
                if (e.cursor) {
                    document.body.style.cursor = "";
                    document.body.removeEventListener("selectstart", document.body.noUiListener);
                }
                var n = document.documentElement;
                n.noUiListeners.forEach(function (e) {
                    n.removeEventListener(e[0], e[1]);
                });
                $(u, g[12]);
                C("set", r);
                C("change", r);
                if (t.handleNumber !== undefined) C("end", t.handleNumber);
            }
            function R(e, t) {
                if (e.type === "mouseout" && e.target.nodeName === "HTML" && e.relatedTarget === null) E(e, t);
            }
            function O(e, t) {
                var a = document.documentElement;
                if (t.handles.length === 1) {
                    Y(t.handles[0].children[0], g[15]);
                    if (t.handles[0].hasAttribute("disabled")) return false;
                }
                e.preventDefault();
                e.stopPropagation();
                var r = T(te.move, a, x, { start: e.calcPoint, baseSize: P(), pageOffset: e.pageOffset, handles: t.handles, handleNumber: t.handleNumber, buttonsProperty: e.buttons, positions: [l[0], l[d.length - 1]] }),
                    n = T(te.end, a, E, { handles: t.handles, handleNumber: t.handleNumber });
                var s = T("mouseout", a, R, { handles: t.handles, handleNumber: t.handleNumber });
                a.noUiListeners = r.concat(n, s);
                if (e.cursor) {
                    document.body.style.cursor = getComputedStyle(e.target).cursor;
                    if (d.length > 1) Y(u, g[12]);
                    var o = function () {
                        return false;
                    };
                    document.body.noUiListener = o;
                    document.body.addEventListener("selectstart", o, false);
                }
                if (t.handleNumber !== undefined) C("start", t.handleNumber);
            }
            function V(e) {
                var t = e.calcPoint,
                    a = 0,
                    r,
                    n;
                e.stopPropagation();
                d.forEach(function (e) {
                    a += D(e)[c.style];
                });
                r = t < a / 2 || d.length === 1 ? 0 : 1;
                t -= D(s)[c.style];
                n = (t * 100) / P();
                if (!c.events.snap) G(u, g[14], 300);
                if (d[r].hasAttribute("disabled")) return false;
                _(d[r], n);
                C("slide", r, true);
                C("set", r, true);
                C("change", r, true);
                if (c.events.snap) O(e, { handles: [d[r]] });
            }
            function I(e) {
                var t = e.calcPoint - D(s)[c.style],
                    a = w.getStep((t * 100) / P()),
                    r = w.fromStepping(a);
                Object.keys(o).forEach(function (e) {
                    if ("hover" === e.split(".")[0])
                        o[e].forEach(function (e) {
                            e.call(i, r);
                        });
                });
            }
            function A(e) {
                var t, a;
                if (!e.fixed) for (t = 0; t < d.length; t += 1) T(te.start, d[t].children[0], O, { handles: [d[t]], handleNumber: t });
                if (e.tap) T(te.start, s, V, { handles: d });
                if (e.hover) {
                    T(te.move, s, I, { hover: true });
                    for (t = 0; t < d.length; t += 1)
                        ["mousemove MSPointerMove pointermove"].forEach(function (e) {
                            d[t].children[0].addEventListener(e, X, false);
                        });
                }
                if (e.drag) {
                    a = [s.querySelector("." + g[7])];
                    Y(a[0], g[10]);
                    if (e.fixed) a.push(d[a[0] === d[0] ? 1 : 0].children[0]);
                    a.forEach(function (e) {
                        T(te.start, e, O, { handles: d });
                    });
                }
            }
            function _(e, t, a) {
                var r = e !== d[0] ? 1 : 0,
                    n = l[0] + c.margin,
                    s = l[1] - c.margin,
                    o = l[0] + c.limit,
                    i = l[1] - c.limit;
                if (d.length > 1) t = r ? Math.max(t, n) : Math.min(t, s);
                if (a !== false && c.limit && d.length > 1) t = r ? Math.min(t, o) : Math.max(t, i);
                t = w.getStep(t);
                t = K(parseFloat(t.toFixed(7)));
                if (t === l[r]) return false;
                if (window.requestAnimationFrame)
                    window.requestAnimationFrame(function () {
                        e.style[c.style] = t + "%";
                    });
                else e.style[c.style] = t + "%";
                if (!e.previousSibling) {
                    $(e, g[17]);
                    if (t > 50) Y(e, g[17]);
                }
                l[r] = t;
                p[r] = w.fromStepping(t);
                C("update", r);
                return true;
            }
            function U(e, t) {
                var a, r, n;
                if (c.limit) e += 1;
                for (a = 0; a < e; a += 1) {
                    r = a % 2;
                    n = t[r];
                    if (n !== null && n !== false) {
                        if (typeof n === "number") n = String(n);
                        n = c.format.from(n);
                        if (n === false || isNaN(n) || _(d[r], w.toStepping(n), a === 3 - c.dir) === false) C("update", r);
                    }
                }
            }
            function F(e) {
                var t,
                    a = Q(e),
                    r;
                if (c.dir && c.handles > 1) a.reverse();
                if (c.animate && l[0] !== -1) G(u, g[14], 300);
                t = d.length > 1 ? 3 : 1;
                if (a.length === 1) t = 1;
                U(t, a);
                for (r = 0; r < d.length; r++) C("set", r);
            }
            function j() {
                var e,
                    t = [];
                for (e = 0; e < c.handles; e += 1) t[e] = c.format.to(p[e]);
                return L(t);
            }
            function z() {
                g.forEach(function (e) {
                    if (!e) return;
                    $(u, e);
                });
                u.innerHTML = "";
                delete u.noUiSlider;
            }
            function N() {
                var e = l.map(function (e, t) {
                    var a = w.getApplicableStep(e),
                        r = W(String(a[2])),
                        n = p[t],
                        s = e === 100 ? null : a[2],
                        o = Number((n - a[2]).toFixed(r)),
                        i = e === 0 ? null : o >= a[1] ? a[2] : a[0] || false;
                    return [i, s];
                });
                return L(e);
            }
            function B(e, t) {
                o[e] = o[e] || [];
                o[e].push(t);
                if (e.split(".")[0] === "update")
                    d.forEach(function (e, t) {
                        C("update", t);
                    });
            }
            function q(e) {
                var r = e.split(".")[0],
                    n = e.substring(r.length);
                Object.keys(o).forEach(function (e) {
                    var t = e.split(".")[0],
                        a = e.substring(t.length);
                    if ((!r || r === t) && (!n || n === a)) delete o[e];
                });
            }
            function M(t) {
                var e = j(),
                    a,
                    r = re({ start: [0, 0], margin: t.margin, limit: t.limit, step: t.step, range: t.range, animate: t.animate, snap: t.snap === undefined ? c.snap : t.snap });
                ["margin", "limit", "step", "range", "animate"].forEach(function (e) {
                    if (t[e] !== undefined) c[e] = t[e];
                });
                w = r.spectrum;
                l = [-1, -1];
                F(e);
                for (a = 0; a < d.length; a++) C("update", a);
            }
            if (u.noUiSlider) throw new Error("Slider was already initialized.");
            s = r(c.dir, c.ort, u);
            d = a(c.handles, c.dir, s);
            t(c.connect, u, d);
            if (c.pips) S(c.pips);
            if (c.tooltips) f();
            i = { destroy: z, steps: N, on: B, off: q, get: j, set: F, updateOptions: M };
            A(c.events);
            return i;
        }
        function O(e, t) {
            if (!e.nodeName) throw new Error("noUiSlider.create requires a single element.");
            var a = re(t, e),
                r = R(e, a);
            r.set(a.start);
            e.noUiSlider = r;
            return r;
        }
        return { create: O };
    })()),
    (window.wNumb = (function () {
        "use strict";
        var s = ["decimals", "thousand", "mark", "prefix", "suffix", "encoder", "decoder", "negativeBefore", "negative", "edit", "undo"];
        function k(e) {
            return e.split("").reverse().join("");
        }
        function h(e, t) {
            return e.substring(0, t.length) === t;
        }
        function v(e, t) {
            return e.slice(-1 * t.length) === t;
        }
        function o(e, t, a) {
            if ((e[t] || e[a]) && e[t] === e[a]) throw new Error(t);
        }
        function b(e) {
            return typeof e === "number" && isFinite(e);
        }
        function y(e, t) {
            e = e.toString().split("e");
            e = Math.round(+(e[0] + "e" + (e[1] ? +e[1] + t : t)));
            e = e.toString().split("e");
            return (+(e[0] + "e" + (e[1] ? +e[1] - t : -t))).toFixed(t);
        }
        function a(e, t, a, r, n, s, o, i, l, c, u, d) {
            var p = d,
                g,
                m,
                h,
                v = "",
                f = "";
            if (s) d = s(d);
            if (!b(d)) return false;
            if (e !== false && parseFloat(d.toFixed(e)) === 0) d = 0;
            if (d < 0) {
                g = true;
                d = Math.abs(d);
            }
            if (e !== false) d = y(d, e);
            d = d.toString();
            if (d.indexOf(".") !== -1) {
                m = d.split(".");
                h = m[0];
                if (a) v = a + m[1];
            } else h = d;
            if (t) {
                h = k(h).match(/.{1,3}/g);
                h = k(h.join(k(t)));
            }
            if (g && i) f += i;
            if (r) f += r;
            if (g && l) f += l;
            f += h;
            f += v;
            if (n) f += n;
            if (c) f = c(f, p);
            return f;
        }
        function r(e, t, a, r, n, s, o, i, l, c, u, d) {
            var p = d,
                g,
                m = "";
            if (u) d = u(d);
            if (!d || typeof d !== "string") return false;
            if (i && h(d, i)) {
                d = d.replace(i, "");
                g = true;
            }
            if (r && h(d, r)) d = d.replace(r, "");
            if (l && h(d, l)) {
                d = d.replace(l, "");
                g = true;
            }
            if (n && v(d, n)) d = d.slice(0, -1 * n.length);
            if (t) d = d.split(t).join("");
            if (a) d = d.replace(a, ".");
            if (g) m += "-";
            m += d;
            m = m.replace(/[^0-9\.\-.]/g, "");
            if (m === "") return false;
            m = Number(m);
            if (o) m = o(m);
            if (!b(m)) return false;
            return m;
        }
        function e(e) {
            var t,
                a,
                r,
                n = {};
            if (e["suffix"] === undefined) e["suffix"] = e["postfix"];
            for (t = 0; t < s.length; t += 1) {
                a = s[t];
                r = e[a];
                if (r === undefined)
                    if (a === "negative" && !n.negativeBefore) n[a] = "-";
                    else if (a === "mark" && n.thousand !== ".") n[a] = ".";
                    else n[a] = false;
                else if (a === "decimals")
                    if (r >= 0 && r < 8) n[a] = r;
                    else throw new Error(a);
                else if (a === "encoder" || a === "decoder" || a === "edit" || a === "undo")
                    if (typeof r === "function") n[a] = r;
                    else throw new Error(a);
                else if (typeof r === "string") n[a] = r;
                else throw new Error(a);
            }
            o(n, "mark", "thousand");
            o(n, "prefix", "negative");
            o(n, "prefix", "negativeBefore");
            return n;
        }
        function n(e, t, a) {
            var r,
                n = [];
            for (r = 0; r < s.length; r += 1) n.push(e[s[r]]);
            n.push(a);
            return t.apply("", n);
        }
        function i(t) {
            if (!(this instanceof i)) return new i(t);
            if (typeof t !== "object") return;
            t = e(t);
            this.to = function (e) {
                return n(t, a, e);
            };
            this.from = function (e) {
                return n(t, r, e);
            };
        }
        return i;
    })()),
    (function (p) {
        var c = /[+-]?\d+(?:\.\d+)?/;
        var e = {
            initSlider: function (s, o) {
                var i = this,
                    e = p.getSetting(o.settings, "settings.search.searchBoxTarget");
                (e = p.dom.find(".kuPriceSlider [data-querykey]", e)) &&
                    e.forEach(function (l) {
                        var c,
                            e,
                            t,
                            a,
                            u,
                            d,
                            r = l.getAttribute("data-querykey"),
                            n = s.template.query[r];
                        n &&
                            n.filters.forEach(function (e) {
                                e.key == o.priceSliderFilterReqQuery.key && "SLIDER" == e.type && (c = e);
                            }),
                            c &&
                            ((e = ""),
                                (t = !1),
                                (n = p.getObjectPath(o.data, "template.query.productList.result")),
                                "function" == typeof p.search.modules.kmcInputs.base.getPriceFormatterObject && n && n.length
                                    ? (a = p.search.modules.kmcInputs.base.getPriceFormatterObject(o.data.template.query.productList.result[0].currency)) &&
                                    ((e = a.string), ((n = document.createElement("textarea")).innerHTML = e), (e = n.value), (o.recentCurrencySymbol = e), (t = a.atEnd || !1))
                                    : "" == e && void 0 !== o.recentCurrencySymbol && o.recentCurrencySymbol && (e = o.recentCurrencySymbol),
                                (a = {}),
                                !0 === t ? (a.suffix = " " + e) : !1 === t && (a.prefix = e + " "),
                                (a.decimals = 0),
                                l.slider && l.slider.destroy(),
                                (void 0 !== (l.sliderData = c).start && null != c.start) || (c.start = c.min),
                                (void 0 !== c.end && null != c.end) || (c.end = c.max),
                                (l.slider = noUiSlider.create(l, { start: [Math.floor(c.start), Math.ceil(c.end)], connect: !0, tooltips: [!0, !0], range: { min: [Math.floor(c.min)], max: [Math.ceil(c.max)] }, format: wNumb(a) })),
                                (u = !1),
                                (d = (Math.ceil(c.max) - Math.ceil(c.min)) / 2),
                                l.slider.on("update", function (e, t, a) {
                                    u = 0 === t;
                                    var r = a[0],
                                        n = p.dom.find(".noUi-handle-lower .noUi-tooltip", l)[0];
                                    (n.textContent = this.get()[0]), (n.style.display = ""), n.classList.remove("kuMergedTooltip");
                                    var s,
                                        o = a[1],
                                        i = p.dom.find(".noUi-handle-upper .noUi-tooltip", l)[0];
                                    (i.textContent = this.get()[1]),
                                        (i.style.display = ""),
                                        i.classList.remove("kuMergedTooltip"),
                                        o - r <= d &&
                                        ((s = u ? i : n),
                                            (t = a[0] - Math.ceil(c.min)),
                                            Math.ceil(c.max) - a[1] < t ? ((s = i), (n.style.display = "none")) : ((s = n), (i.style.display = "none")),
                                            o - r == 0 ? (s.textContent = this.get()[1]) : ((s.textContent = this.get().join(" - ")), s.classList.add("kuMergedTooltip")));
                                }),
                                l.slider.on("change", function (e, t) {
                                    i.sliderOnUpdateEvent(e, r, s, l, o);
                                }));
                    });
            },
            sliderOnUpdateEvent: function (e, t, a, r, n) {
                var s = Math.ceil(c.exec(e[0])[0]),
                    o = Math.ceil(c.exec(e[1])[0]),
                    i = p.getSetting(n.settings, "settings.search.searchBoxTarget");
                (e = p.dom.helpers.getClosest(p.dom.find(".klevuSliderFilter", i)[0], ".klevuTarget").kElem).kScope.data = e.kObject.resetData(e.kElem);
                var l,
                    n = p.dom.helpers.getClosest(p.dom.find(".klevuSliderFilter", i)[0], ".klevuMeta"),
                    a = (i = a.localOverrides.query[t]).filters,
                    t = { key: r.sliderData.key, settings: { singleSelect: "false" }, values: [s.toString(), o.toString()] };
                a
                    ? ((a = a.applyFilters.filters),
                        (l = !1),
                        a
                            ? (a.forEach(function (e) {
                                e.key == r.sliderData.key && ((l = !0), (e.values = [s.toString(), o.toString()]));
                            }),
                                l || a.push(t))
                            : (i.filters.applyFilters.filters = [t]))
                    : ((i.filters = {}), (i.filters.applyFilters = {}), (i.filters.applyFilters.filters = [t])),
                    p.setObjectPath(e.kScope.data, "localOverrides.query." + n.dataset.section + ".settings.offset", 0),
                    p.event.fireChain(e.kScope, "chains.events.keyUp", e, e.kScope.data, event);
            },
        };
        p.extend(!0, p.search.modules, { filterPriceSlider: { base: e, build: !0 } });
    })(klevu),
    klevu.coreEvent.build({
        name: "filterPriceSliderModuleBuild",
        fire: function () {
            return !!(klevu.search.modules && klevu.search.modules.filterPriceSlider && klevu.search.modules.filterPriceSlider.build);
        },
        maxCount: 500,
        delay: 30,
    }),
    (function (c) {
        c.extend(!0, c.search.modules, {
            infiniteScroll: {
                base: {
                    sendLoadMoreItemsRequest: function (e, t, a) {
                        var r,
                            n,
                            s,
                            o,
                            i = e.target,
                            l = c.dom.helpers.getClosest(i, ".klevuTarget");
                        null !== l &&
                            ((r = c.dom.helpers.getClosest(i, ".klevuMeta")),
                                (s = n = 0),
                                ((i = c.getObjectPath(t.template, "query." + r.dataset.section + ".meta")) && ((n = i.noOfResults), (s = Number(i.offset) + Number(n)) > Number(i.totalResultsFound))) ||
                                (t.context.existingResponse || (t.context.existingResponse = []),
                                    (o = []),
                                    (t = c.getObjectPath(t, "response.current.queryResults")) &&
                                    t.length &&
                                    c.each(t, function (e, t) {
                                        t.id === r.dataset.section && (o = t.records);
                                    }),
                                    ((l = l.kElem).kScope.data = l.kObject.resetData(l.kElem)),
                                    (l.kScope.data.context.keyCode = 0),
                                    (l.kScope.data.context.eventObject = e),
                                    (l.kScope.data.context.event = "keyUp"),
                                    (l.kScope.data.context.triggeredFromInfiniteScroll = !0),
                                    (l.kScope.data.context.infiniteScrollSection = r.dataset.section),
                                    (l.kScope.data.context.existingResponse = o),
                                    (l.kScope.data.context.windowScrollTriggeredForInfiniteScroll = !1),
                                    a && (l.kScope.data.context.quickInfiniteScrollLastScrollPosition = a),
                                    (l.kScope.data.context.preventDefault = !1),
                                    c.setObjectPath(l.kScope.data, "localOverrides.query." + r.dataset.section + ".settings.offset", parseInt(s)),
                                    c.event.fireChain(l.kScope, "chains.events.keyUp", l, l.kScope.data, e)));
                    },
                },
                build: !0,
            },
        });
    })(klevu),
    (function (s) {
        s.isUndefined(s.search.modules.imageSearchUpload) &&
            (s.extend(!0, s.search.modules, {
                imageSearchUpload: {
                    base: {
                        storage: s.dictionary("uploadImage"),
                        initChain: s.chain({ stopOnFalse: !0 }),
                        init: function (e) {
                            var t = s.search.modules.imageSearchUpload.base.initChain;
                            s.isUndefined(t) || 0 === t.list().length || (t.setScope(e), t.setData(e.data), t.fire());
                        },
                        resultsPageInitChain: s.chain({ stopOnFalse: !0 }),
                        initResultsPage: function (e, t) {
                            e.data.template.productQueryId = t;
                            t = s.search.modules.imageSearchUpload.base.resultsPageInitChain;
                            s.isUndefined(t) || 0 === t.list().length || (t.setScope(e), t.setData(e.data), t.fire());
                        },
                    },
                    build: !0,
                },
            }),
                s.search.modules.imageSearchUpload.base.initChain.add({
                    name: "addImageUploadChains",
                    fire: function (e, t) {
                        s.setObjectPath(t.element.kScope, "chains.imageUpload.template.process.success", s.chain({ stopOnFalse: !0 })),
                            s.setObjectPath(t.element.kScope, "chains.imageUpload.template.render", s.chain({ stopOnFalse: !0 })),
                            s.setObjectPath(t.element.kScope, "chains.imageUpload.template.events", s.chain({ stopOnFalse: !0 })),
                            s.setObjectPath(t.element.kScope, "chains.imageUpload.template.upload.success", s.chain({ stopOnFalse: !0 })),
                            s.setObjectPath(t.element.kScope, "chains.imageUpload.template.upload.fail", s.chain({ stopOnFalse: !0 }));
                    },
                }),
                s.search.modules.imageSearchUpload.base.initChain.add({
                    name: "attachTemplateProcessSuccessEvents",
                    fire: function (e, t) {
                        t.chains.imageUpload.template.process.success.add({
                            name: "appendImageIconToSearch",
                            fire: function (t, a) {
                                var e = document.createElement("span");
                                e.classList.add("kuImageSearchSelector"),
                                    (e.innerHTML = ""),
                                    a.kElem.parentNode.insertBefore(e, a.kElem.nextSibling),
                                    s.event.attach(e, "click", function (e) {
                                        s.event.fireChain(a.kScope, "chains.imageUpload.template.render", a.kElem, t, null);
                                    });
                            },
                        });
                    },
                }),
                s.search.modules.imageSearchUpload.base.initChain.add({
                    name: "attachTemplateRenderEvent",
                    fire: function (e, t) {
                        t.chains.imageUpload.template.render.add({
                            name: "hideOtherSearchTargets",
                            fire: function (e, t) {
                                s.each(s.search.extraSearchBox, function (e, t) {
                                    s.getSetting(t.getScope().settings, "settings.search.fullPageLayoutEnabled", !0) || (s.getSetting(t.getScope().settings, "settings.search.searchBoxTarget").style = "display: none !important;");
                                });
                            },
                        }),
                            t.chains.imageUpload.template.render.add({
                                name: "renderTemplates",
                                fire: function (e, t) {
                                    (e.context.term = "*"), (e.context.termOriginal = "*"), (e.template.imageUploadTemplateId = "image-upload-" + t.kScope.id), t.kScope.template.setData(e.template);
                                    var a = t.kScope.template.convertTemplate(t.kScope.template.render("klevuQuickImageSearchContent"));
                                    a.value = "*";
                                    var r = document.createElement("div");
                                    r.classList.add("kuImageSearchWrapBackDrop");
                                    var n = s.getSetting(t.kScope.settings, "settings.search.searchBoxTarget");
                                    (n.innerHTML = ""), n.appendChild(r), n.classList.add("klevuTarget"), n.classList.remove("searchRequestLoading"), (t.kScope.element.kData = e.template), t.kScope.template.insertTemplate(n, a);
                                },
                            }),
                            t.chains.imageUpload.template.render.add({
                                name: "triggerBoxTemplateEvents",
                                fire: function (e, t) {
                                    var a = s.getObjectPath(t.kScope, "chains.template.events");
                                    a.setScope(t.kElem), a.setData(e), a.fire(), s.event.fireChain(t.kScope, "chains.imageUpload.template.events", t.kElem, e, null);
                                },
                            });
                    },
                }),
                s.search.modules.imageSearchUpload.base.initChain.add({
                    name: "attachTemplateEventsEvent",
                    fire: function (e, t) {
                        t.chains.imageUpload.template.events.add({
                            name: "attachImageUploadTemplateEvents",
                            fire: function (e, a) {
                                setTimeout(function () {
                                    var e = s.getSetting(a.kScope.settings, "settings.search.searchBoxTarget"),
                                        t = s.dom.getFirst(".klevuWrap", e);
                                    t && t.classList.add("kuQuickImageSearchWrap"), (e.style = "display: block !important;");
                                }, 10);
                            },
                        }),
                            t.chains.imageUpload.template.events.add({
                                name: "attachUploadTargetEvents",
                                fire: function (e, t) {
                                    var t = s.getSetting(t.kScope.settings, "settings.search.searchBoxTarget"),
                                        r = s.dom.getFirst(".kuQuickUploadImageBtn", t),
                                        a = s.dom.getFirst(".kuImageSearchFile", t);
                                    r &&
                                        (s.event.attach(r, "click", function (e) {
                                            a && a.click();
                                        }),
                                            s.event.attach(a, "change", function (e) {
                                                var t = s.dom.helpers.getClosest(this, ".klevuTarget"),
                                                    a = t.kElem,
                                                    t = s.dom.getFirst(".kuImageUploadErrorMsgContainer", t);
                                                t && (t.innerHTML = ""),
                                                    5 < this.files[0].size / 1024 / 1024
                                                        ? alert("File size exceeds 5 MiB")
                                                        : ((t = s.template().translate("Processing, Please wait...")),
                                                            (r.innerHTML = '<span class="kuUploadText processing">' + t + "</span>"),
                                                            (r.disabled = !0),
                                                            (a = { type: "form", source: this, scope: a, callbacks: { success: "chains.imageUpload.template.upload.success", error: "chains.imageUpload.template.upload.fail" } }),
                                                            s.modules.imageUpload.base.submit(a));
                                            }));
                                },
                            });
                    },
                }),
                s.search.modules.imageSearchUpload.base.initChain.add({
                    name: "attachTemplateUploadEventsEvent",
                    fire: function (e, t) {
                        t.chains.imageUpload.template.upload.success.add({
                            name: "attachTemplateUploadEvents",
                            fire: function (e, t) {
                                s.search.modules.imageSearchUpload.base.storage.setStorage("session"),
                                    s.search.modules.imageSearchUpload.base.storage.mergeFromGlobal(),
                                    s.search.modules.imageSearchUpload.base.storage.addElement("path", s.encode(e.url)),
                                    s.search.modules.imageSearchUpload.base.storage.mergeToGlobal();
                                var a = s.getGlobalSetting("url.landing", "/"),
                                    r = s.getGlobalSetting("url.queryParam", "q"),
                                    e = s.getGlobalSetting("theme.modules.imageSearch.imageSearchQueryParam", "imageSearchUpload");
                                window.location = a + "?" + r + "=*&" + e + "=true";
                            },
                        }),
                            t.chains.imageUpload.template.upload.fail.add({
                                name: "performUploadFailOperation",
                                fire: function (e, t) {
                                    var a = "Something went wrong while processing your request.";
                                    500 == e.status && (a = "Something went wrong while processing your request.");
                                    var r = s.getSetting(t.kScope.settings, "settings.search.searchBoxTarget"),
                                        e = s.dom.getFirst(".kuQuickUploadImageBtn", r);
                                    e && ((t = s.template().translate("Upload a photo")), (e.innerHTML = '<span class="kuUploadText upload">' + t + "</span>"), (e.disabled = !1));
                                    r = s.dom.getFirst(".kuImageUploadErrorMsgContainer", r);
                                    r && (r.innerHTML = "<p>" + a + "</p>");
                                },
                            });
                    },
                }),
                s.search.modules.imageSearchUpload.base.initChain.add({
                    name: "triggerProcessChain",
                    fire: function (e, t) {
                        s.event.fireChain(t.element.kScope, "chains.imageUpload.template.process.success", t.element, e, null);
                    },
                }),
                s.search.modules.imageSearchUpload.base.resultsPageInitChain.add({
                    name: "checkAndGetImageURLPath",
                    fire: function (a, e) {
                        (a.template.kuResultsPageImageUploadEnabled = !1), (a.template.kuResultsPageImageUploadPath = "");
                        var r,
                            t = s.getAllUrlParameters();
                        if (
                            (0 < t.length &&
                                ((r = s.getGlobalSetting("theme.modules.imageSearch.imageSearchQueryParam", "imageSearchUpload")),
                                    s.each(t, function (e, t) {
                                        t.name == r &&
                                            "true" == t.value &&
                                            (s.search.modules.imageSearchUpload.base.storage.setStorage("session"),
                                                s.search.modules.imageSearchUpload.base.storage.mergeFromGlobal(),
                                                (t = s.search.modules.imageSearchUpload.base.storage.getElement("path")) && "path" !== t && ((t = s.decode(t)), (a.template.kuResultsPageImageUploadEnabled = !0)),
                                                (a.template.kuResultsPageImageUploadPath = t));
                                    })),
                                !a.template.kuResultsPageImageUploadEnabled)
                        )
                            return !1;
                    },
                }),
                s.search.modules.imageSearchUpload.base.resultsPageInitChain.add({
                    name: "removeResultPageChains",
                    fire: function (e, t) {
                        t.template.setTemplate("", "klevuLandingTemplateResultsHeadingTitle", !0),
                            t.template.setTemplate("", "tab-results", !0),
                            t.chains.request.build.remove({ name: "addContentList" }),
                            t.chains.template.process.success.remove({ name: "processTabs" }),
                            t.chains.request.control.remove({ name: "setStoredActiveQueryId" });
                    },
                }),
                s.search.modules.imageSearchUpload.base.resultsPageInitChain.add({
                    name: "appendImageUploadDataInSearchQuery",
                    fire: function (e, t) {
                        t.chains.request.control.addBefore("sanitiseRequestQuery", {
                            name: "addImageUploadDetails",
                            fire: function (r, e) {
                                var n = s.getObjectPath(r, "template.productQueryId"),
                                    t = s.getObjectPath(r, "request.current.recordQueries");
                                s.setObjectPath(r, "context.activeQueryId", n);
                                e = s.getSetting(e.kScope.settings, "settings.storage");
                                e && e.tabs && (e.tabs.setStorage("local"), e.tabs.mergeFromGlobal(), e.tabs.addElement("active", n), e.tabs.mergeToGlobal()),
                                    t &&
                                    t.length &&
                                    n &&
                                    s.each(t, function (e, t) {
                                        var a;
                                        t.id == n &&
                                            ((a = s.getObjectPath(t, "settings.context.sourceObjects", [])).push({ typeOfRecord: "KLEVU_IMAGE", records: [{ url: r.template.kuResultsPageImageUploadPath }] }),
                                                s.setObjectPath(t, "settings.context.sourceObjects", a));
                                    });
                            },
                        });
                    },
                }),
                s.search.modules.imageSearchUpload.base.resultsPageInitChain.add({
                    name: "attachResultsPageBannerEvents",
                    fire: function (e, t) {
                        t.chains.template.events.add({
                            name: "attachUploadAnotherBtnEvent",
                            fire: function (e, t) {
                                var a = s.getObjectPath(e, "template.productQueryId"),
                                    t = s.getSetting(t.kScope.settings, "settings.search.searchBoxTarget");
                                s.each(s.dom.find(".klevuMeta[data-section='" + a + "']", t), function (e, t) {
                                    t = s.dom.helpers.getClosest(t, ".klevuWrap");
                                    null !== t && t.classList.add(a + "Active");
                                }),
                                    s.each(s.dom.find(".kuTryAnotherPhotoBtn", t), function (e, a) {
                                        s.event.attach(a, "click", function () {
                                            var e,
                                                t = s.dom.helpers.getClosest(a, ".klevuTarget");
                                            t && (e = s.dom.find(".kuImageSearchSelector", t)), (e && e.length) || (e = s.dom.find(".kuImageSearchSelector")), e && e.length && e[0].click();
                                        });
                                    });
                            },
                        });
                    },
                }));
    })(klevu),
    klevu.extend(!0, klevu.search.modules, {
        locale: {
            globalTranslations: {
                en: {
                    "Visual Image Search": "Visual Image Search",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.",
                    "How does this work?": "How does this work?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "After you take or upload a photo, we'll analyse it and recommend the closest matches.",
                    "We found %s matches to your uploaded photo.": "We found %s matches to your uploaded photo.",
                    "Upload a photo": "Upload a photo",
                    "Try another photo": "Try another photo",
                    "Processing, Please wait...": "Processing, Please wait...",
                },
                ar: {
                    "Visual Image Search": "Ø§Ù„Ø¨Ø­Ø« Ø¹Ù† Ø§Ù„ØµÙˆØ± Ø§Ù„Ù…Ø±Ø¦ÙŠØ©",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Ø®ØµÙˆØµÙŠØªÙƒ Ø£Ù…Ø± ÙÙŠ ØºØ§ÙŠØ© Ø§Ù„Ø£Ù‡Ù…ÙŠØ© Ø¨Ø§Ù„Ù†Ø³Ø¨Ø© Ù„Ù†Ø§. Ù„Ù† ÙŠØªÙ… Ø§Ø³ØªØ®Ø¯Ø§Ù… Ø£ÙŠ ØµÙˆØ± ØªÙ… ØªØ­Ù…ÙŠÙ„Ù‡Ø§ Ø¥Ù„Ø§ Ù„ØªÙˆÙÙŠØ± Ø§Ù„Ù†ØªØ§Ø¦Ø¬ Ø°Ø§Øª Ø§Ù„ØµÙ„Ø© ÙˆØªØ­Ø³ÙŠÙ† ØªØ¬Ø±Ø¨Ø© Ø§Ù„Ø¨Ø­Ø« Ø§Ù„Ø¹Ø§Ù…Ø©. ÙˆÙ…Ø¹ Ø°Ù„ÙƒØŒ Ù†ÙˆØµÙŠ Ø¨Ø¹Ø¯Ù… ØªØ­Ù…ÙŠÙ„ Ø§Ù„ØµÙˆØ± Ø§Ù„ØªÙŠ ØªØ­ØªÙˆÙŠ Ø¹Ù„Ù‰ Ø£Ø´Ø®Ø§Øµ Ø£Ùˆ Ù…Ø¹Ù„ÙˆÙ…Ø§Øª Ø­Ø³Ø§Ø³Ø©.",
                    "How does this work?": "ÙƒÙŠÙ ÙŠØ¹Ù…Ù„ Ù‡Ø°Ø§ØŸ",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "Ø¨Ø¹Ø¯ Ø£Ù† ØªØ£Ø®Ø° Ø£Ùˆ Ø­Ù…Ù„ ØµÙˆØ±Ø©ØŒ Ø³Ù†Ù‚ÙˆÙ… Ø¨ØªØ­Ù„ÙŠÙ„Ù‡Ø§ ÙˆØªÙˆØµÙŠ Ø£Ù‚Ø±Ø¨ Ù…Ø¨Ø§Ø±ÙŠØ§Øª.",
                    "We found %s matches to your uploaded photo.": "ÙˆØ¬Ø¯Ù†Ø§Ùª S Ø§Ù„Ù…Ø¨Ø§Ø±ÙŠØ§Øª Ù„ØµÙˆØ±Ø© Ø§Ù„ØªØ­Ù…ÙŠÙ„ Ø§Ù„Ø®Ø§ØµØ© Ø¨Ùƒ.",
                    "Upload a photo": "Ø­Ù…Ù„ Ø§Ù„ØµÙˆØ±Ø©",
                    "Try another photo": "Ø¬Ø±Ø¨ ØµÙˆØ±Ø© Ø£Ø®Ø±Ù‰",
                    "Processing, Please wait...": "ÙŠØªÙ… Ø§Ù„Ù…Ø¹Ø§Ù„Ø¬Ø© .. Ø§Ù„Ø±Ø¬Ø§Ø¡ Ø§Ù„Ø§Ù†ØªØ¸Ø§Ø±...",
                },
                bg: {
                    "Visual Image Search": "Ð¢ÑŠÑ€ÑÐµÐ½Ðµ Ð½Ð° Ð²Ð¸Ð·ÑƒÐ°Ð»Ð½Ð¾ Ð¸Ð·Ð¾Ð±Ñ€Ð°Ð¶ÐµÐ½Ð¸Ðµ",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Ð’Ð°ÑˆÐ°Ñ‚Ð° Ð¿Ð¾Ð²ÐµÑ€Ð¸Ñ‚ÐµÐ»Ð½Ð¾ÑÑ‚ Ðµ Ð¾Ñ‚ Ð¸Ð·ÐºÐ»ÑŽÑ‡Ð¸Ñ‚ÐµÐ»Ð½Ð¾ Ð·Ð½Ð°Ñ‡ÐµÐ½Ð¸Ðµ Ð·Ð° Ð½Ð°Ñ. Ð’ÑÐ¸Ñ‡ÐºÐ¸ ÐºÐ°Ñ‡ÐµÐ½Ð¸ Ð¸Ð·Ð¾Ð±Ñ€Ð°Ð¶ÐµÐ½Ð¸Ñ Ñ‰Ðµ ÑÐµ Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°Ñ‚ ÑÐ°Ð¼Ð¾ Ð·Ð° Ð¿Ñ€ÐµÐ´Ð¾ÑÑ‚Ð°Ð²ÑÐ½Ðµ Ð½Ð° Ð¿Ð¾Ð´Ñ…Ð¾Ð´ÑÑ‰Ð¸ Ñ€ÐµÐ·ÑƒÐ»Ñ‚Ð°Ñ‚Ð¸ Ð¸ Ð¿Ð¾Ð´Ð¾Ð±Ñ€ÑÐ²Ð°Ð½Ðµ Ð½Ð° Ð¾Ð±Ñ‰Ð¾Ñ‚Ð¾ Ñ‚ÑŠÑ€ÑÐµÐ½Ðµ Ð½Ð° Ñ‚ÑŠÑ€ÑÐµÐ½Ðµ. Ð’ÑŠÐ¿Ñ€ÐµÐºÐ¸ Ñ‚Ð¾Ð²Ð°, Ð¿Ñ€ÐµÐ¿Ð¾Ñ€ÑŠÑ‡Ð²Ð°Ð¼Ðµ Ð´Ð° Ð½Ðµ ÐºÐ°Ñ‡Ð²Ð°Ñ‚Ðµ Ð¸Ð·Ð¾Ð±Ñ€Ð°Ð¶ÐµÐ½Ð¸Ñ, ÑÑŠÐ´ÑŠÑ€Ð¶Ð°Ñ‰Ð¸ Ñ…Ð¾Ñ€Ð° Ð¸Ð»Ð¸ Ñ‡ÑƒÐ²ÑÑ‚Ð²Ð¸Ñ‚ÐµÐ»Ð½Ð° Ð¸Ð½Ñ„Ð¾Ñ€Ð¼Ð°Ñ†Ð¸Ñ.",
                    "How does this work?": "ÐšÐ°Ðº Ñ€Ð°Ð±Ð¾Ñ‚Ð¸ Ñ‚Ð¾Ð²Ð°?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.":
                        "Ð¡Ð»ÐµÐ´ ÐºÐ°Ñ‚Ð¾ Ð²Ð·ÐµÐ¼ÐµÑ‚Ðµ Ð¸Ð»Ð¸ ÐºÐ°Ñ‡Ð¸Ñ‚Ðµ ÑÐ½Ð¸Ð¼ÐºÐ°, Ñ‰Ðµ Ð³Ð¾ Ð°Ð½Ð°Ð»Ð¸Ð·Ð¸Ñ€Ð°Ð¼Ðµ Ð¸ Ð¿Ñ€ÐµÐ¿Ð¾Ñ€ÑŠÑ‡Ð²Ð°Ð¼Ðµ Ð½Ð°Ð¹-Ð±Ð»Ð¸Ð·ÐºÐ¸Ñ‚Ðµ ÑÑŠÐ²Ð¿Ð°Ð´ÐµÐ½Ð¸Ñ.",
                    "We found %s matches to your uploaded photo.": "ÐžÑ‚ÐºÑ€Ð¸Ñ…Ð¼Ðµ %s  ÑÑŠÐ²Ð¿Ð°Ð´ÐµÐ½Ð¸Ñ Ñ ÐºÐ°Ñ‡ÐµÐ½Ð°Ñ‚Ð° ÑÐ½Ð¸Ð¼ÐºÐ°.",
                    "Upload a photo": "ÐšÐ°Ñ‡Ð¸ ÑÐ½Ð¸Ð¼ÐºÐ°",
                    "Try another photo": "ÐžÐ¿Ð¸Ñ‚Ð°Ð¹Ñ‚Ðµ Ð´Ñ€ÑƒÐ³Ð° ÑÐ½Ð¸Ð¼ÐºÐ°",
                    "Processing, Please wait...": "ÐžÐ±Ñ€Ð°Ð±Ð¾Ñ‚ÐºÐ°, Ð¼Ð¾Ð»Ñ, Ð¸Ð·Ñ‡Ð°ÐºÐ°Ð¹Ñ‚Ðµ ...",
                },
                da: {
                    "Visual Image Search": "Visual Image Search",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Dit privatliv er af stÃ¸rste betydning for os. Eventuelle billeder, der uploades, vil kun blive brugt til at levere relevante resultater og forbedre den generelle sÃ¸gning oplevelse. Vi anbefaler dog ikke at uploade billeder, der indeholder personer eller fÃ¸lsomme oplysninger.",
                    "How does this work?": "Hvordan virker det?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "NÃ¥r du tager eller uploader et billede, analyserer vi det og anbefaler de nÃ¦rmeste kampe.",
                    "We found %s matches to your uploaded photo.": "Vi fandt %s  kampe til dit uploadede billede.",
                    "Upload a photo": "Upload et billede.",
                    "Try another photo": "PrÃ¸v et andet billede.",
                    "Processing, Please wait...": "Behandling, vent venligst ...",
                },
                de: {
                    "Visual Image Search": "Visuelle Bildsuche.",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Ihre PrivatsphÃ¤re ist fÃ¼r uns von grÃ¶ÃŸter Bedeutung. Alle hochgeladenen Bilder werden nur verwendet, um relevante Ergebnisse bereitzustellen und das allgemeine Sucherlebnis zu verbessern. Wir empfehlen jedoch, keine Bilder mit Personen oder sensiblen Informationen hochzuladen.",
                    "How does this work?": "Wie funktioniert das?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "Nachdem Sie ein Foto eingenommen oder hochgeladen haben, analysieren wir es und empfehlen die engsten Ãœbereinstimmungen.",
                    "We found %s matches to your uploaded photo.": "Wir haben %s  Spiele zu Ihrem hochgeladenen Foto gefunden.",
                    "Upload a photo": "Lade ein Foto hoch",
                    "Try another photo": "Versuchen Sie ein anderes Foto",
                    "Processing, Please wait...": "Verarbeite .. Bitte warten...",
                },
                el: {
                    "Visual Image Search": "Î‘Î½Î±Î¶Î®Ï„Î·ÏƒÎ· Î¿Ï€Ï„Î¹ÎºÎ®Ï‚ ÎµÎ¹ÎºÏŒÎ½Î±Ï‚",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Î¤Î¿ Î±Ï€ÏŒÏÏÎ·Ï„ÏŒ ÏƒÎ±Ï‚ ÎµÎ¯Î½Î±Î¹ ÎµÎ¾Î±Î¹ÏÎµÏ„Î¹ÎºÎ¬ ÏƒÎ·Î¼Î±Î½Ï„Î¹ÎºÏŒ Î³Î¹Î± ÎµÎ¼Î¬Ï‚. ÎŸÏ€Î¿Î¹ÎµÏƒÎ´Î®Ï€Î¿Ï„Îµ Î¼Î¿ÏÏ†Î¿Ï€Î¿Î¹Î·Î¼Î­Î½ÎµÏ‚ ÎµÎ¹ÎºÏŒÎ½ÎµÏ‚ Î¸Î± Ï‡ÏÎ·ÏƒÎ¹Î¼Î¿Ï€Î¿Î¹Î·Î¸Î¿ÏÎ½ Î¼ÏŒÎ½Î¿ Î³Î¹Î± Ï„Î·Î½ Ï€Î±ÏÎ¿Ï‡Î® ÏƒÏ‡ÎµÏ„Î¹ÎºÏŽÎ½ Î±Ï€Î¿Ï„ÎµÎ»ÎµÏƒÎ¼Î¬Ï„Ï‰Î½ ÎºÎ±Î¹ Ï„Î· Î²ÎµÎ»Ï„Î¯Ï‰ÏƒÎ· Ï„Î·Ï‚ Î³ÎµÎ½Î¹ÎºÎ®Ï‚ ÎµÎ¼Ï€ÎµÎ¹ÏÎ¯Î±Ï‚ Î±Î½Î±Î¶Î®Ï„Î·ÏƒÎ·Ï‚. Î©ÏƒÏ„ÏŒÏƒÎ¿, ÏƒÏ…Î½Î¹ÏƒÏ„Î¿ÏÎ¼Îµ Î½Î± Î¼Î·Î½ Î¼ÎµÏ„Î±Ï†Î¿ÏÏ„ÏŽÏƒÎµÏ„Îµ ÎµÎ¹ÎºÏŒÎ½ÎµÏ‚ Ï€Î¿Ï… Ï€ÎµÏÎ¹Î­Ï‡Î¿Ï…Î½ Î¬Ï„Î¿Î¼Î± Î® ÎµÏ…Î±Î¯ÏƒÎ¸Î·Ï„ÎµÏ‚ Ï€Î»Î·ÏÎ¿Ï†Î¿ÏÎ¯ÎµÏ‚.",
                    "How does this work?": "Î Ï‰Ï‚ Î»ÎµÎ¹Ï„Î¿Ï…ÏÎ³ÎµÎ¯ Î±Ï…Ï„ÏŒ?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.":
                        "Î‘Ï†Î¿Ï Ï€Î¬ÏÎµÏ„Îµ Î® Î±Î½ÎµÎ²Î¬ÏƒÎµÏ„Îµ Î¼Î¹Î± Ï†Ï‰Ï„Î¿Î³ÏÎ±Ï†Î¯Î±, Î¸Î± Ï„Î¿ Î±Î½Î±Î»ÏÏƒÎ¿Ï…Î¼Îµ ÎºÎ±Î¹ Î¸Î± ÏƒÏ…ÏƒÏ„Î®ÏƒÎµÏ„Îµ Ï„Î¿Ï…Ï‚ Ï€Î»Î·ÏƒÎ¹Î­ÏƒÏ„ÎµÏÎ¿Ï…Ï‚ Î±Î³ÏŽÎ½ÎµÏ‚.",
                    "We found %s matches to your uploaded photo.": "Î’ÏÎ­Î¸Î·ÎºÎ±Î½ %s  Î±Î³ÏŽÎ½ÎµÏ‚ ÏƒÏ„Î· Ï†Ï‰Ï„Î¿Î³ÏÎ±Ï†Î¯Î± Ï€Î¿Ï… Î±Î½ÎµÎ²Î¬ÏƒÏ„Î·ÎºÎµ.",
                    "Upload a photo": "Î‘Î½Î­Î²Î±ÏƒÎµ Î¼Î¹Î± Ï†Ï‰Ï„Î¿Î³ÏÎ±Ï†Î¯Î±",
                    "Try another photo": "Î”Î¿ÎºÎ¹Î¼Î¬ÏƒÏ„Îµ Î¼Î¹Î± Î¬Î»Î»Î· Ï†Ï‰Ï„Î¿Î³ÏÎ±Ï†Î¯Î±",
                    "Processing, Please wait...": "Î•Ï€ÎµÎ¾ÎµÏÎ³Î±ÏƒÎ¯Î±, Ï€Î±ÏÎ±ÎºÎ±Î»ÏŽ Ï€ÎµÏÎ¹Î¼Î­Î½ÎµÏ„Îµ ...",
                },
                es: {
                    "Visual Image Search": "BÃºsqueda de imÃ¡genes visuales",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Su privacidad es de suma importancia para nosotros. Cualquier imagen cargada solo se utilizarÃ¡ para proporcionar resultados relevantes y mejorar la experiencia de bÃºsqueda general. Sin embargo, recomendamos no cargar imÃ¡genes que contengan personas o informaciÃ³n confidencial.",
                    "How does this work?": "Â¿Como funciona esto?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "DespuÃ©s de tomar o subir o subir una foto, lo analizaremos y recomendaremos las coincidencias mÃ¡s cercanas.",
                    "We found %s matches to your uploaded photo.": "Encontramos fÃ³sforos %s  a su foto cargada.",
                    "Upload a photo": "Sube una foto",
                    "Try another photo": "Intenta otra foto",
                    "Processing, Please wait...": "Procesando .. por favor espere...",
                },
                et: {
                    "Visual Image Search": "Visual Pildiotsing",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Teie privaatsus on meile Ã¤Ã¤rmiselt oluline. KÃµik Ã¼leslaaditud pildid kasutatakse ainult asjakohaste tulemuste esitamiseks ja Ã¼ldise otsingukogemuse parandamiseks. Siiski soovitame Ã¼les laadida inimesi ega tundlikku teavet sisaldavate piltide Ã¼leslaadimist.",
                    "How does this work?": "Kuidas see tÃ¶Ã¶tab?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "PÃ¤rast pildi vÃµtmist vÃµi Ã¼leslaadimist analÃ¼Ã¼me seda ja soovitame kÃµige lÃ¤hemaid vasteid.",
                    "We found %s matches to your uploaded photo.": "Leidsime oma Ã¼leslaaditud fotole %s ocess.",
                    "Upload a photo": "Laadi Foto Ã¼les",
                    "Try another photo": "Proovige teist fotot",
                    "Processing, Please wait...": "TÃ¶Ã¶tlemine, palun oodake ...",
                },
                fa: {
                    "Visual Image Search": "Ø¬Ø³ØªØ¬ÙˆÛŒ ØªØµÙˆÛŒØ± ØªØµÙˆÛŒØ±ÛŒ",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Ø­Ø±ÛŒÙ… Ø®ØµÙˆØµÛŒ Ø´Ù…Ø§ Ø¨Ø±Ø§ÛŒ Ù…Ø§ Ø¨Ø³ÛŒØ§Ø± Ù…Ù‡Ù… Ø§Ø³Øª. Ù‡Ø± Ú¯ÙˆÙ†Ù‡ ØªØµØ§ÙˆÛŒØ±ÛŒ Ø¢Ù¾Ù„ÙˆØ¯ Ø´Ø¯Ù‡ ØªÙ†Ù‡Ø§ Ø¨Ø±Ø§ÛŒ Ø§Ø±Ø§Ø¦Ù‡ Ù†ØªØ§ÛŒØ¬ Ù…Ø±Ø¨ÙˆØ·Ù‡ Ùˆ Ø¨Ù‡Ø¨ÙˆØ¯ ØªØ¬Ø±Ø¨Ù‡ Ø¬Ø³ØªØ¬ÙˆÛŒ Ø¹Ù…ÙˆÙ…ÛŒ Ø§Ø³ØªÙØ§Ø¯Ù‡ Ù…ÛŒ Ø´ÙˆØ¯. Ø¨Ø§ Ø§ÛŒÙ† Ø­Ø§Ù„ØŒ Ù…Ø§ ØªÙˆØµÛŒÙ‡ Ù…ÛŒ Ú©Ù†ÛŒÙ… ØªØµØ§ÙˆÛŒØ± Ø­Ø§ÙˆÛŒ Ø§ÙØ±Ø§Ø¯ ÛŒØ§ Ø§Ø·Ù„Ø§Ø¹Ø§Øª Ø­Ø³Ø§Ø³ Ø±Ø§ Ø¢Ù¾Ù„ÙˆØ¯ Ù†Ú©Ù†ÛŒØ¯.",
                    "How does this work?": "Ø§ÛŒÙ† Ú†Ø·ÙˆØ±ÛŒ Ú©Ø§Ø± Ù…ÛŒÚ©Ù†Ù‡ØŸ",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.":
                        "Ù¾Ø³ Ø§Ø² Ú¯Ø±ÙØªÙ† Ø¹Ú©Ø³ ÛŒØ§ Ø¢Ù¾Ù„ÙˆØ¯ Ø¹Ú©Ø³ØŒ Ù…Ø§ Ø¢Ù† Ø±Ø§ ØªØ¬Ø²ÛŒÙ‡ Ùˆ ØªØ­Ù„ÛŒÙ„ Ùˆ ØªÙˆØµÛŒÙ‡ Ù†Ø²Ø¯ÛŒÚ© ØªØ±ÛŒÙ† Ù…Ø³Ø§Ø¨Ù‚Ø§Øª.",
                    "We found %s matches to your uploaded photo.": "Ù…Ø§Ùª S Ø±Ø§ Ø¨Ù‡ Ø¹Ú©Ø³ Ø¢Ù¾Ù„ÙˆØ¯ Ú©Ø±Ø¯ÛŒÙ….",
                    "Upload a photo": "ÛŒÚ© Ø¹Ú©Ø³ Ø¢Ù¾Ù„ÙˆØ¯ Ú©Ù†ÛŒØ¯",
                    "Try another photo": "Ø¹Ú©Ø³ Ø¯ÛŒÚ¯Ø±ÛŒ Ø±Ø§ Ø§Ù…ØªØ­Ø§Ù† Ú©Ù†ÛŒØ¯",
                    "Processing, Please wait...": "Ø¯Ø± Ø­Ø§Ù„ Ù¾Ø±Ø¯Ø§Ø²Ø´ ... Ù„Ø·ÙØ§ ØµØ¨Ø± Ú©Ù†ÛŒØ¯...",
                },
                fi: {
                    "Visual Image Search": "Visual Image Search",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Yksityisyys on Ã¤Ã¤rimmÃ¤isen tÃ¤rkeÃ¤Ã¤ meille. Kaikki ladatut kuvat kÃ¤ytetÃ¤Ã¤n vain asiaankuuluvien tulosten tarjoamiseen ja parantamaan yleistÃ¤ hakukokemusta. Suosittelemme kuitenkin, ettei kuvien ladata ihmisiÃ¤ tai arkaluonteisia tietoja.",
                    "How does this work?": "Miten tÃ¤mÃ¤ toimii?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "Kun otat tai lataa valokuvan, analysoimme sen ja suosittelemme lÃ¤himpÃ¤Ã¤n otteluihin.",
                    "We found %s matches to your uploaded photo.": "LÃ¶ysimme%: n ottelut ladattuun valokuvaan.",
                    "Upload a photo": "Lataa kuva",
                    "Try another photo": "Kokeile toista kuvaa",
                    "Processing, Please wait...": "KÃ¤sittely, odota ...",
                },
                fr: {
                    "Visual Image Search": "Recherche d'image visuelle",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Votre vie privÃ©e est d'une importance capitale pour nous. Toutes les images tÃ©lÃ©chargÃ©es ne seront utilisÃ©es que pour fournir des rÃ©sultats pertinents et amÃ©liorer l'expÃ©rience de recherche gÃ©nÃ©rale. Cependant, nous vous recommandons de ne pas tÃ©lÃ©charger des images contenant des personnes ou des informations sensibles.",
                    "How does this work?": "Comment cela marche-t-il?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "AprÃ¨s avoir pris ou tÃ©lÃ©charger une photo, nous l'analyserons et recommanderons les correspondances les plus proches.",
                    "We found %s matches to your uploaded photo.": "Nous avons trouvÃ© %s  correspond Ã  votre photo tÃ©lÃ©chargÃ©e.",
                    "Upload a photo": "TÃ©lÃ©charger une photo",
                    "Try another photo": "Essayez une autre photo",
                    "Processing, Please wait...": "Traitement, veuillez patienter ...",
                },
                he: {
                    "Visual Image Search": "×—×™×¤×•×© ×ª×ž×•× ×” ×—×–×•×ª×™×ª",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "×”×¤×¨×˜×™×•×ª ×©×œ×š ×”×™× ×‘×¢×œ×ª ×—×©×™×‘×•×ª ×¢×œ×™×•× ×” ×œ× ×•. ×›×œ ×”×ª×ž×•× ×•×ª ×©×”×•×¢×œ×• ×¨×§ ×œ×©×ž×© ×›×“×™ ×œ×¡×¤×§ ×ª×•×¦××•×ª ×¨×œ×•×•× ×˜×™×•×ª ×•×œ×©×¤×¨ ××ª ×—×•×•×™×™×ª ×”×—×™×¤×•×© ×”×›×œ×œ×™×ª. ×¢× ×–××ª, ×× ×• ×ž×ž×œ×™×¦×™× ×œ× ×œ×”×¢×œ×•×ª ×ª×ž×•× ×•×ª ×”×ž×›×™×œ×•×ª ×× ×©×™× ××• ×ž×™×“×¢ ×¨×’×™×©.",
                    "How does this work?": "××™×š ×–×” ×¢×•×‘×“?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "×œ××—×¨ ×©×ª×™×§×— ××• ×”×¢×œ×” ×ª×ž×•× ×”, × × ×ª×— ××•×ª×• ×•×ž×ž×œ×™×¥ ×¢×œ ×”×”×ª××ž×•×ª ×”×§×¨×•×‘×•×ª ×‘×™×•×ª×¨.",
                    "We found %s matches to your uploaded photo.": "×ž×¦×× ×• %s  ×’×¤×¨×•×¨×™× ×œ×ª×¦×œ×•× ×©×”×•×¢×œ×” ×©×œ×š.",
                    "Upload a photo": "×œ×”×¢×œ×•×ª ×ª×ž×•× ×”",
                    "Try another photo": "× ×¡×” ×ª×ž×•× ×” ××—×¨×ª",
                    "Processing, Please wait...": "×¢×™×‘×•×“, ×× × ×”×ž×ª×Ÿ ...",
                },
                hr: {
                    "Visual Image Search": "TraÅ¾i vizualnu sliku",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "VaÅ¡a privatnost je od najveÄ‡e vaÅ¾nosti za nas. Sve prenesene slike koristit Ä‡e se samo za pruÅ¾anje relevantnih rezultata i poboljÅ¡anje opÄ‡eg iskustva pretraÅ¾ivanja. MeÄ‘utim, preporuÄujemo da ne uÄitate slike koje sadrÅ¾e ljude ili osjetljive informacije.",
                    "How does this work?": "Kako ovo radi?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "Nakon Å¡to preuzmete ili prenesete fotografiju, analizirat Ä‡emo ga i preporuÄiti najbliÅ¾e utakmice.",
                    "We found %s matches to your uploaded photo.": "PronaÅ¡li smo %s  utakmice na vaÅ¡u prenesenu fotografiju.",
                    "Upload a photo": "Uploadovati sliku",
                    "Try another photo": "PokuÅ¡ajte s drugom fotografijom",
                    "Processing, Please wait...": "Obrada, priÄekajte ...",
                },
                hu: {
                    "Visual Image Search": "VizuÃ¡lis kÃ©pkeresÃ©s",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Az Ã–n magÃ¡nÃ©letÃ©nek rendkÃ­vÃ¼l fontos szÃ¡munkra. A feltÃ¶ltÃ¶tt kÃ©pek csak a relevÃ¡ns eredmÃ©nyek biztosÃ­tÃ¡sÃ¡ra szolgÃ¡lnak, Ã©s javÃ­tjÃ¡k az Ã¡ltalÃ¡nos keresÃ©si Ã©lmÃ©nyt. Ugyanakkor azt javasoljuk, hogy ne tÃ¶ltsÃ¶n fel az embereket tartalmazÃ³ kÃ©peket vagy az Ã©rzÃ©keny informÃ¡ciÃ³kat.",
                    "How does this work?": "Hogy mÅ±kÃ¶dik ez?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "MiutÃ¡n felvett egy fotÃ³t, elemezzÃ¼k, Ã©s javasoljuk a legkÃ¶zelebbi mÃ©rkÅ‘zÃ©st.",
                    "We found %s matches to your uploaded photo.": "TalÃ¡ltunk %s mÃ©rkÅ‘zÃ©st a feltÃ¶ltÃ¶tt fotÃ³hoz.",
                    "Upload a photo": "TÃ¶lts fel egy fotÃ³t",
                    "Try another photo": "PrÃ³bÃ¡ljon ki egy mÃ¡sik fÃ©nykÃ©pet",
                    "Processing, Please wait...": "A feldolgozÃ¡s, vÃ¡rjon ...",
                },
                is: {
                    "Visual Image Search": "Visual Image Search.",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "PersÃ³nuvernd Ã¾Ã­n er afar mikilvÃ¦gt fyrir okkur. Allar myndir sem hlaÃ°iÃ° eru upp verÃ°a aÃ°eins notaÃ°ar til aÃ° veita viÃ°eigandi niÃ°urstÃ¶Ã°ur og bÃ¦ta almenna leitarniÃ°urstÃ¶Ã°ur. Hins vegar mÃ¦lum viÃ° meÃ° ekki aÃ° hlaÃ°a upp myndum sem innihalda fÃ³lk eÃ°a viÃ°kvÃ¦mar upplÃ½singar.",
                    "How does this work?": "Hvernig virkar Ã¾etta?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "Eftir aÃ° Ã¾Ãº hefur tekiÃ° eÃ°a hlaÃ°iÃ° upp mynd, munum viÃ° greina Ã¾aÃ° og mÃ¦la meÃ° nÃ¡nustu leikjum.",
                    "We found %s matches to your uploaded photo.": "ViÃ° fundum %s passar viÃ° hlaÃ°iÃ° myndina Ã¾Ã­na.",
                    "Upload a photo": "Hladdu upp mynd",
                    "Try another photo": "PrÃ³faÃ°u annaÃ° mynd",
                    "Processing, Please wait...": "Vinnsla, vinsamlega bÃ­Ã°iÃ° ...",
                },
                it: {
                    "Visual Image Search": "Ricerca dell'immagine visiva",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "La tua privacy Ã¨ della massima importanza per noi. Qualsiasi immagine caricata verrÃ  utilizzata solo per fornire risultati pertinenti e migliorare l'esperienza di ricerca generale. Tuttavia, consigliamo di non caricare immagini contenenti persone o informazioni sensibili.",
                    "How does this work?": "Come funziona?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "Dopo aver preso o caricare una foto, analizzeremo e raccomanderemo le partite piÃ¹ vicine.",
                    "We found %s matches to your uploaded photo.": "Abbiamo trovato %s  corrispondano alla tua foto caricata.",
                    "Upload a photo": "Carica una foto",
                    "Try another photo": "Prova un'altra foto",
                    "Processing, Please wait...": "Elaborazione, per favore aspetta ...",
                },
                ja: {
                    "Visual Image Search": "ãƒ“ã‚¸ãƒ¥ã‚¢ãƒ«ã‚¤ãƒ¡ãƒ¼ã‚¸æ¤œç´¢",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "ã‚ãªãŸã®ãƒ—ãƒ©ã‚¤ãƒã‚·ãƒ¼ã¯ç§ãŸã¡ã«ã¨ã£ã¦æœ€ã‚‚é‡è¦ã§ã™ã€‚ã‚¢ãƒƒãƒ—ãƒ­ãƒ¼ãƒ‰ã•ã‚ŒãŸç”»åƒã¯ã™ã¹ã¦ã€é–¢é€£ã™ã‚‹çµæžœã‚’æä¾›ã—ã€ä¸€èˆ¬çš„ãªæ¤œç´¢ä½“é¨“ã‚’å‘ä¸Šã•ã›ã‚‹ãŸã‚ã«ã®ã¿ä½¿ç”¨ã•ã‚Œã¾ã™ã€‚ãŸã ã—ã€äººã‚„æ©Ÿå¯†æƒ…å ±ã‚’å«ã‚€ç”»åƒã‚’ã‚¢ãƒƒãƒ—ãƒ­ãƒ¼ãƒ‰ã—ãªã„ã“ã¨ã‚’ãŠå‹§ã‚ã—ã¾ã™ã€‚",
                    "How does this work?": "ã“ã‚Œã¯ã©ã®ã‚ˆã†ã«ä½œå‹•ã—ã¾ã™ã‹ï¼Ÿ",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "å†™çœŸã‚’æ’®ã£ãŸã‚Šã‚¢ãƒƒãƒ—ãƒ­ãƒ¼ãƒ‰ã—ãŸå¾Œã¯ã€åˆ†æžã—ãŸã‚Šã€æœ€ã‚‚è¿‘ã„ä¸€è‡´ã‚’ãŠå‹§ã‚ã—ã¾ã™ã€‚",
                    "We found %s matches to your uploaded photo.": "ã‚¢ãƒƒãƒ—ãƒ­ãƒ¼ãƒ‰ã•ã‚ŒãŸå†™çœŸã« %s ãŒä¸€è‡´ã—ã¦ã„ã¾ã™ã€‚",
                    "Upload a photo": "å†™çœŸã‚’ã‚¢ãƒƒãƒ—ãƒ­ãƒ¼ãƒ‰ã—ã¦ãã ã•ã„",
                    "Try another photo": "åˆ¥ã®å†™çœŸã‚’è©¦ã—ã¦ã¿ã¦ãã ã•ã„",
                    "Processing, Please wait...": "å‡¦ç†ã€ãŠå¾…ã¡ãã ã•ã„...",
                },
                ko: {
                    "Visual Image Search": "ì‹œê°ì  ì´ë¯¸ì§€ ê²€ìƒ‰",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "ê·€í•˜ì˜ ê°œì¸ ì •ë³´ëŠ” ìš°ë¦¬ì—ê²Œ ê°€ìž¥ ì¤‘ìš”í•©ë‹ˆë‹¤. ì—…ë¡œë“œ ëœ ëª¨ë“  ì´ë¯¸ì§€ëŠ” ê´€ë ¨ ê²°ê³¼ë¥¼ ì œê³µí•˜ê³  ì¼ë°˜ ê²€ìƒ‰ ê²½í—˜ì„ í–¥ìƒì‹œí‚¤ëŠ” ë°ì—ë§Œ ì‚¬ìš©ë©ë‹ˆë‹¤. ê·¸ëŸ¬ë‚˜ ì‚¬ëžŒë“¤ì´ë‚˜ ë¯¼ê°í•œ ì •ë³´ê°€ í¬í•¨ ëœ ì´ë¯¸ì§€ë¥¼ ì—…ë¡œë“œí•˜ì§€ ì•ŠëŠ” ê²ƒì´ ì¢‹ìŠµë‹ˆë‹¤.",
                    "How does this work?": "ì´ ì¼ì€ ì–´ë–»ê²Œ ìž‘ë™í•©ë‹ˆê¹Œ?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "ì‚¬ì§„ì„ ì°ê±°ë‚˜ ì—…ë¡œë“œ í•œ í›„ì—ëŠ” ê·¸ê²ƒì„ ë¶„ì„í•˜ê³  ê°€ìž¥ ê°€ê¹Œìš´ ì¼ì¹˜ë¥¼ ì¶”ì²œí•©ë‹ˆë‹¤.",
                    "We found %s matches to your uploaded photo.": "ì—…ë¡œë“œ ëœ ì‚¬ì§„ê³¼ ì¼ì¹˜í•˜ëŠ”  %s  ì¼ì¹˜ë¥¼ ë°œê²¬í–ˆìŠµë‹ˆë‹¤.",
                    "Upload a photo": "ì‚¬ì§„ ì—…ë¡œë“œ",
                    "Try another photo": "ë‹¤ë¥¸ ì‚¬ì§„ì„ ì‹œë„í•˜ì‹­ì‹œì˜¤",
                    "Processing, Please wait...": "ê°€ê³µ, ê¸°ë‹¤ë ¤ì£¼ì‹­ì‹œì˜¤ ...",
                },
                lv: {
                    "Visual Image Search": "Visual Image Search",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "JÅ«su privÄtums ir ÄrkÄrtÄ«gi svarÄ«gs mums. Visi augÅ¡upielÄdÄ“tie attÄ“li tiks izmantoti tikai, lai sniegtu atbilstoÅ¡us rezultÄtus un uzlabotu vispÄrÄ“jo meklÄ“Å¡anas pieredzi. TomÄ“r mÄ“s iesakÄm ne augÅ¡upielÄdÄ“t attÄ“lus, kas satur cilvÄ“kus vai konfidenciÄlu informÄciju.",
                    "How does this work?": "KÄ tas darbojas?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "PÄ“c tam, kad esat lietojis vai augÅ¡upielÄdÄ“jis fotoattÄ“lu, mÄ“s to analizÄ“sim un ieteiks tuvÄkÄs spÄ“les.",
                    "We found %s matches to your uploaded photo.": "MÄ“s atradÄm %s  atbilstu jÅ«su augÅ¡upielÄdÄ“tajam fotoattÄ“lam.",
                    "Upload a photo": "AugÅ¡upielÄdÄ“jiet fotoattÄ“lu",
                    "Try another photo": "IzmÄ“Ä£iniet citu fotoattÄ“lu",
                    "Processing, Please wait...": "ApstrÄde, lÅ«dzu, uzgaidiet ...",
                },
                nb: {
                    "Visual Image Search": "Visual Image Search.",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Ditt privatliv er av stÃ¸rste betydning for oss. Eventuelle bilder lastet opp vil bare brukes til Ã¥ gi relevante resultater og forbedre den generelle sÃ¸keopplevelsen. Vi anbefaler imidlertid ikke Ã¥ laste opp bilder som inneholder personer eller sensitiv informasjon.",
                    "How does this work?": "Hvordan virker dette?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "NÃ¥r du har tatt eller laste opp et bilde, analyserer vi det og anbefaler de nÃ¦rmeste kampene.",
                    "We found %s matches to your uploaded photo.": "Vi fant %s  kamper til ditt opplastede bilde.",
                    "Upload a photo": "Last opp et foto",
                    "Try another photo": "PrÃ¸v et annet bilde",
                    "Processing, Please wait...": "Behandling, vennligst vent ...",
                },
                nl: {
                    "Visual Image Search": "Visual Image Search",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Uw privacy is van het grootste belang voor ons. Alle afbeeldingen die worden geÃ¼pload, worden alleen gebruikt om relevante resultaten te bieden en de algemene zoekervaring te verbeteren. We raden echter aan om afbeeldingen met mensen of gevoelige informatie niet te uploaden.",
                    "How does this work?": "Hoe werkt dit?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "Nadat u een foto hebt gebruikt of uploadt, analyseren we het en bevelen we de dichtstbijzijnde overeenkomsten aan.",
                    "We found %s matches to your uploaded photo.": "We hebben %s  wedstrijden gevonden op uw geÃ¼ploade foto.",
                    "Upload a photo": "Upload een foto",
                    "Try another photo": "Probeer een andere foto",
                    "Processing, Please wait...": "Aan het verwerken ... Even wachten, a.u.b...",
                },
                no: {
                    "Visual Image Search": "Visual Image Search.",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Ditt privatliv er av stÃ¸rste betydning for oss. Eventuelle bilder lastet opp vil bare brukes til Ã¥ gi relevante resultater og forbedre den generelle sÃ¸keopplevelsen. Vi anbefaler imidlertid ikke Ã¥ laste opp bilder som inneholder personer eller sensitiv informasjon.",
                    "How does this work?": "Hvordan virker dette?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "NÃ¥r du har tatt eller laste opp et bilde, analyserer vi det og anbefaler de nÃ¦rmeste kampene.",
                    "We found %s matches to your uploaded photo.": "Vi fant %s  kamper til ditt opplastede bilde.",
                    "Upload a photo": "Last opp et foto",
                    "Try another photo": "PrÃ¸v et annet bilde",
                    "Processing, Please wait...": "Behandling, vennligst vent ...",
                },
                pl: {
                    "Visual Image Search": "Wyszukiwanie wizualne",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Twoja prywatnoÅ›Ä‡ jest dla nas niezwykle waÅ¼na. Wszelkie przesyÅ‚ane obrazy bÄ™dÄ… uÅ¼ywane tylko w celu zapewnienia odpowiednich wynikÃ³w i poprawy doÅ›wiadczenia wyszukiwania ogÃ³lnego. Zalecamy jednak nie przesyÅ‚anie obrazÃ³w zawierajÄ…cych ludzi lub poufne informacje.",
                    "How does this work?": "Jak to dziaÅ‚a?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "Po wziÄ™ciu lub przesÅ‚aniu zdjÄ™cia przeanalizujemy go i zalecamy najbliÅ¼sze mecze.",
                    "We found %s matches to your uploaded photo.": "ZnaleÅºliÅ›my dopasowania %s  do przesÅ‚anego zdjÄ™cia.",
                    "Upload a photo": "ZaÅ‚aduj zdjÄ™cie",
                    "Try another photo": "WyprÃ³buj inne zdjÄ™cie",
                    "Processing, Please wait...": "Przetwarzanie ... ProszÄ™ czekaÄ‡...",
                },
                pt: {
                    "Visual Image Search": "Pesquisa de imagem visual",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Sua privacidade Ã© de extrema importÃ¢ncia para nÃ³s. Quaisquer imagens carregadas sÃ³ serÃ£o usadas para fornecer resultados relevantes e melhorar a experiÃªncia de pesquisa geral. No entanto, recomendamos nÃ£o fazer upload de imagens contendo pessoas ou informaÃ§Ãµes confidenciais.",
                    "How does this work?": "Como Ã© que isso funciona?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "Depois de tomar ou carregar uma foto, vamos analisÃ¡-lo e recomendar os jogos mais prÃ³ximos.",
                    "We found %s matches to your uploaded photo.": "Encontramos %s  corresponde Ã  sua foto carregada.",
                    "Upload a photo": "Carregar uma foto",
                    "Try another photo": "Tente outra foto",
                    "Processing, Please wait...": "Processando ... Por favor aguarde...",
                },
                ro: {
                    "Visual Image Search": "CÄƒutarea imaginii vizuale",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "ConfidenÈ›ialitatea dvs. este de cea mai mare importanÈ›Äƒ pentru noi. Orice imagini Ã®ncÄƒrcate vor fi utilizate numai pentru a furniza rezultate relevante È™i pentru a Ã®mbunÄƒtÄƒÈ›i experienÈ›a de cÄƒutare generalÄƒ. Cu toate acestea, recomandÄƒm sÄƒ nu Ã®ncÄƒrcaÈ›i imagini care conÈ›in persoane sau informaÈ›ii sensibile.",
                    "How does this work?": "Cum funcÈ›ioneazÄƒ asta?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "DupÄƒ ce luaÈ›i sau Ã®ncÄƒrcaÈ›i o fotografie, o vom analiza È™i vom recomanda cele mai apropiate meciuri.",
                    "We found %s matches to your uploaded photo.": "Am gÄƒsit meciurile %s  la fotografia dvs. Ã®ncÄƒrcatÄƒ.",
                    "Upload a photo": "ÃŽncarcÄƒ o pozÄƒ",
                    "Try another photo": "ÃŽncercaÈ›i o altÄƒ fotografie",
                    "Processing, Please wait...": "Prelucrarea, aÈ™teptaÈ›i ...",
                },
                ru: {
                    "Visual Image Search": "ÐŸÐ¾Ð¸ÑÐº Ð²Ð¸Ð·ÑƒÐ°Ð»ÑŒÐ½Ð¾Ð³Ð¾ Ð¸Ð·Ð¾Ð±Ñ€Ð°Ð¶ÐµÐ½Ð¸Ñ",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Ð’Ð°ÑˆÐ° ÐºÐ¾Ð½Ñ„Ð¸Ð´ÐµÐ½Ñ†Ð¸Ð°Ð»ÑŒÐ½Ð¾ÑÑ‚ÑŒ Ð¸Ð¼ÐµÐµÑ‚ Ð¿ÐµÑ€Ð²Ð¾ÑÑ‚ÐµÐ¿ÐµÐ½Ð½Ð¾Ðµ Ð·Ð½Ð°Ñ‡ÐµÐ½Ð¸Ðµ Ð´Ð»Ñ Ð½Ð°Ñ. Ð›ÑŽÐ±Ñ‹Ðµ Ð·Ð°Ð³Ñ€ÑƒÐ·ÐºÐ¸ Ð¸Ð·Ð¾Ð±Ñ€Ð°Ð¶ÐµÐ½Ð¸Ð¹ Ð±ÑƒÐ´ÑƒÑ‚ Ð¸ÑÐ¿Ð¾Ð»ÑŒÐ·Ð¾Ð²Ð°Ñ‚ÑŒÑÑ Ñ‚Ð¾Ð»ÑŒÐºÐ¾ Ð´Ð»Ñ Ð¿Ñ€ÐµÐ´Ð¾ÑÑ‚Ð°Ð²Ð»ÐµÐ½Ð¸Ñ ÑÐ¾Ð¾Ñ‚Ð²ÐµÑ‚ÑÑ‚Ð²ÑƒÑŽÑ‰Ð¸Ñ… Ñ€ÐµÐ·ÑƒÐ»ÑŒÑ‚Ð°Ñ‚Ð¾Ð² Ð¸ ÑƒÐ»ÑƒÑ‡ÑˆÐ¸Ñ‚ÑŒ Ð¾Ð±Ñ‰Ð¸Ð¹ Ð¾Ð¿Ñ‹Ñ‚ Ð¿Ð¾Ð¸ÑÐºÐ°. ÐžÐ´Ð½Ð°ÐºÐ¾ Ð¼Ñ‹ Ñ€ÐµÐºÐ¾Ð¼ÐµÐ½Ð´ÑƒÐµÐ¼ Ð½Ðµ Ð·Ð°Ð³Ñ€ÑƒÐ¶Ð°Ñ‚ÑŒ Ð¸Ð·Ð¾Ð±Ñ€Ð°Ð¶ÐµÐ½Ð¸Ñ, ÑÐ¾Ð´ÐµÑ€Ð¶Ð°Ñ‰Ð¸Ðµ Ð»ÑŽÐ´ÐµÐ¹ Ð¸Ð»Ð¸ ÐºÐ¾Ð½Ñ„Ð¸Ð´ÐµÐ½Ñ†Ð¸Ð°Ð»ÑŒÐ½ÑƒÑŽ Ð¸Ð½Ñ„Ð¾Ñ€Ð¼Ð°Ñ†Ð¸ÑŽ.",
                    "How does this work?": "ÐšÐ°Ðº ÑÑ‚Ð¾ Ñ€Ð°Ð±Ð¾Ñ‚Ð°ÐµÑ‚?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.":
                        "ÐŸÐ¾ÑÐ»Ðµ Ñ‚Ð¾Ð³Ð¾, ÐºÐ°Ðº Ð²Ñ‹ Ð²Ð¾Ð·ÑŒÐ¼ÐµÑ‚Ðµ Ð¸Ð»Ð¸ Ð·Ð°Ð³Ñ€ÑƒÐ·Ð¸Ñ‚Ðµ Ñ„Ð¾Ñ‚Ð¾Ð³Ñ€Ð°Ñ„Ð¸ÑŽ, Ð¼Ñ‹ Ð¿Ñ€Ð¾Ð°Ð½Ð°Ð»Ð¸Ð·Ð¸Ñ€ÑƒÐµÐ¼ ÐµÐ³Ð¾ Ð¸ Ñ€ÐµÐºÐ¾Ð¼ÐµÐ½Ð´ÑƒÐµÐ¼ Ð½Ð°Ð¸Ð±Ð¾Ð»ÐµÐµ Ð±Ð»Ð¸Ð·ÐºÐ¸Ðµ Ð¼Ð°Ñ‚Ñ‡Ð¸.",
                    "We found %s matches to your uploaded photo.": "ÐœÑ‹ Ð½Ð°ÑˆÐ»Ð¸ %s  ÑÐ¾Ð¿Ð¾ÑÑ‚Ð°Ð²Ð»ÐµÐ½Ð¸Ñ Ð½Ð° Ð²Ð°ÑˆÑƒ Ð·Ð°Ð³Ñ€ÑƒÐ¶ÐµÐ½Ð½ÑƒÑŽ Ñ„Ð¾Ñ‚Ð¾Ð³Ñ€Ð°Ñ„Ð¸ÑŽ.",
                    "Upload a photo": "Ð—Ð°Ð³Ñ€ÑƒÐ·Ð¸Ñ‚ÑŒ Ñ„Ð¾Ñ‚Ð¾",
                    "Try another photo": "ÐŸÐ¾Ð¿Ñ€Ð¾Ð±ÑƒÐ¹Ñ‚Ðµ Ð´Ñ€ÑƒÐ³ÑƒÑŽ Ñ„Ð¾Ñ‚Ð¾Ð³Ñ€Ð°Ñ„Ð¸ÑŽ",
                    "Processing, Please wait...": "ÐžÐ±Ñ€Ð°Ð±Ð¾Ñ‚ÐºÐ°, Ð¿Ð¾Ð¶Ð°Ð»ÑƒÐ¹ÑÑ‚Ð°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸Ñ‚Ðµ ...",
                },
                sk: {
                    "Visual Image Search": "VizuÃ¡lne vyhÄ¾adÃ¡vanie obrÃ¡zkov",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "VaÅ¡e sÃºkromie je pre nÃ¡s mimoriadne dÃ´leÅ¾itÃ©. VÅ¡etky nahranÃ© obrÃ¡zky sa pouÅ¾ijÃº len na poskytovanie relevantnÃ½ch vÃ½sledkov a zlepÅ¡iÅ¥ vÅ¡eobecnÃ© vyhÄ¾adÃ¡vacie skÃºsenosti. OdporÃºÄame vÅ¡ak nahraÅ¥ obrÃ¡zky obsahujÃºce osoby alebo citlivÃ© informÃ¡cie.",
                    "How does this work?": "Ako to funguje?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "Po prijatÃ­ alebo odovzdenÃ­ fotografie ho budeme analyzovaÅ¥ a odporuÄiÅ¥ najbliÅ¾Å¡ie zÃ¡pasy.",
                    "We found %s matches to your uploaded photo.": "Na nahranÃº fotografiu sme naÅ¡li %s .",
                    "Upload a photo": "NahraÅ¥ fotku",
                    "Try another photo": "SkÃºste inÃº fotografiu",
                    "Processing, Please wait...": "Spracovanie, poÄkajte ...",
                },
                sl: {
                    "Visual Image Search": "Iskanje vizualne slike",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "VaÅ¡a zasebnost nam je zelo pomembna. Vse naloÅ¾ene slike bodo uporabljene le za zagotavljanje ustreznih rezultatov in izboljÅ¡ale sploÅ¡ne izkuÅ¡nje iskanja. Vendar pa priporoÄamo, da ne nalaganje slik, ki vsebujejo ljudi ali obÄutljive informacije.",
                    "How does this work?": "Kako to deluje?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "Ko vzamete ali naloÅ¾ite fotografijo, jo bomo analizirali in priporoÄili najbliÅ¾je tekme.",
                    "We found %s matches to your uploaded photo.": "NaÅ¡li smo %s  tekmi za vaÅ¡o naloÅ¾eno fotografijo.",
                    "Upload a photo": "Prenesite fotografijo",
                    "Try another photo": "Poskusite drugo fotografijo",
                    "Processing, Please wait...": "Obdelava, poÄakajte ...",
                },
                sr: {
                    "Visual Image Search": "Ð’Ð¸Ð·ÑƒÐµÐ»Ð½Ð° Ð¿Ñ€ÐµÑ‚Ñ€Ð°Ð³Ð° ÑÐ»Ð¸ÐºÐ°",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Ð’Ð°ÑˆÐ° Ð¿Ñ€Ð¸Ð²Ð°Ñ‚Ð½Ð¾ÑÑ‚ Ð½Ð°Ð¼ Ñ˜Ðµ Ð¾Ð´ Ð½Ð°Ñ˜Ð²ÐµÑ›Ðµ Ð²Ð°Ð¶Ð½Ð¾ÑÑ‚Ð¸. Ð‘Ð¸Ð»Ð¾ ÐºÐ¾Ñ˜Ðµ Ð¿Ð¾ÑÑ‚Ð°Ð²Ñ™ÐµÐ½Ðµ ÑÐ»Ð¸ÐºÐµ ÐºÐ¾Ñ€Ð¸ÑÑ‚Ð¸Ñ›Ðµ ÑÐµ ÑÐ°Ð¼Ð¾ Ð·Ð° Ð¿Ñ€ÑƒÐ¶Ð°ÑšÐµ Ñ€ÐµÐ»ÐµÐ²Ð°Ð½Ñ‚Ð½Ð¸Ñ… Ñ€ÐµÐ·ÑƒÐ»Ñ‚Ð°Ñ‚Ð° Ð¸ Ð¿Ð¾Ð±Ð¾Ñ™ÑˆÐ°ÑšÐµ Ð¾Ð¿ÑˆÑ‚ÐµÐ³ Ð¸ÑÐºÑƒÑÑ‚Ð²Ð° Ð·Ð° Ð¿Ñ€ÐµÑ‚Ñ€Ð°Ð³Ñƒ. ÐœÐµÑ’ÑƒÑ‚Ð¸Ð¼, Ð¿Ñ€ÐµÐ¿Ð¾Ñ€ÑƒÑ‡ÑƒÑ˜ÐµÐ¼Ð¾ Ð´Ð° Ð½Ðµ Ð¿Ñ€ÐµÐ½ÐµÑÐµÑ‚Ðµ ÑÐ»Ð¸ÐºÐµ ÐºÐ¾Ñ˜Ðµ ÑÐ°Ð´Ñ€Ð¶Ðµ Ñ™ÑƒÐ´Ðµ Ð¸Ð»Ð¸ Ð¾ÑÐµÑ‚Ñ™Ð¸Ð²Ðµ Ð¸Ð½Ñ„Ð¾Ñ€Ð¼Ð°Ñ†Ð¸Ñ˜Ðµ.",
                    "How does this work?": "ÐšÐ°ÐºÐ¾ Ð¾Ð²Ð¾ Ñ€Ð°Ð´Ð¸?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.":
                        "ÐÐ°ÐºÐ¾Ð½ ÑˆÑ‚Ð¾ ÑƒÐ·Ð¼ÐµÑ‚Ðµ Ð¸Ð»Ð¸ Ð¿Ñ€ÐµÐ½ÐµÑÐµÑ‚Ðµ Ñ„Ð¾Ñ‚Ð¾Ð³Ñ€Ð°Ñ„Ð¸Ñ˜Ñƒ, Ð°Ð½Ð°Ð»Ð¸Ð·Ð¸Ñ€Ð°Ñ›ÐµÐ¼Ð¾ Ð³Ð° Ð¸ Ð¿Ñ€ÐµÐ¿Ð¾Ñ€ÑƒÑ‡Ð¸Ñ‚Ð¸ Ð½Ð°Ñ˜Ð±Ð»Ð¸Ð¶Ðµ Ð¼ÐµÑ‡ÐµÐ²Ðµ.",
                    "We found %s matches to your uploaded photo.": "ÐŸÑ€Ð¾Ð½Ð°ÑˆÐ»Ð¸ ÑÐ¼Ð¾ %s ÑƒÑ‚Ð°ÐºÐ¼Ð¸Ñ†Ðµ ÑÐ° Ð²Ð°ÑˆÐµ Ð¿Ñ€ÐµÐ½ÐµÑÐµÐ½Ðµ Ñ„Ð¾Ñ‚Ð¾Ð³Ñ€Ð°Ñ„Ð¸Ñ˜Ðµ.",
                    "Upload a photo": "Ð”Ð¾Ð´Ð°Ñ˜ Ñ„Ð¾Ñ‚Ð¾Ð³Ñ€Ð°Ñ„Ð¸Ñ˜Ñƒ",
                    "Try another photo": "ÐŸÑ€Ð¾Ð±Ð°Ñ˜Ñ‚Ðµ Ð´Ñ€ÑƒÐ³Ñƒ Ñ„Ð¾Ñ‚Ð¾Ð³Ñ€Ð°Ñ„Ð¸Ñ˜Ñƒ",
                    "Processing, Please wait...": "ÐžÐ±Ñ€Ð°Ð´Ð°, Ð¿Ñ€Ð¸Ñ‡ÐµÐºÐ°Ñ˜Ñ‚Ðµ ...",
                },
                sv: {
                    "Visual Image Search": "Visuell bildsÃ¶kning",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Din integritet Ã¤r av yttersta vikt fÃ¶r oss. Alla uppladdade bilder kommer endast att anvÃ¤ndas fÃ¶r att ge relevanta resultat och fÃ¶rbÃ¤ttra den allmÃ¤nna sÃ¶kupplevelsen. Vi rekommenderar dock att du inte laddar upp bilder som innehÃ¥ller personer eller kÃ¤nslig information.",
                    "How does this work?": "Hur fungerar detta?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "NÃ¤r du har tagit eller ladda upp ett foto, analyserar vi det och rekommenderar de nÃ¤rmaste matcherna.",
                    "We found %s matches to your uploaded photo.": "Vi hittade %s  matcher till ditt uppladdade foto.",
                    "Upload a photo": "Ladda upp ett foto",
                    "Try another photo": "Prova ett annat foto",
                    "Processing, Please wait...": "Bearbetning, vÃ¤nligen vÃ¤nta ...",
                },
                tr: {
                    "Visual Image Search": "GÃ¶rsel GÃ¶rÃ¼ntÃ¼ Arama",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "GizliliÄŸiniz bizim iÃ§in Ã§ok Ã¶nemlidir. YÃ¼klenen herhangi bir gÃ¶rÃ¼ntÃ¼ yalnÄ±zca ilgili sonuÃ§lar vermek ve genel arama deneyimini geliÅŸtirmek iÃ§in kullanÄ±lacaktÄ±r. Ancak, insanlarÄ± veya hassas bilgileri iÃ§eren gÃ¶rÃ¼ntÃ¼leri yÃ¼klememizi Ã¶neririz.",
                    "How does this work?": "Bu nasÄ±l Ã§alÄ±ÅŸÄ±yor?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "Bir fotoÄŸraf Ã§ekip yÃ¼kledikten sonra, analiz edeceÄŸiz ve en yakÄ±n eÅŸleÅŸmeyi Ã¶neririz.",
                    "We found %s matches to your uploaded photo.": "YÃ¼klenen fotoÄŸrafÄ±nÄ±zla %s  eÅŸleÅŸmelerini bulduk.",
                    "Upload a photo": "Bir fotoÄŸraf yÃ¼kle",
                    "Try another photo": "BaÅŸka bir fotoÄŸraf deneyin",
                    "Processing, Please wait...": "Ä°ÅŸleniyor .. LÃ¼tfen bekleyin...",
                },
                vi: {
                    "Visual Image Search": "TÃ¬m kiáº¿m hÃ¬nh áº£nh trá»±c quan",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "Quyá»n riÃªng tÆ° cá»§a báº¡n lÃ  vÃ´ cÃ¹ng quan trá»ng Ä‘á»‘i vá»›i chÃºng tÃ´i. Báº¥t ká»³ hÃ¬nh áº£nh Ä‘Æ°á»£c táº£i lÃªn sáº½ chá»‰ Ä‘Æ°á»£c sá»­ dá»¥ng Ä‘á»ƒ cung cáº¥p káº¿t quáº£ cÃ³ liÃªn quan vÃ  cáº£i thiá»‡n tráº£i nghiá»‡m tÃ¬m kiáº¿m chung. Tuy nhiÃªn, chÃºng tÃ´i khuyÃªn báº¡n khÃ´ng nÃªn táº£i lÃªn hÃ¬nh áº£nh cÃ³ chá»©a ngÆ°á»i hoáº·c thÃ´ng tin nháº¡y cáº£m.",
                    "How does this work?": "CÃ¡i nÃ y hoáº¡t Ä‘á»™ng ra sao?",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.":
                        "Sau khi báº¡n chá»¥p hoáº·c táº£i lÃªn má»™t bá»©c áº£nh, chÃºng tÃ´i sáº½ phÃ¢n tÃ­ch nÃ³ vÃ  Ä‘á» xuáº¥t cÃ¡c tráº­n Ä‘áº¥u gáº§n nháº¥t.",
                    "We found %s matches to your uploaded photo.": "ChÃºng tÃ´i tÃ¬m tháº¥y %s  khá»›p vá»›i áº£nh Ä‘Ã£ táº£i lÃªn cá»§a báº¡n.",
                    "Upload a photo": "Táº£i lÃªn má»™t bá»©c áº£nh",
                    "Try another photo": "HÃ£y thá»­ má»™t bá»©c áº£nh khÃ¡c",
                    "Processing, Please wait...": "Cháº¿ biáº¿n .. Xin vui lÃ²ng chá» Ä‘á»£i...",
                },
                zh: {
                    "Visual Image Search": "è§†è§‰å›¾åƒæœç´¢",
                    "Your privacy is of utmost importance to us. Any images uploaded will only be used to provide relevant results and improve the general search experience. However, we recommend not uploading images containing people or sensitive information.":
                        "æ‚¨çš„éšç§å¯¹æˆ‘ä»¬è‡³å…³é‡è¦ã€‚ä¸Šä¼ çš„ä»»ä½•å›¾åƒéƒ½å°†ä»…ç”¨äºŽæä¾›ç›¸å…³ç»“æžœå¹¶æé«˜ä¸€èˆ¬æœç´¢ä½“éªŒã€‚ä½†æ˜¯ï¼Œæˆ‘ä»¬å»ºè®®ä¸è¦ä¸Šä¼ åŒ…å«äººå‘˜æˆ–æ•æ„Ÿä¿¡æ¯çš„å›¾åƒã€‚",
                    "How does this work?": "è¿™æ˜¯å¦‚ä½•è¿ä½œçš„ï¼Ÿ",
                    "After you take or upload a photo, we'll analyse it and recommend the closest matches.": "æ‹æ‘„æˆ–ä¸Šä¼ ç…§ç‰‡åŽï¼Œæˆ‘ä»¬å°†åˆ†æžå®ƒå¹¶æŽ¨èæœ€æŽ¥è¿‘çš„æ¯”èµ›ã€‚",
                    "We found %s matches to your uploaded photo.": "æˆ‘ä»¬å‘çŽ° %s åŒ¹é…åˆ°æ‚¨ä¸Šä¼ çš„ç…§ç‰‡ã€‚",
                    "Upload a photo": "ä¸Šä¼ ä¸€å¼ ç…§ç‰‡",
                    "Try another photo": "å°è¯•å¦ä¸€å¼ ç…§ç‰‡",
                    "Processing, Please wait...": "å¤„ç†ï¼Œè¯·ç¨å€™...",
                },
            },
        },
    }),
    klevu.extend(!0, klevu.search.modules, {
        locale: {
            globalTranslations: {
                en: { "We're sorry, no results found for": "We're sorry, no results found for", "Please type in at least 3 letters...": "Please type in at least 3 letters...", "Add to cart": "Add to cart" },
                ar: {
                    "We're sorry, no results found for": "Ù†Ø­Ù† Ø¢Ø³ÙÙˆÙ†ØŒ Ù„Ù… ÙŠØªÙ… Ø§Ù„Ø¹Ø«ÙˆØ± Ø¹Ù„Ù‰ Ù†ØªØ§Ø¦Ø¬ Ù„",
                    "Please type in at least 3 letters...": "ÙŠØ±Ø¬Ù‰ ÙƒØªØ§Ø¨Ø© 3 Ø£Ø­Ø±Ù Ø¹Ù„Ù‰ Ø§Ù„Ø£Ù‚Ù„ ...",
                    "Add to cart": "Ø£Ø¶Ù Ø¥Ù„Ù‰ Ø§Ù„Ø³Ù„Ø©",
                },
                bg: {
                    "We're sorry, no results found for": "Ð¡ÑŠÐ¶Ð°Ð»ÑÐ²Ð°Ð¼Ðµ, Ð½ÑÐ¼Ð° Ð½Ð°Ð¼ÐµÑ€ÐµÐ½Ð¸ Ñ€ÐµÐ·ÑƒÐ»Ñ‚Ð°Ñ‚Ð¸ Ð·Ð°",
                    "Please type in at least 3 letters...": "ÐœÐ¾Ð»Ñ, Ð²ÑŠÐ²ÐµÐ´ÐµÑ‚Ðµ Ð½Ð°Ð¹-Ð¼Ð°Ð»ÐºÐ¾ 3 Ð±ÑƒÐºÐ²Ð¸ ...",
                    "Add to cart": "Ð”Ð¾Ð±Ð°Ð²Ð¸ Ð² ÐºÐ¾ÑˆÐ½Ð¸Ñ†Ð°Ñ‚Ð°",
                },
                da: { "We're sorry, no results found for": "Vi beklager, ingen resultater fundet for", "Please type in at least 3 letters...": "Indtast venligst mindst 3 bogstaver ...", "Add to cart": "TilfÃ¸j til kurv" },
                de: {
                    "We're sorry, no results found for": "Es tut uns leid, keine Ergebnisse gefunden fÃ¼r",
                    "Please type in at least 3 letters...": "Bitte geben Sie mindestens 3 Buchstaben ein ...",
                    "Add to cart": "In den Warenkorb legen",
                },
                el: {
                    "We're sorry, no results found for": "Î›Ï…Ï€Î¿ÏÎ¼Î±ÏƒÏ„Îµ, Î´ÎµÎ½ Î²ÏÎ­Î¸Î·ÎºÎ±Î½ Î±Ï€Î¿Ï„ÎµÎ»Î­ÏƒÎ¼Î±Ï„Î±",
                    "Please type in at least 3 letters...": "Î Î»Î·ÎºÏ„ÏÎ¿Î»Î¿Î³Î®ÏƒÏ„Îµ Ï„Î¿Ï…Î»Î¬Ï‡Î¹ÏƒÏ„Î¿Î½ 3 Î³ÏÎ¬Î¼Î¼Î±Ï„Î± ...",
                    "Add to cart": "Î ÏÎ¿ÏƒÎ¸Î®ÎºÎ· ÏƒÏ„Î¿ ÎºÎ±Î»Î¬Î¸Î¹",
                },
                es: { "We're sorry, no results found for": "Lo sentimos, no se han encontrado resultados para", "Please type in at least 3 letters...": "Por favor, escriba al menos 3 letras ...", "Add to cart": "AÃ±adir a la cesta" },
                et: { "We're sorry, no results found for": "Vabandame, tulemusi ei leitud", "Please type in at least 3 letters...": "Palun sisesta vÃ¤hemalt 3 tÃ¤hte ...", "Add to cart": "Lisa ostukorvi" },
                fa: {
                    "We're sorry, no results found for": "Ù…ØªØ§Ø³ÙÛŒÙ…ØŒ Ù‡ÛŒÚ† Ù†ØªÛŒØ¬Ù‡ Ø§ÛŒ Ø¨Ø±Ø§ÛŒ Ø¢Ù† ÛŒØ§ÙØª Ù†Ø´Ø¯",
                    "Please type in at least 3 letters...": "Ù„Ø·ÙØ§ Ø­Ø¯Ø§Ù‚Ù„ 3 Ø­Ø±Ù Ø±Ø§ ØªØ§ÛŒÙ¾ Ú©Ù†ÛŒØ¯ ...",
                    "Add to cart": "Ø§ÙØ²ÙˆØ¯Ù† Ø¨Ù‡ Ø³Ø¨Ø¯ Ø®Ø±ÛŒØ¯",
                },
                fi: { "We're sorry, no results found for": "Pahoittelemme, ettÃ¤ tuloksia ei lÃ¶ytynyt", "Please type in at least 3 letters...": "Kirjoita vÃ¤hintÃ¤Ã¤n 3 kirjainta ...", "Add to cart": "LisÃ¤Ã¤ ostoskoriin" },
                fr: { "We're sorry, no results found for": "Nous sommes dÃ©solÃ©s, aucun rÃ©sultat trouvÃ© pour", "Please type in at least 3 letters...": "Veuillez taper au moins 3 lettres ...", "Add to cart": "Ajouter au panier" },
                he: { "We're sorry, no results found for": "×ž×¦×˜×¢×¨×™×, ×œ× × ×ž×¦××• ×ª×•×¦××•×ª", "Please type in at least 3 letters...": "×× × ×”×§×œ×“ ×œ×¤×—×•×ª 3 ××•×ª×™×•×ª ...", "Add to cart": "×”×•×¡×£ ×œ×¢×’×œ×”" },
                hr: { "We're sorry, no results found for": "Å½ao nam je, nema pronaÄ‘enih rezultata", "Please type in at least 3 letters...": "UpiÅ¡ite najmanje 3 slova ...", "Add to cart": "Dodaj u koÅ¡aricu" },
                hu: { "We're sorry, no results found for": "SajnÃ¡ljuk, nem talÃ¡ltak eredmÃ©nyeket", "Please type in at least 3 letters...": "KÃ©rjÃ¼k, Ã­rja be legalÃ¡bb 3 betÅ±t ...", "Add to cart": "KosÃ¡rba" },
                is: {
                    "We're sorry, no results found for": "ÃžvÃ­ miÃ°ur, engar niÃ°urstÃ¶Ã°ur fundust fyrir",
                    "Please type in at least 3 letters...": "Vinsamlegast slÃ¡Ã°u inn aÃ° minnsta kosti 3 stafir ...",
                    "Add to cart": "Setja Ã­ kÃ¶rfu",
                },
                it: { "We're sorry, no results found for": "Siamo spiacenti, nessun risultato trovato per", "Please type in at least 3 letters...": "Si prega di digitare almeno 3 lettere ...", "Add to cart": "Aggiungi al carrello" },
                ja: { "We're sorry, no results found for": "ç”³ã—è¨³ã‚ã‚Šã¾ã›ã‚“ãŒã€çµæžœã¯è¦‹ã¤ã‹ã‚Šã¾ã›ã‚“ã§ã—ãŸ", "Please type in at least 3 letters...": "å°‘ãªãã¨ã‚‚3æ–‡å­—ã‚’å…¥åŠ›ã—ã¦ãã ã•ã„...", "Add to cart": "ã‚«ãƒ¼ãƒˆã«è¿½åŠ " },
                ko: { "We're sorry, no results found for": "ì£„ì†¡í•©ë‹ˆë‹¤. ê²°ê³¼ê°€ ì—†ìŠµë‹ˆë‹¤", "Please type in at least 3 letters...": "ì ì–´ë„ 3 ê¸€ìžë¥¼ ìž…ë ¥í•˜ì‹­ì‹œì˜¤ ...", "Add to cart": "ìž¥ë°”êµ¬ë‹ˆì— ë‹´ê¸°" },
                lv: { "We're sorry, no results found for": "Atvainojamies, nav atrasti rezultÄti", "Please type in at least 3 letters...": "LÅ«dzu, ierakstiet vismaz 3 burtus ...", "Add to cart": "Pievienot grozam" },
                nb: { "We're sorry, no results found for": "Vi beklager, ingen resultater funnet for", "Please type in at least 3 letters...": "Vennligst skriv inn minst 3 bokstaver ...", "Add to cart": "Legg i handlekurv" },
                nl: { "We're sorry, no results found for": "Het spijt ons, geen resultaten gevonden voor", "Please type in at least 3 letters...": "Typ alstublieft in ten minste 3 letters ...", "Add to cart": "Voeg toe aan winkelkar" },
                no: { "We're sorry, no results found for": "Vi beklager, ingen resultater funnet for", "Please type in at least 3 letters...": "Vennligst skriv inn minst 3 bokstaver ...", "Add to cart": "Legg i handlekurv" },
                pl: { "We're sorry, no results found for": "Przykro nam, nie znaleziono Å¼adnych wynikÃ³w", "Please type in at least 3 letters...": "Wpisz co najmniej 3 litery ...", "Add to cart": "Dodaj do koszyka" },
                pt: { "We're sorry, no results found for": "Lamentamos, nenhum resultado encontrado para", "Please type in at least 3 letters...": "Por favor, digite pelo menos 3 letras ...", "Add to cart": "Adicionar ao Carrinho" },
                ro: { "We're sorry, no results found for": "Ne pare rÄƒu, nu au fost gÄƒsite rezultate", "Please type in at least 3 letters...": "IntroduceÈ›i cel puÈ›in 3 litere ...", "Add to cart": "AdaugÄƒ Ã®n coÈ™" },
                ru: {
                    "We're sorry, no results found for": "Ð˜Ð·Ð²Ð¸Ð½Ð¸Ñ‚Ðµ, Ñ€ÐµÐ·ÑƒÐ»ÑŒÑ‚Ð°Ñ‚Ð¾Ð² Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ð¾ Ð´Ð»Ñ",
                    "Please type in at least 3 letters...": "ÐŸÐ¾Ð¶Ð°Ð»ÑƒÐ¹ÑÑ‚Ð°, Ð²Ð²ÐµÐ´Ð¸Ñ‚Ðµ Ð½Ðµ Ð¼ÐµÐ½ÐµÐµ 3 Ð±ÑƒÐºÐ² ...",
                    "Add to cart": "Ð”Ð¾Ð±Ð°Ð²Ð¸Ñ‚ÑŒ Ð² ÐºÐ¾Ñ€Ð·Ð¸Ð½Ñƒ",
                },
                sk: { "We're sorry, no results found for": "Je nÃ¡m Ä¾Ãºto, nie sÃº nÃ¡jdenÃ© Å¾iadne vÃ½sledky", "Please type in at least 3 letters...": "Zadajte aspoÅˆ 3 pÃ­smenÃ¡ ...", "Add to cart": "PridaÅ¥ do koÅ¡Ã­ka" },
                sl: { "We're sorry, no results found for": "Å½al nam je, ni najdenih rezultatov", "Please type in at least 3 letters...": "Vnesite vsaj 3 Ärke ...", "Add to cart": "Dodaj v voziÄek" },
                sr: {
                    "We're sorry, no results found for": "Ð–Ð°Ð¾ Ð½Ð°Ð¼ Ñ˜Ðµ, Ð½ÐµÐ¼Ð° Ñ€ÐµÐ·ÑƒÐ»Ñ‚Ð°Ñ‚Ð° Ð·Ð°",
                    "Please type in at least 3 letters...": "Ð£Ð½ÐµÑÐ¸Ñ‚Ðµ Ð½Ð°Ñ˜Ð¼Ð°ÑšÐµ 3 ÑÐ»Ð¾Ð²Ð° ...",
                    "Add to cart": "Ð”Ð¾Ð´Ð°Ñ˜ Ñƒ ÐºÐ¾Ð»Ð¸Ñ†Ð°",
                },
                sv: { "We're sorry, no results found for": "Vi Ã¤r ledsna, inga resultat hittades fÃ¶r", "Please type in at least 3 letters...": "VÃ¤nligen skriv in minst 3 bokstÃ¤ver ...", "Add to cart": "LÃ¤gg till i kundvagn" },
                tr: { "We're sorry, no results found for": "ÃœzgÃ¼nÃ¼z, sonuÃ§ bulunamadÄ±", "Please type in at least 3 letters...": "LÃ¼tfen en az 3 harf girin ...", "Add to cart": "Sepete ekle" },
                vi: {
                    "We're sorry, no results found for": "ChÃºng tÃ´i xin lá»—i, khÃ´ng tÃ¬m tháº¥y káº¿t quáº£ nÃ o cho",
                    "Please type in at least 3 letters...": "Vui lÃ²ng nháº­p Ã­t nháº¥t 3 chá»¯ cÃ¡i ...",
                    "Add to cart": "ThÃªm vÃ o giá» hÃ ng",
                },
                zh: { "We're sorry, no results found for": "å¾ˆæŠ±æ­‰ï¼Œæ²¡æœ‰æ‰¾åˆ°ç»“æžœ", "Please type in at least 3 letters...": "è¯·è¾“å…¥è‡³å°‘3ä¸ªå­—æ¯...", "Add to cart": "æ·»åŠ åˆ°è´­ç‰©è½¦" },
            },
        },
    }),
    klevu.extend(!0, klevu.search.modules, {
        locale: {
            globalTranslations: {
                en: { "<b>%s</b> productList": "<b>%s</b> Products", "<b>%s</b> contentList": "<b>%s</b> Other results", "<b>%s</b> cmsCompressed": "<b>%s</b> Other results" },
                ar: { "<b>%s</b> productList": "<b>%s</b> Ù…Ù†ØªØ¬Ø§Øª", "<b>%s</b> contentList": "<b>%s</b> Ø§Ù„Ù†ØªØ§Ø¦Ø¬ Ø§Ù„Ø£Ø®Ø±Ù‰", "<b>%s</b> cmsCompressed": "<b>%s</b> Ø§Ù„Ù†ØªØ§Ø¦Ø¬ Ø§Ù„Ø£Ø®Ø±Ù‰" },
                bg: { "<b>%s</b> productList": "<b>%s</b> ÐŸÑ€Ð¾Ð´ÑƒÐºÑ‚Ð¸", "<b>%s</b> contentList": "<b>%s</b> Ð”Ñ€ÑƒÐ³Ð¸ Ñ€ÐµÐ·ÑƒÐ»Ñ‚Ð°Ñ‚Ð¸", "<b>%s</b> cmsCompressed": "<b>%s</b> Ð”Ñ€ÑƒÐ³Ð¸ Ñ€ÐµÐ·ÑƒÐ»Ñ‚Ð°Ñ‚Ð¸" },
                da: { "<b>%s</b> productList": "<b>%s</b> Produkter", "<b>%s</b> contentList": "<b>%s</b> Andre resultater", "<b>%s</b> cmsCompressed": "<b>%s</b> Andre resultater" },
                de: { "<b>%s</b> productList": "<b>%s</b> Produkte", "<b>%s</b> contentList": "<b>%s</b> Weitere Ergebnisse", "<b>%s</b> cmsCompressed": "<b>%s</b> Weitere Ergebnisse" },
                el: { "<b>%s</b> productList": "<b>%s</b> Î ÏÎ¿ÏŠÏŒÎ½Ï„Î±", "<b>%s</b> contentList": "<b>%s</b> Î†Î»Î»Î± Î±Ï€Î¿Ï„ÎµÎ»Î­ÏƒÎ¼Î±Ï„Î±", "<b>%s</b> cmsCompressed": "<b>%s</b> Î†Î»Î»Î± Î±Ï€Î¿Ï„ÎµÎ»Î­ÏƒÎ¼Î±Ï„Î±" },
                es: { "<b>%s</b> productList": "<b>%s</b> productos", "<b>%s</b> contentList": "<b>%s</b> otros resultados", "<b>%s</b> cmsCompressed": "<b>%s</b> otros resultados" },
                et: { "<b>%s</b> productList": "<b>%s</b> Tooted", "<b>%s</b> contentList": "<b>%s</b> muud tulemused", "<b>%s</b> cmsCompressed": "<b>%s</b> muud tulemused" },
                fa: { "<b>%s</b> productList": "<b>%s</b> Ù…Ø­ØµÙˆÙ„Ø§Øª", "<b>%s</b> contentList": "<b>%s</b> Ù†ØªØ§ÛŒØ¬ Ø¯ÛŒÚ¯Ø±", "<b>%s</b> cmsCompressed": "<b>%s</b> Ù†ØªØ§ÛŒØ¬ Ø¯ÛŒÚ¯Ø±" },
                fi: { "<b>%s</b> productList": "<b>%s</b> Tuotteet", "<b>%s</b> contentList": "<b>%s</b> Muut tulokset", "<b>%s</b> cmsCompressed": "<b>%s</b> Muut tulokset" },
                fr: { "<b>%s</b> productList": "<b>%s</b> Des produits", "<b>%s</b> contentList": "<b>%s</b> autres rÃ©sultats", "<b>%s</b> cmsCompressed": "<b>%s</b> autres rÃ©sultats" },
                he: { "<b>%s</b> productList": "<b>%s</b> ×ž×•×¦×¨×™×", "<b>%s</b> contentList": "<b>%s</b> ×ª×•×¦××•×ª × ×•×¡×¤×•×ª", "<b>%s</b> cmsCompressed": "<b>%s</b> ×ª×•×¦××•×ª × ×•×¡×¤×•×ª" },
                hr: { "<b>%s</b> productList": "<b>%s</b> proizvodi", "<b>%s</b> contentList": "<b>%s</b> Ostali rezultati", "<b>%s</b> cmsCompressed": "<b>%s</b> Ostali rezultati" },
                hu: { "<b>%s</b> productList": "<b>%s</b> TermÃ©kek", "<b>%s</b> contentList": "<b>%s</b> TovÃ¡bbi talÃ¡latok", "<b>%s</b> cmsCompressed": "<b>%s</b> TovÃ¡bbi talÃ¡latok" },
                is: { "<b>%s</b> productList": "<b>%s</b> vÃ¶rur", "<b>%s</b> contentList": "<b>%s</b> aÃ°rar niÃ°urstÃ¶Ã°ur", "<b>%s</b> cmsCompressed": "<b>%s</b> aÃ°rar niÃ°urstÃ¶Ã°ur" },
                it: { "<b>%s</b> productList": "<b>%s</b> Prodotti", "<b>%s</b> contentList": "<b>%s</b> altri risultati", "<b>%s</b> cmsCompressed": "<b>%s</b> altri risultati" },
                ja: { "<b>%s</b> productList": "<b>%s</b> ãƒ—ãƒ­ãƒ€ã‚¯ãƒˆ", "<b>%s</b> contentList": "<b>%s</b> ãã®ä»–ã®çµæžœ", "<b>%s</b> cmsCompressed": "<b>%s</b> ãã®ä»–ã®çµæžœ" },
                ko: { "<b>%s</b> productList": "<b>%s</b> ì œí’ˆ", "<b>%s</b> contentList": "<b>%s</b> ê¸°íƒ€ ê²°ê³¼", "<b>%s</b> cmsCompressed": "<b>%s</b> ê¸°íƒ€ ê²°ê³¼" },
                lv: { "<b>%s</b> productList": "<b>%s</b> Produkcija", "<b>%s</b> contentList": "<b>%s</b> Citi rezultÄti", "<b>%s</b> cmsCompressed": "<b>%s</b> Citi rezultÄti" },
                nb: { "<b>%s</b> productList": "<b>%s</b> Produkter", "<b>%s</b> contentList": "<b>%s</b> andre resultater", "<b>%s</b> cmsCompressed": "<b>%s</b> andre resultater" },
                nl: { "<b>%s</b> productList": "<b>%s</b> producten", "<b>%s</b> contentList": "<b>%s</b> andere resultaten", "<b>%s</b> cmsCompressed": "<b>%s</b> andere resultaten" },
                no: { "<b>%s</b> productList": "<b>%s</b> Produkter", "<b>%s</b> contentList": "<b>%s</b> andre resultater", "<b>%s</b> cmsCompressed": "<b>%s</b> andre resultater" },
                pl: { "<b>%s</b> productList": "<b>%s</b> Produkty", "<b>%s</b> contentList": "<b>%s</b> Inne wyniki", "<b>%s</b> cmsCompressed": "<b>%s</b> Inne wyniki" },
                pt: { "<b>%s</b> productList": "<b>%s</b> Produtos", "<b>%s</b> contentList": "<b>%s</b> outros resultados", "<b>%s</b> cmsCompressed": "<b>%s</b> outros resultados" },
                ro: { "<b>%s</b> productList": "<b>%s</b> Produse", "<b>%s</b> contentList": "<b>%s</b> alte rezultate", "<b>%s</b> cmsCompressed": "<b>%s</b> alte rezultate" },
                ru: { "<b>%s</b> productList": "<b>%s</b> ÐŸÑ€Ð¾Ð´ÑƒÐºÑ‚Ñ‹", "<b>%s</b> contentList": "<b>%s</b> Ð”Ñ€ÑƒÐ³Ð¸Ðµ Ñ€ÐµÐ·ÑƒÐ»ÑŒÑ‚Ð°Ñ‚Ñ‹", "<b>%s</b> cmsCompressed": "<b>%s</b> Ð”Ñ€ÑƒÐ³Ð¸Ðµ Ñ€ÐµÐ·ÑƒÐ»ÑŒÑ‚Ð°Ñ‚Ñ‹" },
                sk: { "<b>%s</b> productList": "<b>%s</b> Produkty", "<b>%s</b> contentList": "<b>%s</b> ÄalÅ¡ie vÃ½sledky", "<b>%s</b> cmsCompressed": "<b>%s</b> ÄalÅ¡ie vÃ½sledky" },
                sl: { "<b>%s</b> productList": "<b>%s</b> izdelki", "<b>%s</b> contentList": "<b>%s</b> Drugi rezultati", "<b>%s</b> cmsCompressed": "<b>%s</b> Drugi rezultati" },
                sr: { "<b>%s</b> productList": "<b>%s</b> ÐŸÑ€Ð¾Ð¸Ð·Ð²Ð¾Ð´Ð¸", "<b>%s</b> contentList": "<b>%s</b> ÐžÑÑ‚Ð°Ð»Ð¸ Ñ€ÐµÐ·ÑƒÐ»Ñ‚Ð°Ñ‚Ð¸", "<b>%s</b> cmsCompressed": "<b>%s</b> ÐžÑÑ‚Ð°Ð»Ð¸ Ñ€ÐµÐ·ÑƒÐ»Ñ‚Ð°Ñ‚Ð¸" },
                sv: { "<b>%s</b> productList": "<b>%s</b> Produkter", "<b>%s</b> contentList": "<b>%s</b> andra resultat", "<b>%s</b> cmsCompressed": "<b>%s</b> andra resultat" },
                tr: { "<b>%s</b> productList": "<b>%s</b> ÃœrÃ¼n:% s", "<b>%s</b> contentList": "<b>%s</b> DiÄŸer sonuÃ§lar", "<b>%s</b> cmsCompressed": "<b>%s</b> DiÄŸer sonuÃ§lar" },
                vi: { "<b>%s</b> productList": "<b>%s</b> CÃ¡c sáº£n pháº©m", "<b>%s</b> contentList": "<b>%s</b> cÃ¡c káº¿t quáº£ khÃ¡c", "<b>%s</b> cmsCompressed": "<b>%s</b> cÃ¡c káº¿t quáº£ khÃ¡c" },
                zh: { "<b>%s</b> productList": "<b>%s</b> äº§å“", "<b>%s</b> contentList": "<b>%s</b> å…¶ä»–æ¯”èµ›ç»“æžœ", "<b>%s</b> cmsCompressed": "<b>%s</b> å…¶ä»–æ¯”èµ›ç»“æžœ" },
            },
        },
    }),
    klevu.extend(!0, klevu.search.modules, {
        locale: {
            globalTranslations: {
                en: {
                    "Color Variants:": "Color Variants:",
                    "variant(s)": "variant(s)",
                    "Grid View": "Grid View",
                    "List View": "List View",
                    "Starting at": "Starting at",
                    Suggestions: "Suggestions",
                    Pages: "Pages",
                    Category: "Category",
                    Products: "Products",
                    "View All": "View All",
                    First: "First",
                    Previous: "Previous",
                    Next: "Next",
                    Last: "Last",
                    Close: "Close",
                    " Results": " Results",
                    " Result": " Result",
                    found: "found",
                    for: "for",
                    Filters: "Filters",
                    "Popular Searches": "Popular Searches",
                    "Tags:": "Tags:",
                    "View details": "View details",
                    "Original price %s": "Original price %s",
                    "Items per page : %s": "Items per page : %s",
                    "Sort by : ": "Sort by : ",
                    Relevance: "Relevance",
                    "Price: Low to high": "Price: Low to high",
                    "Price: High to low": "Price: High to low",
                },
                ar: {
                    "Color Variants:": "Ø§Ù„Ù…ØªØºÙŠØ±Ø§Øª Ø§Ù„Ù…Ù„ÙˆÙ†Ø©:",
                    "variant(s)": "Ø§Ù„Ø¨Ø¯ÙŠÙ„ (Ù‚)",
                    "Grid View": "Ø¹Ø±Ø¶ Ø´Ø¨ÙƒÙŠ",
                    "List View": "Ø¹Ø±Ø¶ Ø§Ù„Ù‚Ø§Ø¦Ù…Ø©",
                    "Starting at": "ÙŠØ¨Ø¯Ø£ Ù…Ù†",
                    Suggestions: "Ø§Ù‚ØªØ±Ø§Ø­Ø§Øª",
                    Pages: "Ø§Ù„ØµÙØ­Ø§Øª",
                    Category: "ÙØ¦Ø©",
                    Products: "Ù…Ù†ØªØ¬Ø§Øª",
                    "View All": "Ø¹Ø±Ø¶ Ø§Ù„ÙƒÙ„",
                    First: "Ø£ÙˆÙ„Ø§",
                    Previous: "Ø³Ø§Ø¨Ù‚",
                    Next: "Ø§Ù„ØªØ§Ù„ÙŠ",
                    Last: "Ø§Ù„Ø§Ø®ÙŠØ±",
                    Close: "Ù‚Ø±ÙŠØ¨",
                    " Results": " Ù†ØªØ§Ø¦Ø¬",
                    " Result": " Ù†ØªÙŠØ¬Ø©",
                    found: "ÙˆØ¬Ø¯Øª",
                    for: "Ù„",
                    Filters: "Ù…Ø±Ø´Ø­Ø§Øª",
                    "Popular Searches": "Ø¹Ù…Ù„ÙŠØ§Øª Ø§Ù„Ø¨Ø­Ø« Ø§Ù„Ø´Ø¹Ø¨ÙŠØ©",
                    "Tags:": "Ø§Ù„Ø¹Ù„Ø§Ù…Ø§Øª:",
                    "View details": "Ø¹Ø±Ø¶ Ø§Ù„ØªÙØ§ØµÙŠÙ„",
                    "Original price %s": "Ø§Ù„Ø³Ø¹Ø± Ø§Ù„Ø£ØµÙ„ÙŠ %s",
                    "Items per page : %s": "Ø§Ù„Ø¨Ù†ÙˆØ¯ Ù„ÙƒÙ„ ØµÙØ­Ø©: %s",
                    "Sort by : ": "ØµÙ†Ù Ø­Ø³Ø¨ :",
                    Relevance: "Ù…Ù„Ø§Ø¡Ù…Ø©",
                    "Price: Low to high": "Ø§Ù„Ø³Ø¹Ø± Ù…Ù† Ø§Ù„Ø§Ø±Ø®Øµ Ù„Ù„Ø§Ø¹Ù„Ù‰",
                    "Price: High to low": "Ø§Ù„Ø³Ø¹Ø± Ø§Ù„Ø§Ø¹Ù„Ù‰ Ø§Ù„Ù‰ Ø§Ù„Ø§Ø¯Ù†Ù‰",
                },
                bg: {
                    "Color Variants:": "Ð¦Ð²ÐµÑ‚Ð¾Ð²Ð¸ Ð²Ð°Ñ€Ð¸Ð°Ð½Ñ‚Ð¸:",
                    "variant(s)": "Ð²Ð°Ñ€Ð¸Ð°Ð½Ñ‚ (Ð¸)",
                    "Grid View": "Ð˜Ð·Ð³Ð»ÐµÐ´ ÐºÑŠÐ¼ Ð¼Ñ€ÐµÐ¶Ð°Ñ‚Ð°",
                    "List View": "Ð˜Ð·Ð³Ð»ÐµÐ´ Ð˜Ð·Ð³Ð»ÐµÐ´",
                    "Starting at": "Ð—Ð°Ð¿Ð¾Ñ‡Ð²Ð° Ð²",
                    Suggestions: "ÐŸÑ€ÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ",
                    Pages: "Ð¡Ñ‚Ñ€Ð°Ð½Ð¸Ñ†Ð¸",
                    Category: "ÐšÐ°Ñ‚ÐµÐ³Ð¾Ñ€Ð¸Ñ",
                    Products: "ÐŸÑ€Ð¾Ð´ÑƒÐºÑ‚Ð¸",
                    "View All": "Ð’Ð¸Ð¶ Ð²ÑÐ¸Ñ‡ÐºÐ¸",
                    First: "ÐŸÑŠÑ€Ð²Ð¾",
                    Previous: "ÐŸÑ€ÐµÐ´Ð¸ÑˆÐµÐ½",
                    Next: "Ð¡Ð»ÐµÐ´Ð²Ð°Ñ‰Ð¸Ñ",
                    Last: "ÐŸÐ¾ÑÐ»ÐµÐ´Ð½Ð¾",
                    Close: "Ð‘Ð»Ð¸Ð·Ð¾",
                    " Results": " Ð ÐµÐ·ÑƒÐ»Ñ‚Ð°Ñ‚Ð¸.",
                    " Result": " Ð’ Ñ€ÐµÐ·ÑƒÐ»Ñ‚Ð°Ñ‚",
                    found: "Ð½Ð°Ð¼ÐµÑ€ÐµÐ½",
                    for: "Ð·Ð°",
                    Filters: "Ð¤Ð¸Ð»Ñ‚Ñ€Ð¸",
                    "Popular Searches": "ÐŸÐ¾Ð¿ÑƒÐ»ÑÑ€Ð½Ð¸ Ñ‚ÑŠÑ€ÑÐµÐ½Ð¸Ñ",
                    "Tags:": "Ð¢Ð°Ð³Ð¾Ð²Ðµ:",
                    "View details": "Ð Ð°Ð·Ð³Ð»ÐµÐ´Ð°Ð¹Ñ‚Ðµ Ð´ÐµÑ‚Ð°Ð¹Ð»Ð¸Ñ‚Ðµ",
                    "Original price %s": "ÐžÑ€Ð¸Ð³Ð¸Ð½Ð°Ð»Ð½Ð° Ñ†ÐµÐ½Ð° %s",
                    "Items per page : %s": "Ð•Ð»ÐµÐ¼ÐµÐ½Ñ‚Ð¸ Ð½Ð° ÑÑ‚Ñ€Ð°Ð½Ð¸Ñ†Ð° : %s",
                    "Sort by : ": "Ð¡Ð¾Ñ€Ñ‚Ð¸Ñ€Ð°Ð½Ðµ Ð¿Ð¾:",
                    Relevance: "Ð£Ð¼ÐµÑÑ‚Ð½Ð¾ÑÑ‚",
                    "Price: Low to high": "Ð¦ÐµÐ½Ð°: ÐÐ¸ÑÐºÐ° Ð´Ð¾ Ð²Ð¸ÑÐ¾ÐºÐ°",
                    "Price: High to low": "Ð¦ÐµÐ½Ð°: Ð²Ð¸ÑÐ¾ÐºÐ° Ð´Ð¾ Ð½Ð¸ÑÐºÐ°",
                },
                da: {
                    "Color Variants:": "Farvevarianter:",
                    "variant(s)": "variant (er)",
                    "Grid View": "Grid View.",
                    "List View": "List View.",
                    "Starting at": "Starter ved",
                    Suggestions: "Forslag",
                    Pages: "sider",
                    Category: "Kategori",
                    Products: "Produkter",
                    "View All": "Se alt",
                    First: "FÃ¸rst",
                    Previous: "Tidligere",
                    Next: "NÃ¦ste",
                    Last: "Sidst",
                    Close: "TÃ¦t",
                    " Results": " Resultater",
                    " Result": " Resultat",
                    found: "fundet",
                    for: "til",
                    Filters: "Filtre.",
                    "Popular Searches": "PopulÃ¦re sÃ¸gninger",
                    "Tags:": "Tags:",
                    "View details": "Se detaljer",
                    "Original price %s": "Original pris %s",
                    "Items per page : %s": "Varer pr. Side: %s",
                    "Sort by : ": "Sorter efter :",
                    Relevance: "Relevans.",
                    "Price: Low to high": "Pris: Lav til hÃ¸j",
                    "Price: High to low": "Pris: hÃ¸j til lav",
                },
                de: {
                    "Color Variants:": "Farbvarianten:",
                    "variant(s)": "Variante(n)",
                    "Grid View": "Rasteransicht",
                    "List View": "Listenansicht",
                    "Starting at": "Beginnt um",
                    Suggestions: "VorschlÃ¤ge",
                    Pages: "Seiten",
                    Category: "Kategorie",
                    Products: "Produkte",
                    "View All": "Alle ansehen",
                    First: "Zuerst",
                    Previous: "Vorherige",
                    Next: "NÃ¤chste",
                    Last: "Zuletzt",
                    Close: "Nah dran",
                    " Results": " Ergebnisse",
                    " Result": " Ergebnis",
                    found: "gefunden",
                    for: "zum",
                    Filters: "Filter",
                    "Popular Searches": "beliebte Suchanfragen",
                    "Tags:": "Stichworte:",
                    "View details": "Details anzeigen",
                    "Original price %s": "UrsprÃ¼nglicher Preis %s",
                    "Items per page : %s": "Artikel pro Seite: %s",
                    "Sort by : ": "Sortieren nach :",
                    Relevance: "Relevanz",
                    "Price: Low to high": "Preis niedrig bis hoch",
                    "Price: High to low": "Preis: hoch bis niedrig",
                },
                el: {
                    "Color Variants:": "Î Î±ÏÎ±Î»Î»Î±Î³Î­Ï‚ Ï‡ÏÏŽÎ¼Î±Ï„Î¿Ï‚:",
                    "variant(s)": "Î Î±ÏÎ±Î»Î»Î±Î³Î®",
                    "Grid View": "Î ÏÎ¿Î²Î¿Î»Î® Ï€Î»Î­Î³Î¼Î±Ï„Î¿Ï‚",
                    "List View": "Î ÏÎ¿Î²Î¿Î»Î® Î»Î¯ÏƒÏ„Î±Ï‚",
                    "Starting at": "ÎžÎµÎºÎ¹Î½ÏŽÎ½Ï„Î±Ï‚ Î±Ï€ÏŒ",
                    Suggestions: "Î ÏÎ¿Ï„Î¬ÏƒÎµÎ¹Ï‚",
                    Pages: "Î£ÎµÎ»Î¯Î´ÎµÏ‚",
                    Category: "ÎšÎ±Ï„Î·Î³Î¿ÏÎ¯Î±",
                    Products: "Î ÏÎ¿ÏŠÏŒÎ½Ï„Î±",
                    "View All": "Î ÏÎ¿Î²Î¿Î»Î® ÏŒÎ»Ï‰Î½",
                    First: "Î ÏÏŽÏ„Î±",
                    Previous: "Î ÏÎ¿Î·Î³Î¿ÏÎ¼ÎµÎ½Î¿Ï‚",
                    Next: "Î•Ï€ÏŒÎ¼ÎµÎ½Î¿",
                    Last: "Ï„ÎµÎ»ÎµÏ…Ï„Î±Î¯Î¿Ï‚",
                    Close: "ÎšÎ»ÎµÎ¯ÏƒÎµ",
                    " Results": " Î‘Ï€Î¿Ï„ÎµÎ»Î­ÏƒÎ¼Î±Ï„Î±",
                    " Result": " Î‘Ï€Î¿Ï„Î­Î»ÎµÏƒÎ¼Î±",
                    found: "Î²ÏÎ­Î¸Î·ÎºÎ±Î½",
                    for: "Î“Î¹Î±",
                    Filters: "Î¦Î¯Î»Ï„ÏÎ±",
                    "Popular Searches": "Î”Î·Î¼Î¿Ï†Î¹Î»ÎµÎ¯Ï‚ Î±Î½Î±Î¶Î·Ï„Î®ÏƒÎµÎ¹Ï‚",
                    "Tags:": "Î•Ï„Î¹ÎºÎ­Ï„ÎµÏ‚:",
                    "View details": "Î”ÎµÎ¯Ï„Îµ Î»ÎµÏ€Ï„Î¿Î¼Î­ÏÎµÎ¹ÎµÏ‚",
                    "Original price %s": "Î‘ÏÏ‡Î¹ÎºÎ® Ï„Î¹Î¼Î® %s",
                    "Items per page : %s": "Î£Ï„Î¿Î¹Ï‡ÎµÎ¯Î± Î±Î½Î¬ ÏƒÎµÎ»Î¯Î´Î±: %s",
                    "Sort by : ": "Î¤Î±Î¾Î¹Î½ÏŒÎ¼Î·ÏƒÎ· ÎºÎ±Ï„Î¬ :",
                    Relevance: "Î£Ï…Î½Î¬Ï†ÎµÎ¹Î±",
                    "Price: Low to high": "Î¤Î¹Î¼Î®: Ï‡Î±Î¼Î·Î»Î® Î­Ï‰Ï‚ Ï…ÏˆÎ·Î»Î®",
                    "Price: High to low": "Î¤Î¹Î¼Î®: Î¥ÏˆÎ·Î»Î® Î­Ï‰Ï‚ Ï‡Î±Î¼Î·Î»Î®",
                },
                es: {
                    "Color Variants:": "Variantes de color:",
                    "variant(s)": "Variante (s)",
                    "Grid View": "Vista en cuadrÃ­cula",
                    "List View": "Vista de la lista",
                    "Starting at": "A partir de",
                    Suggestions: "Sugerencias",
                    Pages: "PÃ¡ginas",
                    Category: "CategorÃ­a",
                    Products: "Productos",
                    "View All": "Ver todo",
                    First: "Primero",
                    Previous: "Anterior",
                    Next: "prÃ³ximo",
                    Last: "Ãšltimo",
                    Close: "Cerrar",
                    " Results": " Resultados",
                    " Result": " Resultado",
                    found: "fundar",
                    for: "por",
                    Filters: "Filtros",
                    "Popular Searches": "BÃºsquedas populares",
                    "Tags:": "Etiquetas:",
                    "View details": "Ver detalles",
                    "Original price %s": "Precio original %s",
                    "Items per page : %s": "ArtÃ­culos por pÃ¡gina : %s",
                    "Sort by : ": "Ordenar por :",
                    Relevance: "Relevancia",
                    "Price: Low to high": "Precios de barato a caro",
                    "Price: High to low": "Precio: alto a bajo",
                },
                et: {
                    "Color Variants:": "VÃ¤rvariandid:",
                    "variant(s)": "Variant (id)",
                    "Grid View": "VÃµrguvaade",
                    "List View": "Loendivaade",
                    "Starting at": "Alustades",
                    Suggestions: "Ettepanekud",
                    Pages: "LehekÃ¼ljed",
                    Category: "Kategooria",
                    Products: "Tooted",
                    "View All": "Vaata kÃµiki",
                    First: "Esimene",
                    Previous: "Eelmine",
                    Next: "JÃ¤rgmine",
                    Last: "Viimati",
                    Close: "Sulge",
                    " Results": " Tulemused",
                    " Result": " Tulemus",
                    found: "leitud",
                    for: "jaoks",
                    Filters: "Filtrid",
                    "Popular Searches": "Populaarsed otsingud",
                    "Tags:": "Sildid:",
                    "View details": "Vaata detaile",
                    "Original price %s": "Originaalhind %s",
                    "Items per page : %s": "Ãœksused lehekÃ¼lje kohta : %s",
                    "Sort by : ": "Sorteerima :",
                    Relevance: "TÃ¤htsus",
                    "Price: Low to high": "Hind: madal kuni kÃµrge",
                    "Price: High to low": "Hind: kÃµrge madal",
                },
                fa: {
                    "Color Variants:": "Ø§Ù†ÙˆØ§Ø¹ Ø±Ù†Ú¯:",
                    "variant(s)": "Ù†ÙˆØ¹ (Ù‡Ø§)",
                    "Grid View": "Ù†Ù…Ø§ÛŒØ´ Ø´Ø¨Ú©Ù‡",
                    "List View": "Ù†Ù…Ø§ÛŒØ´ Ù„ÛŒØ³Øª",
                    "Starting at": "Ø´Ø±ÙˆØ¹ Ø§Ø²",
                    Suggestions: "Ù¾ÛŒØ´Ù†Ù‡Ø§Ø¯Ø§Øª",
                    Pages: "ØµÙØ­Ø§Øª",
                    Category: "Ø¯Ø³ØªÙ‡ Ø¨Ù†Ø¯ÛŒ",
                    Products: "Ù…Ø­ØµÙˆÙ„Ø§Øª",
                    "View All": "Ù…Ø´Ø§Ù‡Ø¯Ù‡ Ù‡Ù…Ù‡",
                    First: "Ø§ÙˆÙ„ÛŒÙ†",
                    Previous: "Ù‚Ø¨Ù„ÛŒ",
                    Next: "Ø¨Ø¹Ø¯",
                    Last: "Ø¢Ø®Ø±",
                    Close: "Ù†Ø²Ø¯ÛŒÚ©",
                    " Results": " Ù†ØªØ§ÛŒØ¬",
                    " Result": " Ù†ØªÛŒØ¬Ù‡",
                    found: "Ù¾ÛŒØ¯Ø§ Ú©Ø±Ø¯Ù†",
                    for: "Ø¨Ø±Ø§ÛŒ",
                    Filters: "ÙÛŒÙ„ØªØ±Ù‡Ø§",
                    "Popular Searches": "Ø¬Ø³ØªØ¬ÙˆÙ‡Ø§ÛŒ Ù…Ø­Ø¨ÙˆØ¨",
                    "Tags:": "Ø¨Ø±Ú†Ø³Ø¨ Ù‡Ø§:",
                    "View details": "Ø¯ÛŒØ¯Ù† Ø¬Ø²Ø¦ÛŒØ§Øª",
                    "Original price %s": "Ù‚ÛŒÙ…Øª Ø§ØµÙ„ÛŒ %s",
                    "Items per page : %s": "Ø§Ù‚Ù„Ø§Ù… Ø¯Ø± Ù‡Ø± ØµÙØ­Ù‡: %s",
                    "Sort by : ": "Ù…Ø±ØªØ¨ Ø³Ø§Ø²ÛŒ Ø¨Ø± Ø§Ø³Ø§Ø³ :",
                    Relevance: "Ø§Ø±ØªØ¨Ø§Ø·",
                    "Price: Low to high": "Ù‚ÛŒÙ…Øª: Ú©Ù… Ø¨Ù‡ Ø¨Ø§Ù„Ø§",
                    "Price: High to low": "Ù‚ÛŒÙ…Øª: Ø¨Ø§Ù„Ø§ Ø¨Ù‡ Ù¾Ø§ÛŒÛŒÙ†",
                },
                fi: {
                    "Color Variants:": "VÃ¤rivariantit:",
                    "variant(s)": "Variantti (t)",
                    "Grid View": "Verkkokuva",
                    "List View": "ListanÃ¤kymÃ¤",
                    "Starting at": "Alkaen",
                    Suggestions: "Ehdotukset",
                    Pages: "Sivut",
                    Category: "Kategoria",
                    Products: "Tuotteet",
                    "View All": "NÃ¤ytÃ¤ kaikki",
                    First: "EnsimmÃ¤inen",
                    Previous: "Edellinen",
                    Next: "Seuraava",
                    Last: "KestÃ¤Ã¤",
                    Close: "kiinni",
                    " Results": " Tulokset",
                    " Result": " Tulos",
                    found: "lÃ¶ydetty",
                    for: "varten",
                    Filters: "Suodattimet",
                    "Popular Searches": "Suosittuja hakuja",
                    "Tags:": "Tunnisteet:",
                    "View details": "Tarkemmat tiedot",
                    "Original price %s": "AlkuperÃ¤inen hinta %s",
                    "Items per page : %s": "Tuotteet per sivu : %s",
                    "Sort by : ": "JÃ¤rjestÃ¤ :",
                    Relevance: "Merkityksellisyys",
                    "Price: Low to high": "Hinta: Alhainen korkealle",
                    "Price: High to low": "Hinta: Alhainen",
                },
                fr: {
                    "Color Variants:": "Variantes de couleur:",
                    "variant(s)": "variante (s)",
                    "Grid View": "Grille",
                    "List View": "Vue de la liste",
                    "Starting at": "Ã€ partir de",
                    Suggestions: "Suggestions",
                    Pages: "Pages",
                    Category: "CatÃ©gorie",
                    Products: "Des produits",
                    "View All": "Voir tout",
                    First: "D'abord",
                    Previous: "PrÃ©cÃ©dent",
                    Next: "Prochain",
                    Last: "Durer",
                    Close: "proche",
                    " Results": " RÃ©sultats",
                    " Result": " RÃ©sultat",
                    found: "trouvÃ©",
                    for: "pour",
                    Filters: "Filtres",
                    "Popular Searches": "Recherches populaires",
                    "Tags:": "Mots clÃ©s:",
                    "View details": "Voir les dÃ©tails",
                    "Original price %s": "Prix â€‹â€‹original %s",
                    "Items per page : %s": "Articles par page : %s",
                    "Sort by : ": "Trier par :",
                    Relevance: "Pertinence",
                    "Price: Low to high": "Prix â€‹â€‹croissant",
                    "Price: High to low": "Prix: haut Ã  faible",
                },
                he: {
                    "Color Variants:": "×•×¨×™××œ×™ ×¦×‘×¢:",
                    "variant(s)": "×•×¨×™×× ×˜ (×™×)",
                    "Grid View": "×ª×¦×•×’×ª ×¨×©×ª",
                    "List View": "×ª×¦×•×’×ª ×¨×©×™×ž×”",
                    "Starting at": "×ž×ª×—×™×œ ×‘",
                    Suggestions: "×”×¦×¢×•×ª",
                    Pages: "×“×¤×™×",
                    Category: "×§×˜×’×•×¨×™×”",
                    Products: "×ž×•×¦×¨×™×",
                    "View All": "×¦×¤×” ×‘×”×›×œ",
                    First: "×¨××©×•×Ÿ",
                    Previous: "×§×•×“×",
                    Next: "×”Ö·×‘Ö¼Ö¸×",
                    Last: "××—×¨×•×Ÿ",
                    Close: "×¡×’×•×¨",
                    " Results": " ×ª×•×¦××•×ª",
                    " Result": " ×ª×•Ö¹×¦Ö¸×Ö¸×”",
                    found: "×ž×¦××ª×™",
                    for: "×œ",
                    Filters: "×ž×¡× × ×™×",
                    "Popular Searches": "×—×™×¤×•×©×™× ×¤×•×¤×•×œ×¨×™×™×",
                    "Tags:": "×ª×’×™×•×ª:",
                    "View details": "×”×¦×’ ×¤×¨×˜×™×",
                    "Original price %s": "×ž×—×™×¨ ×ž×§×•×¨×™ %s",
                    "Items per page : %s": "×¤×¨×™×˜×™× ×œ×¢×ž×•×“ : %s",
                    "Sort by : ": "×ž×™×™×Ÿ ×œ×¤×™ :",
                    Relevance: "×¨×œ×•×•× ×˜×™×•×ª",
                    "Price: Low to high": "×ž×—×™×¨ ×ž×”× ×ž×•×š ×œ×’×‘×•×”",
                    "Price: High to low": "×ž×—×™×¨: ×’×‘×•×” ×¢×“ × ×ž×•×š",
                },
                hr: {
                    "Color Variants:": "Varijante boja:",
                    "variant(s)": "varijanta",
                    "Grid View": "Prikaz reÅ¡etke",
                    "List View": "Prikaz popisa",
                    "Starting at": "S poÄetkom u",
                    Suggestions: "Prijedlozi",
                    Pages: "Stranicama",
                    Category: "Kategorija",
                    Products: "Proizvodi",
                    "View All": "Pogledaj sve",
                    First: "Prvi",
                    Previous: "Prethodni",
                    Next: "SljedeÄ‡i",
                    Last: "Posljednji",
                    Close: "Zatvoriti",
                    " Results": " Rezultati",
                    " Result": " Proizlaziti",
                    found: "pronaÄ‘eno",
                    for: "za",
                    Filters: "Filteri",
                    "Popular Searches": "Popularna pretraÅ¾ivanja",
                    "Tags:": "Oznake:",
                    "View details": "Pregledavati pojedinosti",
                    "Original price %s": "Izvorna cijena %s",
                    "Items per page : %s": "Stavke po stranici : %s",
                    "Sort by : ": "Sortiraj po:",
                    Relevance: "Relevantnost",
                    "Price: Low to high": "Cijena: niska do visokog",
                    "Price: High to low": "Cijena: visoko do niskog",
                },
                hu: {
                    "Color Variants:": "SzÃ­nvÃ¡ltozatok:",
                    "variant(s)": "Variant (ek)",
                    "Grid View": "RÃ¡csnÃ©zet",
                    "List View": "Lista nÃ©zet",
                    "Starting at": "Kezdve",
                    Suggestions: "Javaslatok",
                    Pages: "Oldalak",
                    Category: "KategÃ³ria",
                    Products: "TermÃ©kek",
                    "View All": "Ã–sszes megtekintÃ©se",
                    First: "ElsÅ‘",
                    Previous: "ElÅ‘zÅ‘",
                    Next: "KÃ¶vetkezÅ‘",
                    Last: "UtolsÃ³",
                    Close: "BezÃ¡rÃ¡s",
                    " Results": " EredmÃ©nyek",
                    " Result": " EredmÃ©ny",
                    found: "megtalÃ¡lt",
                    for: "-Ã©rt",
                    Filters: "SzÅ±rÅ‘kÃ©szÃ¼lÃ©kek",
                    "Popular Searches": "NÃ©pszerÅ± keresÃ©sek",
                    "Tags:": "CÃ­mkÃ©k:",
                    "View details": "RÃ©szletek megtekintÃ©se",
                    "Original price %s": "Eredeti Ã¡r %s",
                    "Items per page : %s": "TÃ©telek oldalankÃ©nt : %s",
                    "Sort by : ": "RendezÃ©s :",
                    Relevance: "Relevancia",
                    "Price: Low to high": "Ãr: alacsony Ã©s magas",
                    "Price: High to low": "Ãr: Magas vagy alacsony",
                },
                is: {
                    "Color Variants:": "Litur afbrigÃ°i:",
                    "variant(s)": "Variant (s)",
                    "Grid View": "Grid View.",
                    "List View": "LIST VIEW.",
                    "Starting at": "Byrjar Ã¡.",
                    Suggestions: "TillÃ¶gur",
                    Pages: "SÃ­Ã°ur",
                    Category: "Flokkur",
                    Products: "VÃ¶rur",
                    "View All": "SjÃ¡ allt",
                    First: "Fyrsta",
                    Previous: "Fyrri",
                    Next: "NÃ¦sta",
                    Last: "Endinn",
                    Close: "NÃ¦rri",
                    " Results": " NiÃ°urstÃ¶Ã°ur",
                    " Result": " NiÃ°urstaÃ°an",
                    found: "FundiÃ°",
                    for: "fyrir",
                    Filters: "SÃ­ur",
                    "Popular Searches": "VinsÃ¦lar leitir",
                    "Tags:": "Tags:",
                    "View details": "SkoÃ°a smÃ¡atriÃ°i",
                    "Original price %s": "Upprunalega verÃ° %s",
                    "Items per page : %s": "AtriÃ°i Ã¡ sÃ­Ã°u : %s",
                    "Sort by : ": "RaÃ°a eftir :",
                    Relevance: "MikilvÃ¦gi",
                    "Price: Low to high": "VerÃ°: lÃ¡gt til hÃ¡tt",
                    "Price: High to low": "VerÃ°: hÃ¡tt til lÃ¡gt",
                },
                it: {
                    "Color Variants:": "Varianti di colore:",
                    "variant(s)": "variante (s)",
                    "Grid View": "Vista a griglia",
                    "List View": "Visualizzazione elenco",
                    "Starting at": "A partire da",
                    Suggestions: "Suggerimenti",
                    Pages: "Pagine",
                    Category: "Categoria",
                    Products: "Prodotti",
                    "View All": "Mostra tutto",
                    First: "Primo",
                    Previous: "Precedente",
                    Next: "Prossimo",
                    Last: "Scorso",
                    Close: "Chiudere",
                    " Results": " Risultati",
                    " Result": " Risultato",
                    found: "trovato",
                    for: "per",
                    Filters: "Filtri",
                    "Popular Searches": "Ricerche popolari",
                    "Tags:": "Tag:",
                    "View details": "Visualizza dettagli",
                    "Original price %s": "Prezzo originale %s",
                    "Items per page : %s": "Articoli per pagina : %s",
                    "Sort by : ": "Ordina per :",
                    Relevance: "Pertinenza",
                    "Price: Low to high": "Prezzo: basso ad alto",
                    "Price: High to low": "Prezzo: alto a basso",
                },
                ja: {
                    "Color Variants:": "ã‚«ãƒ©ãƒ¼ãƒãƒªã‚¨ãƒ³ãƒˆï¼š",
                    "variant(s)": "ãƒãƒªã‚¢ãƒ³ãƒˆ",
                    "Grid View": "ã‚°ãƒªãƒƒãƒ‰ãƒ“ãƒ¥ãƒ¼",
                    "List View": "ãƒªã‚¹ãƒˆãƒ“ãƒ¥ãƒ¼",
                    "Starting at": "å‡ºèº«",
                    Suggestions: "suggest suggest",
                    Pages: "ãƒšãƒ¼ã‚¸",
                    Category: "ã‚«ãƒ†ã‚´ãƒªãƒ¼",
                    Products: "è£½å“",
                    "View All": "å…¨ä½“ã‚’è¦‹ã‚‹",
                    First: "åˆã‚",
                    Previous: "å‰",
                    Next: "æ¬¡",
                    Last: "æœ€å¾Œ",
                    Close: "é¸ã¶",
                    " Results": " çµæžœ",
                    " Result": " çµæžœ",
                    found: "è¦‹ã¤ã‹ã£ãŸ",
                    for: "ã«ã¨ã£ã¦",
                    Filters: "ãƒ•ã‚£ãƒ«ã‚¿",
                    "Popular Searches": "äººæ°—ã®æ¤œç´¢",
                    "Tags:": "ã‚¿ã‚°ï¼š",
                    "View details": "è©³ç´°ã‚’è¦‹ã‚‹",
                    "Original price %s": "å…ƒã®ä¾¡æ ¼ %s.",
                    "Items per page : %s": "1ãƒšãƒ¼ã‚¸ã‚ãŸã‚Šã®é …ç›®ï¼š%s",
                    "Sort by : ": "ä¸¦ã³æ›¿ãˆ ï¼š",
                    Relevance: "é–¢é€£æ€§",
                    "Price: Low to high": "ä¾¡æ ¼ï¼šä½Žã™ãªã‚ã¡é«˜ã„",
                    "Price: High to low": "ä¾¡æ ¼ï¼šé«˜ã„ã‹ã‚‰ä½Žã„",
                },
                ko: {
                    "Color Variants:": "ìƒ‰ìƒ ë³€í˜• :",
                    "variant(s)": "ë³€ì¢… (ë“¤)",
                    "Grid View": "ê²©ìžë³´ê¸°",
                    "List View": "ëª©ë¡ë³´ê¸°",
                    "Starting at": "ë¶€í„° ì‹œìž‘í•˜ì—¬",
                    Suggestions: "ì œì•ˆ",
                    Pages: "íŽ˜ì´ì§€",
                    Category: "ë²”ì£¼",
                    Products: "ì œí’ˆ",
                    "View All": "ëª¨ë‘ë³´ê¸°",
                    First: "ì²« ë²ˆì§¸",
                    Previous: "ì´ì „ì˜",
                    Next: "ë‹¤ìŒ",
                    Last: "ë§ˆì§€ë§‰",
                    Close: "ë‹«ë‹¤",
                    " Results": " ê²°ê³¼",
                    " Result": " ê²°ê³¼",
                    found: "ì„¤ë¦½í•˜ë‹¤",
                    for: "~ì„ìœ„í•œ",
                    Filters: "í•„í„°",
                    "Popular Searches": "ì¸ê¸°ìžˆëŠ” ê²€ìƒ‰",
                    "Tags:": "íƒœê·¸ :",
                    "View details": "ì„¸ë¶€ ì •ë³´ë³´ê¸°",
                    "Original price %s": "ì›ëž˜ ê°€ê²© %s.",
                    "Items per page : %s": "íŽ˜ì´ì§€ ë‹¹ í•­ëª© : %s.",
                    "Sort by : ": "ì •ë ¬ ê¸°ì¤€ :",
                    Relevance: "ê´€ë ¨ì„±",
                    "Price: Low to high": "ê°€ê²© : ë‚®ì€ ê³³ìœ¼ë¡œ",
                    "Price: High to low": "ê°€ê²© : ë‚®ì€ ê³³ì—ì„œ",
                },
                lv: {
                    "Color Variants:": "KrÄsu varianti:",
                    "variant(s)": "Variants (-i)",
                    "Grid View": "ReÅ¾Ä£a skats",
                    "List View": "Saraksta skats",
                    "Starting at": "SÄkot no",
                    Suggestions: "IerosinÄjumi",
                    Pages: "Lapas",
                    Category: "Kategorija",
                    Products: "Produkti",
                    "View All": "ApskatÄ«t visus",
                    First: "PirmkÄrt",
                    Previous: "IepriekÅ¡Ä“jais",
                    Next: "NÄkamais",
                    Last: "PÄ“dÄ“jais",
                    Close: "Tuvoties",
                    " Results": " RezultÄti",
                    " Result": " RezultÄts",
                    found: "atrasts",
                    for: "priekÅ¡",
                    Filters: "Filtri",
                    "Popular Searches": "PopulÄri meklÄ“jumi",
                    "Tags:": "Tags:",
                    "View details": "SkatÄ«t detaÄ¼as",
                    "Original price %s": "OriÄ£inÄlÄ cena %s",
                    "Items per page : %s": "Vienumi vienÄ lapÄ : %s",
                    "Sort by : ": "KÄrtot pÄ“c :",
                    Relevance: "AtbilstÄ«ba",
                    "Price: Low to high": "Cena: zema lÄ«dz augstai",
                    "Price: High to low": "Cena: augsts lÄ«dz zems",
                },
                nb: {
                    "Color Variants:": "Fargevarianter:",
                    "variant(s)": "variant (er)",
                    "Grid View": "Rutenett visning",
                    "List View": "Listevisning",
                    "Starting at": "Starter pÃ¥",
                    Suggestions: "Forslag",
                    Pages: "Sider",
                    Category: "Kategori",
                    Products: "Produkter",
                    "View All": "Se alt",
                    First: "FÃ¸rst",
                    Previous: "Tidligere",
                    Next: "NESTE",
                    Last: "Siste",
                    Close: "Lukk",
                    " Results": " Resultater.",
                    " Result": " Resultat",
                    found: "funnet",
                    for: "til",
                    Filters: "Filtre",
                    "Popular Searches": "PopulÃ¦re sÃ¸k",
                    "Tags:": "Tags:",
                    "View details": "Vis detaljer",
                    "Original price %s": "Opprinnelige pris %s",
                    "Items per page : %s": "Elementer per side : %s",
                    "Sort by : ": "Sorter etter :",
                    Relevance: "Relevans",
                    "Price: Low to high": "Pris: Lav til hÃ¸y",
                    "Price: High to low": "Pris: HÃ¸y til lav",
                },
                nl: {
                    "Color Variants:": "Kleurvarianten:",
                    "variant(s)": "Variant (s)",
                    "Grid View": "Rasterweergave",
                    "List View": "Lijstweergave",
                    "Starting at": "Beginnend bij",
                    Suggestions: "Suggesties",
                    Pages: "Pagina's",
                    Category: "Categorie",
                    Products: "Producten",
                    "View All": "Bekijk alles",
                    First: "Eerst",
                    Previous: "Vorig",
                    Next: "Volgende",
                    Last: "Laatste",
                    Close: "Dichtbij",
                    " Results": " Resultaten",
                    " Result": " Resultaat",
                    found: "gevonden",
                    for: "voor",
                    Filters: "Filters",
                    "Popular Searches": "populaire zoekopdrachten",
                    "Tags:": "Tags:",
                    "View details": "Bekijk details",
                    "Original price %s": "Originele prijs %s",
                    "Items per page : %s": "Items per pagina : %s",
                    "Sort by : ": "Sorteer op :",
                    Relevance: "Relevantie",
                    "Price: Low to high": "Prijs laag naar hoog",
                    "Price: High to low": "Prijs: hoog naar laag",
                },
                no: {
                    "Color Variants:": "Fargevarianter:",
                    "variant(s)": "variant (er)",
                    "Grid View": "Rutenett visning",
                    "List View": "Listevisning",
                    "Starting at": "Starter pÃ¥",
                    Suggestions: "Forslag",
                    Pages: "Sider",
                    Category: "Kategori",
                    Products: "Produkter",
                    "View All": "Se alt",
                    First: "FÃ¸rst",
                    Previous: "Tidligere",
                    Next: "NESTE",
                    Last: "Siste",
                    Close: "Lukk",
                    " Results": " Resultater.",
                    " Result": " Resultat",
                    found: "funnet",
                    for: "til",
                    Filters: "Filtre",
                    "Popular Searches": "PopulÃ¦re sÃ¸k",
                    "Tags:": "Tags:",
                    "View details": "Vis detaljer",
                    "Original price %s": "Opprinnelige pris %s",
                    "Items per page : %s": "Elementer per side : %s",
                    "Sort by : ": "Sorter etter :",
                    Relevance: "Relevans",
                    "Price: Low to high": "Pris: Lav til hÃ¸y",
                    "Price: High to low": "Pris: HÃ¸y til lav",
                },
                pl: {
                    "Color Variants:": "Warianty kolorÃ³w:",
                    "variant(s)": "wariant (y)",
                    "Grid View": "Widok siatki",
                    "List View": "Widok listy",
                    "Starting at": "ZaczynaÄ‡ od",
                    Suggestions: "Propozycje",
                    Pages: "Strony",
                    Category: "Kategoria",
                    Products: "Produkty",
                    "View All": "PokaÅ¼ wszystkie",
                    First: "Najpierw",
                    Previous: "Poprzedni",
                    Next: "NastÄ™pny",
                    Last: "Ostatni",
                    Close: "Blisko",
                    " Results": " Wyniki",
                    " Result": " Wynik",
                    found: "znaleziony",
                    for: "dla",
                    Filters: "Filtry.",
                    "Popular Searches": "popularne wyszukiwania",
                    "Tags:": "Tagi:",
                    "View details": "PokaÅ¼ szczegÃ³Å‚y",
                    "Original price %s": "Oryginalna cena %s",
                    "Items per page : %s": "Przedmioty na stronie : %s",
                    "Sort by : ": "Sortuj wedÅ‚ug :",
                    Relevance: "Znaczenie",
                    "Price: Low to high": "Cena: Niska do wysokiego",
                    "Price: High to low": "Cena: wysoka do niskiego",
                },
                pt: {
                    "Color Variants:": "Variantes de cor:",
                    "variant(s)": "Variante (s)",
                    "Grid View": "Vista da grade",
                    "List View": "ExibiÃ§Ã£o de lista",
                    "Starting at": "ComeÃ§ando Ã s",
                    Suggestions: "SugestÃµes",
                    Pages: "PÃ¡ginas",
                    Category: "Categoria",
                    Products: "Produtos",
                    "View All": "Ver tudo",
                    First: "Primeiro",
                    Previous: "Anterior",
                    Next: "PrÃ³ximo",
                    Last: "Ãšltimo",
                    Close: "Fechar",
                    " Results": " Resultados",
                    " Result": " Resultado",
                    found: "encontrado",
                    for: "para",
                    Filters: "Filtros",
                    "Popular Searches": "Pesquisas populares",
                    "Tags:": "Tag:",
                    "View details": "Ver detalhes",
                    "Original price %s": "PreÃ§o original %s",
                    "Items per page : %s": "Itens por pÃ¡gina : %s",
                    "Sort by : ": "Ordenar por :",
                    Relevance: "RelevÃ¢ncia",
                    "Price: Low to high": "PreÃ§o: baixo para alto",
                    "Price: High to low": "PreÃ§o: alta a baixa",
                },
                ro: {
                    "Color Variants:": "Variante de culoare:",
                    "variant(s)": "Variante (e)",
                    "Grid View": "Vizualizare grilÄƒ",
                    "List View": "Vizualizare listÄƒ.",
                    "Starting at": "ÃŽncepÃ¢nd de la",
                    Suggestions: "Sugestii",
                    Pages: "Pagini",
                    Category: "Categorie",
                    Products: "Produse",
                    "View All": "A vedea tot",
                    First: "Primul",
                    Previous: "Anterior",
                    Next: "UrmÄƒtorul",
                    Last: "Ultimul",
                    Close: "ÃŽnchide",
                    " Results": " Rezultate",
                    " Result": " Rezultat",
                    found: "gÄƒsite",
                    for: "pentru",
                    Filters: "Filtre",
                    "Popular Searches": "CÄƒutÄƒri populare",
                    "Tags:": "Etichete:",
                    "View details": "Vezi detalii",
                    "Original price %s": "PreÈ›ul original %s",
                    "Items per page : %s": "Elementele pe paginÄƒ : %s",
                    "Sort by : ": "FiltreazÄƒ dupÄƒ :",
                    Relevance: "RelevanÅ£Äƒ",
                    "Price: Low to high": "PreÈ›: scÄƒzut la Ã®nÄƒlÈ›ime",
                    "Price: High to low": "PreÈ›: ridicat la scÄƒzut",
                },
                ru: {
                    "Color Variants:": "Ð¦Ð²ÐµÑ‚Ð½Ñ‹Ðµ Ð²Ð°Ñ€Ð¸Ð°Ð½Ñ‚Ñ‹:",
                    "variant(s)": "Ð’Ð°Ñ€Ð¸Ð°Ð½Ñ‚ (Ñ‹)",
                    "Grid View": "Ð’Ð¸Ð´ ÑÐµÑ‚ÐºÐ¸",
                    "List View": "ÐŸÐ¾ÑÐ¼Ð¾Ñ‚Ñ€ÐµÑ‚ÑŒ ÑÐ¿Ð¸ÑÐ¾Ðº",
                    "Starting at": "ÐÐ°Ñ‡Ð¸Ð½Ð°ÐµÑ‚ÑÑ Ñ",
                    Suggestions: "ÐŸÑ€ÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ",
                    Pages: "Ð¡Ñ‚Ñ€Ð°Ð½Ð¸Ñ†Ñ‹",
                    Category: "ÐšÐ°Ñ‚ÐµÐ³Ð¾Ñ€Ð¸Ñ",
                    Products: "ÐŸÑ€Ð¾Ð´ÑƒÐºÑ‚Ñ‹",
                    "View All": "ÐŸÐ¾ÑÐ¼Ð¾Ñ‚Ñ€ÐµÑ‚ÑŒ Ð²ÑÐµ",
                    First: "ÐŸÐµÑ€Ð²Ñ‹Ð¹",
                    Previous: "ÐŸÑ€ÐµÐ´Ñ‹Ð´ÑƒÑ‰Ð¸Ð¹",
                    Next: "Ð¡Ð»ÐµÐ´ÑƒÑŽÑ‰Ð¸Ð¹",
                    Last: "ÐŸÐ¾ÑÐ»ÐµÐ´Ð½Ð¸Ð¹",
                    Close: "Ð—Ð°ÐºÑ€Ñ‹Ð²Ð°Ñ‚ÑŒ",
                    " Results": " ÐŸÐ¾Ð»ÑƒÑ‡ÐµÐ½Ð½Ñ‹Ðµ Ñ€ÐµÐ·ÑƒÐ»ÑŒÑ‚Ð°Ñ‚Ñ‹",
                    " Result": " Ð ÐµÐ·ÑƒÐ»ÑŒÑ‚Ð°Ñ‚",
                    found: "Ð½Ð°ÑˆÐµÐ»",
                    for: "Ð´Ð»Ñ",
                    Filters: "Ð¤Ð¸Ð»ÑŒÑ‚Ñ€Ñ‹",
                    "Popular Searches": "ÐŸÐ¾Ð¿ÑƒÐ»ÑÑ€Ð½Ñ‹Ðµ Ð¿Ð¾Ð¸ÑÐºÐ¸",
                    "Tags:": "Ð¢ÐµÐ³Ð¸:",
                    "View details": "ÐŸÐ¾ÑÐ¼Ð¾Ñ‚Ñ€ÐµÑ‚ÑŒ Ð´ÐµÑ‚Ð°Ð»Ð¸",
                    "Original price %s": "ÐžÑ€Ð¸Ð³Ð¸Ð½Ð°Ð»ÑŒÐ½Ð°Ñ Ñ†ÐµÐ½Ð° %s",
                    "Items per page : %s": "ÐŸÑ€ÐµÐ´Ð¼ÐµÑ‚Ñ‹ Ð½Ð° ÑÑ‚Ñ€Ð°Ð½Ð¸Ñ†Ðµ : %s",
                    "Sort by : ": "Ð¡Ð¾Ñ€Ñ‚Ð¸Ñ€Ð¾Ð²Ð°Ñ‚ÑŒ Ð¿Ð¾ :",
                    Relevance: "ÐÐºÑ‚ÑƒÐ°Ð»ÑŒÐ½Ð¾ÑÑ‚ÑŒ",
                    "Price: Low to high": "Ð¦ÐµÐ½Ð°: Ð½Ð¸Ð·ÐºÐ¸Ð¹ Ð´Ð¾ Ð²Ñ‹ÑÐ¾ÐºÐ¾Ð³Ð¾",
                    "Price: High to low": "Ð¦ÐµÐ½Ð°: Ð²Ñ‹ÑÐ¾ÐºÐ¾ Ð´Ð¾ Ð½Ð¸Ð·ÐºÐ¾Ð³Ð¾",
                },
                sk: {
                    "Color Variants:": "Varianty farieb:",
                    "variant(s)": "Variant (y)",
                    "Grid View": "Zobrazenie mrieÅ¾ky",
                    "List View": "Zobrazenie zoznamu",
                    "Starting at": "ZaÄne",
                    Suggestions: "NÃ¡vrhy",
                    Pages: "StrÃ¡nka",
                    Category: "KategÃ³ria",
                    Products: "Produkty",
                    "View All": "ZobraziÅ¥ vÅ¡etko",
                    First: "najprv",
                    Previous: "PredchÃ¡dzajÃºci",
                    Next: "ÄŽalÅ¡ie",
                    Last: "PoslednÃ½",
                    Close: "ZavrieÅ¥",
                    " Results": " VÃ½sledok",
                    " Result": " VÃ½sledok",
                    found: "zistiÅ¥",
                    for: "pre",
                    Filters: "Filtre",
                    "Popular Searches": "PopulÃ¡rne vyhÄ¾adÃ¡vania",
                    "Tags:": "Tagy:",
                    "View details": "ZobraziÅ¥ podrobnosti",
                    "Original price %s": "PÃ´vodnÃ¡ cena %s",
                    "Items per page : %s": "PoloÅ¾ky na strÃ¡nku : %s",
                    "Sort by : ": "TriediÅ¥ podÄ¾a :",
                    Relevance: "RelevantnosÅ¥",
                    "Price: Low to high": "Cena: NÃ­zka aÅ¾ vysokÃ¡",
                    "Price: High to low": "Cena: vysokÃ¡ aÅ¾ nÃ­zka",
                },
                sl: {
                    "Color Variants:": "Barvne variante:",
                    "variant(s)": "Varianta (-e)",
                    "Grid View": "Pogled na mreÅ¾o",
                    "List View": "Pogled seznama",
                    "Starting at": "ZaÄetek",
                    Suggestions: "Predloge",
                    Pages: "Strani",
                    Category: "Kategorija",
                    Products: "Izdelki",
                    "View All": "Poglej vse",
                    First: "PrviÄ",
                    Previous: "PrejÅ¡nji",
                    Next: "Naslednji",
                    Last: "Zadnja",
                    Close: "Zapri",
                    " Results": " Rezultati",
                    " Result": " Rezultat.",
                    found: "najdemo",
                    for: "za",
                    Filters: "Filtri",
                    "Popular Searches": "Popularna iskanja",
                    "Tags:": "Oznake:",
                    "View details": "Ogled podrobnosti",
                    "Original price %s": "Originalna cena %s",
                    "Items per page : %s": "Postavke na stran : %s",
                    "Sort by : ": "Razvrsti po :",
                    Relevance: "Ustreznost",
                    "Price: Low to high": "Cena: nizka do visoka",
                    "Price: High to low": "Cena: visoka do nizka",
                },
                sr: {
                    "Color Variants:": "Ð’Ð°Ñ€Ð¸Ñ˜Ð°Ð½Ñ‚Ðµ Ñƒ Ð±Ð¾Ñ˜Ð¸:",
                    "variant(s)": "Ð’Ð°Ñ€Ð¸Ð°Ð½Ñ‚ (Ñ)",
                    "Grid View": "ÐŸÐ¾Ð³Ð»ÐµÐ´ Ð¼Ñ€ÐµÐ¶Ð°",
                    "List View": "Ð›Ð¸ÑÑ‚Ð° Ð¿Ñ€Ð¸ÐºÐ°Ð·Ð°",
                    "Starting at": "Ð¡Ð° Ð¿Ð¾Ñ‡ÐµÑ‚ÐºÐ¾Ð¼ Ñƒ",
                    Suggestions: "ÐŸÑ€ÐµÐ´Ð»Ð¾Ð·Ð¸",
                    Pages: "Ð¡Ñ‚Ñ€Ð°Ð½Ð¸Ñ†Ðµ",
                    Category: "ÐšÐ°Ñ‚ÐµÐ³Ð¾Ñ€Ð¸Ñ˜Ð°",
                    Products: "ÐŸÑ€Ð¾Ð¸Ð·Ð²Ð¾Ð´Ð¸",
                    "View All": "ÐŸÐ¾Ð³Ð»ÐµÐ´Ð°Ñ‚Ð¸ ÑÐ²Ðµ",
                    First: "ÐŸÑ€Ð²Ð¸",
                    Previous: "ÐŸÑ€ÐµÑ‚Ñ…Ð¾Ð´Ð½Ð°",
                    Next: "Ð¡Ð»ÐµÐ´ÐµÑ›Ð¸",
                    Last: "Ð—Ð°Ð´ÑšÐ¸",
                    Close: "Ð‘Ð»Ð¸Ð·Ñƒ",
                    " Results": " Ð ÐµÐ·ÑƒÐ»Ñ‚Ð°Ñ‚Ð¸",
                    " Result": " Ð ÐµÐ·ÑƒÐ»Ñ‚Ð°Ñ‚",
                    found: "Ð½Ð°ÑˆÐ°Ð¾",
                    for: "Ð·Ð°",
                    Filters: "Ð¤Ð¸Ð»Ñ‚ÐµÑ€Ð¸",
                    "Popular Searches": "ÐŸÐ¾Ð¿ÑƒÐ»Ð°Ñ€Ð½Ðµ Ð¿Ñ€ÐµÑ‚Ñ€Ð°Ð³Ðµ",
                    "Tags:": "ÐžÐ·Ð½Ð°ÐºÐµ:",
                    "View details": "ÐŸÑ€Ð¸ÐºÐ°Ð· Ð´ÐµÑ‚Ð°Ñ™Ð°",
                    "Original price %s": "ÐžÑ€Ð¸Ð³Ð¸Ð½Ð°Ð»Ð½Ð° Ñ†ÐµÐ½Ð° %s",
                    "Items per page : %s": "ÐÑ€Ñ‚Ð¸ÐºÐ»Ð¸ Ð½Ð° ÑÑ‚Ñ€Ð°Ð½Ð¸Ñ†Ð¸ : %s",
                    "Sort by : ": "Ð¡Ð¾Ñ€Ñ‚Ð¸Ñ€Ð°Ñ˜ Ð¿Ð¾ :",
                    Relevance: "Ð ÐµÐ»ÐµÐ²Ð°Ð½Ñ‚Ð½Ð¾ÑÑ‚",
                    "Price: Low to high": "Ð¦ÐµÐ½Ð°: Ð½Ð¸ÑÐºÐ¾ Ð´Ð¾ Ð²Ð¸ÑÐ¾ÐºÐ¾Ð³",
                    "Price: High to low": "Ð¦ÐµÐ½Ð°: Ð’Ð¸ÑÐ¾ÐºÐ¾ Ð·Ð° Ð½Ð¸ÑÐºÐ¾",
                },
                sv: {
                    "Color Variants:": "FÃ¤rgvarianter:",
                    "variant(s)": "Variant (er)",
                    "Grid View": "Gridvy",
                    "List View": "Listvy",
                    "Starting at": "BÃ¶rjar vid",
                    Suggestions: "FÃ¶rslag",
                    Pages: "Sidor",
                    Category: "Kategori",
                    Products: "Produkter",
                    "View All": "Visa alla",
                    First: "FÃ¶rst",
                    Previous: "Tidigare",
                    Next: "NÃ¤sta",
                    Last: "Sista",
                    Close: "StÃ¤nga",
                    " Results": " Resultat",
                    " Result": " Resultat",
                    found: "hittades",
                    for: "fÃ¶r",
                    Filters: "Filter",
                    "Popular Searches": "PopulÃ¤ra sÃ¶kningar",
                    "Tags:": "Taggar:",
                    "View details": "Visa detaljer",
                    "Original price %s": "Originalpris %s",
                    "Items per page : %s": "Artiklar per sida : %s",
                    "Sort by : ": "Sortera efter :",
                    Relevance: "Relevans",
                    "Price: Low to high": "Pris: lÃ¥gt till hÃ¶gt",
                    "Price: High to low": "Pris: HÃ¶gt till lÃ¥gt",
                },
                tr: {
                    "Color Variants:": "Renk Ã§eÅŸitleri:",
                    "variant(s)": "varyant (lar)",
                    "Grid View": "Izgara gÃ¶rÃ¼nÃ¼mÃ¼",
                    "List View": "Liste gÃ¶rÃ¼nÃ¼mÃ¼",
                    "Starting at": "Buradan baÅŸlayarak",
                    Suggestions: "Ã–neriler",
                    Pages: "Sayfalar",
                    Category: "Kategori",
                    Products: "ÃœrÃ¼n:%s",
                    "View All": "Hepsini gÃ¶r",
                    First: "Ã–ncelikle",
                    Previous: "Ã–ncesi",
                    Next: "Sonraki",
                    Last: "Son",
                    Close: "Kapat",
                    " Results": " SonuÃ§lar",
                    " Result": " SonuÃ§",
                    found: "bulundu",
                    for: "iÃ§in",
                    Filters: "Filtreler",
                    "Popular Searches": "popÃ¼ler aramalar",
                    "Tags:": "Etiketler:",
                    "View details": "DetaylarÄ± gÃ¶ster",
                    "Original price %s": "Orijinal fiyat %s",
                    "Items per page : %s": "Sayfa baÅŸÄ±na Ã¶ÄŸeler : %s",
                    "Sort by : ": "GÃ¶re sÄ±rala :",
                    Relevance: "Ä°lgi",
                    "Price: Low to high": "Fiyat: dÃ¼ÅŸÃ¼kten yÃ¼ksek",
                    "Price: High to low": "Fiyat pahalÄ±dan ucuza",
                },
                vi: {
                    "Color Variants:": "CÃ¡c biáº¿n thá»ƒ mÃ u:",
                    "variant(s)": "Biáº¿n thá»ƒ (s)",
                    "Grid View": "Cháº¿ Ä‘á»™ hiá»ƒn thá»‹ theo Ã´",
                    "List View": "Danh sÃ¡ch View.",
                    "Starting at": "Báº¯t Ä‘áº§u táº¡i",
                    Suggestions: "Gá»£i Ã½",
                    Pages: "Trang.",
                    Category: "Loáº¡i",
                    Products: "CÃ¡c sáº£n pháº©m",
                    "View All": "Xem táº¥t cáº£",
                    First: "NgÃ y thá»© nháº¥t",
                    Previous: "TrÆ°á»›c",
                    Next: "Káº¿ tiáº¿p",
                    Last: "Cuá»‘i cÃ¹ng",
                    Close: "Gáº§n",
                    " Results": " Káº¿t quáº£",
                    " Result": " Káº¿t quáº£",
                    found: "tÃ¬m",
                    for: "vÃ¬",
                    Filters: "Bá»™ lá»c",
                    "Popular Searches": "TÃ¬m kiáº¿m phá»• biáº¿n",
                    "Tags:": "Tags:",
                    "View details": "Xem chi tiáº¿t",
                    "Original price %s": "GiÃ¡ gá»‘c %s",
                    "Items per page : %s": "CÃ¡c má»¥c trÃªn má»—i trang : %s",
                    "Sort by : ": "Sáº¯p xáº¿p theo:",
                    Relevance: "Sá»± liÃªn quan",
                    "Price: Low to high": "GiÃ¡: tháº¥p Ä‘áº¿n cao",
                    "Price: High to low": "GiÃ¡ tá»« cao Ä‘áº¿n tháº¥p",
                },
                zh: {
                    "Color Variants:": "é¢œè‰²å˜ç§ï¼š",
                    "variant(s)": "å˜ä½“",
                    "Grid View": "ç½‘æ ¼è§†å›¾",
                    "List View": "åˆ—è¡¨æ˜¾ç¤º",
                    "Starting at": "å¼€å§‹äºŽ",
                    Suggestions: "å»ºè®®",
                    Pages: "é¡µé¢",
                    Category: "ç±»åˆ«",
                    Products: "äº§å“",
                    "View All": "æŸ¥çœ‹å…¨éƒ¨",
                    First: "ç¬¬ä¸€çš„",
                    Previous: "ä»¥å‰çš„",
                    Next: "ä¸‹ä¸€ä¸ª",
                    Last: "æœ€åŽçš„",
                    Close: "å…³é—­",
                    " Results": " ç»“æžœ",
                    " Result": " ç»“æžœ",
                    found: "æˆç«‹",
                    for: "ä¸ºäº†",
                    Filters: "è¿‡æ»¤å™¨",
                    "Popular Searches": "çƒ­é—¨æœç´¢",
                    "Tags:": "æ ‡ç­¾ï¼š",
                    "View details": "æŸ¥çœ‹è¯¦æƒ…",
                    "Original price %s": "åŽŸä»· %s",
                    "Items per page : %s": "æ¯é¡µç‰©å“ï¼š%s",
                    "Sort by : ": "æŽ’åºæ–¹å¼ ï¼š",
                    Relevance: "å…³è”",
                    "Price: Low to high": "ä»·æ ¼ï¼šä½Žè‡³é«˜",
                    "Price: High to low": "ä»·æ ¼ï¼šé«˜åˆ°ä½Ž",
                },
            },
            getDefaultLanguageCode: function () {
                "undefined" == typeof klevu_lang && (klevu_lang = "en");
                var e = "en";
                return (
                    "nn" === klevu_lang
                        ? (e = "nb")
                        : "zh_Hant_HK" === klevu_lang || "zh-CN" === klevu_lang
                            ? (e = "zh")
                            : "lav" === klevu_lang
                                ? (e = "lv")
                                : klevu.search.modules.locale.globalTranslations.hasOwnProperty(klevu_lang) && (e = klevu_lang),
                    e
                );
            },
            getTranslations: function (e) {
                return klevu.search.modules.locale.globalTranslations.hasOwnProperty(e) ? klevu.search.modules.locale.globalTranslations[e] : {};
            },
            applyTranslationOverrides: function (e) {
                if ("undefined" != typeof klevu_storeTranslations && klevu_storeTranslations) for (key in klevu_storeTranslations) e[key] = klevu_storeTranslations[key];
                return e;
            },
        },
    }),
    klevu.coreEvent.build({
        name: "appendLandingPageLoaderEvent",
        fire: function () {
            return !(!klevu.dom.find(".klevuLanding") || !klevu.dom.find(".klevuLanding").length);
        },
        maxCount: 500,
        delay: 10,
    }),
    klevu.coreEvent.attach("appendLandingPageLoaderEvent", {
        name: "renderLoaderUI",
        fire: function () {
            var t = klevu.dom.find(".klevuLanding")[0];
            !(function () {
                !(function () {
                    document.body.classList.remove("kuFeatureResourcesLoading");
                    for (var e = document.getElementsByClassName("kuResourceLoader"); 0 < e.length;) e[0].parentNode.removeChild(e[0]);
                })(),
                    document.body.classList.add("kuFeatureResourcesLoading");
                var e = document.createElement("div");
                e.classList.add("kuResourceLoader"), t.appendChild(e);
            })();
        },
    }),
    klevu.coreEvent.build({
        name: "setRemoteConfigLanding",
        fire: function () {
            return (
                !(!klevu.dom.find(".klevuLanding") || !klevu.dom.find(".klevuLanding").length) &&
                !klevu.isUndefined(klevu.search.landing) &&
                !klevu.isUndefined(klevu.search.modules.kmcInputs) &&
                !(klevu.search.modules.kmcInputs.build && !klevu.search.modules.kmcInputs.hasAllResourcesLoaded && !klevu.search.modules.kmcInputs.hasAllResourcesLoadedJson) &&
                !!(!0 !== klevu.getGlobalSetting("theme.landing.loadDefaultTemplates") || (klevu.dom.find("#klevu-landing-search-theme-templates") && klevu.dom.find("#klevu-landing-search-theme-templates").length))
            );
        },
        maxCount: 500,
        delay: 30,
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "search-landing-locale",
        fire: function () {
            klevu.search.landing.getScope().template.getTranslator().mergeFromGlobal(), klevu.search.landing.getScope().template.getTranslator().getCurrencyObject().mergeFromGlobal();
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "search-landing-templates",
        fire: function () {
            klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplateBase"), "klevuTemplateLanding", !0),
                klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplateResults"), "results", !0),
                klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplateProductBlock"), "productBlock", !0),
                klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplateResultsHeadingTitle"), "klevuLandingTemplateResultsHeadingTitle", !0);
        },
    }),
    klevu.setSetting(klevu, "settings.theme.modules.pagination.searchResultsPage.enable", !0),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "addPaginationModule",
        fire: function () {
            !0 !== klevu.getGlobalSetting("theme.modules.resultInfiniteScroll.searchResultsPage.enable", !1)
                ? (klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplatePagination"), "pagination", !0),
                    klevu.search.landing.getScope().chains.template.events.add({
                        name: "addPagination",
                        fire: function (e, t) {
                            t = klevu.getSetting(t.kScope.settings, "settings.search.searchBoxTarget");
                            klevu.each(klevu.dom.find(".klevuPaginate", t), function (e, t) {
                                klevu.event.attach(
                                    t,
                                    "click",
                                    function (e) {
                                        (e = e || window.event).preventDefault();
                                        var t,
                                            a = e.target,
                                            r = klevu.dom.helpers.getClosest(a, ".klevuTarget");
                                        console.log(r);
                                        console.log(r.dataset);
                                        null !== r &&
                                            (((t = r.kElem).kScope.data = t.kObject.resetData(t.kElem)),
                                                (t.kScope.data.context.keyCode = 0),
                                                (t.kScope.data.context.eventObject = e),
                                                (t.kScope.data.context.event = "keyUp"),
                                                (t.kScope.data.context.preventDefault = !1),
                                                (r = klevu.dom.helpers.getClosest(a, ".klevuMeta")),
                                                (a = (a = a.dataset.offset) < 0 ? 0 : a),
                                                klevu.setObjectPath(t.kScope.data, "localOverrides.query." + r.dataset.section + ".settings.offset", parseInt(a)),
                                                klevu.event.fireChain(t.kScope, "chains.events.keyUp", t, t.kScope.data, e));
                                    },
                                    !0
                                );
                            });
                        },
                    }))
                : klevu.setSetting(klevu, "settings.theme.modules.pagination.searchResultsPage.enable", !1);
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "search-landing-chains",
        fire: function () {
            klevu.search.landing.getScope().chains.template.process.success.add({
                name: "processCurrencySetting",
                fire: function (e, t) {
                    var a = klevu.search.landing.getScope().template.getTranslator().getCurrencyObject().getCurrencys(),
                        r = "";
                    klevu.each(e.template.query, function (e, t) {
                        klevu.isUndefined(t) ||
                            "" != r ||
                            klevu.each(t.result, function (e, t) {
                                t.currency && t.currency.length && (r = t.currency);
                            });
                    }),
                        r.length && !a[r] && ((a[r] = klevu.search.modules.kmcInputs.base.getPriceFormatterObject(r)), (e = klevu.search.landing.getScope().template.getTranslator().getCurrencyObject()).setCurrencys(a), e.mergeToGlobal());
                },
            }),
                klevu.search.landing.getScope().chains.template.process.success.add({
                    name: "processFilters",
                    fire: function (a, e) {
                        var r = [];
                        klevu.each(a.template.query, function (e, t) {
                            r.push(e);
                        }),
                            r.length &&
                            ((a.template.queryIds = r),
                                klevu.each(a.template.queryIds, function (e, t) {
                                    t = klevu.getObjectPath(a.template.query, t);
                                    klevu.isUndefined(t) ||
                                        klevu.each(t.filters, function (e, t) {
                                            t.multiselect = klevu.search.modules.kmcInputs.base.getFilterMultiSelectValue();
                                        });
                                }));
                    },
                }),
                klevu.search.landing.getScope().chains.template.events.add({
                    name: "manageKlevuTemplateBlocksStatus",
                    fire: function (e, t) {
                        klevu.baseStructure.base.initialize(t);
                    },
                }),
                klevu.search.landing.getScope().chains.template.render.add({
                    name: "renderResponse",
                    fire: function (e, t) {
                        var a, r;
                        e.context.isSuccess &&
                            (t.kScope.template.setData(e.template),
                                (a = t.kScope.template.convertTemplate(t.kScope.template.render("klevuTemplateLanding"))),
                                ((r = klevu.getSetting(t.kScope.settings, "settings.search.searchBoxTarget")).innerHTML = ""),
                                r.classList.add("klevuTarget"),
                                r.classList.add("kuSearchResultsPageContainer"),
                                r.classList.remove("searchRequestLoading"),
                                document.body.classList.remove("kuFeatureResourcesLoading"),
                                (t.kScope.element.kData = e.template),
                                t.kScope.template.insertTemplate(r, a));
                    },
                }),
                klevu.search.landing.getScope().chains.request.control.addBefore("sanitiseRequestSuggestions", {
                    name: "storeOriginRequestSuggestions",
                    fire: function (e, t) {
                        var a = klevu.getObjectPath(e, "request.current.suggestions");
                        klevu.setObjectPath(e, "request.original.suggestions", klevu.extend([], a));
                    },
                }),
                klevu.search.landing.getScope().chains.request.control.addBefore("sanitiseRequestQuery", {
                    name: "storeOriginRequestRecordQueries",
                    fire: function (e, t) {
                        var a = klevu.getObjectPath(e, "request.current.recordQueries");
                        klevu.setObjectPath(e, "request.original.recordQueries", klevu.extend([], a));
                    },
                });
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "search-landing-template-helpers",
        fire: function () {
            klevu.getSetting(klevu.settings, "settings.storage");
            klevu.search.landing.getScope().template.setHelper("cropText", function (e, t) {
                return e.length <= t ? e : e.substring(0, t) + "...";
            }),
                klevu.search.landing.getScope().template.setHelper("hasResults", function (e, t) {
                    return !!(e.query[t] && 0 < e.query[t].result.length);
                }),
                klevu.search.landing.getScope().template.setHelper("hasFilters", function (e, t) {
                    return !!(e.query[t] && 0 < e.query[t].filters.length);
                });
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "attachSearchRequestLoader",
        fire: function () {
            klevu.search.modules.requestLoader.base.initSearchRequestLoader(klevu.search.landing.getScope());
        },
    }),
    (klevu.themeVersion = "2.0.15"),
    klevu.setObjectPath(klevu, "support.theme", { landing: !0, version: "2.0.15" }),
    klevu.interactive(function () {
        void 0 === klevu.getSetting(klevu, "settings.powerUp.landing") && klevu.setSetting(klevu, "settings.powerUp.landing", !0);
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "addQueryForSearchRequest",
        fire: function () {
            klevu.search.landing.getScope().chains.request.build.add({
                name: "addProductList",
                fire: function (e, t) {
                    var a = klevu.getSetting(t.kScope.settings, "settings.search.map", !1),
                        t = klevu.extend(!0, {}, a.recordQuery);
                    (t.id = "productList"),
                        (t.typeOfRequest = "SEARCH"),
                        (t.settings.query.term = e.context.term),
                        (t.settings.typeOfRecords = ["KLEVU_PRODUCT"]),
                        (t.settings.searchPrefs = ["searchCompoundsAsAndQuery"]),
                        (t.settings.limit = 12),
                        (t.settings.fallbackQueryId = "productListFallback"),
                        (t.filters.filtersToReturn.enabled = !0);
                    a = klevu.search.modules.kmcInputs.base.getFacetRangeFilterSettings();
                    a && (t.filters.filtersToReturn.rangeFilterSettings = [a]), e.request.current.recordQueries.push(t), (e.context.doSearch = !0), e.context.activeQueryId || (e.context.activeQueryId = "productList");
                },
            }),
                klevu.search.landing.getScope().chains.request.build.add({
                    name: "addProductListFallback",
                    fire: function (e, t) {
                        (t = klevu.getSetting(t.kScope.settings, "settings.search.map", !1)), (t = klevu.extend(!0, {}, t.recordQuery));
                        (t.id = "productListFallback"),
                            (t.typeOfRequest = "SEARCH"),
                            (t.isFallbackQuery = "true"),
                            (t.settings.query.term = "*"),
                            (t.settings.typeOfRecords = ["KLEVU_PRODUCT"]),
                            (t.settings.searchPrefs = ["excludeDescription", "searchCompoundsAsAndQuery"]),
                            (t.settings.limit = 3),
                            (t.settings.sort = "RELEVANCE"),
                            e.request.current.recordQueries.push(t),
                            (e.context.doSearch = !0);
                    },
                });
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "attachSearchResultLandingPageAnalyticsEvents",
        fire: function () {
            klevu.search.landing.getScope().chains.template.events.add({
                name: "attachAnalyticsActionEvent",
                fire: function (a, r) {
                    var e = klevu.getSetting(r.kScope.settings, "settings.search.searchBoxTarget");
                    klevu.each(
                        klevu.dom.find(".klevuMeta", e),
                        function (e, t) {
                            klevu.event.attach(t, "click", function (e) {
                                (a.context.section = t.dataset.section), (r.kScope.data.context.section = t.dataset.section);
                            });
                        },
                        !0
                    );
                    var t = klevu.getSetting(r.kScope.settings, "settings.storage");
                    t && t.tabs
                        ? (t.tabs.setStorage("local"),
                            t.tabs.mergeFromGlobal(),
                            (t = t.tabs.getElement("active")) && t.length && "active" != t ? ((a.context.section = t), (r.kScope.data.context.section = t)) : klevu.dom.find(".klevuMeta", e)[0] && klevu.dom.find(".klevuMeta", e)[0].click())
                        : klevu.dom.find(".klevuMeta", e)[0] && klevu.dom.find(".klevuMeta", e)[0].click();
                    e = klevu.analyticsUtil.base.getTermOptions(r.kScope, !0);
                    e.klevu_src && ((e.klevu_src = e.klevu_src.replace("]]", ";;template:landing]]")), e.filters && (e.klevu_src = e.klevu_src.replace("]]", ";;source:filters]]")), (e.klevu_src = e.klevu_src)),
                        delete e.filters,
                        klevu.analyticsEvents.term(e),
                        klevu.analyticsUtil.base.registerLandingProductClickEvent(r.kScope, klevu.analyticsUtil.base.storage.dictionary, klevu.analyticsUtil.base.storage.click);
                },
            });
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "addFacetsOnLandingPage",
        fire: function () {
            var e = klevu.search.modules.kmcInputs.base.getFiltersEnableValue(),
                t = klevu.search.modules.kmcInputs.base.getLandingFilterPosition();
            !e ||
                (e && "left" !== t) ||
                (klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplateFilters"), "filters", !0),
                    klevu.search.landing.getScope().chains.template.events.add({
                        name: "initializeFilterLeft",
                        fire: function (e, t) {
                            klevu.search.modules.facets.base.attachFacetItemsClickEvent(t.kScope);
                        },
                    }));
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "addTopFacetsOnLandingPage",
        fire: function () {
            var e = klevu.search.modules.kmcInputs.base.getFiltersEnableValue(),
                t = klevu.search.modules.kmcInputs.base.getLandingFilterPosition();
            !e ||
                (e && "top" !== t) ||
                (klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplateTopFilters"), "filtersTop", !0),
                    klevu.search.landing.getScope().chains.template.events.add({
                        name: "initializeFilterTop",
                        fire: function (e, t) {
                            klevu.search.modules.facets.base.attachFacetItemsClickEvent(t.kScope);
                        },
                    }));
        },
    }),
    klevu.coreEvent.attach("addToCartModuleBuild", {
        name: "extendModuleForLandingPage",
        fire: function () {
            klevu.extend(!0, klevu.search.modules.addToCart.base, {
                bindLandingProductAddToCartBtnClickEvent: function (a) {
                    var r = this,
                        e = klevu.getSetting(a.settings, "settings.search.searchBoxTarget");
                    klevu.each(klevu.dom.find(".kuLandingAddToCartBtn", e), function (e, t) {
                        klevu.event.attach(t, "click", function (e) {
                            var t = klevu.dom.helpers.getClosest(this, ".klevuMeta");
                            t && t.dataset && t.dataset.section && ((t = klevu.getObjectPath(a.data.template.query, t.dataset.section)), r.attachProductAddToCartBtnEvent(this, e, t.result));
                        });
                    });
                },
                attachProductAddToCartBtnEvent: function (e, t, a) {
                    var r;
                    (t = t || window.event).preventDefault();
                    var n = klevu.dom.helpers.getClosest(e, ".kuAddtocart").getAttribute("data-id");
                    klevu.each(a, function (e, t) {
                        t.id == n && (r = t);
                    }),
                        r && (e.selected_product = r) && klevu.search.modules.addToCart.base.sendAddToCartRequest(r.id, r.url, 1);
                },
            });
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "addAddToCartButtonLandingPage",
        fire: function () {
            klevu.search.modules.kmcInputs.base.getAddToCartEnableValue() &&
                (klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#landingPageProductAddToCart"), "landingPageProductAddToCart", !0),
                    klevu.search.landing.getScope().chains.template.events.add({
                        name: "landingPageProductAddToCartEvent",
                        fire: function (e, t) {
                            klevu.search.modules.addToCart.base.bindLandingProductAddToCartBtnClickEvent(t.kScope);
                        },
                    }));
        },
    }),
    klevu.coreEvent.attach("analyticsPowerUp", {
        name: "extAddToCartAnalyticsUtil",
        fire: function () {
            klevu.extend(!0, klevu.analyticsUtil.base, {
                registerProductAddToCartClickEvent: function (n, e, s, o) {
                    var t = klevu.getSetting(n.settings, "settings.search.searchBoxTarget");
                    klevu.each(klevu.dom.find(e, t), function (e, r) {
                        klevu.event.attach(r, "click", function (e) {
                            var t,
                                a = klevu.dom.helpers.getClosest(r, ".klevuProduct");
                            null === a ||
                                ((t = a.dataset.id) &&
                                    (!(a = klevu.analyticsUtil.base.getProductDetailsFromId(t, n)) ||
                                        ((t = klevu.analyticsUtil.base.getTermOptions(n)) &&
                                            ((t.klevu_keywords = t.klevu_term),
                                                (t.klevu_productId = a.id),
                                                void 0 !== a.itemGroupId && (t.klevu_productGroupId = a.itemGroupId),
                                                (t.klevu_productVariantId = a.id),
                                                (t.klevu_productName = a.name),
                                                (t.klevu_productUrl = a.url),
                                                (t.klevu_src = "[[shortlist:add-to-cart;;template:landing]]"),
                                                delete t.klevu_term,
                                                klevu.analyticsUtil.base.storeAnalyticsEvent(s, o, t)))));
                        });
                    });
                },
            });
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "attachLandingProductAddToCartButtonAnalytics",
        fire: function () {
            klevu.search.landing.getScope().chains.template.events.add({
                name: "bindAnalyticsOnAddToCartButtonEvent",
                fire: function (e, t) {
                    klevu.analyticsUtil.base.registerProductAddToCartClickEvent(t.kScope, ".kuAddtocart", klevu.analyticsUtil.base.storage.dictionary, klevu.analyticsUtil.base.storage.click);
                },
            });
        },
    }),
    klevu.coreEvent.attach("colorSwatchesModuleBuild", {
        name: "extendColorSwatchesModuleForLandingPage",
        fire: function () {
            klevu.extend(!0, klevu.search.modules.colorSwatches.base, {
                bindColorGridEventsToLandingProducts: function (r) {
                    var n = this;
                    klevu.each(r.data.response.current.queryResults, function (e, t) {
                        var a;
                        t &&
                            t.id &&
                            ((t = klevu.getObjectPath(r.data.template.query, t.id)) && t.result && (a = t.result),
                                (t = klevu.getSetting(r.settings, "settings.search.searchBoxTarget")),
                                klevu.each(klevu.dom.find(".klevuLandingSwatchColorGrid", t), function (e, t) {
                                    n.landingMapColorSwatchesData(t, a),
                                        n.landingSetDefaultProductImageToSwatches(t),
                                        klevu.event.attach(t, "mouseenter", function (e) {
                                            n.landingColorGridMouseEnterEvent(t);
                                        }),
                                        klevu.event.attach(t, "mouseleave", function (e) {
                                            n.landingColorGridMouseLeaveEvent(t);
                                        });
                                }));
                    });
                },
                getNearestProductImageByElement: function (e) {
                    var t,
                        e = klevu.dom.helpers.getClosest(e, ".klevuProduct");
                    return (e = klevu.dom.find(".klevuImgWrap img", e)[0]) && (t = e), t;
                },
                landingMapColorSwatchesData: function (a, e) {
                    var r,
                        n,
                        s,
                        t = klevu.dom.helpers.getClosest(a, ".klevuProduct");
                    !t ||
                        ((n = t.getAttribute("data-id")) &&
                            (klevu.each(e, function (e, t) {
                                t.id == n && (r = t);
                            }),
                                r &&
                                r.swatchesInfo &&
                                (s = a.getAttribute("data-variant")) &&
                                klevu.each(r.swatchesInfo, function (e, t) {
                                    t.variantId == s && (a.swatchesInfo = t);
                                })));
                },
                landingColorGridMouseEnterEvent: function (e) {
                    var t = this.getNearestProductImageByElement(e);
                    t && t.setAttribute("src", e.swatchesInfo.variantImage);
                },
                landingColorGridMouseLeaveEvent: function (e) {
                    var t = this.getNearestProductImageByElement(e);
                    t && t.setAttribute("src", e.defaultImage);
                },
                landingSetDefaultProductImageToSwatches: function (e) {
                    var t = this.getNearestProductImageByElement(e);
                    t && (e.defaultImage = t.getAttribute("src"));
                },
            });
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "attachLandingPageProductColorSwatch",
        fire: function () {
            klevu.search.modules.kmcInputs.base.getColorSwatchesEnableValue() &&
                (klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#landingPageProductColorSwatches"), "landingProductSwatch", !0),
                    klevu.search.landing.getScope().chains.template.render.addBefore("renderResponse", {
                        name: "initializeLandingProductSwatches",
                        fire: function (e, a) {
                            e.context.isSuccess &&
                                klevu.each(e.response.current.queryResults, function (e, t) {
                                    t && t.id && klevu.search.modules.colorSwatches.base.parseProductColorSwatch(a.kScope, t.id);
                                });
                        },
                    }),
                    klevu.search.landing.getScope().chains.template.events.add({
                        name: "addProductGridColorSwatches",
                        fire: function (e, t) {
                            klevu.search.modules.colorSwatches.base.bindColorGridEventsToLandingProducts(t.kScope);
                        },
                    }));
        },
    }),
    klevu.coreEvent.attach("colorSwatchesModuleBuild", {
        name: "extendColorSwatchesModuleForQuickView",
        fire: function () {
            klevu.extend(!0, klevu.search.modules.colorSwatches.base, {
                bindColorGridEvents: function () {
                    var e = this.getSelectedProductData();
                    e && e.swatchesInfo && this.mapSwatchObjectToColorGrid(e);
                },
                getSelectedProductData: function () {
                    var e,
                        t = klevu.dom.find(".productQuickView");
                    return t && t[0] && (e = t[0].selected_product), e;
                },
                mapSwatchObjectToColorGrid: function (r) {
                    var n = this;
                    klevu.each(klevu.dom.find(".klevuLandingSwatchColorGrid"), function (e, t) {
                        var a = t.getAttribute("data-variant");
                        a &&
                            (r.swatchesInfo.forEach(function (e) {
                                e.variantId == a && (t.swatchesInfo = e);
                            }),
                                klevu.event.attach(t, "mouseenter", function (e) {
                                    n.colorGridMouseEnterEvent(t);
                                }),
                                klevu.event.attach(t, "mouseleave", function (e) {
                                    n.colorGridMouseLeaveEvent(r);
                                }));
                    });
                },
                colorGridMouseLeaveEvent: function (e) {
                    var t,
                        a = this.getProductImageElement();
                    a &&
                        ((t = e.id),
                            e.swatchesInfo.forEach(function (e) {
                                t == e.variantId && a.setAttribute("src", e.variantImage);
                            }));
                },
                colorGridMouseEnterEvent: function (e) {
                    var t = this.getProductImageElement();
                    t && t.setAttribute("src", e.swatchesInfo.variantImage);
                },
                getProductImageElement: function () {
                    var e,
                        t = klevu.dom.find(".productQuick-imgBlock img");
                    return t && t[0] && (e = t[0]), e;
                },
            });
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "attachProductQuickViewColorSwatch",
        fire: function () {
            klevu.search.modules.kmcInputs.base.getColorSwatchesEnableValue() &&
                (klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#quickViewProductColorSwatches"), "quickViewProductSwatch", !0),
                    klevu.search.landing.getScope().chains.template.events.add({
                        name: "parseQuickViewProductColorSwatch",
                        fire: function (e, a) {
                            klevu.each(e.response.current.queryResults, function (e, t) {
                                t && t.id && klevu.search.modules.colorSwatches.base.parseProductColorSwatch(a.kScope, t.id);
                            });
                        },
                    }),
                    klevu.search.landing.getScope().chains.quickView &&
                    klevu.search.landing.getScope().chains.quickView.add({
                        name: "bindColorGridEvents",
                        fire: function (e, t) {
                            klevu.search.modules.colorSwatches.base.bindColorGridEvents();
                        },
                    }));
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "addProductavailabilityLabel",
        fire: function () {
            klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#landingSearchResultProductStock"), "landingProductStock", !0);
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "addProductVATLabel",
        fire: function () {
            var e = klevu.search.modules.kmcInputs.base.getVatCaption();
            e && "" != e && klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#searchResultProductVATLabel"), "searchResultProductVATLabel", !0);
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "search-landing-sort",
        fire: function () {
            var e = { storage: { sort: klevu.dictionary("sort") } };
            klevu(e),
                klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplateSortBy"), "sortBy", !0),
                klevu.search.landing.getScope().chains.request.build.add({
                    name: "setSortBy",
                    fire: function (e, t) {
                        var r = klevu.getSetting(t.kScope.settings, "settings.storage");
                        klevu.each(e.request.current.recordQueries, function (e, t) {
                            var a = r.sort.getElement(t.id) != t.id && r.sort.getElement(t.id);
                            a && (t.settings.sort = a);
                        });
                    },
                });
            e = klevu.getSetting(klevu.search.landing.getScope().settings, "settings.storage");
            e.sort.setStorage("local"),
                e.sort.mergeFromGlobal(),
                klevu.search.landing.getScope().template.setHelper("getSortBy", function (e) {
                    var t = klevu.getSetting(klevu.settings, "settings.storage"),
                        a = "";
                    switch (t.sort.getElement(e) == e ? "RELEVANCE" : t.sort.getElement(e)) {
                        case "RELEVANCE":
                            a = "Relevance";
                            break;
                        case "PRICE_ASC":
                            a = "Price: Low to high";
                            break;
                        case "PRICE_DESC":
                            a = "Price: High to low";
                            break;
                        default:
                            a = "Relevance";
                    }
                    return a;
                }),
                klevu.search.landing.getScope().chains.template.events.add({
                    name: "SortBySort",
                    fire: function (e, t) {
                        t = klevu.getSetting(t.kScope.settings, "settings.search.searchBoxTarget");
                        klevu.each(klevu.dom.find(".kuDropdown .kuSort", t), function (e, t) {
                            klevu.event.attach(t, "click", function (e) {
                                (e = e || window.event).preventDefault();
                                var t = klevu.dom.helpers.getClosest(this, ".klevuMeta"),
                                    a = klevu.dom.helpers.getClosest(this, ".klevuTarget"),
                                    r = klevu.getSetting(a.kScope.settings, "settings.storage");
                                r.sort.addElement(t.dataset.section, this.dataset.value), r.sort.mergeToGlobal();
                                a = a.kElem;
                                (a.kScope.data = a.kObject.resetData(a.kElem)),
                                    (a.kScope.data.context.keyCode = 0),
                                    (a.kScope.data.context.eventObject = e),
                                    (a.kScope.data.context.event = "keyUp"),
                                    (a.kScope.data.context.preventDefault = !1),
                                    klevu.setObjectPath(a.kScope.data, "localOverrides.query." + t.dataset.section + ".settings.offset", 0),
                                    klevu.event.fireChain(a.kScope, "chains.events.keyUp", a, a.kScope.data, e);
                            });
                        });
                    },
                });
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "search-landing-limit",
        fire: function () {
            var e;
            !0 !== klevu.getGlobalSetting("theme.modules.resultInfiniteScroll.searchResultsPage.enable", !1) &&
                ((e = { storage: { limits: klevu.dictionary("limits") } }),
                    klevu(e),
                    klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplateLimit"), "limit", !0),
                    klevu.search.landing.getScope().chains.request.build.add({
                        name: "setLimits",
                        fire: function (e, t) {
                            var r = klevu.getSetting(t.kScope.settings, "settings.storage");
                            klevu.each(e.request.current.recordQueries, function (e, t) {
                                var a = r.limits.getElement(t.id) != t.id && r.limits.getElement(t.id);
                                a ? (t.settings.limit = a) : ((t.settings.limit = 12), r.limits.addElement(t.id, 12), r.limits.mergeToGlobal());
                            });
                        },
                    }),
                    (e = klevu.getSetting(klevu.search.landing.getScope().settings, "settings.storage")).limits.setStorage("local"),
                    e.limits.mergeFromGlobal(),
                    klevu.search.landing.getScope().template.setHelper("getLimit", function (e) {
                        var t = klevu.getSetting(klevu.settings, "settings.storage");
                        return t.limits.getElement(e) == e ? 12 : t.limits.getElement(e);
                    }),
                    klevu.search.landing.getScope().chains.template.events.add({
                        name: "SortByLimit",
                        fire: function (e, t) {
                            t = klevu.getSetting(t.kScope.settings, "settings.search.searchBoxTarget");
                            klevu.each(klevu.dom.find(".kuDropdown .kuLimit", t), function (e, t) {
                                klevu.event.attach(t, "click", function (e) {
                                    (e = e || window.event).preventDefault();
                                    var t = klevu.dom.helpers.getClosest(this, ".klevuMeta"),
                                        a = klevu.dom.helpers.getClosest(this, ".klevuTarget"),
                                        r = klevu.getSetting(a.kScope.settings, "settings.storage");
                                    r.limits.addElement(t.dataset.section, this.dataset.value), r.limits.mergeToGlobal();
                                    a = a.kElem;
                                    (a.kScope.data = a.kObject.resetData(a.kElem)),
                                        (a.kScope.data.context.keyCode = 0),
                                        (a.kScope.data.context.eventObject = e),
                                        (a.kScope.data.context.event = "keyUp"),
                                        (a.kScope.data.context.preventDefault = !1),
                                        klevu.setObjectPath(a.kScope.data, "localOverrides.query." + t.dataset.section + ".settings.offset", 0),
                                        klevu.event.fireChain(a.kScope, "chains.events.keyUp", a, a.kScope.data, e);
                                });
                            });
                        },
                    }));
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "search-tabs",
        fire: function () {
            var e = { storage: { tabs: klevu.dictionary("tabs") } };
            klevu(e);
            e = klevu.getSetting(klevu.search.landing.getScope().settings, "settings.storage");
            e.tabs.setStorage("local"),
                e.tabs.mergeFromGlobal(),
                klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplateTabResults"), "tab-results", !0),
                klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplateContentBlock"), "contentBlock", !0);
            e = klevu.search.modules.kmcInputs.base.getCmsEnabledValue();
            (klevu.search.landing.getScope().tabResultsList = e ? ["productList", "contentList"] : ["productList"]),
                klevu.search.landing.getScope().chains.request.control.addBefore("initRequest", {
                    name: "setStoredActiveQueryId",
                    fire: function (e, t) {
                        var a = klevu.getSetting(klevu.search.landing.getScope().settings, "settings.storage");
                        a.tabs.setStorage("local"), a.tabs.mergeFromGlobal();
                        a = a.tabs.getElement("active");
                        a && "active" !== a && (e.context.activeQueryId = a);
                    },
                }),
                klevu.search.landing.getScope().chains.template.process.success.add({
                    name: "processTabs",
                    fire: function (r, e) {
                        var n;
                        klevu.search.landing.getScope().tabResultsList &&
                            klevu.search.landing.getScope().tabResultsList.length &&
                            ((n = []),
                                klevu.each(klevu.search.landing.getScope().tabResultsList, function (e, t) {
                                    var a = klevu.getObjectPath(r.template.query, t);
                                    klevu.isUndefined(a) || ((a.id = t), (a.tab = !0), (a.tabText = "<b>%s</b> " + t), (a.sort = e + 1), n.push(a));
                                }),
                                klevu.search.modules.kmcInputs.base.getCmsEnabledValue() &&
                                n.length &&
                                (n.sort(function (e, t) {
                                    return t.sort - e.sort;
                                }),
                                    n.forEach(function (e) {
                                        r.template.query = klevu.dom.helpers.moveObjectElement(e.id, "", r.template.query);
                                    })));
                    },
                }),
                klevu.search.landing.getScope().template.setHelper("hasResults", function (e, t) {
                    return !!(e.query[t] && 0 < e.query[t].result.length);
                }),
                klevu.search.landing.getScope().chains.template.events.add({
                    name: "tabContent",
                    fire: function (n, s) {
                        var e = klevu.getSetting(klevu.settings, "settings.storage"),
                            t = klevu.getSetting(s.kScope.settings, "settings.search.searchBoxTarget");
                        klevu.dom.helpers.initializeTabSelection(n, s, t, e.tabs),
                            klevu.each(klevu.dom.find(".kuTab", t), function (e, r) {
                                klevu.event.attach(r, "click", function (e) {
                                    var t,
                                        a = klevu.dom.helpers.getClosest(this, ".klevuWrap");
                                    null !== a &&
                                        (klevu.each(klevu.dom.find(".kuTab.kuTabSelected", a), function (e, t) {
                                            t.classList.remove("kuTabSelected"), a.classList.remove(t.dataset.section + "Active");
                                        }),
                                            (n.context.activeQueryId = r.dataset.section),
                                            this.classList.add("kuTabSelected"),
                                            a.classList.add(this.dataset.section + "Active"),
                                            (t = klevu.dom.helpers.getClosest(this, ".klevuTarget")),
                                            (t = klevu.getSetting(t.kScope.settings, "settings.storage")).tabs.addElement("active", this.dataset.section),
                                            t.tabs.mergeToGlobal(),
                                            klevu.search.modules.filterPriceSlider && klevu.search.modules.filterPriceSlider.base.initSlider(n, s.kScope));
                                });
                            });
                    },
                }),
                !0 === klevu.getObjectPath(klevu.search.modules, "addFiltersToURL.build") &&
                (klevu.each(klevu.search.landing.getScope().tabResultsList, function (e, t) {
                    var a = klevu.dom.helpers.getQueryStringValue(t + "Filters");
                    a && a.length && ((a = klevu.getSetting(klevu.search.landing.getScope().settings, "settings.storage")).tabs.setStorage("local"), a.tabs.mergeFromGlobal(), a.tabs.addElement("active", t), a.tabs.mergeToGlobal());
                }),
                    klevu.search.landing.getScope().chains.template.events.add({
                        name: "updateContentForFilterURLUpdate",
                        fire: function (r, n) {
                            var e = klevu.getSetting(n.kScope.settings, "settings.search.searchBoxTarget");
                            klevu.each(klevu.dom.find(".kuTab", e), function (e, t) {
                                klevu.event.attach(t, "click", function (e) {
                                    klevu.each(klevu.search.landing.getScope().tabResultsList, function (e, t) {
                                        var a;
                                        t !== r.context.activeQueryId
                                            ? ((a = window.location.search),
                                                (a = (a = klevu.dom.helpers.updateQueryStringParameter(a, t + "Filters", "")).replace("&" + t + "Filters=", "")),
                                                void 0 !== window.history && void 0 !== window.history.replaceState
                                                    ? window.history.replaceState({}, "", a)
                                                    : console.log("This browser does not have the support of window.history or window.history.replaceState"))
                                            : klevu.search.modules.addFiltersToURL.base.setFilters(r, n);
                                    });
                                });
                            });
                        },
                    })),
                !0 === klevu.getObjectPath(klevu.search.modules, "addPaginationToURL.build") &&
                (klevu.each(klevu.search.landing.getScope().tabResultsList, function (e, t) {
                    var a = klevu.dom.helpers.getQueryStringValue(t + "PgNo");
                    a && 0 < a && ((a = klevu.getSetting(klevu.search.landing.getScope().settings, "settings.storage")).tabs.setStorage("local"), a.tabs.mergeFromGlobal(), a.tabs.addElement("active", t), a.tabs.mergeToGlobal());
                }),
                    klevu.search.landing.getScope().chains.template.events.add({
                        name: "updateContentForPaginationURLUpdate",
                        fire: function (r, n) {
                            var e = klevu.getSetting(n.kScope.settings, "settings.search.searchBoxTarget");
                            klevu.each(klevu.dom.find(".kuTab", e), function (e, t) {
                                klevu.event.attach(t, "click", function (e) {
                                    klevu.each(klevu.search.landing.getScope().tabResultsList, function (e, t) {
                                        var a;
                                        t !== r.context.activeQueryId
                                            ? ((a = window.location.search),
                                                (a = (a = klevu.dom.helpers.updateQueryStringParameter(a, t + "PgNo", "")).replace("&" + t + "PgNo=", "")),
                                                void 0 !== window.history && void 0 !== window.history.replaceState
                                                    ? window.history.replaceState({}, "", a)
                                                    : console.log("This browser does not have the support of window.history or window.history.replaceState"))
                                            : klevu.search.modules.addPaginationToURL.base.setPagination(r, n);
                                    });
                                });
                            });
                        },
                    }));
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "attachContentListRequest",
        fire: function () {
            klevu.search.modules.kmcInputs.base.getCmsEnabledValue() &&
                (klevu.search.landing.getScope().template.setTemplate("", "klevuLandingTemplateResultsHeadingTitle", !0),
                    klevu.search.landing.getScope().chains.request.build.add({
                        name: "addContentList",
                        fire: function (e, t) {
                            (t = klevu.getSetting(t.kScope.settings, "settings.search.map", !1)), (t = klevu.extend(!0, {}, t.recordQuery));
                            (t.id = "contentList"),
                                (t.typeOfRequest = "SEARCH"),
                                (t.settings.query.term = e.context.term),
                                (t.settings.typeOfRecords = ["KLEVU_CMS"]),
                                (t.settings.searchPrefs = ["searchCompoundsAsAndQuery"]),
                                (t.settings.limit = 12),
                                (t.filters.filtersToReturn.enabled = !0),
                                e.request.current.recordQueries.push(t),
                                (e.context.doSearch = !0);
                        },
                    }));
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "addSearchResultProductBadges",
        fire: function () {
            klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#searchResultProductBadge"), "landingProductBadge", !0);
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "promotionalBannerInit",
        fire: function () {
            klevu.search.modules.promotionBanner.base.init([]),
                klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingPromotionBanner"), "klevuLandingPromotionBanner", !0),
                klevu.search.landing.getScope().chains.template.process.success.add({
                    name: "validateResultSetForPromotionalBanner",
                    fire: function (e, t) {
                        var a = !1,
                            r = klevu.getObjectPath(e, "template.query.productList.result");
                        (r && r.length) || (klevu.search.modules.kmcInputs.base.getCmsEnabledValue() && (n = klevu.getObjectPath(e, "template.query.cmsCompressed.result")) && n.length) || (a = !0);
                        var n = klevu.getObjectPath(e, "template.settings.term");
                        (n && n.length) || (a = !0), klevu.setObjectPath(e, "template.modules.promotionalBanner.hasNoResultFound", a);
                    },
                }),
                klevu.search.landing.getScope().chains.template.events.add({
                    name: "attachBannerClickEvent",
                    fire: function (e, t) {
                        klevu.analyticsUtil.base.registerBannerClickEvent(t.kScope, klevu.analyticsUtil.base.storage.dictionary, klevu.analyticsUtil.base.storage.bannerClick);
                    },
                });
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "updatePromotionalBannerData",
        fire: function () {
            klevu.search.landing.getScope().chains.template.process.success.add({
                name: "appendLandingBanners",
                fire: function (r) {
                    var t,
                        n,
                        s,
                        e = klevu.search.modules.promotionBanner.base.getLandingPageBanners();
                    e &&
                        e.length &&
                        ((r.template.banners = { top: [], bottom: [] }),
                            (n = !(t = "")),
                            (s = "top"),
                            klevu.each(e, function (e, a) {
                                a.hasOwnProperty("showForTerms") &&
                                    (null == a.showForTerms
                                        ? ((s = a.position), (t = a))
                                        : klevu.isEmptyObject(a.showForTerms) ||
                                        klevu.each(a.showForTerms, function (e, t) {
                                            r.context.term == t && ((t = a.position || "top"), r.template.banners[t].push(a), (n = !1));
                                        }));
                            }),
                            n && t && r.template.banners[s].push(t));
                },
            });
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "updateMagentoSearchResultProductImagePath",
        fire: function () {
            klevu.search.landing.getScope().chains.template.process.success.add({
                name: "updateProductImagePath",
                fire: function (e, t) {
                    var a = klevu.search.modules.productDataModification;
                    a && a.base.updateImagePath(t.kScope);
                },
            });
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "collapseFilters",
        fire: function () {
            var e = klevu.getGlobalSetting("search.apiKey", klevu.getGlobalSetting("global.apiKey")),
                t = e && e.length ? "filterShowMore_" + e : "filterShowMore",
                e = e && e.length ? "filterCollapse_" + e : "filterCollapse",
                e = { storage: { filterShowMore: klevu.dictionary(t), filterCollapse: klevu.dictionary(e) } };
            klevu(e);
            e = klevu.getSetting(klevu.search.landing.getScope().settings, "settings.storage");
            e.filterShowMore.setStorage("session"),
                e.filterShowMore.mergeFromGlobal(),
                e.filterShowMore.addElement("keys", ""),
                e.filterShowMore.mergeToGlobal(),
                e.filterCollapse.setStorage("session"),
                e.filterCollapse.mergeFromGlobal(),
                e.filterCollapse.addElement("keys", ""),
                e.filterCollapse.mergeToGlobal(),
                klevu.search.landing.getScope().chains.template.events.add({
                    name: "enableFilterCollapse",
                    fire: function (e, t) {
                        klevu.search.modules.collapseFilters.base.initialize(t.kScope);
                    },
                }),
                klevu.search.landing.getScope().chains.template.render.addBefore("renderResponse", {
                    name: "collapseFilterPosition",
                    fire: function (e, t) {
                        e.context.isSuccess && klevu.search.modules.collapseFilters.base.collapse(e, [], "productList");
                    },
                });
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "addNoResultsFoundEvents",
        fire: function () {
            klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplateNoResultFound"), "noResultsFoundLanding", !0),
                klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingNoResultsFoundBanners"), "landingNoResultsFoundBanners", !0),
                klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#kuNoResultsPopularSearchesLanding"), "noResultsLandingPopularSearches", !0),
                klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuNoResultsPopularProductsLanding"), "noResultsLandingPopularProductsTemplate", !0),
                klevu.search.landing.getScope().chains.request.build.add({
                    name: "addPopularProductsRequest",
                    fire: function (e, t) {
                        klevu.search.modules.noResultsFound.base.buildPopularProductsReq(e, t, 4);
                    },
                }),
                klevu.search.landing.getScope().chains.template.process.success.add({
                    name: "addNoResultsFoundData",
                    fire: function (e, t) {
                        (e.template.noResultsFoundMsg = klevu.search.modules.noResultsFound.base.getMessage(e.context.term, t)),
                            (e.template.landingNoResultsFoundBanners = klevu.search.modules.noResultsFound.base.getLandingBanners(e.context.term)),
                            (e.template.landingNoResultsPopularHeading = klevu.search.modules.noResultsFound.base.popularProductsHeading());
                        var a = klevu.search.modules.noResultsFound.base.isPopularSearchesKeywordsEnabled(),
                            t = klevu.search.modules.kmcInputs.base.getWebstorePopularTermsValue();
                        a && void 0 !== t && t && (e.template.noResultsFoundPopularSearches = t);
                    },
                });
        },
    }),
    (function (c) {
        c.extend(!0, c.search.modules, {
            filterTags: {
                base: {
                    init: function (e) {
                        var a = e.data.template;
                        a.query &&
                            ((a.filterTags.query = {}),
                                c.each(a.query, function (e, t) {
                                    var n = { tags: [] };
                                    t.filters &&
                                        c.each(t.filters, function (e, t) {
                                            var a = { key: t.key, label: t.label, values: [] },
                                                r = !1;
                                            t.options &&
                                                c.each(t.options, function (e, t) {
                                                    t.selected && ((r = !0), a.values.push(t.name));
                                                }),
                                                "SLIDER" == t.type &&
                                                null !== t.start &&
                                                null !== t.end &&
                                                ((Number(t.start) === Number(t.min) && Number(t.end) === Number(t.max)) || (a.values.push(t.start + " - " + t.end), (a.key = "price"), (a.label = "price"), (r = !0))),
                                                r && n.tags.push(a);
                                        }),
                                        (a.filterTags.query[e] = n);
                                }));
                    },
                    attachEvents: function (l) {
                        c.each(c.dom.find(".kuFilterTagClearAll"), function (e, t) {
                            c.event.attach(t, "click", function (e) {
                                var t,
                                    a = c.dom.helpers.getClosest(this, ".klevuTarget");
                                null === a ||
                                    (null !== (t = c.dom.helpers.getClosest(this, ".klevuMeta")) &&
                                        (((a = a.kElem).kScope.data = a.kObject.resetData(a.kElem)),
                                            (a.kScope.data.context.keyCode = 0),
                                            (a.kScope.data.context.eventObject = e),
                                            (a.kScope.data.context.event = "keyUp"),
                                            (a.kScope.data.context.preventDefault = !1),
                                            c.setObjectPath(a.kScope.data, "localOverrides.query." + t.dataset.section + ".settings.offset", 0),
                                            c.setObjectPath(a.kScope.data, "localOverrides.query." + t.dataset.section + ".filters.applyFilters", {}),
                                            c.event.fireChain(a.kScope, "chains.events.keyUp", a, a.kScope.data, e)));
                            });
                        }),
                            c.each(c.dom.find(".kuFilterTagValue"), function (e, i) {
                                c.event.attach(i, "click", function (e) {
                                    var t = c.dom.helpers.getClosest(i, ".kuFilterTag"),
                                        r = t && t.dataset.key ? t.dataset.key : void 0;
                                    if (r) {
                                        if ("price" == r) {
                                            if (null === (o = c.dom.helpers.getClosest(this, ".klevuTarget"))) return;
                                            var a = c.dom.helpers.getClosest(this, ".klevuMeta");
                                            if (null === a) return;
                                            var n = o.kElem;
                                            (n.kScope.data = n.kObject.resetData(n.kElem)),
                                                (n.kScope.data.context.keyCode = 0),
                                                (n.kScope.data.context.eventObject = e),
                                                (n.kScope.data.context.event = "keyUp"),
                                                (n.kScope.data.context.preventDefault = !1);
                                            var s = Array.from(c.search.landing.getScope().data.localOverrides.query.productList.filters.applyFilters.filters),
                                                t = s
                                                    .map(function (e) {
                                                        return e.key;
                                                    })
                                                    .indexOf("klevu_price");
                                            s.splice(t, 1),
                                                c.setObjectPath(n.kScope.data, "localOverrides.query." + a.dataset.section + ".settings.offset", 0),
                                                c.setObjectPath(n.kScope.data, "localOverrides.query." + a.dataset.section + ".filters.applyFilters.filters", s),
                                                c.event.fireChain(n.kScope, "chains.events.keyUp", n, n.kScope.data, e);
                                        }
                                        var o = c.getSetting(l.settings, "settings.search.searchBoxTarget");
                                        c.each(c.dom.find(".kuFilterBox", o), function (e, t) {
                                            var a = t.dataset && t.dataset.filter ? t.dataset.filter : void 0;
                                            r == a &&
                                                c.each(c.dom.find(".klevuFilterOption", t), function (e, t) {
                                                    var a = t.dataset && t.dataset.value ? t.dataset.value : void 0,
                                                        r = i.dataset && i.dataset.value ? i.dataset.value : void 0;
                                                    a && a == r && t.click();
                                                });
                                        });
                                    }
                                });
                            });
                    },
                },
                build: !0,
            },
        });
    })(klevu),
    klevu.coreEvent.build({
        name: "filterTagsModuleBuild",
        fire: function () {
            return !!(klevu.search.modules && klevu.search.modules.filterTags && klevu.search.modules.filterTags.build);
        },
        maxCount: 500,
        delay: 30,
    }),
    klevu.extend(!0, klevu.search.modules, {
        locale: {
            globalTranslations: {
                en: { "Clear all": "Clear all" },
                ar: { "Clear all": "Ø§Ù…Ø³Ø­ Ø§Ù„ÙƒÙ„" },
                bg: { "Clear all": "Ð˜Ð·Ñ‡Ð¸ÑÑ‚Ð¸ Ð²ÑÐ¸Ñ‡ÐºÐ¾" },
                da: { "Clear all": "Slet alt" },
                de: { "Clear all": "Alles lÃ¶schen" },
                el: { "Clear all": "Î¤Î± ÎºÎ±Î¸Î±ÏÎ¯Î¶Ï‰ ÏŒÎ»Î±" },
                es: { "Clear all": "Limpiar todo" },
                et: { "Clear all": "Kustuta kÃµik" },
                fa: { "Clear all": "Ù‡Ù…Ù‡ Ø±Ø§ Ù¾Ø§Ú© Ú©Ù†" },
                fi: { "Clear all": "TyhjennÃ¤" },
                fr: { "Clear all": "Tout effacer" },
                he: { "Clear all": "×”Ö·×¨×’Ö¸×¢Ö¸×”" },
                hr: { "Clear all": "OÄistiti sve" },
                hu: { "Clear all": "Mindent kitÃ¶rÃ¶l" },
                is: { "Clear all": "Hreinsa allt" },
                it: { "Clear all": "Cancella tutto" },
                ja: { "Clear all": "ã™ã¹ã¦ã‚¯ãƒªã‚¢" },
                ko: { "Clear all": "ëª¨ë‘ ì§€ìš°ê¸°" },
                lv: { "Clear all": "NodzÄ“st visu" },
                nb: { "Clear all": "Slett alt" },
                nl: { "Clear all": "Wis alles" },
                no: { "Clear all": "Slett alt" },
                pl: { "Clear all": "WyczyÅ›Ä‡ wszystko" },
                pt: { "Clear all": "Limpar tudo" },
                ro: { "Clear all": "Curata tot" },
                ru: { "Clear all": "ÐžÑ‡Ð¸ÑÑ‚Ð¸Ñ‚ÑŒ Ð²ÑÐµ" },
                sk: { "Clear all": "ZmazaÅ¥ vÅ¡etko" },
                sl: { "Clear all": "PoÄisti vse" },
                sr: { "Clear all": "Ð˜Ð·Ð±Ñ€Ð¸ÑˆÐ¸ ÑÐ²Ðµ" },
                sv: { "Clear all": "Rensa alla" },
                tr: { "Clear all": "Hepsini temizle" },
                vi: { "Clear all": "LÃ m sáº¡ch táº¥t cáº£" },
                zh: { "Clear all": "æ¸…é™¤æ‰€æœ‰" },
            },
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "renderFilterTags",
        fire: function () {
            klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#kuFilterTagsTemplate"), "kuFilterTagsTemplate", !0),
                klevu.setObjectPath(klevu.search.landing.getScope().data, "template.filterTags", {}),
                klevu.search.landing.getScope().chains.template.process.success.add({
                    name: "prepareDataForFilterTags",
                    fire: function (e, t) {
                        klevu.search.modules.filterTags.base.init(t.kScope);
                    },
                }),
                klevu.search.landing.getScope().chains.template.events.add({
                    name: "attachFilterTagEvents",
                    fire: function (e, t) {
                        klevu.search.modules.filterTags.base.attachEvents(t.kScope);
                    },
                });
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "kuModuleResultViewSwitch",
        fire: function () {
            klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#kuTemplateLandingResultsViewSwitch"), "kuTemplateLandingResultsViewSwitch", !0);
            var e = klevu.getGlobalSetting("search.apiKey", klevu.getGlobalSetting("global.apiKey")) ? "view_" + klevu.getGlobalSetting("search.apiKey", klevu.getGlobalSetting("global.apiKey")) : "view_",
                e = { storage: { view: klevu.dictionary(e) } };
            klevu(e),
                klevu.search.landing.getScope().chains.template.events.add({
                    name: "attachViewSwitchEvents",
                    fire: function (e, o) {
                        var t = klevu.getSetting(o.kScope.settings, "settings.search.searchBoxTarget");
                        klevu.each(klevu.dom.find(".kuViewSwitch", t), function (e, s) {
                            setTimeout(function () {
                                var r,
                                    n = klevu.dom.helpers.getClosest(s, ".klevuMeta");
                                n &&
                                    ((r = !1),
                                        klevu.each(klevu.dom.find(".kuViewSwitch", n), function (e, t) {
                                            var a = klevu.getSetting(o.kScope.settings, "settings.storage");
                                            a.view.setStorage("local"), a.view.mergeFromGlobal();
                                            a = a.view.getElement(n.dataset.section);
                                            (n.dataset.resultView = a) == t.dataset.value && (t.classList.add("kuCurrent"), (r = !0));
                                        }),
                                        r ||
                                        klevu.each(klevu.dom.find(".kuViewSwitch", n), function (e, t) {
                                            "grid" == t.dataset.value && t.classList.add("kuCurrent");
                                        }));
                            }, 10),
                                klevu.event.attach(s, "click", function (e) {
                                    (e = e || window.event).preventDefault();
                                    var t = klevu.dom.helpers.getClosest(s, ".klevuMeta");
                                    t &&
                                        klevu.each(klevu.dom.find(".kuViewSwitch", t), function (e, t) {
                                            t.classList.remove("kuCurrent");
                                        });
                                    var a = klevu.getSetting(klevu.search.landing.getScope().settings, "settings.storage");
                                    s.classList.add("kuCurrent");
                                    var r = s.dataset && s.dataset.value ? s.dataset.value : "value",
                                        e = "";
                                    t && ((t.dataset.resultView = r), (e = t.dataset.section)), a.view.setStorage("local"), a.view.mergeFromGlobal(), a.view.addElement(e, r), a.view.mergeToGlobal();
                                });
                        });
                    },
                });
        },
    }),
    (function (n) {
        n.extend(!0, n.searchEvents, {
            bindLatestQuickSearchBox: {
                name: "interactive-results-search-boxes-activate",
                fire: function () {
                    n.search.active = null;
                    var e = n.getSetting(n.settings, "settings.search.searchBoxSelector", n.randomId()),
                        e = n.dom.find(e);
                    n.each(e, function (e, t) {
                        if ("text" === t.type || "search" === t.type || "input" === t.type) {
                            if (!n.isUndefined(t.kObject)) return !0;
                            var a = void 0 !== n.search.resultsQuick && n.search.extraSearchBox[n.search.resultsQuick] ? n.search.extraSearchBox[n.search.resultsQuick] : n.searchObjectClone(n.search.extra);
                            ((a.getScope().element = t).kObject = a), (t.kScope = t.kObject.getScope()), (t.kElem = t.kObject.getScope().element);
                            var r = n.getSetting(n.settings, "settings.search.searchBoxTarget", !1);
                            r || (n.dom.helpers.addElementToParent(null, "div", { id: t.kScope.id, class: "klevu-fluid" }), n.setSetting(t.kScope.settings, "settings.search.searchBoxTarget", document.getElementById(t.kScope.id))),
                                ((r = n.getSetting(t.kScope.settings, "settings.search.searchBoxTarget", !1)).kObject = t.kObject),
                                (r.kScope = t.kScope),
                                (r.kElem = t.kElem),
                                r.classList.add("klevuTarget"),
                                n.event.attach(a.getScope().element, "focus", n.searchEvents.box.focus, !0),
                                n.event.attach(a.getScope().element, "keyup", n.searchEvents.box.keyUp, !0),
                                n.event.attach(
                                    a.getScope().element,
                                    "paste",
                                    function (e) {
                                        setTimeout(function () {
                                            n.searchEvents.box.keyUp.call(e.target, e);
                                        }, 10);
                                    },
                                    !0
                                ),
                                t.form &&
                                ((t.form.kObject = a), (t.form.kScope = t.form.kObject.getScope()), (t.form.kElem = t.form.kObject.getScope().element), n.event.attach(a.getScope().element.form, "submit", n.searchEvents.box.submit, !0)),
                                a.getScope().element.setAttribute("autocomplete", "off");
                            t = n.getSetting(t.kScope.settings, "settings.search.maxChars", 128);
                            return (
                                a.getScope().element.setAttribute("maxlength", t),
                                void 0 !== n.search.resultsQuick ? (n.search.extraSearchBox[n.search.resultsQuick] = a) : (n.search.extraSearchBox.push(a), (n.search.resultsQuick = n.search.extraSearchBox.length - 1)),
                                !0
                            );
                        }
                    });
                },
            },
        }),
            n.extend(!0, n.search.modules, {
                resultsSearchBar: {
                    base: {
                        init: function (e) {
                            var t = n.getSetting(e.settings, "settings.search.searchBoxTarget");
                            t &&
                                n.each(n.dom.find(".kuSearchResultsSearchBarContainer", t), function (e, t) {
                                    t.classList.remove("kuHideExtraSearch");
                                }),
                                n.searchEvents.bindLatestQuickSearchBox.fire();
                            var a,
                                r = "";
                            (r =
                                void 0 !== n.search.resultsQuick && n.search.extraSearchBox[n.search.resultsQuick] && n.getObjectPath(n.search.extraSearchBox[n.search.resultsQuick].getScope().data, "context.term")
                                    ? n.getObjectPath(n.search.extraSearchBox[n.search.resultsQuick].getScope().data, "context.term")
                                    : n.getObjectPath(e.data, "context.term")) &&
                                r.length &&
                                "*" != r &&
                                n.search.extraSearchBox[n.search.resultsQuick] &&
                                (n.search.extraSearchBox[n.search.resultsQuick].getScope().element.value = r),
                                n.search.extraSearchBox[n.search.resultsQuick] &&
                                ((a = n.dom.helpers.getClosest(n.search.quick.getScope().element, "form")) &&
                                    ((e = a.getAttribute("action")),
                                        (r = a.getAttribute("name")),
                                        (a = n.dom.helpers.getClosest(n.search.extraSearchBox[n.search.resultsQuick].getScope().element, "form")) &&
                                        e &&
                                        e.length &&
                                        (e && e.length && a.setAttribute("action", e), r && r.length && a.setAttribute("name", r))),
                                    n.search.extraSearchBox[n.search.resultsQuick].getScope().chains.template.events.add({
                                        name: "positionTemplate",
                                        fire: function (e, t) {
                                            var a = n.getSetting(t.kScope.settings, "settings.search.searchBoxTarget"),
                                                r = document.body.getBoundingClientRect(),
                                                t = t.kScope.element.getBoundingClientRect(),
                                                r = t.top - r.top;
                                            n.dom.find(".klevuWrap", a)[0].style = "top:" + (0 < r + t.height ? r + t.height : 0) + "px;left: " + (t.left || 0) + "px;right: auto;";
                                        },
                                    }),
                                    (t = n.getSetting(n.search.extraSearchBox[n.search.resultsQuick].getScope().settings, "settings.search.searchBoxTarget")) &&
                                    ("basic" === n.search.modules.kmcInputs.base.getQuickSearchLayoutType().toLowerCase() ? t.classList.add("kuQuickSearchFacetedLayout") : t.classList.add("kuQuickSearchAutoCompleteLayout")));
                        },
                    },
                    initialized: !1,
                    build: !0,
                },
            });
    })(klevu),
    klevu.extend(!0, klevu.search.modules, {
        locale: {
            globalTranslations: {
                en: { "Search text": "Search text" },
                ar: { "Search text": "Ù†Øµ Ø§Ù„Ø¨Ø­Ø«" },
                bg: { "Search text": "Ð¢ÑŠÑ€ÑÐ¸ Ñ‚ÐµÐºÑÑ‚" },
                da: { "Search text": "SÃ¸g tekst" },
                de: { "Search text": "Suchtext" },
                el: { "Search text": "Î‘Î½Î±Î¶Î®Ï„Î·ÏƒÎ· ÎºÎµÎ¹Î¼Î­Î½Î¿Ï…" },
                es: { "Search text": "Buscar texto" },
                et: { "Search text": "Otsi teksti" },
                fa: { "Search text": "Ù…ØªÙ† Ø¬Ø³ØªØ¬Ùˆ" },
                fi: { "Search text": "hakuteksti" },
                fr: { "Search text": "texte de recherche" },
                he: { "Search text": "×˜×§×¡×˜ ×œ×—×™×¤×•×©" },
                hr: { "Search text": "TraÅ¾i tekst" },
                hu: { "Search text": "A keresett szÃ¶veg" },
                is: { "Search text": "leitartexta" },
                it: { "Search text": "Ricerca di testo" },
                ja: { "Search text": "æ¤œç´¢ãƒ†ã‚­ã‚¹ãƒˆ" },
                ko: { "Search text": "ê²€ìƒ‰ í…ìŠ¤íŠ¸" },
                lv: { "Search text": "MeklÄ“jamais teksts" },
                nb: { "Search text": "sÃ¸ketekst" },
                nl: { "Search text": "Zoek tekst" },
                no: { "Search text": "sÃ¸ketekst" },
                pl: { "Search text": "Szukaj tekstu" },
                pt: { "Search text": "pesquisa de texto" },
                ro: { "Search text": "CautÄƒ text" },
                ru: { "Search text": "ÐŸÐ¾Ð¸ÑÐº Ñ‚ÐµÐºÑÑ‚Ð°" },
                sk: { "Search text": "fulltextovÃ© vyhÄ¾adÃ¡vanie" },
                sl: { "Search text": "Iskanje besedila" },
                sr: { "Search text": "Ð¢Ñ€Ð°Ð¶Ð¸ Ñ‚ÐµÐºÑÑ‚" },
                sv: { "Search text": "SÃ¶k text" },
                tr: { "Search text": "Arama metni" },
                vi: { "Search text": "TÃ¬m kiáº¿m vÄƒn báº£n" },
                zh: { "Search text": "æœç´¢æ–‡æœ¬" },
            },
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "landingSearchBarModule",
        fire: function () {
            klevu.search.modules.kmcInputs.base.getShowSearchOnLandingPageEnableValue() &&
                (klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplateSearchBar"), "klevuLandingTemplateSearchBar", !0),
                    klevu.search.landing.getScope().chains.template.events.add({
                        name: "triggerExtraSearchEvent",
                        fire: function (e, t) {
                            klevu.getObjectPath(klevu.search.modules, "resultsSearchBar.initialized") && klevu.search.modules.resultsSearchBar.base.init(klevu.search.landing.getScope());
                        },
                    }));
        },
    }),
    klevu.coreEvent.build({
        name: "setRemoteConfigLandingExtraSearchBoxAttachEvent",
        fire: function () {
            var e = klevu.getSetting(klevu, "settings.flags.setRemoteConfigLanding.build", !1),
                t = klevu.getSetting(klevu, "settings.flags.setRemoteConfigLanding.rendered", !1),
                a = klevu.getSetting(klevu, "settings.powerUp.landing", !1);
            if (a && e && t && klevu.search.modules.kmcInputs.base.getShowSearchOnLandingPageEnableValue() && klevu.search.modules.resultsSearchBar && klevu.search.modules.resultsSearchBar.build) {
                t = klevu.getSetting(klevu, "settings.flags.setRemoteConfigQuick.build", !1);
                if (klevu.getSetting(klevu, "settings.powerUp.quick", !1) && t) return !0;
            }
            return !1;
        },
        maxCount: 150,
        delay: 100,
    }),
    klevu.coreEvent.attach("setRemoteConfigLandingExtraSearchBoxAttachEvent", {
        name: "cloneExtraFromQuick",
        fire: function () {
            var a;
            klevu.setObjectPath(klevu.search, "extra", klevu.searchObjectClone(klevu.search.quick)),
                klevu.search.modules.resultsSearchBar.base.init(klevu.search.landing.getScope()),
                (klevu.search.modules.resultsSearchBar.initialized = !0),
                1 != klevu.getGlobalSetting("theme.modules.imageSearch.enable", !1) ||
                klevu.isUndefined(klevu.search.resultsQuick) ||
                ((a = klevu.search.extraSearchBox[klevu.search.resultsQuick]),
                    klevu.isUndefined(a) ||
                    (a.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuQuickImageSearchContent"), "klevuQuickImageSearchContent", !0),
                        klevu.search.modules.imageSearchUpload.base.init(a.getScope().element.kScope),
                        klevu.search.landing.getScope().chains.template.events.add({
                            name: "attachResultPageImageSearch",
                            fire: function (e, t) {
                                klevu.search.modules.imageSearchUpload.base.init(a.getScope().element.kScope);
                            },
                        })));
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "attachRecentViewClickEvents",
        fire: function () {
            var e = klevu.search.modules.kmcInputs.base.getShowRecentlyViewedItemsValue();
            e.showRecentlyViewedItems &&
                ((klevu.search.modules.recentViewedProducts.base.limit = e.showRecentlyViewedItemsLimit),
                    (e = (e = klevu.settings.search.apiKey) && e.length ? "recentViewedProducts_" + e : "recentViewedProducts"),
                    (e = { storage: { recentViewedProducts: klevu.dictionary(e) } }),
                    klevu(e),
                    klevu.search.landing.getScope().chains.template.events.add({
                        name: "attachRecentViewProductClick",
                        fire: function (e, r) {
                            var t;
                            klevu.search.modules.recentViewedProducts &&
                                ((t = klevu.getSetting(r.kScope.settings, "settings.search.searchBoxTarget")),
                                    klevu.each(klevu.dom.find(".kuTrackRecentView", t), function (e, a) {
                                        klevu.event.attach(a, "click", function (e) {
                                            var t = a.dataset.id;
                                            t && klevu.search.modules.recentViewedProducts.base.addProductId(r.kScope, t);
                                        });
                                    }));
                        },
                    }));
        },
    }),
    (function (i) {
        i.extend(!0, i.search.modules, {
            imageRollover: {
                base: {
                    initImageRollover: function (e, t, s, o) {
                        i.each(i.dom.find(e, t), function (e, t) {
                            var a,
                                r = i.dom.find(s, t),
                                n = i.dom.find(o, t)[0];
                            i.event.attach(t, "mouseover", function (e) {
                                r && r[0] && ((a = r[0]), (n.style.display = "none"), (a.style.display = "inline-block"));
                            }),
                                i.event.attach(t, "mouseout", function (e) {
                                    r && r[0] && ((a = r[0]), (n.style.display = "inline-block"), (a.style.display = "none"));
                                });
                        });
                    },
                },
                build: !0,
            },
        });
    })(klevu),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "imageRollover",
        fire: function () {
            klevu.search.modules.kmcInputs.base.getShowRolloverImageValue() &&
                (klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#landingImageRollover"), "landingImageRollover", !0),
                    klevu.search.landing.getScope().chains.template.events.add({
                        name: "initializeLandingImageRollover",
                        fire: function (e, t) {
                            t = klevu.getSetting(t.kScope.settings, "settings.search.searchBoxTarget");
                            klevu.search.modules.imageRollover.base.initImageRollover(".klevuImgWrap", t, ".kuProdImgHover", ".kuProdImg");
                        },
                    }));
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "attachPriceSliderFilter",
        fire: function () {
            (klevu.search.landing.getScope().priceSliderFilterReqQuery = { key: "klevu_price", minMax: !0 }),
                klevu.search.landing.getScope().chains.template.events.add({
                    name: "initSliderFilter",
                    fire: function (e, t) {
                        klevu.search.modules.filterPriceSlider.base.initSlider(e, t.kScope);
                    },
                });
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "addProductIdToCookieLanding",
        fire: function () {
            klevu.search.landing.getScope().chains.template.events.add({
                name: "addClickedProductToCookie",
                fire: function (e, t) {
                    t = klevu.getSetting(t.kScope.settings, "settings.search.searchBoxTarget");
                    klevu.each(klevu.dom.find(".kuTrackRecentView", t), function (e, a) {
                        klevu.event.attach(a, "click", function (e) {
                            var t = klevu.dom.helpers.getClosest(a, ".klevuProduct").dataset.id;
                            t && klevu.dom.helpers.addClickedProductToCookie(t);
                        });
                    });
                },
            });
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "personalizedSearchLanding",
        fire: function () {
            klevu.search.modules.kmcInputs.base.getEnablePersonalisationInSearch() &&
                klevu.search.landing.getScope().chains.request.build.add({
                    name: "updateSearchParamsLanding",
                    fire: function (e, t) {
                        var a,
                            r = klevu.dom.helpers.readCookie(klevu.settings.constants.COOKIE_KLEVU_RCP);
                        if (r && "" !== r.trim()) {
                            for (var n = (a = r.split("#-#")).length, s = 3 * parseInt(n / 3), o = [], i = 0; i < s; i++) {
                                var l = {};
                                (l.id = window.atob(a.shift())), o.push(l);
                            }
                            3 <= s &&
                                klevu.each(e.request.current.recordQueries, function (e, t) {
                                    "productList" == t.id &&
                                        ((t.settings.personalisation.enablePersonalisation = !0),
                                            (t.settings.personalisation.fields = []),
                                            (t.settings.query.context.recentObjects = [{}]),
                                            (t.settings.query.context.recentObjects[0].typeOfRecord = "KLEVU_PRODUCT"),
                                            (t.settings.query.context.recentObjects[0].records = o)),
                                        "productListFallback" == t.id &&
                                        ((t.settings.personalisation.enablePersonalisation = !0),
                                            (t.settings.personalisation.fields = []),
                                            (t.settings.query.context.recentObjects = [{}]),
                                            (t.settings.query.context.recentObjects[0].typeOfRecord = "KLEVU_PRODUCT"),
                                            (t.settings.query.context.recentObjects[0].records = o));
                                });
                        }
                    },
                });
        },
    }),
    klevu.setSetting(klevu, "settings.theme.modules.resultInfiniteScroll.searchResultsPage.enable", klevu.getGlobalSetting("theme.modules.resultInfiniteScroll.searchResultsPage.enable", !1)),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "attachLandingInfiniteScroll",
        fire: function () {
            !1 !== klevu.getGlobalSetting("theme.modules.resultInfiniteScroll.searchResultsPage.enable", !1) &&
                (klevu.search.landing.getScope().chains.events.keyUp.remove({ name: "scrollToTop" }),
                    klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplateInfiniteScrollDown"), "klevuLandingTemplateInfiniteScrollDown", !0),
                    klevu.search.landing.getScope().chains.response.success.addAfter("addResponseDataQuery", {
                        name: "appendExistingResponseForInfiniteScroll",
                        fire: function (a, r) {
                            var e;
                            r.kScope.data.context.triggeredFromInfiniteScroll
                                ? (e = klevu.getObjectPath(a, "response.current.queryResults")) &&
                                e.length &&
                                klevu.each(e, function (e, t) {
                                    t.id === r.kScope.data.context.infiniteScrollSection && (t.records = a.context.existingResponse.concat(t.records));
                                })
                                : (a.context.existingResponse = []);
                        },
                    }),
                    klevu.search.landing.getScope().chains.template.events.add({
                        name: "hideLoadMoreButton",
                        fire: function (e, t) {
                            var s = klevu.getSetting(t.kScope.settings, "settings.search.searchBoxTarget"),
                                e = klevu.getObjectPath(e, "response.current.queryResults");
                            e &&
                                e.length &&
                                klevu.each(e, function (e, t) {
                                    var a = t.meta,
                                        r = Number(a.noOfResults),
                                        n = Number(a.offset);
                                    Number(a.totalResultsFound) <= r + n && (t = klevu.dom.find("." + t.id + " .kuLoadMoreBtn", s)).length && t[0].classList.add("hide");
                                });
                        },
                    }),
                    klevu.search.landing.getScope().chains.template.events.add({
                        name: "attachLoadMore",
                        fire: function (a, e) {
                            setTimeout(function () {
                                e.kScope.data.context.triggeredFromInfiniteScroll = !1;
                            }, 100),
                                klevu.setObjectPath(klevu.search.landing.getScope().data, "context.windowScrollTriggeredForInfiniteScroll", !1);
                            var t = klevu.getSetting(e.kScope.settings, "settings.search.searchBoxTarget");
                            klevu.each(klevu.dom.find(".kuLoadMoreBtn", t), function (e, t) {
                                klevu.event.attach(t, "click", function (e) {
                                    klevu.search.modules.infiniteScroll.base.sendLoadMoreItemsRequest(e, a);
                                });
                            });
                        },
                    }));
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "attachInfiniteScrollOnWindow",
        fire: function () {
            !1 !== klevu.getGlobalSetting("theme.modules.resultInfiniteScroll.searchResultsPage.enable", !1) &&
                (klevu.search.landing.getScope().chains.template.events.add({
                    name: "hideLoadMoreButtonForWindowScroll",
                    fire: function (e, t) {
                        (t = klevu.getSetting(t.kScope.settings, "settings.search.searchBoxTarget")), (t = klevu.dom.find(".kuLoadMoreBtn", t));
                        t.length &&
                            klevu.each(t, function (e, t) {
                                t.classList.add("hide");
                            });
                    },
                }),
                    (window.onscroll = function (e) {
                        var t, a;
                        window.innerHeight + Math.ceil(window.pageYOffset) >= document.body.offsetHeight - 50 &&
                            (klevu.getObjectPath(klevu.search.landing.getScope().data, "context.triggeredFromInfiniteScroll") ||
                                ((a = klevu.getSetting(klevu.search.landing.getScope().settings, "settings.search.searchBoxTarget")),
                                    !(t = klevu.getObjectPath(klevu.search.landing.getScope().data, "context.activeQueryId")) || ((a = klevu.dom.find("." + t + " .kuLoadMoreBtn", a)).length && a[0].click())));
                    }));
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "attachImageSearchLandingModuleEvents",
        fire: function () {
            !1 !== klevu.getGlobalSetting("theme.modules.imageSearch.enable", !1) &&
                (klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingImageSearchUploadBanner"), "klevuLandingImageSearchUploadBanner", !0),
                    klevu.search.modules.imageSearchUpload.base.initResultsPage(klevu.search.landing.getScope(), "productList"),
                    klevu.search.landing.getScope().chains.template.events.add({
                        name: "attachTermOverride",
                        position: 0,
                        fire: function (e, t) {
                            klevu.getObjectPath(e.template, "kuResultsPageImageUploadEnabled", !1) && (e.context.termOriginal = "KLEVU_IMAGE_SEARCH");
                        },
                    }));
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "search-translation-locale",
        fire: function () {
            klevu.search.landing.getScope().template.getTranslator().mergeFromGlobal();
            var e = klevu.search.modules.locale.getDefaultLanguageCode(),
                e = klevu.search.modules.locale.getTranslations(e),
                e = klevu.search.modules.locale.applyTranslationOverrides(e),
                a = klevu.search.landing.getScope().template.getTranslator();
            klevu.each(e, function (e, t) {
                a.addTranslation(e, t);
            });
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "displayProductRating",
        fire: function () {
            klevu.search.modules.kmcInputs.base.showProductRatingLanding() && klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingProductRating"), "klevuLandingProductRating", !0);
        },
    }),
    klevu.coreEvent.build({
        name: "setRemoteConfigLandingInitialize",
        fire: function () {
            var e = klevu.getSetting(klevu, "settings.flags.setRemoteConfigLanding.build", !1);
            return !(!klevu.getSetting(klevu, "settings.powerUp.landing", !1) || !e);
        },
        maxCount: 150,
        delay: 100,
    }),
    klevu.coreEvent.attach("setRemoteConfigLandingInitialize", {
        name: "search-landing-init",
        fire: function () {
            var r = "q",
                e = klevu.getSetting(klevu, "settings.url.queryParam");
            e && e.length ? (r = e) : klevu.setSetting(klevu, "settings.url.queryParam", r),
                0 < klevu.dom.find(".klevuLanding").length &&
                (klevu.search.landing.setTarget(klevu.dom.find(".klevuLanding")[0]),
                    klevu.setSetting(klevu.search.landing.getScope().settings, "settings.search.fullPageLayoutEnabled", !0),
                    klevu.setSetting(klevu.search.landing.getScope().settings, "settings.search.minChars", 0),
                    0 < (t = klevu.getAllUrlParameters()).length &&
                    klevu.each(t, function (e, t) {
                        var a;
                        t.name == r &&
                            (((a = klevu.search.landing.getScope().element).value = t.value && "" != t.value ? t.value.split("+").join(" ") : "*"),
                                (a.kScope.data = a.kObject.resetData(a)),
                                klevu.event.fireChain(a.kScope, "chains.events.keyUp", a, a.kScope.data, null));
                    }));
            var t,
                e = klevu.getSetting(klevu.search.landing.getScope().settings, "settings.search.searchBoxTarget");
            e &&
                (klevu.dom.helpers.isMobileDevice() && e.classList.add("kuMobileDeviceEnabled"),
                    klevu.search.modules.kmcInputs.base.getFiltersEnableValue() ? ((t = klevu.search.modules.kmcInputs.base.getLandingFilterPosition()), e.classList.add("ku" + t.toUpperCase() + "Filters")) : e.classList.add("kuNoFilters"));
        },
    }),
    klevu.coreEvent.attach("setRemoteConfigLanding", {
        name: "enableBuildFlag",
        fire: function () {
            klevu.setSetting(klevu, "settings.flags.setRemoteConfigLanding.build", !0, !0),
                klevu.search.landing.getScope().chains.template.events.add({
                    name: "addTemplateRenderedTrigger",
                    fire: function (e, t) {
                        klevu.setSetting(klevu, "settings.flags.setRemoteConfigLanding.rendered", !0, !0);
                    },
                });
        },
    });
